import cargo from "./cargo/id";

export default {
  "STT Sudah Di Scan": "STT Sudah Di Scan",
  "Semua waktu": "Semua waktu",
  urgentRelabel: {
    searchPlaceholder: "Cari no. STT",
    download: "Download",
    printAll: "Print semua resi",
    printSize: "Print Ukuran {size}",
    column: {
      no: "No",
      sttNo: "No. STT",
      shipmentType: "Jenis pengiriman",
      rootSttNo: "No. STT asal",
      processedBy: "Diproses oleh",
      overtimeDuration: "Durasi overtime",
      overtimeDurationDays: "{day} hari",
      bkdDate: "Tanggal BKD",
      originCity: "Kota asal",
      destinationCity: "Kota tujuan",
      printReceipt: "Print Resi"
    },
    empty: {
      header: "Belum ada STT Monitor Relabel",
      message:
        "STT hasil Reroute dari HAL yang menunggu Relabel akan muncul di sini."
    },
    filter: {
      title: "Filter",
      processedBy: "Diproses oleh",
      processedByPlaceholder: "Pilih diproses oleh",
      shipmentType: "Jenis pengiriman",
      shipmentTypePlaceholder: "Pilih jenis pengiriman",
      originCity: "Kota asal",
      originCityPlaceholder: "Pilih kota asal",
      destinationCity: "Kota tujuan",
      destinationCityPlaceholder: "Pilih kota tujuan",
      bkdUpdateDate: "Tanggal update BKD",
      reset: "Reset",
      apply: "Terapkan",
      optionClient: "Client",
      optionConsolidator: "Consolidator",
      allProducts: "Semua Produk",
      productCount: "{count} Produk"
    },
    cityFilter: {
      defaultTitle: "Kota",
      defaultPlaceholder: "Pilih kota",
      locationCount: "{count} Lokasi"
    }
  },
  bookingSdn: {
    notice: "Rute ini berpotensi mengalami keterlambatan pengiriman, namun tetap dapat melakukan booking."
  },
  loading: "sedang diproses",
  "Download data": "Download data",
  "Print PDF": "Print PDF",
  custom: "Custom",
  "hari ini": "Hari ini",
  kemarin: "Kemarin",
  "3 hari terakhir": "3 hari terakhir",
  "7 hari terakhir": "7 hari terakhir",
  "Total STT": "Total STT",
  "Print Label": "Print Label",
  "Proses PUP": "Proses PUP",
  "14 hari terakhir": "14 hari terakhir",
  "30 hari terakhir": "30 hari terakhir",
  "satu bulan": "Satu bulan",
  Cari: "Cari",
  "Simpan Perubahan": "Simpan perubahan",
  "Pos pembooking": "Pos pembooking",
  "Pilih POS": "Pilih POS",
  "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.":
    "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.",
  "Silahkan menunggu CS follow up untuk konfirmasi adjust ulang STT.":
    "Silahkan menunggu CS follow up untuk konfirmasi adjust ulang STT.",
  Kendala:
    "Terjadi Kendala pada proses pengiriman? Hubungi Customer Service 021-80820072\natau hubungi Kota Asal yang bersangkutan.",
  attachment: "Lampirkan File",
  attach: "Lampiran",
  "STT Paid/Unpaid": "STT Kurang Bayar",
  "STT belum di STI DEST & DEL": "STT belum di STI DEST & DEL",
  STT: "STT",
  "STT Manual": "STT Manual",
  FPR: "FPR",
  Transaksi: "Transaksi",
  Misroute: "Misroute",
  Shortland: "Shortland",
  Scrap: "Scrap",
  Pengiriman: "Pengiriman",
  "Pengiriman Keluar (Kota Asal)": "Pengiriman Keluar (Kota Asal)",
  "Pengiriman Masuk (Kota Tujuan)": "Pengiriman Masuk (Kota Tujuan)",
  "Pembatalan STT": "Pembatalan STT",
  "Top Up": "Top Up",
  "Komisi Pengiriman": "Komisi Pengiriman",
  "Komisi Pengiriman Tier X": "Komisi Pengiriman Tier X",
  Kejarcuan: "Kejarcuan",
  "STT Client": "STT Client",
  "Mutasi Saldo": "Mutasi Saldo",
  "Saldo Tertahan": "Saldo Tertahan",
  downloadReceipt: "Download Resi",
  bosspackNote: "BOSSPACK (Maksimal jam Pick Up 14:00)",
  "COD International Client": "Internasional Klien",
  validation: {
    phone: {
      invalid: "Nomor telepon tidak valid, mohon ulangi kembali",
      validMsisdn: "Nomor telepon valid dengan tipe MSISDN",
      validPstn: "Nomor telepon valid dengan tipe PSTN"
    }
  },
  error: {
    internet: {
      title: "Tidak Terhubung ke Internet",
      message: "Pastikan koneksi internet Anda aktif dan muat ulang"
    }
  },
  parsingErrorSpec: {
    rateNotFoundHeader: "Harga Tidak Ditemukan !",
    rateNotFoundMessage: "Kota tujuan yang Anda pilih belum memiliki harga.",
    embargoHeader: "EMBARGO !",
    embargoMessage: "Sistem tidak dapat memproses permintaan Anda.",
    balanceBelowHeader: "Saldo Anda Dibawah Limit !",
    balanceBelowMessage:
      "Lakukan pengisian saldo sekarang juga. Pastikan saldo Anda tersedia sebelum melakukan aktivitas pengiriman.",
    posBalanceHeader: "Saldo POS tidak mencukupi",
    posBalanceMessage:
      "Silakan hubungi pihak POS untuk top up saldo untuk perubahan alamat.",
    requestFailedHeader: "Permintaan Gagal !",
    updateFailedHeader: "Gagal Update!",
    okUnderstand: "Oke, Saya Mengerti"
  },
  sidebar: {
    currentVersion: "Versi saat ini.",
    revertToPreviousVersion: "Balik versi sebelumnya",
    searchMenuPlaceholder: "Cari menu",
    menuNotFound: "Menu tidak ditemukan",
    menuNotFoundDescription: "Tidak terdapat menu yang kamu cari",
    back: "Kembali",
    feedback: {
      title: "Berikan penilaian Anda",
      subtitle: "Penilaian Anda sangat berharga untuk kami",
      subtitleCardReview: "Penilaian Anda sangat Berharga untuk perbaikan",
      rateButton: "Nilai"
    }
  },
  featureName: {
    "Manajemen User": "Manajemen User",
    "Daftar CARGO": "Daftar CARGO",
    Beranda: "Beranda",
    "Manifest cari STT": "Manifest cari STT",
    "Lacak Pengiriman": "Lacak Pengiriman",
    "Kiriman Penting": "Kiriman Penting",
    "Performa DEX Asesmen": "Performa DEX Asesmen",
    "DEX Asesmen": "DEX Asesmen",
    "Proses STI": "Proses STI",
    "Proses BAG": "Proses BAG",
    "Proses RTC": "Proses RTC",
    "Proses STIDEST": "Proses STIDEST",
    "Proses DISPATCH": "Proses DISPATCH",
    "Proses Custom Status": "Proses Custom Status",
    "Handover Vendor (HND)": "Handover Vendor (HND)",
    "STT Kurang Bayar": "STT Kurang Bayar",
    "STT Dalam Proses": "STT Dalam Proses",
    "Manajemen Kurir": "Manajemen Kurir",
    "Cek Tarif": "Cek Tarif",
    "Daftar Booking": "Daftar Booking",
    "Cetak Tagihan": "Cetak Tagihan",
    "Cetak Resi": "Cetak Resi",
    "Pusat Resolusi": "Pusat Resolusi",
    "Rekon Delivery": "Rekon Delivery",
    "Batas POD Terlewati": "Batas POD Terlewati",
    "Batas POD Hari Ini": "Batas POD Hari Ini",
    "Batas RTS Terlewati": "Batas RTS Terlewati",
    "Batas RTS Hari ini": "Batas RTS Hari ini",
    "Batas RTS Besok": "Batas RTS Besok",
    "Proses CARGO": "Proses CARGO",
    "Pusat Panduan": "Pusat Panduan"
  },
  outgoingShipment: {
    bagging: {
      uploadPhoto: {
        headerLeading: "Wajib upload bukti foto jika perbedaan antara",
        headerTrailing:
          "berat kargo dan berat timbang ulang mencapai 1 kg atau lebih",
        rulesTitle: "Ketentuan foto:",
        ruleGoodResolution: "Foto harus memiliki resolusi bagus.",
        ruleScaleReadable: "Berat aktual pada timbangan harus terbaca jelas.",
        ruleAllPackagesVisible:
          "Semua paket yang ditimbang harus terlihat jelas.",
        ruleMinimumOne: "Minimal 1 foto",
        guideWeighingWithItem: "Foto timbangan <br /> dengan barang",
        guideMeasurementWithItem: "Foto ukuran <br /> dengan barang",
        additionalPhoto: "Foto tambahan"
      }
    }
  },
  dashboard: {
    summary: "Ringkasan",
    onTime: "Tepat Waktu",
    late: "Terlambat",
    resi: "Resi",
    route: "Rute",
    byRoute: "Per Rute",
    distributionByProduct: "Distribusi Per Produk",
    delivery: "Pengiriman",
    totalResi: "Total Resi",
    status: "Status",
    detail: "Detail",
    posReferral: "POS Referral",
    termsAndConditions: "Syarat dan Ketentuan:",
    registerNow: "Daftar Sekarang!",
    claimMbgSuccess: "Anda telah berhasil klaim MBG sebesar",
    claim: "Klaim",
    totalClaim: "Total Klaim",
    filter: "Filter",
    reset: "Reset",
    apply: "Terapkan",
    allShipments: "Semua Pengiriman",
    deliveryPerformance: "Performa Pengiriman",
    shippingCost: "Ongkos Kirim",
    cancelledCodValue: "Nilai COD Batal",
    codVsNonCod: "COD VS Non COD",
    rejectionReason: "Alasan Ditolak",
    tooltipClaimData: "Data yang ditampilkan dimulai dari September 2022",
    routes: "Rute",
    stt: "STT",
    referralInviteCopy:
      "Ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel dengan menggunakan kode referral dan dapatkan insentif",
    referralShareCopy:
      "Bagikan kode referral ini dan ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel.",
    packageInfo: "Informasi Paket",
    cod: "COD",
    performance: "Performa",
    emptyState: "Oops.. Belum ada data yang dapat ditampilkan",
    greeting: "Hai, {name} !",
    lastSync: "Sinkronisasi Data Terakhir",
    sttNoteBefore: "STT diupdate setiap ",
    sttNoteStrong: "10 menit",
    sttNoteAfter: " & akan muncul saat jam cut off dimulai",
    codIntro:
      "Berikut adalah total STT yang Anda proses dalam 3 hari terakhir dengan masing-masing status.",
    seeMore: "Lihat Selengkapnya",
    filterLabels: {
      selectService: "Pilih layanan",
      selectDelivery: "Pilih pengiriman",
      selectDate: "Pilih Tanggal",
      allServices: "Semua Layanan",
      allBranches: "Semua Cabang",
      maxDaysError: "Tanggal tidak boleh lebih dari 365 hari"
    },
    advanceFilter: {
      serviceType: "Jenis layanan",
      deliveryType: "Jenis pengiriman"
    },
    claimSubmitted: "Diajukan",
    claimApproved: "Disetujui",
    claimRejected: "Ditolak",
    claimCompleted: "Selesai",
    tabUtama: "Utama",
    tabPerforma: "Performa",
    tabHangingBkd: "Hanging BKD",
    tabCustomer: "Customer",
    tabLeaderboard: "Leaderboard",
    tabCod: "COD",
    tabRevenue: "Omzet",
    shortcut: {
      menuUtama: "Menu Utama",
      bookingRetail: "Booking Retail",
      bookingKlien: "Booking Klien",
      bookingShipment: "Booking Aplikasi & Marketplace",
      bookingInstant: "Booking Instant",
      ppob: "PPOB",
      new: "New"
    },
    console: {
      card: {
        remainingTime: "Sisa waktu",
        maxTime: "Maksimal Pukul"
      },
      tabs: {
        allStt: "Seluruh STT",
        currentStt: "STT Saat Ini",
        cod: "COD",
        hangingBkd: "Hanging BKD",
        hangingOutgoing: "Hanging Outgoing",
        hangingIncoming: "Hanging Incoming",
        hangingLastMile: "Hanging Last Mile",
        performance: "Performa"
      },
      common: {
        viewDetail: "Lihat Detail",
        downloadXlsx: "Unduh .xlsx",
        total: "Total"
      },
      allStt: {
        failedToLoad: "Gagal menampilkan data",
        incomingStt: "Incoming STT",
        transitStt: "Transit STT",
        outgoingStt: "Outgoing STT",
        loadMore: "Muat Lebih Banyak",
        cardTitles: {
          sttNotReceived: "STT Belum Diterima",
          sttCargoPlane: "STT Kargo Pesawat",
          sttCargoTruck: "STT Cargo Truck",
          sttCargoTrain: "STT Cargo Train",
          sttTransit: "STT Transit",
          sttMisroute: "STT Misroute",
          sttShortland: "STT Shortland",
          sttNotFinished: "STT Belum Selesai",
          sttStiDest: "STT STI-DEST",
          sttStiDestSc: "STT STI DEST-SC",
          sttDel: "STT DEL",
          sttDex: "STT DEX",
          sttHal: "STT HAL",
          sttBkd: "STT BKD",
          sttPup: "STT PUP",
          sttStiSc: "STT STI-SC",
          sttSti: "STT STI",
          sttBagging: "STT Bagging",
          sttRejected: "STT Rejected"
        },
        cardDescriptions: {
          incomingNotReceived:
            "Total STT yang belum sampai di Consolidator kota tujuan",
          incomingCargoPlane:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Kargo Pesawat",
          incomingCargoTruck:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Cargo Truck",
          incomingCargoTrain:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Cargo Train",
          incomingTransit:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Transit",
          incomingMisroute:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Misroute",
          incomingShortland:
            "Total STT dengan tujuan kota consolidator dengan status terakhir Shortland",
          incomingNotFinished:
            "Total STT yang sudah sampai di Consolidator kota tujuan tetapi belum selesai proses pengiriman",
          incomingStiDest:
            "Total STT di kota tujuan dengan status terakhir STI-DEST",
          incomingStiDestSc:
            "Total STT di kota tujuan dengan status terakhir STI DEST-SC",
          incomingDel: "Total STT di kota tujuan dengan status terakhir DEL",
          incomingDex: "Total STT di kota tujuan dengan status terakhir DEX",
          incomingHal:
            "Paket ditahan di Consolidator Kota Tujuan karena beberapa alasan.",
          transitUndelivered:
            "Total STT transit yang belum sampai di consolidator transit",
          transitUndeliveredCargoPlane:
            "Total STT dengan tujuan Kota Transit dengan status terakhir Kargo Pesawat",
          transitUndeliveredCargoTruck:
            "Total STT dengan tujuan Kota Transit dengan status terakhir Cargo Truck",
          transitUndeliveredCargoTrain:
            "Total STT dengan tujuan Kota Transit dengan status terakhir Cargo Train",
          transitUnfinished:
            "Total STT transit yang sudah sampai di consol transit, namun belum selesai proses pengiriman",
          transitUnfinishedCargoPlane:
            "Total STT berkota asal Consolidator Transit dengan status terakhir Kargo Pesawat",
          transitUnfinishedCargoTruck:
            "Total STT berkota asal Consolidator Transit dengan status terakhir Cargo Truck",
          transitUnfinishedCargoTrain:
            "Total STT berkota asal Consolidator Transit dengan status terakhir Cargo Train",
          transitUnfinishedTransit:
            "Total STT yang ada di kota transit dengan status terakhir Transit",
          outgoingNotReceived:
            "Total STT yang belum diterima oleh Consolidator kota asal",
          outgoingBkd: "Total STT di kota asal dengan status terakhir BKD",
          outgoingPup: "Total STT di kota asal dengan status terakhir PUP",
          outgoingStiSc: "Total STT di kota asal dengan status terakhir STI-SC",
          outgoingNotFinished:
            "Total STT yang sudah dikirim dari kota asal tetapi belum sampai di kota tujuan",
          outgoingSti:
            "Total STT berkota asal consolidator dengan status terakhir STI",
          outgoingBagging:
            "Total STT berkota asal consolidator dengan status terakhir Bagging",
          outgoingShortland:
            "Total STT berkota asal consolidator dengan status terakhir Shortland",
          outgoingCargoPlane:
            "Total STT berkota asal consolidator dengan status terakhir Kargo Pesawat",
          outgoingCargoTruck:
            "Total STT berkota asal consolidator dengan status terakhir Cargo Truck",
          outgoingCargoTrain:
            "Total STT berkota asal consolidator dengan status terakhir Cargo Train",
          outgoingMisroute:
            "Total STT berkota asal consolidator dengan status terakhir Misroute",
          outgoingRejected:
            "Paket tidak diterima oleh tim kargo, karena tidak sesuai dengan regulasi Kargo Pesawat"
        }
      },
      currentStt: {
        outgoing: "Outgoing",
        incoming: "Incoming",
        infoTitle: "Informasi {type}",
        posListTitle: "Daftar POS yang Belum Mengirim STT",
        notProcessed: "Belum Diproses",
        processed: "Sudah Diproses",
        errorTitle: "Halaman dalam perbaikan",
        errorMessage:
          "Maaf halaman ini sedang dalam perbaikan, Kami akan segera online kembali.",
        whatsappActiveAgainAt: "Aktif kembali pada",
        andReloadPage: "dan muat ulang halaman",
        whatsappClickHint: "Klik Chat di Whatsapp.",
        whatsappCooldownHint:
          "Anda hanya dapat menghubungi POS kembali setelah 1 jam berikutnya!",
        clickToDetail: "Klik ke Detail",
        sortDesc: "Urutkan dari yang terbesar ke terkecil",
        sortAsc: "Urutkan dari yang terkecil ke terbesar",
        table: {
          no: "No",
          posName: "Nama POS",
          posCode: "POS Code",
          posPhone: "No Telp POS",
          unprocessed: "Belum Diproses",
          backlogToday: "Backlog Hari Ini",
          backlog2to7: "Backlog 2-7 Hari",
          hanging: "Hanging"
        },
        cutOffTitles: {
          cycle1: "Cycle 1",
          cycle2: "Cycle 2",
          needSti: "Perlu di STI",
          needCargoPlane: "Perlu di Kargo Pesawat",
          needCargoTruckTrain: "Perlu di Kargo Truk/Kereta",
          backlogToday: "Backlog Hari Ini",
          backlog2to7: "Backlog 2-7 Hari",
          hanging: "Hanging",
          bkdToSti: "BKD to STI",
          stiToCargoPlane: "STI to Kargo Pesawat",
          stiToCargoTruckTrain: "STI to Kargo Truk/Kereta",
          onTime: "On Time",
          late: "Late",
          invalidSkippingStatus: "Invalid/Skipping Status",
          needDel: "Perlu di DEL",
          needPod: "Perlu di POD"
        },
        cutOffDescriptions: {
          cycle:
            "Daftar STT yang belum diupdate dan masih di dalam waktu cut off",
          cycle1Incoming:
            "Daftar STT yang belum diupdate dan masih di dalam waktu cut off Cycle 1",
          cycle2Incoming:
            "Daftar STT yang belum diupdate dan masih di dalam waktu cut off Cycle 2",
          backlogToday:
            "Daftar STT yang belum di update dan sudah di luar waktu cut off",
          backlog2to7:
            "Daftar STT yang belum diproses hari ini dan sudah diluar waktu cut off",
          hanging: "Daftar STT yang belum diupdate dan sudah lewat dari 7 hari",
          onTime:
            "Daftar STT yang sudah diupdate dan masih di dalam waktu cut off",
          late: "Daftar STT yang sudah diupdate di luar waktu cut off",
          invalid:
            "Daftar STT yang sudah di proses namun melewati status yang seharusnya"
        }
      },
      detailProcess: {
        locationSti: "di STI",
        locationDel: "di DEL",
        locationCargoPlane: "di Kargo Pesawat",
        locationPod: "di POD",
        locationCargoTruckTrain: "di Kargo Truk/Kereta",
        columns: {
          onTime: "Ontime",
          late: "Late",
          invalid: "Invalid",
          backlogToday: "Backlog Hari Ini",
          backlog2to7: "Backlog 2-7 Hari",
          hanging: "Hanging"
        },
        tooltips: {
          onTime:
            "Daftar STT yang sudah diupdate dan masih di dalam waktu cut off",
          late: "Daftar STT yang sudah diupdate di luar waktu cut off",
          invalid:
            "Daftar STT yang sudah di proses namun melewati status yang seharusnya",
          backlogToday:
            "Daftar STT yang belum diproses hari ini dan sudah diluar waktu cut off",
          backlog2to7:
            "Daftar STT yang belum diproses selama 2-7 hari dan sudah diluar waktu cut off",
          hanging: "Daftar STT yang belum diupdate dan sudah lewat dari 7 hari"
        }
      }
    },
    performa: {
      lastSync: "Sinkronisasi Data Terakhir"
    },
    customer: {
      topCustomer: "Top Pelanggan",
      updated: "Diperbarui",
      tooltip:
        "Daftar customer yang bertransaksi di POS Anda, dengan peringkat tertentu yang diurutkan berdasarkan total transaksi & dihitung 1 bulan sebelumnya.",
      emptyMessage: "Oops.. Belum ada data yang dapat ditampilkan",
      dataLabel: "Data",
      ranking: "Peringkat",
      pelanggan: "Pelanggan",
      labelPelanggan: "Label Pelanggan",
      periodeSaatIni: "Periode saat ini",
      reloadPage: "Muat Ulang",
      systemError: "Terjadi kendala sistem",
      systemErrorHint: 'Klik "Muat Ulang" untuk memperbarui halaman.',
      lastSend: "Terakhir kirim:",
      omzetNaik: "Omzet Naik",
      omzetTurun: "Omzet Turun",
      pelangganBaru: "Pelanggan Baru",
      pelangganChurn: "Pelanggan Churn",
      misbooking: "MISSBOOKING > 5%",
      rts: "RTS > 5%",
      months: {
        january: "Januari",
        february: "Februari",
        march: "Maret",
        april: "April",
        may: "Mei",
        june: "Juni",
        july: "Juli",
        august: "Agustus",
        september: "September",
        october: "Oktober",
        november: "November",
        december: "Desember"
      }
    },
    hanging: {
      emptyHeader: "Data belum tersedia",
      emptyMessage:
        "Jika sudah ada data, maka akan muncul di sini secara otomatis.",
      searchEmptyHeader: "Hasil pencarian tidak ditemukan",
      searchEmptyMessage: "Coba periksa kembali kata kunci atau filter.",
      confirmTitle: "Update Status?",
      confirmSuccess: "Ya, update",
      confirmDoneTitle: "Konfirmasi selesai?",
      confirmDoneMessage:
        "Pastikan kamu sudah melakukan follow up atau mencari STT Hanging.",
      confirmDoneSuccess: "Ya, selesai",
      cancel: "Batalkan",
      confirmUpdateMessage:
        "Apakah Anda yakin ingin update status ke <b>{status}?</b>",
      templateIntro: "Halo, saya dari",
      templateLionParcel: "Lion Parcel",
      templateHanging: "Saya ingin follow up STT dengan status hanging",
      templateMoreThan3Days: "lebih dari 3 hari",
      templateTotal: "Total ada {count} STT yaitu:",
      templateThanks: "Mohon bantuannya, terima kasih",
      accountTypePos: "POS",
      accountTypeKonsolidator: "Consolidator",
      successUpdate: "Berhasil update status aktivitas",
      failUpdate: "Gagal update status aktivitas",
      successUpdateStatus: "Berhasil update status <b>{status}</b>",
      successUpdateStatusWithRatio:
        "Berhasil update status <b>{status} {success}/{total}</b>",
      failUpdateStatus: "Gagal update status <b>{status}</b>",
      all: "Semua",
      searchOrScan: "Cari atau scan",
      statusPackageExistence: "Status Keberadaan paket",
      activityStatus: "Status aktivitas",
      followUpStatus: "Status Follow Up",
      statusNotFound: "Belum ditemukan",
      statusFoundConsole: "Aktual Paket di Konsol",
      statusFoundPos: "Aktual Paket di POS",
      notCompleted: "Belum Selesai",
      completed: "Sudah Selesai",
      notFollowedUp: "Belum Follow Up",
      followedUp: "Sudah Follow Up",
      historyEmptyHeader: "Belum ada riwayat",
      historyEmptyMessage: "Anda belum memiliki riwayat apa pun saat ini.",
      allActivities: "Semua aktivitas",
      followUpDone: "Selesai di follow up",
      followUpAirport: "Follow Up ke Agen Bandara",
      followUpCourierTruck: "Follow Up ke Kurir Truk",
      followUpChecker: "Follow Up ke Checker",
      searchSttWarehouse: "Cari STT di Gudang",
      followUpConsole: "Follow Up ke Konsol",
      followUpPartnerClient: "Follow Up ke Partner/Client",
      followUpUser: "Follow Up ke User",
      searchItemWarehouse: "Cari Barang di Gudang",
      followUpOps: "Follow Up ke Ops",
      followUpCourier: "Follow Up ke Kurir",
      followUpPicLastMile: "Follow Up ke PIC Last Mile",
      followUpTo: "Follow Up ke",
      dashboardTitleIncoming: "Dashboard Hanging Incoming",
      dashboardTitleOutgoing: "Dashboard Hanging Outgoing",
      dashboardTitleLastMile: "Dashboard Hanging Last Mile",
      dashboardTitleBkd: "Dashboard Hanging STI",
      incomingInfoPrefix: "AWB dengan STT hanging",
      incomingInfoOnStatus: "pada status",
      incomingInfoStatuses: "ARR/DROPOFF_TRUCKING/STI-DEST/SHORTLAND",
      incomingInfoActionPrefix: "untuk segera di",
      incomingInfoAction: "DEL",
      outgoingInfoPrefix: "STT hanging",
      outgoingInfoOnStatus: "pada status",
      outgoingInfoStatuses: "STI, BAGGING",
      outgoingInfoActionPrefix: "harus segera di",
      outgoingInfoAction: "CARGO",
      lastMileInfoPrefix: "STT hanging",
      lastMileInfoOnStatus: "pada",
      lastMileInfoStatuses: "DEL/DEX/CODREJ",
      lastMileInfoActionPrefix: "untuk segera",
      lastMileInfoAction: "DEL ulang atau RTS.",
      bkdInfoPrefix: "STT hanging",
      bkdInfoOnStatus: "pada status",
      bkdInfoStatuses: "BKD, ADJUSTED, PUP, STI-SC, STO-SC",
      bkdInfoActionPrefix: "harus segera di",
      bkdInfoAction: "STI",
      day3Plus: "≥ 3hari",
      syncLast: "Sync terakhir",
      searchStt: "Cari STT",
      history: "Riwayat",
      total: "Total",
      mustBeDone: "yang harus dilakukan",
      hanging: "hanging",
      activityDone: "Aktivitas sudah dilakukan",
      processedToday: "sudah proses hari ini",
      totalBag: "Total BAG",
      totalStt: "Total STT",
      totalActivityMustDo: "Total Aktivitas yang harus di lakukan",
      alreadyProcessed: "sudah diproses",
      activity: "Aktivitas",
      awb: "AWB",
      bag: "BAG",
      stt: "STT",
      courier: "Kurir",
      userOps: "User Ops",
      pos: "POS",
      subKon: "SUB-KON",
      corporate: "KORPORATE",
      historyIncomingTitle: "Riwayat Hanging Incoming",
      historyOutgoingTitle: "Riwayat Hanging Outgoing",
      historyLastMileTitle: "Riwayat Hanging Last Mile",
      historyBkdTitle: "Riwayat Hanging BKD",
      historyBkdConsoleTitle: "Riwayat Hanging BKD Console",
      historyBkdPosTitle: "Riwayat Hanging BKD Pos",
      historyHangingTab: "Riwayat Hanging",
      historyFollowUpTab: "Riwayat Follow Up",
      templateHelpQuestion: "Apakah STT di atas ada di sana?",
      templateHangingAwb:
        "Saya ingin follow up AWB dengan status hanging ({groupName})",
      templateTotalAwb:
        "Total ada {totalAwb} AWB dengan {totalPiece} koli, yaitu:",
      templateHelpQuestionAwb: "Apakah AWB di atas ada di sana?",
      templateMessage: "Template Pesan",
      whatsapp: "WhatsApp",
      confirmDone: "Konfirmasi Selesai",
      packageLocation: "Lokasi keberadaan paket",
      notes: "Keterangan",
      dayUnit: "Hari",
      day7Plus: "≥7 Hari"
    },
    tooltipTotalStatusDelivery: "Total STT yang berhasil terbooking",
    onProcess: "Dalam Proses",
    tooltipOnProcess: "Total STT yang sedang dalam proses pengiriman",
    accepted: "Telah Diterima",
    tooltipAccepted: "Total STT yang berhasil diterima",
    failedDelivery: "Gagal Kirim",
    tooltipFailedDelivery: "Total STT yang gagal dikirim",
    return: "Dikembalikan",
    tooltipReturn: "Total STT yang dikembalikan",
    codValue: {
      title: "Nilai COD",
      estTotalCodValue: "Estimasi Total Nilai COD",
      tooltipEstTotalCodValue: {
        list1: "Estimasi Total Nilai COD yang akan diterima",
        list2: "Total STT COD yang berhasil terbooking"
      },
      onProcess: "Dalam Proses",
      tooltipOnProcess: {
        list1: "Estimasi Total Nilai COD yang dalam proses pengiriman",
        list2: "Total STT COD yang dalam proses pengiriman"
      },
      accepted: "Telah Diterima",
      tooltipAccepted: {
        list1: "Estimasi Total Nilai COD yang akan diterima",
        list2: "Total STT COD yang berhasil terbooking"
      },
      failed: "Nilai COD",
      tooltipFailed: {
        list1: "Estimasi Total Nilai COD yang gagal terkirim",
        list2: "Total STT COD yang gagal dikirim"
      }
    },
    sectionShipping: {
      inProgress: "Akan Ditagihkan",
      success: "Ditagihkan",
      tooltipSuccess:
        "Data yang ditagihkan merupakan data yang masih belum dibayar atau sedang dalam proses pembayaran (unpaid ataupun partially paid)",
      paid: "Telah Dibayar",
      tooltipPaid:
        "Data yang telah dibayar merupakan data yang sudah sukses dibayar (paid)"
    },
    hangingBkd: {
      title: "Dashboard Hanging BKD",
      total: "Total",
      stt: "STT",
      adminPos: "Admin POS",
      bkd: "BKD",
      pup: "PUP",
      sttHanging: "STT hanging",
      days: "≥ 3hari",
      on: "pada",
      statuses: "BKD, STT ADJUSTED, PUP",
      mustBe: "harus segera di",
      sti: "STI",
      lastSync: "Sync terakhir",
      searchStt: "Cari STT",
      history: "Riwayat",
      totalActivity: "Total Aktivitas yang harus di lakukan",
      activityDone: "Aktivitas sudah dilakukan",
      processedToday: "sudah proses hari ini",
      historyPage: {
        pageTitle: "Riwayat hanging BKD",
        tabs: {
          historyHanging: "Riwayat Hanging",
          historyFollowUp: "Riwayat Follow Up"
        },
        back: "Kembali",
        historyHanging: {
          manifestNo: "No. Manifest",
          sttNo: "No. STT",
          hanging: "Hanging",
          packageExistenceStatus: "Status keberadaan paket",
          packageExistenceLocation: "Lokasi keberadaan paket",
          description: "Keterangan",
          aggregator: "Aggregator",
          emptyHeader: "Data belum tersedia",
          emptyMessage:
            "Jika sudah ada data, maka akan muncul di sini secara otomatis.",
          days: "Hari",
          day7Plus: "≥7 Hari",
          notFound: "Belum Ditemukan",
          foundConsole: "Aktual Paket di Konsol",
          foundPos: "Aktual Paket di POS"
        },
        historyFollowUp: {
          activityStatus: "Status aktivitas",
          allActivities: "Semua aktivitas",
          followUpPartnerClient: "Follow Up ke Partner/Client",
          followUpUser: "Follow Up ke User",
          searchWarehouse: "Cari Barang di Gudang",
          followUpCompleted: "Selesai di follow up",
          noHistoryTitle: "Belum ada riwayat",
          noHistoryMessage: "Anda belum memiliki riwayat apa pun saat ini.",
          followUpTo: "Follow Up ke",
          searchSttWarehouse: "Cari STT di Gudang"
        }
      }
    },
    leaderboard: {
      updated: "Diperbarui",
      national: "Nasional",
      newPos: "POS Baru",
      emptyState: {
        noConnection: {
          header: "Jaringan internet terputus",
          message: "Periksa jaringan internal Anda lalu klik 'Muat ulang'.",
          button: "Muat ulang"
        },
        noData: {
          header: "Belum ada leaderboard",
          message:
            "Mulai transaksi Anda dan raih reward hingga puluhan juta rupiah dari leaderboard POS!"
        }
      },
      jumpButtons: {
        viewYourRank: "Lihat peringkat anda",
        viewNearestTopReward: "Lihat reward terdekat dari atas",
        viewTopRank: "Lihat peringkat atas"
      },
      columns: {
        rank: "Peringkat",
        posName: "Nama POS",
        achievement: "Pencapaian",
        cityCode: "3LC",
        totalRevenue: "Total Omzet",
        estimatedReward: "Estimasi Reward"
      },
      cardLiolio: {
        noData: {
          header: "Program leaderboard POS {month} belum dimulai.",
          message: "Silakan tunggu untuk meraih reward puluhan juta rupiah!"
        },
        reward: {
          congrats: "Selamat! Anda mendapatkan reward"
        },
        encourage:
          "Tingkatkan omzet Anda & raih reward puluhan juta di kesempatan berikutnya!",
        totals: {
          revenue: "Total omzet"
        }
      },
      podium: {
        title: {
          rank: "Peringkat",
          newPos: "POS Baru",
          area: "Area",
          national: "Peringkat Nasional"
        },
        reward: {
          label: "Estimasi reward"
        }
      },
      cardReward: {
        totalEstimatedReward: "Total estimasi reward",
        totalRevenue: "Total omzet",
        tooltip: {
          revenueInfo:
            "Akumulasi omzet dihitung dari STT Retail dan CBP berdasarkan waktu POD"
        }
      },
      filterMonth: {
        placeholder: "Bulan",
        selectMonth: "Pilih bulan",
        currentMonth: "Bulan ini",
        monthNames: {
          january: "Januari",
          february: "Februari",
          march: "Maret",
          april: "April",
          may: "Mei",
          june: "Juni",
          july: "Juli",
          august: "Agustus",
          september: "September",
          october: "Oktober",
          november: "November",
          december: "Desember"
        }
      },
      topCustomer: {
        title: "10 Pelanggan Terbaik",
        table: {
          no: "No",
          customer: "Pelanggan",
          currentPeriod: "Periode saat ini"
        },
        lastSent: "Terakhir kirim:",
        empty: "Tidak ada data",
        ok: "Oke",
        stt: "STT",
        kg: "kg"
      },
      sliderLeaderboard: {
        title: "Cara tingkatkan reward Anda",
        scope: {
          area: "area",
          newPos: "POS baru"
        },
        slides: {
          national1: "Tingkatkan omzet hingga",
          national2: "Dapatkan reward nasional",
          areaOrNewPos1: "Kejar omzet",
          areaOrNewPos2: "untuk mendapatkan reward",
          topCustomerPrefix: "Ajak",
          topCustomerHighlight: "10 top customer",
          topCustomerSuffix:
            "transaksi lebih sering, raih reward lebih tinggi!",
          operational1: "Perpanjang jam operasional",
          operational2: "untuk meningkatkan omzet."
        }
      }
    },
    filterHistoryHanging: {
      searchPlaceholder: "Cari atau scan",
      today: "Hari ini",
      day3: "3 Hari",
      day4: "4 Hari",
      day5: "5 Hari",
      day6: "6 Hari",
      day7Plus: "≥7 Hari"
    },
    customerLeaderboardFilter: {
      customerName: "Nama customer",
      allLabels: "Semua label",
      omzetUp: "Omzet Naik",
      omzetDown: "Omzet Turun",
      churnCustomer: "Pelanggan Churn",
      newCustomer: "Pelanggan Baru"
    },
    errorBreakdownTable: {
      service: "Layanan",
      channel: "Channel",
      shipmentType: "Jenis pengiriman",
      destinationCity: "Kota tujuan",
      commodity: "Komoditas",
      systemError: "Terjadi kendala sistem",
      reloadInstruction: "Klik “Muat Ulang” untuk memperbarui halaman.",
      reload: "Muat Ulang",
      emptyData: "Oops.. Belum ada data yang dapat ditampilkan"
    },
    breakdownTable: {
      service: "Layanan",
      channel: "Channel",
      shipmentType: "Jenis pengiriman",
      destinationCity: "Kota tujuan",
      commodity: "Komoditas",
      scrollMore: "Scroll untuk lihat lainnya",
      lastSync: "Sinkronasi data terakhir"
    },
    lineComparisonChart: {
      systemError: "Terjadi kendala sistem",
      reloadInstruction: "Klik “Muat Ulang” untuk memperbarui halaman.",
      reload: "Muat ulang",
      performance: "Performa",
      totalOmzet: "Total omzet",
      totalRevenue: "Total penghasilan",
      totalStt: "Total STT",
      current: "Saat ini",
      comparison: "Perbandingan",
      monthsShort: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "Mei",
        jun: "Jun",
        jul: "Jul",
        aug: "Agu",
        sep: "Sep",
        oct: "Okt",
        nov: "Nov",
        dec: "Des"
      },
      omzet: "omzet",
      berat: "berat"
    },
    totalRevenueSection: {
      title: "Total omzet (Retail & CBP)",
      systemError: "Terjadi kendala sistem",
      reloadInstruction: "Klik “Muat Ulang” untuk memperbarui halaman.",
      reload: "Muat ulang",
      previous: "Sebelumnya",
      previousLower: "sebelumnya"
    },
    cardTotalProfit: {
      title: "Total penghasilan",
      systemError: "Terjadi kendala sistem",
      reloadInstruction: "Klik “Muat Ulang” untuk memperbarui halaman.",
      reload: "Muat ulang",
      earnedProfitTitle: "Penghasilan yang didapat",
      earnedProfitDescription:
        "Total penghasilan yang sudah Anda dapatkan dan masuk ke saldo POS.",
      pendingProfitTitle: "Estimasi penghasilan tertunda",
      pendingProfitDescription:
        "Total penghasilan yang akan Anda dapatkan namun menunggu pengiriman POD."
    },
    dateRangeCompare: {
      selectDatePeriod: "Pilih periode tanggal",
      selectDate: "Pilih tanggal",
      mainPeriod: "Periode utama",
      comparePeriod: "Periode pembanding",
      reset: "Atur Ulang",
      apply: "Terapkan",
      presets: {
        customDate: "Custom tanggal",
        last7Days: "7 hari terakhir",
        last14Days: "14 hari terakhir",
        lastMonth: "1 bulan terakhir",
        last3Months: "3 bulan terakhir"
      },
      weekdays: {
        mon: "Sen",
        tue: "Sel",
        wed: "Rab",
        thu: "Kam",
        fri: "Jum",
        sat: "Sab",
        sun: "Min"
      }
    },
    filterGrouping: {
      comparisonTitle: "Perbandingan total omzet & penghasilan",
      showData: "Tampilkan data"
    },
    topCommodity: {
      updatedAt: "Diperbarui",
      title: "Top komoditas",
      yourPos: "Pos Anda",
      tooltip:
        "Data komoditas dengan transaksi tertinggi yang ada di area Anda, beserta jumlah STT yang sudah Anda booking.",
      emptyState: {
        header: "Belum ada komoditas",
        message: "Belum ada komoditas yang dapat ditampilkan"
      },
      table: {
        trending: "Trending",
        bookingAtPos: "Booking di POS Anda",
        totalBooking: "Total booking di"
      },
      retry: "Coba lagi"
    },
    metrics: {
      revenue: "Omzet",
      stt: "STT",
      weight: "Berat"
    },
    breakdownFilter: {
      select: "Pilih",
      reset: "Reset",
      apply: "Terapkan",
      searchHere: "Cari {label} disini",
      service: "Layanan",
      channel: "Channel",
      productType: "Jenis pengiriman",
      destinationCity: "Kota tujuan",
      commodity: "Komoditas"
    },
    cardProgress: {
      complete: "Selesaikan",
      activitiesToday: "Aktivitas hari ini"
    },
    cardCollapsibleHanging: {
      followUpOps: "Follow Up ke Ops {username}",
      followUpPartner: "Follow Up ke {name} ({code})",
      followUpUser: "Follow Up ke {username}",
      searchSttWarehouse: "Cari STT di Gudang",
      notSearched: "Belum dicari",
      doneSearchStt: "Selesai cari STT",
      notFollowedUp: "Belum di follow up",
      doneFollowUp: "Selesai di follow up",
      aggregator: "Aggregator",
      days: "Hari",
      sevenOrMoreDays: "≥7 Hari",
      notFound: "Belum Ditemukan",
      foundConsole: "Aktual Paket di Konsol",
      foundPos: "Aktual Paket di POS",
      templateMessage: "Template Pesan",
      confirmDone: "Konfirmasi Selesai",
      awb: "AWB",
      origin: "Origin",
      koli: "Koli",
      bag: "BAG",
      stt: "STT",
      no: "No.",
      bagNo: "No. Baging",
      manifestNo: "No. Manifest",
      sttNo: "No. STT",
      productType: "Jenis pengiriman",
      hanging: "Hanging",
      destinationCity: "Kota tujuan",
      packageStatus: "Status keberadaan paket",
      packageLocation: "Lokasi keberadaan paket",
      confirmDoneTitle: "Konfirmasi selesai?",
      yesDone: "Ya, selesai",
      confirmDoneMessage:
        "Pastikan kamu sudah melakukan follow up atau mencari STT Hanging.",
      cancel: "Batalkan"
    },
    copyTemplate: {
      templateText: "Template Teks",
      greeting: "Halo, saya dari {accountType} Lion Parcel {cityCode}.",
      followUpHanging:
        "Saya ingin follow up AWB dengan status hanging ({groupName}) lebih dari 3 hari.",
      totalAwb: "Total ada {totalAwb} AWB dengan {totalPiece} koli, yaitu:",
      awbItem: "{awbNo} - Asal {origin}",
      helpThanks:
        "Apakah AWB di atas ada di sana? Mohon bantuannya, terima kasih",
      copyText: "Salin teks",
      copiedSuccess: "Berhasil disalin"
    }
  },
  bulkPrintResi: {
    listSttTitle: "Daftar No. STT",
    maxSttHint: "Jumlah maksimum yang dapat diproses adalah 50 STT.",
    placeholderStt: "Masukan No. STT atau scan barcode",
    tagPlaceholder: "Press enter to add No. STT",
    showStt: "Tampilkan No. STT",
    clearAll: "Hapus Semua",
    tableSectionTitle: "Daftar STT Print",
    clientPartnerName: "Nama Client / Partner",
    totalCharge: "Total Biaya",
    printThermalResi: "Print Thermal Resi",
    printThermalResiToPdf: "Print Thermal Resi to PDF",
    printBasicSaveToPdf: "Print Basic/Save to PDF",
    errorSttNotFound: "Data stt tidak ditemukan",
    modalFailedTitle: "Label Gagal Diprint",
    modalFailedMessage:
      "Pastikan semua perangkat Anda telah terhubung. <br/> Cek & coba lagi",
    modalSuccessTitle: "Label Berhasil Diprint",
    modalSuccessMessage: "Anda berhasil mencetak data yang diinginkan",
    columnNo: "No",
    columnNoStt: "No. STT",
    columnNoReferensi: "No. Referensi",
    columnTotalKoli: "Total Koli",
    columnTotalBerat: "Total Berat",
    columnAlamatTujuan: "Alamat Tujuan",
    columnPengirim: "Pengirim",
    columnPenerima: "Penerima",
    columnAsuransi: "Asuransi",
    columnCod: "COD",
    columnBiayaPengiriman: "Biaya Pengiriman",
    columnSurcharge: "Surcharge",
    columnBiayaAsuransi: "Biaya Asuransi",
    columnTotalTarif: "Total Tarif"
  },
  universalPrint: {
    loading: "Permintaan cetak STT sedang diproses"
  },
  printReceipt: {
    grossVolumeWeightKg: "Berat Kotor/volume",
    sttKoli: "STT/Koli",
    listSttLabel: "Daftar No. STT",
    maxSttInfo: "Jumlah maksimum yang dapat diproses adalah 50 STT.",
    sttPlaceholder: "Ketik atau pilih No. STT",
    createInvoice: "Buat Tagihan",
    deleteAll: "Hapus Semua",
    generalInfo: "Informasi Umum",
    partnerName: "Nama Partner",
    createdAt: "Tanggal Dibuat",
    totalTariff: "Total Tarif",
    totalInvoice: "Total Tagihan",
    payInvoice: "Bayar Tagihan",
    printBasic: "Print Basic/Save to PDF",
    send: "Send",
    billed: "Tertagih",
    invoicePaidAuto: "Tagihan Dibayar Otomatis (Cashless)",
    pageTitle: "Cetak Tagihan",
    errorSttNotFound: "{n}/{total} Data stt tidak ditemukan",
    totalTariffLabel: "Total Tarif",
    totalInvoiceLabel: "Total Tagihan",
    modalSendTitle: "Kirim Tagihan",
    emailLabel: "Alamat Email",
    emailPlaceholder: "Masukkan email Anda untuk mengirim tagihan disini",
    emailError: "Masukan Email dengan benar",
    cancel: "Batal",
    sendLabel: "Kirim",
    sendEmailSuccess: "Kirim email berhasil !",
    date: "Tanggal",
    posName: "Nama POS",
    totalResi: "Total Resi",
    totalTariffBeforeDiscount: "Total Tarif Sebelum Diskon",
    totalTariffAfterDiscount: "Total Tarif Setelah Diskon",
    destination: "Tujuan",
    sender: "Pengirim",
    recipient: "Penerima",
    totalKoli: "Total Koli",
    totalWeight: "Total Berat",
    no: "No",
    noStt: "No. STT",
    add: "Tambahkan",
    save: "Simpan",
    destinationAddress: "Alamat tujuan",
    waMessage:
      "Halo {name}, terima kasih telah mempercayakan kebutuhan pengiriman Anda kepada Lion Parcel.\n\nBerikut kami sampaikan ringkasan tagihan layanan yang telah digunakan:\n\nNomor Tagihan: {invoiceNo}\n\nTotal STT: {totalStt}\n\nTotal Tagihan: {totalAmount}\n\nKami mohon kesediaan Anda untuk segera melakukan pelunasan agar layanan pengiriman berikutnya dapat berjalan lancar tanpa kendala.\n\nTerima kasih atas perhatian dan kerja samanya.",
    sendInvoiceError: "Gagal Mengirim Tagihan",
    insurance: "Asuransi",
    codRate: "Biaya COD",
    other: "Lainnya",
    booking: {
      title: "Cetak Tagihan & Resi",
      successBooked: "berhasil di booking",
      checkHistory: "Cek riwayat berhasil untuk cetak tagihan dan resi",
      table: {
        sttNo: "No. STT",
        senderName: "Nama Pengirim",
        shipmentType: "Jenis Pengiriman",
        invoice: "Tagihan",
        paidViaApp: "Dibayar via Aplikasi",
        paidByRecipient: "Dibayar Penerima",
        activity: "Aktivitas",
        chargableWeight: "Berat dikenakan biaya"
      },
      printReceipt: "Print Resi",
      createInvoice: "Buat Tagihan",
      successHistory: "Riwayat Berhasil Booking",
      lastBooking: "Terakhir booking",
      selectAll: "Semua",
      selected: "Terpilih",
      printThermal: "Print Thermal Resi",
      emptyList: "Tidak ada list riwayat booking",
      previewPrint: "Preview Buat Tagihan",
      totalStt: "Jumlah STT",
      totalTariff: "Total Tarif",
      totalInvoice: "Total Tagihan",
      billedTo: "Ditagihkan ke",
      selectBillingRecipient: "Pilih tujuan penagihan",
      notes: "Catatan",
      notePlaceholder: "Masukkan catatan untuk penerima tagihan",
      cancel: "Batalkan",
      failedFetchList: "Gagal mengambil data riwayat berhasil booking !"
    }
  },
  pickupAddress: {
    common: {
      primary: "Utama",
      coordinates: "Titik koordinat",
      select: "Pilih",
      delete: "Hapus",
      back: "Kembali",
      cancel: "Batalkan"
    },
    savedList: {
      title: "Daftar alamat tersimpan",
      edit: "Ubah",
      setPrimary: "Jadikan alamat utama",
      add: "Tambah alamat"
    },
    deleteConfirmation: {
      title: "Hapus alamat ini?",
      message: "Anda akan kehilangan alamat ini dari daftar alamat tersimpan."
    },
    form: {
      addTitle: "Tambah alamat baru",
      editTitle: "Ubah alamat",
      addressName: "Nama alamat",
      addressNamePlaceholder: "Masukkan nama alamat",
      picName: "Nama PIC",
      picNamePlaceholder: "Masukkan nama PIC",
      phoneNumber: "Nomor handphone",
      district: "Kecamatan, kota",
      districtPlaceholder: "Ketik atau pilih kecamatan, kota",
      pickupAddress: "Alamat Pick Up",
      pickupAddressPlaceholder: "Masukkan alamat Pick Up",
      coordinates: "Titik koordinat Google Maps",
      coordinatesPlaceholder: "Contoh: -6.18959, 106.76477",
      findLocation: "Cari titik",
      setPrimary: "Jadikan alamat utama",
      submit: "Kirim"
    },
    guide: {
      link: "Cek panduan",
      title: "Cek titik lokasi koordinat",
      openMapsPrefix: "Buka",
      googleMaps: "google maps",
      openMapsSuffix: "di laptop/komputer Anda.",
      searchLocation: "Cari & pilih lokasi alamat Pick Up.",
      copyCoordinates:
        "Klik kanan pada lokasi & klik kiri pada titik koordinat.",
      coordinatesExample: "(Contoh: -6.18959, 106.76477)",
      enterCoordinates:
        "Masukkan titik koordinat ke form yang telah disediakan."
    },
    success: {
      addedTitle: '"{name}" berhasil ditambah',
      editedTitle: '"{name}" berhasil diubah',
      message: "Sekarang Anda bisa pakai alamat ini untuk Pick Up.",
      button: "Oke, mengerti"
    }
  },
  receipt: {
    createdAt: "dibuat",
    createdAtV2: "dibuat",
    estimation: "estimasi",
    ref: "Ref",
    shipper: "pengirim",
    receiver: "penerima",
    destination: "kota tujuan",
    home: "rumah",
    office: "kantor",
    goodsValue: "good value",
    totalCost: "total biaya",
    shippingCost: "biaya kirim",
    shippingCostV2: "B. Kirim",
    insurance: "asuransi",
    totalWeight: "total berat",
    chargeableWeight: "Berat\nDitagihkan",
    taxBm: "Pajak/BM",
    others: "lain-lain",
    othersV2: "B. Lainnya",
    downloadApps:
      "Download Aplikasi Lion Parcel melalui Appstore atau Playstore dan lacak paketmu sekarang!",
    toc: "S&K : lionparcel.com/sk",
    goodValue: "good value",
    currencyDisplayGoodValue: "{value} USD",
    goodsPrice: "harga barang",
    returnFee: "biaya retur",
    returnFeeV2: "B. Retur",
    returnFeeV3: "Est. Retur",
    estTax: "Est. Pajak",
    returnCost: "total retur",
    codFee: "Biaya COD",
    dfodFee: "Biaya DFOD",
    returStatement: "*jika terjadi retur",
    senderPage: "Lembar Pengirim",
    terms: "Syarat & ketentuan berlaku.",
    info: "Info lebih lanjut: https://lionparcel.com/sk",
    infoTracking: "untuk mengetahui\nstatus pengiriman\npaketmu!",
    infoTrackingPrn: {
      info1: "Ingin tahu status",
      info2: "paketmu? Yuk lacak",
      info3: "secara real-time!",
      info4: ""
    },
    scanHere: "scan di sini",
    customSla: "*Diluar SLA Bea Cukai",
    no: "No.",
    productName: "Name Produk",
    variant: "Varian",
    quantity: "Qty",
    trackPackageHere: "Lacak Paketmu\nDisini"
  },
  tagihan: {
    pageTitle: "Tagihan",
    createTitle: "Buat Tagihan",
    editTitle: "Edit Tagihan",
    detailTitle: "Rincian Tagihan",
    searchPlaceholder: "Cari Tagihan ID, Nama Tertagih",
    selectStatus: "Pilih Status",
    emptyTitle: "Tidak ada tagihan",
    emptyDescription: "Tagihan akan muncul di sini jika sudah tersedia.",
    errorGetDetail: "Gagal Mendapatkan Detail Tagihan",
    table: {
      no: "No",
      invoiceId: "Tagihan ID",
      billedTo: "Ditagihkan ke",
      totalAmount: "Total Tagihan",
      totalPaid: "Sudah Dibayar",
      status: "Status",
      activities: "Aktivitas",
      createdAt: "Tanggal Dibuat",
      updatedAt: "Tanggal Diperbarui",
      action: "Atur",
      noStt: "No. STT",
      recipient: "Penerima",
      destinationCity: "Kota Tujuan",
      productType: "Jenis Pengiriman",
      totalTariff: "Total Tarif",
      paidByRecipient: "Dibayar Penerima",
      paidViaApp: "Dibayar via Aplikasi"
    },
    status: {
      all: "Semua",
      unpaid: "Belum Lunas",
      partiallyPaid: "Lunas Sebagian",
      paid: "Lunas"
    },
    activity: {
      printInvoice: "Print Tagihan",
      sendInvoice: "Kirim Tagihan"
    },
    action: {
      editInvoice: "Edit Tagihan",
      updatePaid: "Update Lunas",
      sendInvoice: "Kirim Tagihan",
      downloadPdfA4: "Download PDF (A4)",
      downloadPngA4: "Download PNG (A4)",
      downloadPdfStruk: "Download PDF (Ukuran struk)"
    },
    form: {
      email: "Email",
      sender: "Pengirim",
      totalStt: "Total STT",
      totalTariff: "Total Tarif",
      totalAmount: "Total Tagihan",
      billedTo: "Ditagihkan ke",
      note: "Catatan",
      optional: "(Opsional)",
      notePlaceholder: "Masukkan catatan untuk penerima tagihan",
      sendTo: "Kirim Ke",
      close: "Tutup",
      moreSenders: "+{n} Lainnya",
      selectBilledTo: "Pilih tujuan penagihan",
      saveInvoice: "Simpan Tagihan",
      createInvoice: "Buat Tagihan",
      confirmCreateTitle: "Yakin Buat Tagihan?",
      confirmCreateMessage:
        "Pastikan semua STT dan total tagihan sudah sesuai.",
      cancel: "Batal"
    },
    modal: {
      updateLunas: "Update Lunas",
      invoiceInfo: "Informasi Tagihan",
      paymentHistory: "Riwayat Pelunasan",
      payment: "Pembayaran",
      remainingAmount: "Sisa tagihan",
      amountExceeds: "Nominal melebihi sisa tagihan",
      updateInvoice: "Update Tagihan",
      successCreate: "Tagihan Berhasil Dibuat",
      successUpdate: "Berhasil Update Tagihan",
      totalAmount: "Total Tagihan",
      remainingLabel: "Sisa Tagihan",
      close: "Tutup",
      downloadInvoice: "Download Tagihan",
      downloadPdfA4: "PDF (A4)",
      downloadPngA4: "PNG (A4)",
      downloadStruk: "PDF (Ukuran struk)",
      successSendTitle: "Tagihan Berhasil Dikirim",
      sendTo: "Kirim ke",
      via: "Via",
      format: "Format"
    },
    pdf: {
      billedTo: "Ditagihkan ke",
      createdBy: "Dibuat Oleh",
      createdAt: "Tanggal Dibuat",
      totalStt: "Total STT",
      totalAmount: "Total Tagihan",
      balanceDue: "Sisa Tagihan",
      note: "Catatan",
      no: "No",
      sttNo: "Nomor STT",
      recipient: "Penerima",
      productType: "Jenis Pengiriman",
      chargeableWeight: "Berat dikenakan biaya",
      totalTariff: "Total Tarif"
    },
    create: {
      selectCustomer: "Pilih Pelanggan",
      sttType: "Jenis STT",
      sttTypePlaceholder: "Pilih Jenis STT",
      serviceType: "Tipe Layanan",
      serviceTypePlaceholder: "Pilih Tipe Layanan",
      service: "Layanan",
      sttNo: "No. STT",
      sttInputPlaceholder: "Ketik atau pilih No. STT",
      datePlaceholder: "Pilih Tanggal",
      namePlaceholder: "Nama atau No. HP",
      add: "Tambahkan",
      notYetAdded: "Belum ditambahkan",
      save: "Simpan",
      inputEmail: "Masukkan Email",
      inputWhatsappNumber: "Masukkan No. WhatsApp",
      mandatoryEmail: "Email harus diisi.",
      mandatoryWhatsapp: "Nomor WhatsApp harus diisi.",
      formatEmail: "Format email tidak valid",
      formatWhatsapp: "Format nomor WhatsApp tidak valid",
      alreadyAddedEmail: "Email sudah ditambahkan.",
      alreadyAddedWhatsapp: "Nomor WhatsApp sudah ditambahkan.",
      formatBill: "Format tagihan",
      selectFormat: "Pilih format",
      mandatoryFormat: "Format harus dipilih."
    },
    sender: "Pengirim",
    client: "Klien",
    whatsappMessage: `Halo {name}, terima kasih telah mempercayakan kebutuhan pengiriman Anda kepada Lion Parcel.

Berikut kami sampaikan ringkasan tagihan layanan yang telah digunakan:

Nomor Tagihan: {invoiceNo}

Total STT: {totalStt}

Total Tagihan: {totalAmount}

Kami mohon kesediaan Anda untuk segera melakukan pelunasan agar layanan pengiriman berikutnya dapat berjalan lancar tanpa kendala.

Terima kasih atas perhatian dan kerja samanya.`
  },
  breadcrumb: {
    pusatResolusi: "Pusat Resolusi",
    home: "Home",
    notification: "Notifikasi",
    seeAllMessages: "Lihat semua pesan",
    noMessagesToShow: "Belum ada pesan yang dapat ditampilkan",
    profile: "Profil",
    active: "Active",
    inactive: "Inactive"
  },
  notification: {
    searchPlaceholder: "Cari pesan",
    loading: "Loading.......",
    emptyNoResult: "Tidak ada hasil yang ditemukan",
    emptyNoResultDescription:
      "Apa yang Anda cari tidak ditemukan atau tidak ada.",
    emptyNoMessage: "Belum ada pesan yang dapat ditampilkan",
    mainNews: "Berita Utama",
    download: "Download",
    filterNewest: "Paling Baru",
    filterOldest: "Paling Lama",
    timezone: "WIB",
    sharedNewsPrefix: "membagikan berita baru :",
    loginRequest: "Permintaan Login",
    from: "dari",
    reject: "Tolak",
    accept: "Terima",
    actionAccepted: "Diterima",
    actionRejected: "Ditolak",
    actionAcceptVerb: "terima",
    actionRejectVerb: "tolak",
    loginRequestHandled:
      "Permintaan login <b>{accountName}</b> telah Anda {action}.",
    okUpper: "OKE",
    failedProcessTitle: "Gagal diproses",
    tryAgain: "Coba lagi",
    back: "Kembali",
    confirmRejectTitle: "Tolak permintaan login?",
    confirmAcceptTitle: "Terima permintaan login?",
    confirmRejectMessage:
      "Apakah kamu yakin ingin tolak permintaan login untuk user ini?",
    confirmAcceptMessage:
      "Ketika permintaan login diterima, user akan memiliki akses ke genesis",
    confirmActionButton: "Ya, {action}",
    cancel: "Batalkan",
    kemarin: "Kemarin",
    hariIni: "Hari Ini"
  },
  integration: {
    breadcrumb: "Integrasi API",
    title: "Generate New Token",
    subtitle: "Generate token to connect your app to Lion Parcel.",
    ok: "OK",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    copy: "Copy",
    generate: "Generate",
    contactHelp: "Is there a problem when generating token? Please contact",
    systemErrorTryAgain: "There was an error in our system, please try again",
    tryAgain: "Try Again",
    clientIdCopied: "Client ID successfully copied",
    clientSecretCopied: "Client Secret successfully copied",
    promptSuccess:
      "Token successfully created, please use it to connect app plugin.",
    promptExpired: "Client ID & Client Secret expired, please generate again.",
    errorGenerateMessage:
      "There was an error in our system, <br> please generate again.",
    errorGenerateTitle: "Token Generated Failed!",
    trackPackageHere: "Lacak Paketmu\nDisini",
    productTable: {
      no: "No.",
      name: "Nama Produk",
      variant: "Varian",
      qty: "Qty"
    },
    customSla: "*Diluar SLA Bea Cukai"
  },
  shipmentRates: {
    titleAddressOriginDestination: "Alamat Asal & Tujuan",
    titleShipmentType: "Produk Pengiriman",
    titleCommodityType: "Jenis Komoditas",
    placeholderSelectCommodity: "Ketik atau pilih nama komoditas",
    titleWeight: "Berat/Paket",
    titleDimensionPackage: "Dimensi Paket",
    titleDimensionSuffix: "P x L x T",
    titleItemPrice: "Harga Barang",
    placeholderItemPrice: "e.g 20.000",
    titlePrefixItemPrice: "IDR",
    titleButtonCheckRates: "Cek Tarif",
    titleToggleFilterOpen: "Hide",
    titleToggleFilterClose: "Show",
    errorMaximalWeight: "Maksimal berat",
    titleMenuDownload: "Download Tarif",
    subtitleMenuDownload:
      "Gunakan Download Tarif untuk membandingan antara tarif client dan partner. Sebelum mendownload, pastikan kembali semua data sudah terisi dengan benar dan sesuai.",
    titleRouteName: "Cek Tarif",
    placeholderOrigin: "Ketik atau pilih lokasi awal",
    placeholderDestination: "Ketik atau pilih destinasi",
    defaultOptionProduct: "Semua Produk",
    defaultOptionCommodity: "Semua Komoditas",
    emptyListMessage: "Belum ada data cek tarif yang dapat ditampilkan",
    titleDownloadSuccess: "Download Tarif Berhasil",
    titleNotFoundRates: "Harga tidak ditemukan",
    codYes: "Yes",
    codNo: "No",
    tooltipSLA:
      "SLA ini adalah level kota.<br />Akan ada peningkatan sistem SLA level<br />district atau alamat tujuan",
    detailRates: {
      commodity: "Komoditas",
      product: "Produk",
      shipmentRates: "Total Tariff",
      shipmentTime: "Estimasi Pengiriman Level Kota",
      clientPartner: "Client/Partner",
      baseRate: "Base Rate",
      heavyweightSurcharge: "Heavyweight Surcharge",
      commodityRate: "Commodity Rate",
      documentSurcharge: "Document Surcharge",
      originForwardRate: "Origin Forward Rate",
      publishRate: "Publish Rate",
      shippingSurcharge: "Shipping Surcharge",
      destinationForwardRate: "Destination Forward Rate"
    },
    embargo: "Embargo",
    errorOttopackNotAllProduct:
      "Biaya Pengiriman untuk produk yang Anda pilih tidak termasuk Asuransi",
    errorOttopackAllProduct:
      "Biaya Pengiriman untuk produk OTOPACK150 dan OTOPACK250 tidak termasuk Asuransi",
    errorFullEmbargo:
      "Alamat asal & tujuan yang Anda pilih sedang dalam Embargo.",
    errorPartialEmbargo:
      "Beberapa komoditas pada alamat asal & tujuan yang Anda pilih sedang dalam Embargo.",
    titleAddressOrigin: "Kota Asal",
    titleAddressDestination: "Kota Tujuan",
    detailTitle: "Detail Tarif",
    baseRate: "Base Rate",
    commodityRate: "Commodity Rate",
    documentSurcharge: "Document Surcharge",
    heavyweightSurcharge: "Heavyweight Surcharge",
    clientPartner: "Client/Partner",
    codReturnTooltip: "Biaya akan dibayarkan ketika paket dikembalikan",
    promoUntil: "sampai dengan",
    columnServiceType: "Produk",
    columnCommodity: "Komoditas",
    columnClientPartnerName: "Nama Client/Partner",
    columnBaseRate: "Base Rate",
    columnCommodityRate: "Commodity Rate",
    columnHeavyweightSurcharge: "Heavyweight Surcharge",
    columnDocumentSurcharge: "Document Surcharge",
    columnShipmentTime: "Estimasi SLA Level Kota",
    columnDfodFee: "Biaya DFOD",
    columnCodFee: "Biaya COD",
    columnCodReturnFee: "Biaya Retur COD",
    columnTotalCost: "Total Tarif",
    retail: "Retail",
    confirmExitTitle: "Yakin ingin keluar?",
    confirmExitMessage:
      "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
    confirmExitButton: "Keluar",
    confirmBackButton: "Kembali",
    bookingButton: "+ Booking Pengiriman",
    columnCod: "COD",
    actionBooking: "Booking",
    slaDaySuffixId: "Hari",
    slaDaySuffixEn: "Working days",
    until: "Sampai dengan",
    download: {
      downloadDescTop:
        "Sebelum mendownload daftar manual STT, pastikan kembali daftar",
      downloadDescBot:
        "client/partner sudah benar dan sesuai dengan status masing-masing."
    },
    allClient: "Semua Client/Pa...",
    allStatus: "Semua Status"
  },
  userManagement: {
    pageTitle: "Manajemen User",
    list: {
      title: "User Management",
      searchPlaceholder: "Cari username atau user ID",
      createUser: "Buat User",
      emptyData: "data User",
      filter: {
        filter: "Filter",
        reset: "Reset",
        accountType: "Tipe Akun",
        reference: "Reference",
        hub: "Hub",
        division: "Divisi",
        status: "Status",
        selectAccountType: "Pilih tipe akun",
        selectReference: "Pilih reference",
        selectHub: "Pilih hub",
        selectDivision: "Pilih divisi",
        selectStatus: "Pilih status"
      },
      column: {
        userId: "User ID",
        username: "Username",
        email: "Email",
        phoneNumber: "No. handphone",
        accountType: "Tipe akun",
        division: "Divisi",
        reference: "Referensi",
        role: "Role",
        hub: "Hub",
        shuttle: "Shuttle",
        accountStatus: "Status akun"
      }
    },
    detail: {
      userId: "User ID",
      username: "Username",
      accountType: "Tipe Akun",
      division: "Divisi",
      role: "Role",
      assignedTo3lc: "Ditugaskan ke 3LC",
      all3lc: "Semua",
      phoneNumber: "No. Hp",
      email: "Email",
      reference: "Referensi",
      shuttle: "Shuttle",
      hub: "Hub",
      hubCode: "Hub Code",
      hubName: "Hub Name",
      createdAt: "Tanggal Dibuat",
      updatedAt: "Tanggal Diubah",
      accountStatus: "Status Akun",
      edit: "Ubah",
      resetPassword: "Reset Password",
      noHub: "Tanpa hub",
      deviceInfo: "Informasi perangkat Anda",
      confirmed: "Dikonfirmasi"
    },
    edit: {
      title: "Edit User",
      save: "Simpan",
      username: "Username",
      email: "Email",
      phoneNumber: "No. Hp",
      accountType: "Tipe Akun",
      role: "Role",
      reference: "Reference",
      accountStatus: "Status Akun",
      accountStatusDescription:
        "Akun dengan status yang aktif dapat digunakan login oleh user. Kamu dapat mengaktifkan atau menonaktifkan akun kapan saja.",
      accountActive: "Aktif",
      accountInactive: "Tidak Aktif",
      statusUser: "Status User",
      createdAt: "Tanggal Dibuat",
      lastUpdated: "Terakhir Diubah",
      modalDeactivateTitle: "Non-aktifkan Akun",
      modalDeactivateMessage:
        "Selama user berstatus non-aktif maka akun tidak dapat digunakan untuk login",
      modalActivateTitle: "Aktifkan Akun",
      modalActivateMessage:
        "Selama user berstatus aktif maka akun dapat digunakan untuk login",
      modalDeactivate: "Non-aktifkan",
      modalActivate: "Aktifkan",
      back: "Kembali",
      modalSuccessTitle: "Perubahan Disimpan",
      modalConfirmTitle: "Konfirmasi Perubahan Akun",
      modalConfirmMessage:
        "Anda yakin akan menyimpan perubahan akun dengan nama {name}",
      modalLeaveTitle: "Yakin ingin keluar?",
      modalLeaveMessage:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      leave: "Keluar",
      ok: "Oke",
      modalSuccessMessage: "User dengan nama {name} berhasil diubah"
    },
    modalEditDetail: {
      oldEmail: "Email Lama",
      newEmail: "Email Baru",
      placeholderNewEmail: "Masukan email baru",
      active: "Aktif",
      inactive: "Nonaktif",
      statusInfo:
        "Akun yang tidak aktif tidak dapat melakukan aktivitas apapun sampai akun diaktifkan kembali. Anda dapat mengubah status kapan saja.",
      selectRole: "Pilih Role",
      modal3lcTitle: "3LC Origin Terpilih",
      cityOptionName: "kota",
      all: "Semua",
      searchOrSelect3lc: "Cari atau pilih 3LC",
      selectHub: "Pilih hub",
      selectDivision: "Pilih divisi",
      selectShuttle: "Pilih shuttle",
      save: "Simpan",
      noShuttle: "Tanpa shuttle",
      titleStatus: "Ubah Status Akun",
      titleEmail: "Ubah Email",
      titleRole: "Ubah Role",
      title3lc: "Ubah ditugaskan ke 3LC",
      titleDefault: "Ubah",
      confirmStatusTitle: "Konfirmasi {action}",
      activation: "Pengaktifan",
      deactivation: "Penonaktifan",
      statusInactiveMessage:
        "Akun yang tidak aktif tidak dapat melakukan aktivitas apapun sampai akun diaktifkan kembali.",
      back: "Kembali",
      activate: "Aktifkan",
      deactivate: "Nonaktifkan",
      payloadTypeStatusAccount: "Status Akun",
      statusSuccess: "{action} status berhasil !",
      payloadTypeEmail: "Email",
      confirmChangeTitle: "Konfirmasi Perubahan",
      confirmChangeMessage:
        "Anda yakin akan menyimpan perubahan detail Akun dengan username “{username}” ?",
      confirmHubTitle: "Konfirmasi perubahan data hub",
      confirmHubMessage: "Apakah Anda yakin data hub yang diubah sudah benar?",
      yesSave: "Ya, simpan",
      confirmDivisionTitle: "Konfirmasi perubahan data divisi",
      confirmDivisionMessage:
        "Apakah Anda yakin data divisi yang diubah sudah benar?",
      confirmShuttleTitle: "Konfirmasi perubahan data shuttle",
      confirmShuttleMessage:
        "Apakah Anda yakin data shuttle yang diubah sudah benar?",
      hubUpdatedTitle: "Data Hub berhasil diperbarui",
      ok: "Ok",
      emailUpdatedSuccess: "Perubahan email berhasil !",
      roleUpdatedSuccess: "Perubahan role berhasil !",
      roleUpdateFailed: "Role Gagal Diubah !",
      assigned3lcConfirmTitle: "Ubah penugasan 3LC ini?",
      assigned3lcConfirmMessage:
        "Pastikan data user yang Anda ubah telah benar.",
      assigned3lcUpdatedTitle: "3LC akun berhasil diperbarui",
      assigned3lcUpdatedMessage:
        "Akses akun “{accountId}” untuk 3LC “{assigned3lc}” sudah bisa diperbarui."
    },
    resetPassword: {
      modalTitle: "Konfirmasi Perubahan",
      modalMessage:
        'Anda baru saja mengajukan pengaturan ulang password baru. Password baru akan kami kirimkan ke email <span class="text-blue-600 underline">{email}</span>.',
      cancel: "Kembali",
      submit: "Reset",
      successMessage:
        "Pengaturan ulang password baru berhasil. Password baru telah terkirim ke {email}",
      errorTitle: "Reset Password Gagal"
    },
    add: {
      pageTitle: "Buat User",
      title: "Buat User Baru",
      save: "Simpan",
      accountType: "Tipe Akun",
      selectAccountType: "Pilih tipe akun",
      division: "Divisi",
      selectDivision: "Pilih divisi",
      reference: "Referensi",
      selectReference: "Pilih reference",
      role: "Role",
      selectRole: "Pilih role",
      hub: "Hub",
      selectHub: "Pilih hub",
      shuttleOptional: "Shuttle (opsional)",
      selectShuttle: "Pilih shuttle",
      assignedTo3lc: "Ditugaskan ke 3LC",
      modal3lcTitle: "3LC Origin Terpilih",
      all3lc: "Semua 3LC",
      searchOrSelect3lc: "Cari atau Pilih 3LC",
      username: "Username",
      placeholderUsername: "Masukkan nama user",
      usernameFormatInvalid: "Format username tidak sesuai",
      usernameRule1: "Username hanya boleh berisi huruf dan tanda titik.",
      usernameRule2:
        "Username akan digunakan untuk proses login dengan format:",
      email: "Email",
      placeholderEmail: "e.g email{'@'}gmail.com",
      phoneNumber: "No. handphone",
      placeholderPhone: "e.g 2112341234",
      emailInvalid: "Email yang anda masukkan salah",
      emailDomainInvalid: "Email domain tidak terdaftar dan valid",
      modalSuccessTitle: "Buat User Baru Selesai",
      all: "Semua",
      modalSuccessMessage: "User dengan nama {name} berhasil dibuat",
      confirmLeaveTitle: "Yakin ingin keluar?",
      confirmLeaveMessage:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      leave: "Keluar",
      back: "Kembali",
      confirmCreateTitle: "Konfirmasi Pembuatan User",
      confirmCreateMessage: "Anda yakin akan menyimpan user dengan nama {name}",
      ok: "Oke",
      errorTitle: "Buat User Gagal"
    }
  },
  posBranch: {
    pageTitle: "Daftar POS Cabang & Di Pickup",
    list: {
      searchPlaceholder: "Cari nama POS",
      createPos: "Buat POS",
      emptyMessage: "Belum ada data Pos yang dapat ditampilkan",
      column: {
        no: "No.",
        posCode: "Kode POS",
        posName: "Nama POS",
        posType: "Tipe POS",
        districtCity: "Kecamatan, Kota",
        lastTransaction: "Transaksi terakhir",
        balanceAvailable: "Saldo Tersedia",
        partnerAreaName: "Nama Partner Area",
        contractStatus: "Status Kontrak",
        partnerStatus: "Status Partner",
        action: "Action"
      },
      filter: {
        filter: "Filter",
        reset: "Reset",
        contractStatus: "Status Kontrak",
        partnerStatus: "Status Partner",
        posType: "Tipe POS",
        selectStatus: "Pilih status",
        selectPosType: "Pilih tipe",
        originCity: "Kota asal"
      },
      contractStatus: {
        active: "Active",
        waiting: "Waiting",
        nearlyExpired: "Nearly Expired",
        expired: "Expired"
      },
      posType: {
        parent: "POS Parent",
        branch: "POS Child",
        pickup: "POS Dipickup"
      },
      status: {
        freezed: "Freezed",
        notFreezed: "-",
        active: "Aktif",
        inactive: "Tidak Aktif"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze"
      }
    },
    detail: {
      pageTitle: "Daftar POS Cabang & Di Pickup | Detail",
      title: "Detail POS Cabang",
      contractStatus: "Status Kontrak",
      partnerStatus: "Status Partner",
      balanceAvailable: "Saldo Tersedia",
      tierLevel: "Tier Level",
      createdAt: "Tanggal Dibuat",
      updatedAt: "Tanggal Diubah",
      qrCode: "QR Code",
      tab: {
        parent: "Detail POS Induk",
        branchList: "Daftar POS Cabang & Di Pickup"
      },
      status: {
        freezed: "Freezed"
      },
      action: {
        freeze: "Freeze",
        unfreeze: "Unfreeze",
        edit: "Ubah",
        downloadQr: "Download QR Code"
      },
      contact: {
        title: "Informasi Kontak",
        name: "Nama",
        phone: "No. Telepon",
        jobTitle: "Jabatan",
        email: "Email"
      }
    }
  },
  modalButtonBackTitle: "Kembali",
  modalButtonTryAgainTitle: "Coba Lagi",
  errorNotFoundMessage: "Cek dan atur ulang filter yang Anda cari.",
  errorNotFoundTitle: "Filter tidak ditemukan",
  errorKeywordCaseNotFoundMessage: "Silahkan cari dengan kata kunci lainnya",
  errorKeywordCaseNotFoundTitle: "Tidak Menemukan Data Transaksi",
  invoice: {
    date: "tanggal",
    shipperName: "nama pengirim",
    shipperPhone: "telepon pengirim",
    shipperAddress: "alamat pengirim",
    conssigneeID: "ID penerima",
    conssigneeName: "nama penerima",
    conssigneePhone: "telepon penerima",
    conssigneeAddress: "alamat penerima",
    postCode: "kode pos",
    dutyTaxTerms: "Duty & Tax Terms",
    signatureOfShipper: "Tanda Tangan Pengirim",
    itemDescription: "Item Description/ Komoditi",
    unitValue: "Unit Value/Harga Barang",
    qty: "Quantity/Jumlah",
    totalValue: "Total Value/Total Harga Barang",
    weight: "Weight/Berat",
    note:
      "*Note : Publish rate not include tax fee (Ongkos kirim tidak termasuk biaya pajak)",
    term:
      "I declare all the information contained in this invoice to be true and correct, and i am willing to bear\nany cost if the information is incorrect. (Saya menyatakan semua informasi yang berada di invoice\nini adalah benar dan saya bersedia menanggung biaya jika informasi yang saya berikan salah)",
    commodity: "komoditas",
    HSCODE: "HSCODE",
    unitValueGoods: "unit value goods",
    totalItem: "total item",
    totalValueGoods: "total value goods",
    totalWeight: "total weight",
    totalKoli: "Total Koli"
  },
  placeholderDatePicker: "Pilih Tanggal",
  showFilter: "Lihat",
  hideFilter: "Sembunyikan",
  showingPagination: "Menampilkan",
  cnManifest: {
    pageTitle: "Manifest CN",
    filterTypeSttListing: "Tipe STT Listing",
    filterTypeUser: "Tipe User",
    filterPartner: "Nama Client/Partner/Customer",
    filterDestinationCity: "Kota Tujuan",
    placeholderDestinationCity: "Ketik atau pilih kota tujuan",
    placeholderSttNo: "Ketik atau pilih No. STT",
    placeholderClientPartner: "Ketik atau pilih nama client/partner",
    filterDateStart: "Dimulai Dari",
    filterDateEnd: "Sampai",
    errorInvalidStartDate: "Tanggal mulai tidak boleh lebih dari tanggal akhir",
    errorInvalidDuration: "Periode booking yang dapat dipilih max 14 hari",
    errorInvalidEndDate: "Tanggal akhir tidak boleh kurang dari tanggal mulai",
    emptyListMessage: "Belum ada data cek tarif yang dapat ditampilkan",
    buttonSearch: "Cari",
    buttonExportCsv: "Export ke CSV",
    exportError: "Unduh Gagal !",
    columnNo: "No.",
    columnBookingDate: "Tanggal Booking",
    columnNoStt: "No. STT",
    columnDestinationCity: "Kota Tujuan",
    columnTotalPiece: "Total Koli",
    columnTotalWeight: "Total Berat",
    columnTotalVolume: "Total Volume",
    columnProduct: "Produk",
    columnRecipient: "Penerima",
    columnRecipientAddress: "Alamat Penerima",
    columnRecipientPhone: "No. Telp Penerima",
    columnCommodityType: "Tipe Komoditas",
    columnHsCode: "HS Code",
    columnNpwp: "NPWP",
    columnItemPrice: "Harga Barang",
    columnBm: "BM",
    columnPpn: "PPN",
    columnPph: "PPH",
    columnTotalGoodTax: "Total Good Tax",
    columnTaxImposition: "Pengenaan Pajak",
    columnStatus: "Status",
    columnBookedBy: "Booked By",
    columnTotalAmount: "Total Amount",
    sttListingTypeBookingDate: "Tanggal Booking",
    sttListingTypeSttList: "No. STT / No. Ref",
    filterDestinationCityAll: "Semua",
    tagPlaceholderStt: "Tekan enter untuk menambah No. STT",
    userTypeConsole: "Consolidator",
    userTypeSubconsole: "Subconsolidator",
    userTypePos: "POS",
    userTypeClient: "Client",
    userTypeCustomer: "Customer"
  },
  placeholderSTTColumn: "Cari No. STT",
  placeholderCargoColumn: "Cari No. Kargo",
  shortland: {
    title: "Shortland",
    searchPlaceholder: "Cari No. STT genesis/elexys",
    timeRangeCustom: "custom",
    timeRangeToday: "hari ini",
    timeRangeLast7Days: "7 hari terakhir",
    timeRangeLast14Days: "14 hari terakhir",
    downloadButton: "Download Shortland",
    emptyMessage: "Belum ada Shortland yang dapat ditampilkan",
    table: {
      no: "No.",
      cargoNo: "No. Kargo",
      cargoType: "Tipe Kargo",
      sttNoElexys: "No. STT Elexys",
      sttNoGenesis: "No. STT Genesis",
      sttNoPiecesGenesis: "No. STT Pieces Genesis",
      destinationCity: "Kota Tujuan",
      commodity: "Komoditas",
      koli: "Koli",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    },
    csv: {
      no: "No",
      cargoNo: "No. Kargo",
      cargoType: "Tipe Kargo",
      sttNoElexys: "No. STT Elexys",
      sttNoGenesis: "No. STT Genesis",
      sttNoPiecesGenesis: "No. STT Pieces Genesis",
      sttNo: "No. STT",
      sttNoPieces: "No. STT Pieces",
      arrivalCity: "Kota Kedatangan",
      commodity: "Komoditas",
      koli: "Koli",
      grossWeight: "Gross Weight",
      volumeWeight: "Volume Weight"
    }
  },
  trackingCargo: {
    trackingSTTTabTitle: "Tracking STT",
    trackingCargoTabTitle: "Tracking Kargo",
    buttonTracking: "Lacak",
    buttonPrintReceipt: "Print Resi",
    buttonShowDetailStt: "Detail",
    sttDetailTitle: "Detail STT",
    titleToggleFilterOpen: "Sembunyikan",
    titleToggleFilterClose: "Selengkapnya",
    bookedBy: "Dibooking oleh",
    bookedFor: "Dibooking untuk",
    bookedAtLabel: "Dibooking",
    sttDetailInfo: {
      detailShipperName: "Nama Pengirim",
      detailRecipientName: "Nama Penerima",
      detailDistrictOriginCity: "Kecamatan, Kota Asal",
      detailDistrictDestinationCity: "Kecamatan, Kota Tujuan"
    },
    columnsSttDetail: {
      colNoSttGenesis: "No. STT Genesis",
      colNoSttElexys: "No. STT Elexys",
      colNoStt: "No. STT",
      colStatusPayment: "Status Pembayaran",
      colPieces: "Koli",
      colCurrentStatus: "Status Terkini",
      colCurrentStatusForModal: "Status terakhir",
      colResponse: "Sanggahan",
      colShipmentType: "Produk Pengiriman",
      colShipmentTime: "Estimasi",
      colShipmentTimeForModal: "Estimasi pengiriman",
      colChargeableWeight: "Berat Dikenakan Biaya",
      colAssessmentStatus: "Status adjusment"
    },
    paymentStatus: {
      cod: "Pembayaran COD",
      unpaid: "Kurang Bayar",
      paid: "Sudah Lunas"
    },
    assessmentStatus: {
      waiting: "Menunggu",
      rejected: "Ditolak",
      approved: "Diterima"
    },
    timeInternational: "(Waktu Internasional)",
    timeInternationalLabel: "Waktu<br/>Internasional",
    proofPodLink: "Lihat bukti pengiriman",
    proofAdjustBookLink: "Lihat bukti foto perubahan berat",
    reportIssue: "Lapor Kendala",
    needRelabel: "Perlu relabel",
    customerRequestRts: "Customer meminta RTS",
    printThermalReceipt: "Print Thermal Resi",
    printThermalReceiptPdf: "Print Thermal Resi PDF",
    printBasicSavePdf: "Print Basic/Save to PDF",
    detailCargoTitle: "Detail Kargo",
    cargoOriginCity: "Kota Asal",
    cargoDestCity: "Kota Tujuan",
    cargoDestType: "Tipe Kota Tujuan",
    cargoHistoryTitle: "Riwayat Pengiriman",
    colCargoNo: "No. Kargo",
    colStatus: "Status",
    colTotalStt: "Total STT",
    sttHistoryTitle: "Riwayat Pengiriman",
    sttHistoryTitleLowerCase: "Riwayat pengiriman",
    columnHistoryStatus: {
      colStatusDate: "Tanggal Status",
      colCurrentStatus: "Status Terkini",
      colPieces: "Koli",
      colLocation: "Lokasi",
      colRemarks: "Keterangan"
    },
    error: {
      errMessageEmptyTitle: "Oops.. detail tracking tidak tersedia",
      errMessageEmpty: "data STT",
      errDataNotFoundTitle: "Data Tidak Ditemukan",
      errDataNotFoundMsg: "Maaf, data yang Anda cari tidak ditemukan.",
      errMessageEmptyCargo: "Data Cargo",
      errUnusedTitle: "STT Belum Digunakan",
      errUnusedMsg: "STT yang Anda cari belum digunakan atau <i>unused</i>."
    },
    sttReturn: "Pengganti",
    sttBefore: "Sebelumnya",
    sttElexys: "Elexys",
    customToday: "custom, hari ini, 7 hari terakhir, bulan ini",
    deliveryStatus: "Status Pengiriman",
    deliveryType: "Tipe Pengiriman",
    performDelivery: "Performa Pengiriman",
    apply: "Terapkan"
  },
  booking: {
    titleConfirmReject: "Pilih Alasan Pembatalan Booking",
    messageConfirmReject:
      "Nomor STT yang sudah dibatalkan tidak dapat dikembalikan.",
    submitConfirmReject: "Lanjutkan",
    cancelConfirmReject: "Kembali",
    placeholderReason: "Pilih alasan pembatalan",
    titleSuccessReject: "Booking Berhasil Dibatalkan !",
    messageSuccessReject:
      'STT dengan "{sttNumber}" berhasil dibatalkan. Alasan pembatalan akan terlihat pada detail status aktivitas.',
    messageInputNewStt:
      "Pembatalan booking dengan alasan diatas wajib memasukkan nomor STT terbaru.",
    errorInputNewStt: "Nomor STT tidak valid, cek & ubah lagi.",
    errorInputNewSttSame: "STT tidak boleh sama dengan yang di Cancel",
    generateNewSttForReturn: "Buat STT baru untuk pengembalian paket",
    printReceipt: "Print Resi",
    printThermalResiSuccess: "Print Thermal Resi",
    printBasicPdfSuccess: "Print Basic/Save to PDF",
    successOk: "OK",
    printTitle: "Print Resi",
    successCancelBook: "Pembatalan booking STT berhasil",
    successCancelBookDesc:
      "berhasil dibatalkan dan telah dibuat STT baru dengan nomor",
    errorNotAllowEditBeforeCs:
      "Akun Anda tidak dapat melakukan perubahan. Silahkan hubungi ",
    errorNotAllowEditAfterCs: " untuk permintaan perubahan.",
    productPoster: {
      shippingEmbargo: "Embargo Pengiriman",
      notAvailable: "Belum tersedia",
      legacyBookingMotto: {
        sameday: "Paket sampai di hari yang sama",
        bosspack: "Pengiriman Prioritas",
        onepack: "Pengiriman <br>Express",
        regpack: "Pengiriman <br>Reguler",
        minipack: "Paket <br>kecil",
        jagopack: "Pengiriman <br>Termurah",
        bigpack: "Pengiriman Paket Besar",
        bigpackfast: "Pengiriman Paket Besar & Cepat",
        jumbopack: "Pengiriman Paket Besar",
        interpack: "Pengiriman <br>Internasional",
        interpackmaxi: "Pengiriman besar <br>Internasional",
        otopack: "Pengiriman <br>Otomotif",
        jumbopackh2h: "Pengiriman Paket Besar",
        vippack: "Pengiriman VIP"
      }
    }
  },
  bulkAction: {
    searchPlaceholder: "Cari nama atau ID aktivitas",
    uploadFile: "Upload Berkas",
    uploadFileNow: "Upload Berkas Sekarang",
    emptyNoBulk: "Belum ada bulk upload yang dapat ditampilkan",
    emptyNoResult: "Tidak ada hasil yang ditemukan",
    emptyNoResultDesc: "Apa yang anda cari tidak ditemukan atau tidak ada",
    emptyNoDataOnPage: "Data tidak ditemukan pada halaman ini",
    tabExistingData: "Data Tersedia",
    tabTemplate: "Template",
    searchFile: "Cari berkas",
    downloadCsv: "Download csv",
    searchTemplate: "Cari template",
    learnTemplateDesc:
      "Pelajari cara mengisi template dengan mendownload berkas dibawah ini.",
    downloadExtension: "Download {extension}",
    followTemplateHint: "Ikuti langsung cara mengisi template bulk upload",
    activityNamePlaceholder: "Masukkan nama aktivitas upload",
    attachmentOriginal: "Attachment Orginal File",
    attachmentFailed: "Attachment Failed File",
    columnUploadId: "Upload ID",
    columnNamaAktivitas: "Nama Aktivitas",
    columnTipeBerkas: "Tipe Berkas",
    columnWaktuDibuat: "Waktu Dibuat",
    columnStatus: "Status",
    columnLampiran: "Lampiran",
    detailTitle: "Detail Aktivitas",
    detailNamaAktivitas: "Nama Aktivitas",
    detailTipeBerkas: "Tipe Berkas",
    detailNamaVersi: "Nama Versi Retail Base Rate",
    detailClient: "Client",
    detailPeriode: "Periode Harga Retail",
    detailTanggalAktif: "Tanggal Aktif Harga",
    detailWaktuDibuat: "Waktu Dibuat",
    detailDibuatOleh: "Dibuat Oleh",
    statusAll: "Semua Status",
    statusUploading: "Uploading",
    statusPartially: "Partially",
    statusSuccess: "Success",
    statusFailed: "Failed"
  },
  profile: {
    balanceAvailable: "Saldo Tersedia",
    logout: "Keluar",
    logoutConfirmTitle: "Yakin Ingin Keluar?",
    logoutConfirmMessage:
      "Sebelum Anda keluar pastikan kembali tidak ada proses aktivitas yang berjalan atau semua aktivitas sudah selesai.",
    changePassword: {
      title: "Konfirmasi Perubahan",
      msg: "Anda yakin ingin menyimpan perubahan password baru ?"
    },
    aturUlang: "Atur Ulang Password Berhasil",
    pesanAturUlang: "Password baru Anda sudah berhasil tersimpan",
    passwordOne: "Password tidak boleh sama dengan password sebelumnya",
    passwordTwo: "Password tidak boleh sama dengan password sebelumnya"
  },
  Nama: "{prefix}Nama{suffix}",
  balance: {
    router: "Saldo",
    balanceAvailable: "Saldo Tersedia",
    searchPlaceholder: "Cari No. STT",
    searchPlaceholderGenesis: "Cari No. STT atau ID Transaksi Genesis",
    downloadButtontitle: "Download Mutasi",
    downloadPopupTitle: "Download Mutasi",
    downloadSuccessTitle: "Download Saldo Mutasi Berhasil",
    activityTitle: "Aktifitas",
    activityPlaceholder: "Pilih jenis aktifitas",
    transactionDatePickerTitle: "Tanggal Transaksi",
    emptyMessage: "Oops.. Belum ada data yang dapat ditampilkan",
    filterAll: "Semua",
    balanceDeposit: "Saldo Deposit",
    tierLevel: "Tier Level",
    tooltipBalanceAvailableTitle: "Saldo Tersedia",
    tooltipBalanceAvailableMessage:
      "Saldo Tersedia merupakan saldo yang digunakan untuk transaksi STT",
    tooltipBalanceDepositTitle: "Saldo Deposit",
    tooltipBalanceDepositMessage:
      "Saldo Deposit merupakan uang jaminan saat pembuatan akun Mitra POS baru dan tidak dapat diuangkan sampai penutupan Mitra POS",
    tooltipTierLevel: "Tiering POS",
    warningNearLimit: "Saldo Anda mendekati limit",
    warningBelowLimit: "Saldo Anda dibawah limit",
    warningAtLimit: "Saldo Anda mencapai limit",
    fillBalanceNow:
      "Lakukan pengisian saldo sekarang juga. Pastikan saldo Anda tersedia sebelum melakukan aktivitas pengiriman.",
    topupViaAdmin: "Anda dapat top up saldo melalui Admin",
    filterPlaceholder: "Filter",
    activityAll: "Semua",
    activityDebit: "Debit",
    activityCredit: "Credit",
    downloadButton: "Download",
    tabMutation: "Saldo",
    tabNett: "Saldo Nett",
    tabHold: "Saldo Tertahan",
    tabNetBalance: "Net Balance",
    withdraw: {
      title: "Withdraw",
      balanceAvailable: "Saldo Tersedia",
      codIncomeTitle: "Penghasilan COD",
      amountLabel: "Jumlah Penarikan Saldo",
      amountPlaceholder: "e.g. 100.000",
      minWithdrawMessage: "Minimum penarikan adalah",
      balanceInsufficient: "Saldo anda kurang",
      balanceBelowMin: "Sisa saldo anda dibawah",
      minWithdraw: "Min. penarikan",
      maxWithdrawTotal: "Maks. penarikan yaitu total saldo",
      maxWithdrawOnceWeek: "Maks. penarikan seminggu 1x",
      maxWithdrawTotalMinBalance: "Maks. penarikan yaitu total saldo -",
      beneficiaryLabel: "Nomor Rekening Tujuan",
      passwordLabel: "Password Genesis",
      passwordPlaceholder: "Masukkan password akun",
      passwordWrong: "Password anda salah",
      cancel: "Cancel",
      withdraw: "Withdraw",
      cashbackDisclaimer:
        "Program cashback saldo hanya dapat digunakan untuk transaksi pengiriman (booking STT) dan mitra tidak dapat melakukan penarikan saldo cashback."
    },
    tableTitle: {
      genesisTransactionId: "ID Transaksi Genesis",
      type: "Tipe Transaksi",
      activity: "Aktivitas",
      amount: "Jumlah",
      lastBalance: "Saldo Terakhir",
      trancasationDate: "Tanggal Transaksi",
      note: "Catatan",
      bankName: "Nama Bank",
      accountName: "Nama Rekening",
      accountNumber: "No. Rekening",
      genesisRefId: "Genesis Referensi ID",
      status: "Status",
      sttNo: "No. STT"
    },
    hold: {
      searchPlaceholder: "Cari No. STT",
      allStatus: "Semua Status",
      selectCodType: "Pilih Tipe COD",
      downloadReport: "Download Laporan",
      totalHoldBalance: "Total Saldo Tertahan",
      infoPodReturn:
        "Saldo Anda akan dikembalikan setelah paket berhasil diterima oleh penerima (POD)",
      statusAll: "Semua Status",
      statusHold: "Saldo Tertahan",
      statusReturned: "Saldo Dikembalikan",
      codAll: "Semua Tipe STT",
      codRetail: "COD Retail",
      codCustomerApp: "COD Customer App",
      codCorporate: "COD Corporate",
      dfodRetail: "DFOD Retail",
      dfodCustomerApp: "DFOD Customer App",
      tableTitle: {
        sttNo: "No. STT",
        bookingDate: "Tanggal Booking",
        bookingShipment: "Booking Shipment",
        bookingReturn: "Booking Return",
        bookingCod: "Booking COD",
        totalSttFee: "Total Biaya STT",
        senderName: "Nama Pengirim",
        status: "Status",
        action: "Atur",
        detail: "Detail",
        tracking: "Tracking"
      },
      modal: {
        title: "Download Laporan",
        status: "Status",
        transactionDate: "Tanggal Transaksi",
        codType: "Tipe COD",
        selectStatus: "Pilih Status",
        selectCodType: "Pilih Tipe COD",
        search: "Cari"
      }
    }
  },
  titleSearchReport: "Pencarian laporan",
  customStatus: {
    updateStatus: "Update Status",
    remarks: "Remarks",
    remarksPlaceholder: "Masukan STT pengganti atau catatan lainnya",
    singleSttWarningRtsRtsHq:
      "Untuk status RTS dan RTSHQ hanya bisa memperbaharui 1 No. STT",
    singleSttWarningOther:
      "Untuk status {status} hanya bisa memperbaharui 1 No. STT",
    hubDestination: "Hub tujuan",
    vehicleNumber: "Nomor kendaraan",
    pos: "POS",
    selectPos: "Pilih POS",
    editAddress: "Ubah Alamat",
    editReceiverAddress: "Ubah Alamat Penerima",
    backlineAddressUpdated:
      "Alamat penerima ini sudah diubah oleh backline, Anda bisa langsung proses saat update misbooking dari akun console",
    mustEditAddressMisbooking:
      "Wajib ubah alamat penerima untuk memproses MISBOOKING.",
    totalStt: "Total STT",
    download: "Download",
    ok: "OK",
    addSttFailedTitle: "Tambah No. STT Gagal",
    scanSttFailedTitle: "Scan No. STT Gagal",
    sttAlreadyInput: "No. STT sudah di input",
    updateSuccessTitleInOutHub: "Perubahan Status Berhasil",
    updateSuccessMessageInOutHub:
      'Status No.STT berhasil diupdate menjadi "{status}"',
    printReceipt: "Print Resi",
    printThermalReceipt: "Print Thermal Resi",
    printBasicPdf: "Print Basic/Save to PDF",
    updateFailedTitle: "Perubahan Status Gagal !",
    leavePageTitle: "Yakin ingin keluar?",
    leavePageMessage:
      "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
    selectConsoleType: "Pilih Tipe konsol",
    consolidator: "Consolidator",
    subConsolidator: "Sub Consolidator",
    selectRemarks: "Pilih Remarks",
    remarksOptionCustomer: "Permintaan perubahan alamat dari Customer",
    remarksOptionPos: "Permintaan perubahan alamat dari POS",
    isPaid:
      "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke {status}",
    delete:
      "Masukan No. STT atau Scan Barcode/QR Code</br>barang yang ingin dihapus dari daftar {status}.",
    deleteInOutHub:
      "Scan atau masukan nomor STT/bag/DEM untuk menghapus dari daftar update status.",
    confirmUpdateTitle: "Konfirmasi Pembuatan",
    titleSuccess: "STT Berhasil di Update ke {status}",
    successMessageNewStt:
      "STT {listStt} harus dikirim kembali dengan STT pengembalian <b>{newStt}</b>",
    successMessage: "Status STT berhasil diupdate menjadi {status}.",
    partialMessage:
      "Beberapa status STT berhasil diupdate menjadi {status}, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.",
    failedMessage: "Perubahan status {status} gagal dibuat.",
    buttonCancel: "Oke, mengerti"
  },
  courierManagement: {
    menuTitle: "Manajemen Kurir",
    listTitle: "Daftar Kurir",
    approvalListTitle: "Daftar Kurir Approval",
    addTitle: "Manajemen Kurir | Tambah",
    addCourier: "Tambah Kurir",
    detailTitle: "Manajemen Kurir | Detail",
    editTitle: "Manajemen Kurir | Edit",
    edit: "Edit",
    editDetailCourier: "Ubah detail kurir",
    detailParent: "Detail Manajemen Kurir",
    tabList: "Management Kurir",
    tabApproval: "Management Kurir Approval",
    save: "Simpan",
    detailCourier: "Detail Kurir",
    courierName: "Nama kurir",
    placeholderCourierName: "Masukkan nama kurir",
    phoneLabel: "No. handphone",
    courierType: "Jenis kurir",
    announcementCourierType: "Informasi jenis kurir",
    vehicleType: "Tipe kendaraan",
    plateNumber: "Plat nomor",
    placeholderPlateNumber: "Masukkan plat nomor",
    ownershipName: "Nama kepemilikan",
    placeholderOwnershipName: "Masukkan nama kepemilikan",
    bank: "Bank",
    bankName: "Nama Bank",
    codDelivery: "Bisa pengiriman COD?",
    yes: "Iya",
    cod: "COD",
    yesShort: "YA",
    noShort: "TIDAK",
    accountOwnerName: "Nama pemilik rekening",
    placeholderAccountOwnerName: "Masukkan nama pemilik rekening",
    accountNumber: "Nomor rekening",
    placeholderAccountNumber: "Masukkan nomor rekening",
    areaDelivery: "Area Delivery",
    no: "No",
    district: "District",
    select3lc: "Pilih 3LC",
    searchDistrict: "Cari dan pilih district",
    add3lc: "Tambah 3LC lainnya",
    courierStatus: "Status kurir",
    statusToggleHint: "Anda bisa mengaktifkan status ini kapan saja",
    active: "Aktif",
    inactive: "Tidak Aktif",
    connectedDevices: "Perangkat Terhubung",
    lastActiveToday: "Terakhir aktif hari ini",
    lastActiveAt: "Terakhir aktif",
    delete: "Hapus",
    back: "Kembali",
    cancel: "Batalkan",
    posName: "Nama POS",
    placeholderPosName: "Masukkan nama pos",
    consolidatorName: "Nama Consolidator",
    noAreaDeliveryData: "Tidak ada data area delivery",
    confirmSaveCourier: "Simpan perubahan data kurir?",
    confirmSaveCourierMessage:
      "Pastikan detail kurir yang Anda ubah sudah benar.",
    courierUpdateSuccess: "Data kurir berhasil diperbarui",
    courierUpdateSuccessMessage:
      "Silakan cek detail kurir yang telah Anda ubah.",
    checkCourier: "Cek Kurir",
    confirmDeleteDevice: "Konfirmasi hapus perangkat",
    confirmDeleteDeviceMessage:
      "Perangkat <b>{deviceName} ({deviceOs})</b> tidak akan bisa lagi mengakses akun Anda kecuali Anda masuk kembali",
    courierCreateSuccess: "Data kurir berhasil ditambah",
    courierCreateSuccessMessage: "Cek detail kurir yang telah Anda tambahkan.",
    failedAddCourier: "Gagal Menambahkan Kurir",
    failedEditCourier: "Gagal Mengubah Kurir",
    downloadData: "Download Data Kurir",
    searchPlaceholder: "Cari nama, kurir id & no telp",
    driverType: "Tipe Kurir",
    placeholderDriverType: "Pilih tipe kurir",
    status: "Status",
    placeholderStatus: "Pilih status",
    emptyListHeader: "Belum ada data kurir ",
    emptyListMessage: "Yuk, tambah kurir dan cek daftarnya disini.",
    emptyApprovalHeader: "Belum Ada Data Kurir",
    emptyApprovalMessage: "Silahkan tambah kurir terlebih dahulu",
    acceptRequest: "Terima permintaan ini?",
    acceptRequestMessage:
      "Kurir tetap akan bisa mengakses aplikasi Lion Parcel Driver.",
    accept: "Ya, diterima",
    rejectRequest: "Tolak permintaan ini?",
    rejectRequestMessage:
      "Kurir tidak akan bisa mengakses aplikasi Lion Parcel Driver.",
    reject: "Ya, ditolak",
    requestSuccess: "Permintaan berhasil {action}",
    requestRejected: "ditolak",
    requestAccepted: "diterima",
    okGotIt: "Oke, mengerti",
    kurirId: "Kurir ID",
    nameWithPartner: "{name} {partnerTitle}",
    name: "Nama",
    consoleName: "Nama Konsol/POS",
    tipePermintaan: "Tipe Permintaan",
    atur: "Atur",
    riwayatPermintaanKurir: "Riwayat permintaan kurir",
    belumAdaDataRiwayatKurir: "Belum Ada Data Riwayat Kurir",
    partnerType: "Tipe Partner",
    placeholderPartnerType: "Masukkan tipe partner",
    phonePlaceholder: "812345678901",
    threeLc: "3LC",
    deleteDeviceSuccess: "Perangkat berhasil dihapus",
    deleteDeviceFailed: "Gagal menghapus perangkat!",
    placeholderAnnouncementCourierType: "Pilih announcement tipe kurir",
    placeholderVehicleType: "Pilih tipe kendaraan",
    motorcycle: "Sepeda Motor",
    truck: "Truck",
    placeholderBank: "Pilih Bank",
    invalidPhone: "Nomor telepon tidak valid, mohon ulangi kembali",
    invalidPlate: "Plat nomor tidak valid, mohon ulangi kembali",
    invalidBankAccount: "Nomor bank tidak valid, mohon ulangi kembali",
    courierTypeRequired: "Tipe kurir wajib diisi",
    console: "Konsol",
    all: "Semua",
    courierData: "Data Kurir"
  },
  chooseHub: "Pilih HUB",
  chooseSelected: "Terpilih",
  codReconcile: {
    title: "Rekonsiliasi",
    menuTitle: "Rekonsiliasi",
    menuReportTitle: "Rekonsiliasi & Laporan",
    reportTitle: "Laporan Rekonsiliasi",
    tabCourier: "Kurir",
    tabPartner: "Partner",
    tabPicShuttle: "PIC Shuttle",
    detailCourierTitle: "Detail Kurir",
    detailPicShuttleTitle: "Detail PIC Shuttle",
    detailShuttleTitle: "Rekonsiliasi | Detail shuttle",
    detailPageTitle: "Rekonsiliasi | Detail Kurir",
    summary: {
      totalMoneyToDeposit: "Total Uang Harus Disetor",
      totalSttToDeposit: "Total STT Harus Disetor",
      totalCodMoney: "Total Uang COD",
      mustDeposit: "Harus Disetor",
      alreadyDeposit: "Sudah Disetor",
      dex: "DEX",
      codrej: "CODREJ",
      inDelivery: "Dalam Pengiriman",
      del: "DEL",
      podCodrejDex: "POD/CODREJ/DEX",
      progressDelivery: "Progress Pengiriman",
      noStt: "No. STT",
      serviceType: "Jenis layanan",
      nominal: "Nominal"
    },
    list: {
      searchPlaceholder: "ID, nama atau nomor telepon kurir",
      downloadReconcile: "Download Rekonsiliasi",
      emptyDexAutomationConfig:
        "Tidak Ada Konfigurasi Automasi Indikasi DEX Palsu",
      emptyDexAutomationConfigMessage:
        "Mulai buat Konfigurasi Automasi Indikasi DEX Palsu dan cek daftarnya disini",
      emptyHeaderMessage: "Belum ada data rekonsiliasi kurir",
      emptyMessage:
        "Semua data rekonsiliasi kurir (Gagal, berhasil & dalam pengiriman) akan tercatat disini!",
      no: "No.",
      courierName: "Nama Kurir",
      deliverySuccess: "Pengiriman Berhasil",
      action: "Atur",
      sisaHarusDisetor: "Sisa harus disetor",
      setorHarian: "Setor harian",
      detailCourier: "Detail kurir",
      downloadDetailCourier: "Download detail kurir",
      mustDeposit: "Harus disetor",
      alreadyDeposit: "Sudah disetor",
      progressDelivery: "Progress Pengiriman"
    },
    detail: {
      courierName: "Nama Kurir",
      picShuttleName: "Nama PIC Shuttle",
      phoneNumber: "No. handphone",
      courierId: "Kurir ID",
      partner: "Partner",
      threeLc: "3LC",
      checkRemainingDeposit: "Cek sisa setoran kemarin",
      downloadDetailCourier: "Download detail kurir",
      setorHarian: "Setor harian",
      totalMoneyToDeposit: "Total uang harus disetor",
      totalSttToDeposit: "Total STT harus disetor",
      totalCodMoney: "Total uang COD",
      tabDetailStt: "Detail STT",
      tabRiwayatSetorUang: "Riwayat setor uang",
      tabRiwayatSetorPaket: "Riwayat setor paket",
      tabMoney: "Uang",
      tabPackage: "Paket",
      tabOnDelivery: "On Delivery",
      tanggal: "Tanggal",
      nominalUang: "Nominal uang",
      totalStt: "Total STT",
      catatan: "Catatan",
      lihatDetail: "Lihat detail",
      nilaiCod: "Nilai COD",
      noStt: "No. STT",
      statusTerakhir: "Status Terakhir",
      tipePembayaranCod: "Tipe Pembayaran COD",
      statusSetoran: "Status setoran",
      statusSetoranLast: "Status terakhir",
      alasan: "Alasan",
      namaPenerima: "Nama Penerima",
      tanggalDel: "Tanggal DEL",
      pengirimanBerhasil: "Pengiriman berhasil",
      pengirimanGagal: "Pengiriman gagal",
      dalamPengiriman: "Dalam pengiriman",
      performaPengiriman: "Performa Pengiriman",
      emptyHeaderDelivery: "Belum ada pengiriman",
      emptyMessageDelivery:
        "Semua data pengiriman (Gagal, berhasil & dalam pengiriman) akan tercatat disini!",
      paymentMethod: "Metode pembayaran",
      depositLocation: "Lokasi setor",
      biayaKirim: "Biaya kirim",
      biayaAsuransi: "Biaya asuransi",
      biayaLainLain: "Biaya lain-lain",
      totalBiaya: "Total Biaya",
      detail: "Detail",
      close: "Tutup",
      total: "Total",
      pengirim: "Pengirim",
      jenisKiriman: "Jenis Kiriman",
      berat: "Berat",
      volume: "Volume",
      waktu: "Waktu",
      namaPenerimaTab: "Nama penerima"
    },
    report: {
      lastSyncData: "Sinkronisasi Data Terakhir",
      downloadDetail: "Download Detail",
      deliveryFailed: "Pengiriman Gagal",
      deliveryFailedCodrej: "Pengiriman Gagal (CODREJ)",
      deliveryFailedDex: "Pengiriman Gagal (DEX)",
      notYetDeposited: "(Belum Setor)",
      alreadyDeposited: "(Sudah Setor)",
      inDeliveryProcess: "Dalam Proses Pengiriman",
      cash: "Tunai",
      tooltip: {
        podTotalValue:
          "Total nilai COD dari STT COD yang berhasil dikirim (POD) kepada penerima.",
        podTotalStt: "Total STT COD yang berhasil dikirim (POD).",
        podPercentage:
          "Persentase keberhasilan pengiriman STT COD (POD) dari total keseluruhan STT COD.",
        podNotDepositedValue:
          "Total nilai COD yang berhasil dikirim (POD) kepada penerima dan uang COD belum disetor oleh kurir ke admin POS.",
        podNotDepositedStt:
          "Total STT COD yang berhasil dikirim dan uang COD belum disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        podNotDepositedPercentage:
          "Persentase total STT COD yang berhasil terkirim dan uang COD belum disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        podDepositedValue:
          "Total nilai COD yang berhasil dikirim (POD) kepada penerima dan uang COD sudah disetor oleh kurir ke admin POS.",
        podDepositedStt:
          "Total STT COD yang berhasil dikirim dan uang COD sudah disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        podDepositedPercentage:
          "Persentase total STT COD yang berhasil terkirim dan uang COD sudah disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        failedTotalStt:
          "STT COD yang gagal dikirim (DEX & CODREJ) kepada penerima.",
        failedPercentage:
          "Persentase kegagalan pengiriman STT COD (DEX & CODREJ) dari total keseluruhan STT COD.",
        codrejNotDepositedValue:
          "Total nilai COD yang gagal dikirim (CODREJ) kepada penerima dan uang COD belum disetor oleh kurir ke admin POS.",
        codrejNotDepositedStt:
          "Total STT COD yang gagal dikirim dan uang COD belum disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        codrejNotDepositedPercentage:
          "Persentase total STT COD yang gagal terkirim dan uang COD belum disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        codrejDepositedValue:
          "Total nilai COD yang gagal dikirim (CODREJ) kepada penerima dan uang COD sudah disetor oleh kurir ke admin POS.",
        codrejDepositedStt:
          "Total STT COD yang gagal dikirim dan uang COD sudah disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        codrejDepositedPercentage:
          "Persentase total STT COD yang gagal terkirim dan uang COD sudah disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        dexNotDepositedValue:
          "Total nilai COD yang gagal dikirim (DEX) kepada penerima dan uang COD belum disetor oleh kurir ke admin POS.",
        dexNotDepositedStt:
          "Total STT COD yang gagal dikirim dan uang COD belum disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        dexNotDepositedPercentage:
          "Persentase total STT COD yang gagal terkirim dan uang COD belum disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        dexDepositedValue:
          "Total nilai COD yang gagal dikirim (DEX) kepada penerima dan uang COD sudah disetor oleh kurir ke admin POS.",
        dexDepositedStt:
          "Total STT COD yang gagal dikirim dan uang COD sudah disetor oleh kurir ke admin POS/Total keseluruhan STT COD yang berhasil dikirim (sudah setor dan belum setor).",
        dexDepositedPercentage:
          "Persentase total STT COD yang gagal terkirim dan uang COD sudah disetor oleh kurir ke admin POS dari total keseluruhan nilai COD yang berhasil dikirim (sudah setor dan belum setor).",
        delStt: "Total STT COD yang sedang dalam pengiriman (DEL).",
        delPercentage:
          "Persentase STT COD yang sedang dalam pengiriman (DEL) dari total keseluruhan STT COD.",
        delValue: "Total nilai COD dari STT COD yang sedang dalam pengiriman."
      }
    },
    dailyDeposit: {
      titleSetorHarian: "Setor Harian",
      titleSetorHarianPicShuttle: "Setor Harian PIC Shuttle",
      cekSisaSetoranKemarin: "Cek sisa setoran kemarin",
      totalUangHarusDisetor: "Total uang harus disetor",
      jumlahUangDisetor: "Jumlah uang yang disetor",
      placeholderAmount: "e.g 100.000",
      placeholderInputAmount: "Masukkan jumlah uang yang disetor",
      errorAmount: "Masukkan jumlah sesuai dengan uang yang harus disetor",
      catatan: "Catatan",
      simpan: "Simpan",
      batal: "Batal",
      setor: "Setor",
      setoranMasuk: "Setoran masuk",
      belumAdaSetoran: "Belum ada setoran masuk",
      foto: "Foto",
      uploadPhotoHint:
        "Maksimum 5 MB, dan format pastikan .JPG, .PNG, .JPEG, .WEBP",
      uploadPhotoError:
        "Upload foto gagal pastikan ukuran foto dan format benar",
      successSetorUang: "Berhasil setor uang",
      successSetorPaket: "Berhasil setor paket",
      nominalUang: "Nominal uang",
      totalStt: "Total STT",
      buktiFoto: "Bukti foto",
      catatanLabel: "Catatan",
      lihatBukti: "Lihat bukti",
      noData: "Oops.. Belum ada data yang dapat ditampilkan",
      noStt: "No. STT",
      noSttShipment: "No. STT/Shipment",
      layanan: "Layanan",
      serviceType: "Jenis layanan",
      nominal: "Nominal",
      buktiSetor: "Bukti setor",
      lastStatus: "Last Status",
      koli: "Koli",
      oleh: "oleh",
      amountDepositedLabel: "yang disetor",
      placeholderStt: "Masukan no. STT atau scan barcode/QR code",
      exampleStt: "Contoh : 99LP1234567890123/88-22-12345678",
      successTitle: "Setor harian berhasil!",
      successMessage: "Uang sebesar {amount} & {count} STT berhasil disetor.",
      failTitle: "Setor harian gagal!",
      scanSuccess: "Berhasil Scan",
      sttAlreadySelected: "STT sudah dipilih",
      emptyTitleSttNotFound: "Nomor STT tidak ditemukan",
      emptyMessageSttNotFound:
        "Pastikan nomor STT sudah sesuai, cek & ubah lagi.",
      emptyMessageNoStt: "Belum ada STT yang harus di setor",
      courierUnknown: "Kurir Tidak Dikenal",
      tabMoney: "Uang",
      tabPackage: "Paket",
      failGetDetailCourier: "Gagal Mengambil Detail Kurir",
      failGetSummary: "Gagal Mendapatkan Summary!",
      failUploadCourierNotesPhoto: "Gagal mengupload foto catatan kurir",
      failSaveCourierNotes: "Gagal menyimpan catatan kurir",
      successSetor: "Berhasil setor",
      noHistoryFromDriverApp: "Belum ada riwayat setor dari Driver App",
      failGetSettlement: "Gagal mengambil data setllement",
      deposit: "Setoran",
      depositIn: "Setoran {type} masuk",
      amount: "Jumlah",
      failDeletePhoto: "Gagal menghapus Foto ke storage!",
      uploadedBy: "Uploaded by"
    },
    overallSummary: "Overall Summary",
    addCourier: "Tambah Kurir"
  },
  bagging: {
    koli: "Koli",
    chargeableWeightReweigh: "Chargeable weight (Timbang ulang)",
    totalSttKoli: "Total STT (koli)",
    placeholderSearch: "Cari No. Bag",
    titleButtonCreate: "Buat Bagging",
    disputeSummaryTitle: "BAG dengan selisih berat",
    disputeSummaryDataRange: "Data",
    disputeSummaryCount: "({0}%) BAG",
    bagWithWeightDispute: "Bag dengan selisih berat",
    proses: "Proses",
    noBagging: "No. Bagging",
    toReadyToCargo: "ke Siap Dikargo",
    hapus: "Hapus",
    fromReadyToCargo: "dari Siap Dikargo",
    modalTitleSTTPaid: "Pastikan Nomor STT Sudah Terbayar",
    modalMessageSTTPaid:
      "Cek kembali nomor STT Adjusted atau yang kelebihan berat, pastikan sudah terbayar lunas",
    ok: "OK",
    emptyStateMessage: "Belum ada bagging yang dapat ditampilkan",
    noBag: "No. Bag",
    totalSTT: "Total STT",
    beratBagDikenakanBiaya: "Berat bag dikenakan biaya",
    totalBeratKotorBag: "Total berat kotor bag",
    totalBeratVolumeBag: "Total berat volume bag",
    totalSttGrossWeight: "Total berat kotor STT",
    totalSttVolumeWeight: "Total berat volume STT",
    buktiFotoPerubahan: "Bukti foto perubahan",
    grossWeight: "Berat Kotor",
    volumeWeight: "Volume Berat",
    editDimensionInfo: "Ubah jika dimensi berubah",
    volumeWeightBag: "Berat volume bag",
    chargeableWeightBag: "Berat bag dikenakan biaya",
    errorBagExceed: "Berat bag melebihi berat STT.",
    destinationCity: "Kota Tujuan",
    payment: "Pembayaran",
    woodpacking: "Packing kayu",
    commodity: "Komofditas",
    totalPieces: "Total koli",
    CodAmount: "Biaya COD",
    dibuatOlehHub: "Dibuat oleh HUB",
    action: "Action",
    printPdf: "Print PDF",
    printLabel: "Print Label",
    downloadExcel: "Download Excel",
    codFee: "Biaya COD",
    totalKoli: "Total Koli",
    komoditas: "Komoditas",
    tableTitle: {
      totalSttKoli: "Total STT & koli",
      partnerName: "Nama Partner",
      userType: "Tipe User",
      destinationType: "Kota tujuan",
      baggingDate: "Tanggal Bagging",
      totalPieces: "Total koli",
      notFoundSTTBagging: "No. STT/Bagging tidak ditemukan",
      weightGross: "Berat Kotor",
      totalSTTDG: "Jumlah STT DG",
      serviceType: "Jenis Pengiriman",
      updatedBy: "Diubah oleh",
      createdBy: "Dibuat oleh"
    },
    createdBaggingDate: "Tanggal Dibuat",
    chargeableWeightStt: "Chargeable weight (STT)",
    chargeableWeight: "Chargeable weight",
    printBagging: "Print Bagging",
    ubah: "Ubah",
    noStt: "No. STT",
    baggingConfirmationTitle: "Konfirmasi Pembuatan?",
    rtcBaggingConfirmationTitle: "Lanjutkan Proses Bagging?",
    rtcBaggingConfirmationMessage: "Bagging akan masuk ke daftar Siap di Kargo",
    baggingConfirmationEditTitle: "Konfirmasi Perubahan",
    baggingConfirmationEditSub:
      "Anda yakin ingin menyimpan perubahan detail Bagging dengan No. {bagNo}",
    buttonProcessBagging: "Process",
    editBagging: "Ubah Bagging",
    editBaggingAndPrint: "Ubah Bagging & Print Label",
    successEditBagTitle: "Detail No. Bag {bagNo} berhasil diubah.",
    rtcTitleContinue: "Lanjutkan Proses ke",
    rtcTitleRemove: "Hapus Bagging dari",
    rtcSubtitleContinue:
      "No. Bagging akan otomatis terupdate dan masuk ke daftar",
    rtcSubtitleRemove: "No. Bagging akan otomatis terhapus dari daftar",
    confirmRtcProcessTitle: "Lanjutkan Proses ke Siap Dikargo?",
    confirmBaggingDeleteTitle: "Hapus Bagging dari Siap Dikargo?",
    confirmRtcProcessMessage:
      "No. Bagging akan otomatis terupdate dan masuk ke daftar Siap Dikargo",
    confirmBaggingDeleteMessage:
      "No. Bagging akan otomatis terhapus dari daftar Siap Dikargo",
    rtcTitleErrorUpdate: "No. Bagging Gagal Diupdate",
    rtcTitleErrorDelete: "No. Bagging Gagal Dihapus",
    rtcSubtitleErrorUpdate: "No. Bagging telah gagal ditambahkan ke daftar",
    rtcSubtitleErrorDelete: "No. Bagging telah gagal terhapus dari daftar",
    rtcModalPartialTitle: "Beberapa bagging gagal siap di kargo",
    rtcModalPartialMessage:
      "Ada status STT dalam bag tidak valid. Silakan cek & download bag",
    rtcModalConfirmBoth: "Lanjutkan Proses & Hapus ke Siap Dikargo?",
    rtcModalConfirmMessage: "Pastikan No. Bagging yang dipilih telah sesuai",
    rtcKembali: "Kembali",
    rtcLanjutkan: "Lanjutkan",
    rtcHapus: "Hapus",
    rtcSiapDikargo: "Siap Dikargo",
    rtcSuccessProcess: "Bagging Akan Diproses",
    rtcSuccessAndDeleted: "dan Dihapus",
    rtcSuccessRTC: "RTC",
    rtcSuccessDeleteTitle: "No. Bagging Berhasil Dihapus",
    rtcSuccessDeleteMessage:
      "No. Bagging telah terhapus dari daftar Siap Dikargo",
    rtcSuccessMessage: "Silahkan lihat bagging Anda saat proses booking kargo",
    rtcErrorBothTitle: "Tambah dan Hapus No. Bagging Gagal",
    rtcErrorBothMessage: "Tambah dan hapus No. Bagging gagal dilakukan.",
    rtcErrorSiapDikargo: "Siap DiKargo",
    rtcSttUnpaidTitle: "Beberapa No. Bagging Gagal Diproses ",
    rtcSttUnpaidMessage:
      "Terjadi kelebihan berat dan kurang bayar. Tunggu sampai customer melunasi tagihan",
    downloadBagFailedNoBag: "Nomor Bag",
    downloadBagFailedNoStt: "Nomor STT",
    downloadBagFailedStatus: "Status Terakhir STT/Bag",
    downloadBagFailedReason: "Alasan Gagal",
    belumSiapDikargo: "Belum Siap Dikargo",
    siapDikargo: "Siap Dikargo",
    placeholderAdd: "Contoh: no. STT: 99LP1234567890123"
  },
  cargo,
  dexAssessmentDashboard: {
    breakdownTicketDex: "Breakdown Tiket DEX",
    breakdownTicketDexSanggahL2: "Breakdown Tiket DEX Sanggah L2",
    top20KonsolTiketDex: "Top 20 Konsol Tiket DEX Terbanyak",
    top10KonsolTiketDexSanggahL2:
      "Top 10 Konsol Tiket DEX Sanggah L2 Terbanyak",
    listAgentCsL1: "Daftar Agen CS L1",
    listAgentCsL2: "Daftar Agen CS L2",
    sortOrder: "Urutkan",
    searchCsName: "Cari nama CS",
    emptyListAgentCsL1: "Tidak Ada Daftar Agen CS L1",
    emptyListAgentCsL2: "Tidak Ada Daftar Agen CS L2",
    columnNo: "No",
    columnNamaCs: "Nama CS",
    columnStatus: "Status",
    columnKuotaTiket: "Kuota Tiket",
    columnTiketDiassign: "Tiket Diassign",
    columnTiketSelesai: "Tiket Selesai",
    columnPersentaseTiketSelesai: "Persentase Tiket Selesai",
    columnRataRataWaktuSelesai: "Rata Rata Waktu Selesai",
    columnTotalJamAktif: "Total Jam Aktif",
    statusActive: "Aktif",
    statusInactive: "Tidak Aktif",
    sortPercentageDoneHighest: "Persentase Selesai Tertinggi",
    sortPercentageDoneLowest: "Persentase Selesai Terendah",
    totalTicketDexPerHari: "Total Tiket DEX Per Hari",
    totalTicketDexSanggahL2PerHari: "Total Tiket DEX Sanggah L2 Per Hari",
    totalPercobaanTicketDex: "Total Percobaan Tiket DEX",
    courierLabel: "Kurir:",
    totalTicketDexLabel: "Total Tiket Dex:",
    emptyTop10Konsol: "Tidak Ada Top 10 Konsol Terbanyak",
    emptyTop10KonsolMessage:
      "Mulai buat Top 10 Konsol Terbanyak dan cek daftarnya disini",
    emptyKurir: "Tidak Ada Kurir",
    emptyKurirMessage: "Mulai buat Kurir dan cek daftarnya disini",
    totalCustomerService: "Total Customer Service",
    totalCsL1: "Total Customer Service L1",
    totalCsL2: "Total Customer Service L2",
    penyelesaianTercepat: "Penyelesaian Tercepat",
    penyelesaianTerlama: "Penyelesaian Terlama",
    persentaseSelesaiTerbanyak: "Persentase Selesai Terbanyak",
    persentaseSelesaiTersedikit: "Persentase Selesai Tersedikit",
    ringkasanDexIndikasiPalsu: "Ringkasan DEX Indikasi Palsu",
    totalTicketDexIndikasiPalsu: "Total Tiket DEX Indikasi Palsu",
    ticketDexDariAlasanDex: "Tiket DEX dari Alasan DEX",
    totalTicketDexBerdasarkanRentangWaktu:
      "Total Tiket DEX Berdasarkan Rentang Waktu",
    backlogTicketDexAgenCsL1: "Backlog Tiket DEX untuk Agen CS L1",
    backlogTicketDexAgenCsL2: "Backlog Tiket DEX untuk Agen CS L2",
    titleChartByReason: "Tiket DEX dari Alasan DEX",
    titleChartByReasonDispute: "Tiket DEX Sanggah L2 Berdasarkan Alasan"
  },
  Loading: "Memuat",
  report: {
    title: "Laporan",
    searchByName: "Cari laporan",
    generateFailed: "Generate Laporan Gagal !",
    sectionStt: "STT",
    sectionFinance: "Finance",
    sectionDelivery: "Delivery",
    category: {
      stt: "STT",
      finance: "Finance",
      delivery: "Delivery"
    },
    cards: {
      titleSttReport: "Laporan STT",
      titleSttClient: "Laporan STT Client",
      titleSttManual: "Laporan STT Manual",
      titlePembatalanStt: "Laporan Pembatalan STT",
      titleFpr: "Laporan FPR",
      titleCod: "Laporan COD",
      titleTopUp: "Laporan Top Up",
      titlePendapatan: "Laporan Pendapatan",
      titlePembayaran: "Laporan Pembayaran",
      titleTransaksi: "Laporan Transaksi",
      titleReferralPos: "Laporan Referral POS",
      titleBonusKomisi: "Laporan Bonus Komisi",
      titleKomisiAffiliate: "Laporan Komisi Affiliate",
      titleKomisiPosInduk: "Laporan Komisi POS Induk",
      titleTransit: "Laporan Transit",
      titleMisroute: "Laporan Misroute",
      titleShortland: "Laporan Shortland",
      titlePengiriman: "Laporan Pengiriman",
      titleScrap: "Laporan Scrap",
      titlePengirimanKeluar: "Laporan Pengiriman Keluar (Kota Asal)",
      titlePengirimanMasuk: "Laporan Pengiriman Masuk (Kota Tujuan)",
      titleKomisiPengiriman: "Laporan Komisi Pengiriman",
      titleKomisiPengirimanTierX: "Laporan Komisi Pengiriman Tier X",
      colPartnerName: "Nama Partner",
      placeholderPartnerName: "Ketik atau pilih pos induk/cabang",
      colCity: "Kota",
      labelLastSyncData: "Terakhir Sync Data",
      descLastSyncData:
        "Refresh halaman untuk memperbarui informasi sync data terakhir",
      colDate: "Tanggal",
      labelAllPOS: "Semua POS",
      labelAllClient: "Semua Klien",
      waitingDownload:
        "Proses pencarian sedang berjalan, silahkan tunggu hingga proses pencarian selesai",
      reportType: "Tipe Laporan",
      reportSearch: "Pencarian laporan",
      generateFailed: "Generate gagal",
      reportTypeData: "Tipe Data",
      sttBookedBy: "STT dibooking oleh",
      descStt: "STT",
      descSttClient: "STT Client",
      descSttManual: "STT Manual",
      descPembatalanStt: "Pembatalan STT",
      descFpr: "FPR",
      descCod: "COD",
      descTopUp: "Top Up",
      descPendapatan: "Pendapatan",
      descPembayaran: "Pembayaran",
      descTransaksi: "Transaksi",
      descReferralPos: "Referral POS",
      descBonusKomisi: "Bonus Komisi",
      descKomisiAffiliate: "Komisi Affiliate",
      descKomisiPosInduk: "Komisi POS Induk",
      descTransit: "Transit",
      descMisroute: "Misroute",
      descShortland: "Shortland",
      descPengiriman: "Pengiriman",
      descScrap: "Scrap",
      descPengirimanKeluar: "Pengiriman Keluar (Kota Asal)",
      descPengirimanMasuk: "Pengiriman Masuk (Kota Tujuan)",
      descKomisiPengiriman: "Komisi Pengiriman",
      descDtpolTierX: "DTPOL Tier X"
    },
    modal: {
      sttBookedFor: "STT Dibuat untuk",
      placeholderPosParent: "Ketik atau pilih pos induk",
      placeholderPosBranch: "Ketik atau pilih pos induk/cabang",
      placeholderSelect: "Pilih",
      clientPartnerTitleClient: "Nama Client",
      clientPartnerTitleBookedFor: "Dibooking Untuk",
      clientPartnerTitlePartner: "Nama Partner",
      clientPartnerTitleKlien: "Nama Klien",
      placeholderPartner: "Pilih Partner",
      placeholderClient: "Pilih Klien",
      selectBookedBy: "Pilih pembuat STT",
      bookedForClient: "Klien",
      bookedForPos: "POS",
      bookedForClientBranch: "Klien Cabang",
      reportTypeOutbound: "Outbound",
      reportTypeInbound: "Inbound",
      dataTypeDetailStt: "Detail STT",
      dataTypeCost: "Detail biaya",
      allPartner: "Semua Partner",
      misrouteType: "Jenis Misroute",
      scrapType: "Jenis Scrap",
      shortlandType: "Jenis Shortland",
      cancelBased: "Pembatalan berdasarkan",
      sttStatus: "STT Status",
      topUpType: "Jenis Top Up",
      deliveryBy: "Pengiriman Oleh",
      placeholderCity: "Pilih kota",
      placeholderAccount: "Pilih akun",
      selectType: "Pilih jenis",
      selectTypeMisroute: "Pilih tipe",
      originCity: "Origin City",
      destinationCity: "Destination City",
      shortlandCity: "Shortland City",
      misrouteCity: "Misroute City",
      topUpVirtualAccount: "Top Up Virtual Account",
      topUpManual: "Top Up Manual",
      used: "Used",
      unused: "Unused",
      console: "Console",
      subConsole: "Sub Console",
      pos: "POS",
      all: "Semua",
      dataNotFound: "Data tidak ditemukan",
      dataNotFoundMessage: "Maaf, data yang Anda cari tidak ditemukan.",
      showingReportSearch: "Menampilkan pencarian laporan",
      reportDescription: "Laporan",
      download: "Download",
      dateRangeErrorStart:
        "Tanggal mulai harus dimulai dari tanggal 01 sampai tanggal 30/31.",
      dateRangeErrorChange: "Mohon ubah tanggal.",
      lastSyncLoadFailed:
        "Gagal memuat data sync terakhir pada<br />Laporan STT !",
      allPrefix: "Semua"
    }
  },
  announcement: {
    menuTitle: "Pengumuman",
    detailTitle: "Pengumuman | Detail",
    editTitle: "Pengumuman | Edit",
    createTitle: "Pengumuman | Buat",
    createName: "Buat Pengumuman Baru",
    searchPlaceholder: "Cari nama aktivitas",
    buttonCreate: "Buat Announcement",
    emptyData: "data Announcement",
    allStatus: "Semua Status",
    statusDraft: "Draft",
    statusSent: "Sent",
    announcementId: "Announcement ID",
    nameActivity: "Nama Aktivitas",
    targetUser: "Target User",
    releaseDate: "Tanggal Rilis",
    status: "Status",
    createdAt: "Tanggal Dibuat",
    description: "Deskripsi",
    attachment: "Berkas Lampiran",
    banner: "Banner",
    target: "Target",
    pinnedMessage: "Tandai Pesan",
    pinnedYes: "Pesan Ditandai",
    lastModified: "Terakhir Diubah",
    edit: "Edit",
    optional: "(Optional)",
    placeholderName: "masukkan nama aktivitas",
    placeholderDescription: "Tulis deskripsi berita disini",
    changeFile: "Ubah File",
    targetHint: "Target akan menerima notifikasi pada akun genesis mereka",
    pinnedHint:
      "Pesan yang ditandai akan muncul di bagian paling atas halaman notifikasi. Gunakan fitur ini untuk meng-highlight pesan penting.",
    save: "Simpan",
    successTitle: "Perubahan Berhasil Disimpan !",
    news: "Berita",
    successChanged: "berhasil diubah",
    successMessage: 'Berita "{name}" berhasil diubah',
    ok: "Oke",
    confirmLeaveTitle: "Yakin ingin keluar?",
    confirmLeaveMessage:
      "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
    leave: "Keluar",
    back: "Kembali",
    confirmSaveTitle: "Konfirmasi Perubahan",
    confirmSaveMessage: 'Anda yakin ingin menyimpan perubahan "{name}"',
    confirmSaveMessageTwo: "Anda yakin ingin menyimpan perubahan",
    confirmDeleteTitle: "Yakin ingin menghapus aktivitas ini?",
    confirmDeleteMessage:
      "Pastikan kembali, Anda akan kehilangan data aktivitas ketika Anda hapus aktivitas ini",
    delete: "Hapus",
    invalidEndDate:
      "Tanggal akhir tidak boleh kurang atau sama dengan tanggal sekarang",
    maxSizeFormatBanner:
      "Max size : 5MB, Format : jpg, png. Rekomendasi Dimensi 2 : 4, (contoh: 200px X 800px)",
    loading: "Loading...",
    invalidFileMessage:
      "Pastikan kembali format file sesuai dan ukuran file tidak lebih dari 16MB",
    targetWillReceive:
      "Target akan menerima notifikasi pada akun genesis mereka",
    selectTargetHint: "Pilih target yang akan menerima notifikasi.",
    pinnedActive: "Pesan ditandai",
    pinnedInactive: "Pesan tidak ditandai",
    invalidReleaseDate:
      "Tanggal rilis tidak boleh kurang atau minimal satu jam dari sekarang",
    captionBanner:
      "Max size : 5MB, Format : jpg, png. Rekomendasi Dimensi 2 : 4, (contoh: 200px X 800px)"
  },
  sttPaidUnpaid: {
    labelSearch: "Cari",
    placeholderSearch: "Cari No. STT",
    labelPaymentStatus: "Status Pembayaran",
    placeholderPaymentStatus: "Pilih status pembayaran",
    labelProcessStatus: "Status Proses",
    placeholderProcessStatus: "Pilih status proses",
    labelCityOrigin: "Kota Asal",
    placeholderCityOrigin: "Pilih kota asal",
    labelCityDestination: "Kota Tujuan",
    placeholderCityDestination: "Pilih kota tujuan",
    labelDateModified: "Tanggal Diubah",
    titleDateRange: "Tanggal Bayar",
    defaultDateRange: "7 hari terakhir",
    downloadStt: "Download STT",
    emptyData: "data STT Paid/Unpaid",
    colNoStt: "No. STT",
    colLastStatus: "Status Terakhir",
    colPaymentStatus: "Status Pembayaran",
    colPaymentDate: "Tanggal Bayar",
    colBookingDate: "Tanggal Booking",
    colProcessStatus: "Status Proses",
    colOriginCity: "Kota Asal",
    colDestinationCity: "Kota Tujuan",
    colDateModified: "Tanggal Diubah",
    statusPaid: "Sudah Lunas",
    statusUnpaid: "Kurang Bayar",
    statusCodPayment: "Pembayaran COD",
    processStateProcessed: "Sudah Diproses",
    processStateNotProcessed: "Belum Diproses",
    processStateNeedToPay: "Perlu Dibayar",
    processStateNeedToCancel: "Perlu Dibatalkan",
    downloadFailed: "Download STT Gagal!",
    totalNotification: "Ada {total} STT baru sudah lunas"
  },
  manualStt: {
    searchPlaceholder: "Cari No. STT genesis",
    emptyData: "data Manual STT",
    columnSttNo: "No. STT",
    columnClientPartnerName: "Nama Client/Partner",
    columnCode: "Kode Client/Partner",
    columnMixpack: "MIXPACK",
    columnCreatedAt: "Tanggal Dibuat",
    columnStatus: "Status",
    yes: "Yes",
    no: "No",
    table: {
      noStt: "No. STT",
      clientPartnerName: "Nama Client/Partner",
      clientPartnerCode: "Kode Client/Partner",
      mixpack: "MIXPACK",
      createdAt: "Tanggal Dibuat",
      status: "Status",
      yes: "Yes",
      no: "No"
    },
    statusAll: "Semua Status",
    statusUsed: "Used",
    statusUnused: "Unused",
    emptyMessage: "data Manual STT",
    buttonGenerateStt: "Generate STT",
    placeholderSearchClientPartner: "Ketik atau pilih client/partner",
    placeholderSearchClientBranch: "Ketik atau pilih client branch",
    placeholderClientPartner: "Ketik atau pilih client/partner",
    placeholderClientBranch: "Ketik atau pilih client branch",
    placeholderAmount: "e.g 20",
    confirmLeave: {
      title: "Yakin Keluar Halaman ?",
      message:
        "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      leave: "Keluar",
      back: "Kembali"
    },
    leaveConfirmTitle: "Yakin Keluar Halaman ?",
    leaveConfirmMessage:
      "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
    leaveConfirmLeave: "Keluar",
    leaveConfirmBack: "Kembali",
    generate: {
      title: "Generate Manual STT",
      infoText:
        "Sebelum melanjutkan Auto Generate, pastikan kembali detail sudah terisi dengan benar dan sesuai.",
      typeStt: "Jenis STT",
      clientPartner: "Client/Partner",
      amountStt: "Jumlah STT",
      placeholderClientBranch: "Ketik atau pilih client branch",
      placeholderClientPartner: "Ketik atau pilih client/partner",
      placeholderAmount: "e.g 20",
      placeholderTypeStt: "Pilih Jenis STT",
      typeClient: "Client",
      typePartner: "Partner",
      back: "Kembali",
      autoGenerate: "Auto Generate",
      errorAmountMax: "Jumlah STT tidak boleh lebih dari {max}"
    },
    generateTitle: "Generate Manual STT",
    generateInfo:
      "Sebelum melanjutkan Auto Generate, pastikan kembali detail sudah terisi dengan benar dan sesuai.",
    labelTypeStt: "Jenis STT",
    labelClientPartner: "Client/Partner",
    labelAmountStt: "Jumlah STT",
    optionSelectType: "Pilih Jenis STT",
    optionClient: "Client",
    optionPartner: "Partner",
    validationAmountMax: "Jumlah STT tidak boleh lebih dari {max}",
    buttonBack: "Kembali",
    buttonAutoGenerate: "Auto Generate",
    download: {
      title: "Download List STT",
      infoText:
        "Sebelum mendownload daftar manual STT, pastikan kembali daftar client/partner sudah benar dan sesuai dengan status masing-masing.",
      labelClientPartner: "Nama Client/Partner",
      placeholderClientPartner: "Ketik atau pilih client/partner",
      labelStatus: "Status",
      statusAll: "Semua Status",
      statusUsed: "Used",
      statusUnused: "Unused",
      buttonDownload: "Download",
      successTitle: "Download Manual STT Berhasil !",
      successOk: "Oke"
    },
    downloadTitle: "Download List STT",
    downloadInfo:
      "Sebelum mendownload daftar manual STT, pastikan kembali daftar client/partner sudah benar dan sesuai dengan status masing-masing.",
    downloadLabelClientPartner: "Nama Client/Partner",
    downloadLabelStatus: "Status",
    downloadButton: "Download",
    downloadSuccessTitle: "Download Manual STT Berhasil !",
    downloadSuccessOk: "Oke",
    generateFailed: "Generate Gagal !",
    printForm: {
      title: "Formulir Booking",
      sectionShipping: "D E T A I L  P E N G I R I M A N",
      date: "Tanggal",
      sttManual: "STT Manual",
      originDistrictCity: "Kecamatan, Kota Asal",
      senderName: "Nama Pengirim",
      senderAddress: "Alamat Pengirim",
      senderPhone: "No. Telepon",
      shipmentProduct: "Produk Pengiriman",
      shipmentProductPlaceholder: "(Checklist satu produk)",
      clientName: "Nama Client/POS",
      externalRefNo: "No. Referensi Eksternal",
      optionalPlaceholder: "(Opsional)",
      destinationDistrictCity: "Kecamatan, Kota Tujuan",
      recipientName: "Nama Penerima",
      recipientAddress: "Alamat Penerima",
      recipientPhone: "No. Telepon",
      sectionGoods: "D E T A I L  B A R A N G",
      goodsDescription: "Deskripsi Barang",
      goodsDetail: "Detail Barang",
      goodsEstimate: "Estimasi Harga Barang",
      woodpacking: "Woodpacking",
      woodpackingDescription: "Packing Kayu",
      insurance: "Asuransi",
      insuranceFree: "Free",
      insuranceBasic: "Basic",
      insurancePremium: "Premium",
      columnPieces: "Koli",
      columnGrossWeight: "Gross Weight (Kg)",
      columnDimension: "Dimension (P x L x T)",
      columnVolumeWeight: "Volume Weight (Kg)",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight"
    }
  },
  optional: "opsional",
  pusatResolusi: {
    cekKendala: "Cek kendala",
    laporkanKendala: "Laporkan kendala",
    sttNumberNeverReported: "No. STT/kendala belum pernah dilaporkan",
    sttNumberMessage: "Anda bisa melaporkan kendala untuk STT/kendala ini.",
    cekKendalaGagal: "Cek Kendala Gagal!",
    tabEscalate: "Tiket eskalasi",
    tabMyTicket: "Tiket saya",
    tabFollowed: "Tiket diikuti",
    searchPlaceholder: "Cari no. kendala/STT/shipment",
    escalatedBy: "Sedang dieskalasi oleh {name}",
    refresh: "Refresh",
    filter: "Filter",
    filterReset: "Reset",
    filterCategory: "Kategori",
    filterSelectCategory: "Pilih kategori",
    filterStatus: "Status",
    filterTicketType: "Jenis tiket",
    filterClaim: "Klaim",
    filterPriority: "Prioritas",
    filterApply: "Terapkan",
    sortOldest: "Terlama",
    sortNewest: "Terbaru",
    needToBeSolved: "Perlu diselesaikan",
    newMessage: "Pesan baru",
    mention: "Mention",
    needReview: "Perlu ulasan",
    emptyInternet: "Jaringan internet terputus",
    emptyServer: "Terjadi gangguan sistem",
    emptyNoData: "Belum ada kendala",
    emptySearchNotFound: "Kendala tidak ditemukan",
    emptyInternetDesc: "Periksa jaringan internal Anda.",
    emptyServerDesc: 'Klik "Muat ulang" atau coba beberapa saat lagi.',
    emptyNoDataDesc: "Yuk! Mulai laporkan kendala Anda.",
    emptySearchDesc:
      "Cek kembali atau cari nomor kendala/STT/shipment id lain.",
    columnIssueNo: "No. Kendala",
    columnSttShipment: "No. STT/shipment id",
    columnCategory: "Kategori kendala",
    columnPriority: "Prioritas",
    columnStatus: "Status",
    columnCreatedAt: "Waktu dibuat",
    columnAction: "Atur",
    badgeNeedToSolve: "Perlu diselesaikan",
    badgeClaim: "Claim",
    tooltipReviewExpired: "Batas waktu ulasan telah berakhir",
    newMessagePlaceholder: "Masukkan & tambahkan pesan terbaru disini",
    messageTemplateList: "Daftar template pesan",
    deleteMessage: "Hapus pesan",
    editMessage: "Edit pesan",
    issue: "Kendala",
    valid: "Sesuai",
    notValid: "Tidak Sesuai",
    ulasanToast: "Ulasan tiket <b>no. kendala",
    successSaved: "berhasil disimpan.",
    failedSaved: "gagal disimpan.",
    insertNote: "Masukkan catatan Anda",
    failedToSaveNote: "Gagal simpan catatan",
    sttIssue: "STT Bermasalah",
    category: "Kategori",
    updatedDate: "Tanggal Diperbarui",
    replyMessage: "Pesan Balasan",
    maxSize: "Maksimal foto tidak lebih dari",
    eachSize: "dan masing-masing ukuran adalah",
    addAttachment: "Tambahkan Lampiran",
    createdDate: "Tanggal Dibuat",
    statusReport: "Status Laporan Kendala",
    detail: {
      detailGoods: "Detail barang",
      grossWeight: "Berat kotor",
      dimension: "Dimensi",
      chargeableWeight: "Berat dikenakan biaya",
      koli: "Koli",
      codCharge: "Tagihan COD",
      goodsPrice: "Harga barang",
      insurance: "Asuransi",
      yes: "Ya",
      no: "Tidak",
      commodity: "Komoditas",
      isEscalation: "Tiket eskalasi Anda sedang dibuka di tab lain.",
      isNotEscalation: "Tiket Anda sedang dibuka di tab lain.",
      isEscalationSecondMessage:
        "Lanjutkan pengerjaan tiket di tab atau browser tersebut.",
      ticketActor: "Tiket sudah dieskalasi oleh",
      youStillCan: "Anda masih bisa eskalasi tiket dari kendala lainnya.",
      notes: "Catatan"
    },
    create: {
      reportIssue: "Laporkan kendala",
      issueType: "Jenis Kendala",
      sttLabel: "No. STT/shipment id",
      sttPlaceholder: "Masukkan nomor STT/shipment id",
      lastStatus: "Status terakhir",
      check: "Cek",
      reload: "Muat ulang",
      category: "Kategori kendala",
      selectCategory: "Pilih kategori kendala",
      description: "Deskripsi",
      deleteDescription: "Hapus deskripsi",
      descPlaceholder: "Masukkan deskripsi",
      submit: "Kirim laporan",
      uploadDesc:
        "Lampiran file berupa bukti file kendala. Cek panduan disamping. Maksimal 3 file: video (.mp4, .webm, .mov) hingga 200 MB, dokumen & gambar (.png, .jpg, .jpeg, .pdf, .docx, .csv, .xlsx, .xls) hingga 5 MB",
      problemDescTop: "Kendala sudah dilaporkan, ",
      problemDescBot: "tapi belum terdaftar di kategori kendala Genesis.",
      noKendala: "No. kendala",
      kategoriKendala: "Kategori kendala",
      pengirimanNbantuan: "Pengiriman & bantuan",
      sistemNbandingPinalti: "Sistem & banding pinalti",
      failedCheck: "Gagal cek laporan kendala!",
      faieldCheckCategory: "Gagal mengambil data category!",
      confirmMessage:
        "Pastikan detail yang Anda kirim sesuai karena hanya bisa melaporkan 1 kendala untuk 1 STT.",
      yes: "Ya, sesuai",
      cancel: "Batal",
      failed: "Gagal membuat laporan kendala!",
      fail: "Kendala gagal dilaporkan",
      success: "Kendala berhasil dilaporkan!",
      everReported: "Pernah dilaporkan dengan kendala berikut:",
      seeDetail: "Lihat detail",
      back: "Kembali",
      problemHavBeenReported:
        "Kendala sudah dilaporkan,<br />tapi belum terdaftar di kategori kendala Genesis.",
      lastStatusMessage:
        "Status terakhir STT kendala ini sudah tidak memenuhi syarat.",
      sttIssueCategory:
        "Kategori kendala tidak sesuai panduan laporan status terakhir.",
      ticketDetail: "Kendala sudah dilaporkan, sebelum pusat resolusi terbaru.",
      teamWillProcess: "Tim akan memproses kendala Anda.",
      snackbarMessage:
        "Template pesan berhasil ditambahkan. Klik <br /> “Simpan” untuk menutup.",
      snackbarMessageEdit:
        "Template pesan berhasil diubah. Klik “Simpan” <br /> untuk menutup.",
      snackbarMessageTemplateList:
        "Urutan template pesan berhasil diubah. Klik <br /> “Simpan” untuk menutup.",
      snackbarMessageDelete:
        "Template pesan berhasil dihapus. Klik <br /> “Simpan” untuk menutup.",
      snackbarMessageSuccess: "Perubahan template pesan berhasil disimpan.",
      snackbarMessageFailed: "Perubahan template pesan gagal disimpan.",
      deleteTemplate: "Hapus template pesan ini?",
      deleteTemplateMessage:
        "Pesan yang Anda hapus akan hilang dari daftar template.",
      noBack: "Tidak, kembali",
      yesDelete: "Ya, hapus",
      reportNewIssue: "Laporkan Kendala Baru",
      typeOrChoose: "Ketik atau pilih kategori kendala pengiriman",
      noShipment: "Nomor Shipment ID",
      noStt: "Nomor STT",
      ticketDesc: "Deskripsi Tiket",
      writeUrReply: "Tulis pesan balasan Anda disini",
      photoProof: "Bukti Foto",
      photoProofDesc:
        "Bukti foto bisa berupa foto paket/resi/chat pelanggan/berat paket saat ditimbang",
      logisticsDocumentationPhotoTwo:
        "Maks. file: 5 MB, Format: jpg, png. Rekomendasi dimensi 2 : 4 (contoh: 200px X 800px)",
      doxMaxSizeDesc:
        "Dokumen .pdf, word & excel, maks. size: 16 mb, maks. file: 2 Dokumen bisa berupa Surat Karantina, MSDS (Material Safety Data Sheet), SPTJ (Surat Pelepasan Tanggung Jawab) & PTI (Pemberitahuan Tentang Isi)",
      reportIt: "Laporkan",
      isReportDone: "Laporan Kendala Sudah Sesuai?",
      sttNoIsReported: "Nomor STT Sudah Pernah Dilaporkan",
      makesureDetail:
        "Pastikan detail yang Anda kirim sesuai karena Anda hanya bisa melaporkan 1 kendala untuk 1 STT",
      lookatStatus: "Lihat status laporan kendala yang sudah Anda kirimkan",
      seeReport: "Lihat Laporan",
      successSendReport: "Kendala Berhasil Dikirim",
      ourTeamWillProcess: "Tim kami akan memproses kendala Anda",
      reportFailed: "Pelaporan Kendala Gagal",
      sttNoFailed: "Validasi No. STT gagal",
      sttNoShipmentFailed: "Validasi No. Shipment gagal",
      failedToAddComment: "Gagal menambahkan komentar",
      attachment: "Panduan lampiran file:",
      thereIs: "Ada",
      problemReported: "kendala yang sudah di laporkan untuk STT ini"
    },
    detailPage: {
      updated: "Diperbarui"
    },
    summaryTab: "Ringkasan",
    detailInfoTab: "Detail informasi",
    modal: {
      reload: "Muat ulang",
      systemError: "Terjadi gangguan sistem",
      systemErrorMessage:
        'Klik "Muat ulang" atau coba laporkan beberapa saat lagi.'
    },
    review: {
      titleIssueNo: "No. kendala {ticketNo}",
      giveRating: "Kasih penilaian laporan kendala, ya!",
      ratingHint:
        "(pilih jempol ke bawah = mengecewakan dan atas = sangat memuaskan)",
      reviewLabel: "Berikan ulasan Anda",
      reviewPlaceholder: "Masukan ulasan terkait penggunaan Genesis",
      optional: "Opsional",
      cancel: "Batal",
      submit: "Kirim",
      save: "Simpan",
      rating: "Penilaian Anda",
      timeLimit: "Batas waktu ulasan telah berakhir",
      giveusrating: "Nilai kami, yuk!"
    },
    finish: {
      title: "Beri komentar terlebih dahulu sebelum menyelesaikan kendala.",
      sendAndFinish: "Kirim & selesaikan",
      cancel: "Batalkan"
    },
    reopen: {
      title: "Silahkan beri alasan terlebih dahulu sebelum membuka ulang tiket",
      reopenTicket: "Buka ulang tiket",
      cancel: "Batalkan"
    },
    success: {
      title: "Tiket no. kendala {noIssue} berhasil diselesaikan!",
      message: "Kendala sudah ditandai dengan status selesai.",
      ok: "Oke, mengerti",
      toastSuccess: "Tiket no. kendala {noIssue} berhasil diselesaikan.",
      failedToSendMessage: "Gagal mengirim pesan",
      insertYourMessage: "Masukkan pesan Anda"
    },
    history: {
      newMessagesAt: "{count} pesan baru pada jam {time}.",
      viewMessages: "Lihat pesan",
      attachment: "Lampiran",
      new: "Baru",
      today: "Hari ini",
      yesterday: "Kemarin",
      csAgentOnDuty: "Agen CS bertugas",
      transferredTo: "dipindahkan ke",
      priorityChangedTo: "Prioritas tiket diubah ke",
      by: "oleh",
      categoryChanged: "Kategori kendala",
      changedTo: "diubah ke",
      escalationTask: "Tugas eskalasi",
      completedBy: "diselesaikan oleh",
      ticketInEscalation: "dalam eskalasi",
      for: "untuk",
      ticket: "Tiket",
      madeByNew: "dibuat oleh",
      madeBy: "oleh",
      systemError: "Terjadi gangguan sistem",
      systemErrorDesc: 'Klik "Muat ulang" atau coba beberapa saat lagi.',
      internetError: "Jaringan internet terputus",
      internetErrorDesc:
        'Periksa jaringan internal Anda lalu klik "Muat ulang".',
      reload: "Muat ulang",
      dalamProses: "Dalam proses",
      ditundaSementara: "Ditunda sementara",
      direspon: "Direspon",
      selesai: "Selesai",
      ditutup: "Ditutup",
      menungguDokumen: "Menunggu dokumen",
      dokumenDiterima: "Dokumen diterima",
      dalamInvestigasi: "Dalam investigasi",
      diprosesAsuransi: "Diproses asuransi",
      konfirmasiCustomer: "Konfirmasi customer",
      dibayar: "Dibayar",
      ditolak: "Ditolak",
      rekonsiliasi: "Rekonsiliasi",
      klaim: "Klaim",
      failedToFinishIssue: "Gagal menyelesaikan kendala!",
      addTemplateTitle: "Tambah template pesan"
    },
    follow: {
      description:
        "Ikuti laporan kendala ini untuk mendapatkan update dan beri komentar!",
      button: "Ikuti laporan"
    },
    reply: {
      placeholder: "Balas",
      send: "Kirim"
    },
    chatBox: {
      partnerList: "Daftar mitra",
      letsCreateMessage: "Buat template untuk kirim pesan lebih cepat",
      addTemplate: "Tambah template",
      image: "Gambar",
      uploadErrorMessage: "Sesuaikan dan upload ulang file",
      anda: "anda",
      maxChar: "Maksimum 1.000 karakter.",
      insertAt: `Masukkan simbol {'@'} untuk mention seseorang`
    },
    deldex: {
      summary: "Ringkasan",
      lastCourier: "Kurir terakhir",
      detailDex: "Lihat detail DEX"
    },
    modalDex: {
      detailValidDex: "Detail Validasi DEX",
      reason: "Alasan"
    },
    partnerSection: {
      partnerTitle: "Mitra pelapor",
      escalationPartner: "Mitra eskalasi",
      isYou: "Anda",
      finishedAt: "Selesai pada",
      lookAtPrev: "Lihat eskalasi sebelumnya",
      csAgent: "Agent CS bertugas",
      partnerFollower: "Mitra pengikut",
      follower: "follower",
      seeAlittle: "Lihat sedikit",
      seeAll: "Lihat semua",
      prevPartner: "Mitra eskalasi yang bertugas sebelumnya"
    },
    summary: {
      updatedDate: "Tanggal diperbarui",
      bookingDate: "Tanggal booking",
      sendroute: "Rute pengiriman",
      deliveryType: "Jenis pengiriman",
      deliveryEst: "Estimasi pengiriman",
      track: "Lacak",
      detailTrackStt: "Detail tracking STT"
    },
    choose: "Pilih",
    dataResolution: "data pusat resolusi",
    noReportedIssue: "Belum Ada Kendala yang Dilaporkan",
    ifYouHaveIssue: "Jika Anda mengalami kendala, kami selalu siap membantu!",
    inProcess: "Dalam Penanganan",
    needHelp: "Butuh Balasan Anda",
    all: "Semua",
    sender: "Pengirim",
    receiver: "Penerima",
    csName: "Nama CS",
    reportSent: "Laporan kendala telah dikirim",
    reportInProcess: "Laporan kendala dalam penanganan",
    confused: "Bingung cara lapor? Baca panduan yuk!",
    makeSure: "Pastikan jenis & kategori sesuai kendala Anda.",
    checkModalLabel: "No. kendala/STT/shipment id",
    checkModalPlaceHolder: "Masukkan nomor kendala/STT/shipment id",
    checkNow: "Cek sekarang",
    new: "Baru",
    inProcess2: "Dalam proses",
    inEscalation: "Dalam eskalasi",
    onHold: "Ditunda sementara",
    solved: "Selesai",
    closed: "Ditutup",
    problemAlreadyReported:
      "Kendala sudah dilaporkan, sebelum pusat resolusi terbaru.",
    alreadyReportedHaventListed:
      "Kendala sudah dilaporkan, <br/>tapi belum terdaftar di kategori kendala Genesis.",
    shipmentId: "No STT / shipment id",
    problemCategory: "Kategori kendala",
    claim: "Khusus informasi klaim Anda bisa melacak",
    here: "di sini",
    contactCs: "Hubungi CS untuk melaporkan kendala baru",
    phone: "Telepon",
    solveProblem: "Selesaikan kendala",
    escalatedTo: "Dieskalasi ke",
    askRevertTicket: "Permintaan Penarikan Paket",
    failedToDeliver: "Paket Gagal Antar",
    refute: "Sanggah Terima",
    infobar: {
      alreadyReported:
        "No. STT sudah pernah dilaporkan, lihat detail untuk mengikuti laporan!",
      reportLimit: "Anda tidak bisa melaporkan kendala lagi!",
      issue: "Kendala",
      prohibitedReport: "tidak bisa dilaporkan lagi.",
      seeDetail: "Lihat detail"
    }
  },
  bookingShipment: {
    appsMarketplace: {
      title: "Booking aplikasi & marketplace",
      emptyHeader: "Belum ada data shipment/booking ID",
      emptyMessage: "Tambahkan shipment/booking ID terlebih dahulu.",
      scanLabel: "Shipment/booking ID",
      instantToggle: "Aktifkan booking Instan",
      tooltipScan: "Proses scan langsung berhasil booking",
      placeholderScan: "Masukkan atau scan shipment/booking ID",
      buttonAdd: "Tambah",
      errorAddFailed: "Penambahan shipment ID gagal !",
      totalShipmentStt: "Total Shipment/STT",
      successBooked: "Berhasil dibooking",
      successBookedCount: "Berhasil dibooking ({n})",
      notBooked: "Belum dibooking",
      notBookedCount: "Belum dibooking ({n})",
      failedBooked: "Gagal dibooking",
      failedBookedCount: "Gagal dibooking ({n})",
      sortOldest: "Terlama",
      sortNewest: "Terbaru",
      printAll: "Print semua",
      printThermalResi: "Print thermal resi PRN",
      printThermalPdf: "Print thermal resi PDF",
      printResiA4: "Print resi A4 PDF",
      receiptA6: "Resi A6",
      receiptA4: "Resi A4",
      printReceiptA6: "Print A6",
      printReceiptA4: "Print A4",
      addAddress: "Tambah penerima/alamat",
      importantInformation: "Informasi Penting",
      agreementCommodityMatch:
        "Saya setuju komoditas dalam paket sudah sesuai dengan komoditas yang ada pada informasi detail shipment di sistem.",
      agreementCommodityDefault:
        "Saya setuju apabila tidak ada komoditas yang tertera pada informasi detail di sistem, maka akan dikategorikan sebagai komoditas General.",
      agreementForbiddenCommodity:
        "Saya setuju bahwa komoditas yang dikirim bukan komoditas yang dilarang untuk dilakukan pengiriman.",
      viewDetails: "Lihat detailnya.",
      confirmBookingAgreement:
        "Dengan ini saya menyetujui dan ingin melanjutkan proses booking.",
      continueBooking: "Lanjutkan booking",
      skipBooking: "Lewati booking",
      no: "No",
      shipmentBookingId: "No. shipment/booking ID",
      noStt: "No. STT",
      productType: "Jenis pengiriman",
      chargeableWeight: "Berat dikenakan biaya",
      weightPieces: "Berat/Koli",
      dimension: "Dimensi",
      totalTariff: "Total tarif",
      bookingStatus: "Status Booking",
      action: "Atur",
      dataNotFound: "Data tidak ditemukan",
      filterNotMatch: "Pastikan filter yang Anda pilih sudah sesuai",
      success: "Berhasil",
      unbooked: "Belum dibooking",
      failed: "Gagal",
      failedWithReason: "Gagal: {reason}",
      piece: "koli"
    },
    column: {
      sttRecipientEmail: "Email Penerima",
      sttIdentityNumber: "Nomor ID Penerima",
      sttInterTaxNumber: "Nomor Tax ID Penerima",
      sttDutyTaxTerms: "Customs & Tax Payment",
      detailShipment: "Detail Pengiriman",
      manualSttNumber: "No. STT manual",
      noStt: "No. STT",
      externalRefNumber: "No. referensi eksternal",
      shipmentId: "Shipment ID",
      shipperName: "Nama Pengirim",
      recipientName: "Nama Penerima",
      shipperNameBookingNew: "Nama",
      recipientNameBookingNew: "Nama",
      shipperPhoneNumber: "No. Telepon Pengirm",
      recipientPhoneNumber: "No. Telepon Penerima",
      shipperAddress: "Alamat Pengirim",
      saveSender: "Simpan detail pengirim",
      saveReceiver: "Simpan detail penerima",
      recipientAddress: "Alamat Penerima",
      districtOriginCity: "Kecamatan, Kota Asal",
      districtDestinationCity: "Kecamatan, kota tujuan",
      postalCode: "Kode pos",
      itemDetails: "Detail Barang",
      selectServiceType: "Pilih Jenis Pengiriman",
      commodity: "Komoditas",
      insurance: "Asuransi",
      itemPrice: "Harga Barang",
      crossBorderInformation: "Free Trade Zone",
      taxIdentificationNumber: "No Registrasi Pajak (NPWP)",
      ftzIdNumber: "Nomor identitas",
      ftzEmail: "Email",
      shipmentStatus: "Status Pengiriman",
      additionalInformation: "Informasi Tambahan",
      additionalInterpack: "(Khusus INTERPACK)",
      additionalInterpackMaxi: "(Khusus INTERPACK MAXI)",
      commodityDetails: "Detail Komoditas",
      logisticsDocumentationPhoto: "Foto Pendukung",
      grossWeight: "Berat Kotor",
      dimensionsPackage: "Dimensi/Paket",
      dimensionWeight: "Berat Volume",
      totalItem: "Total Barang",
      totalGrossWeight: "Total Berat Kotor",
      totalDimensionWeight: "Total Berat Dimensi",
      chargeableWeight: "Berat Dikenakan Biaya",
      home: "Rumah",
      office: "Kantor",
      photo: "Foto",
      paymentMethod: "Metode Pembayaran",
      clientName: "Nama Klien",
      woodPacking: "Packing Kayu",
      piecePerPack: "Total Koli Per Kemasan",
      nextCommodity: "Komoditas Selanjutnya",
      codFeeOptional: "Tagihan COD",
      codGoodsPrice: "Harga Barang COD",
      protection: "Proteksi",
      shippingProtection: "Proteksi Pengiriman",
      titleCIPL:
        "Detail barang untuk CIPL (Commercial Invoice and Packing List)",
      detailitemCIPL: "Detail barang",
      quantityCIPL: "Kuantitas",
      priceCIPL: "Harga barang",
      numberShipment: "No Shipment",
      codAmount: "COD Amount",
      codType: "Tipe COD",
      photoSupportWeightChange: "Foto Pendukung Ubah Berat"
    },
    shipment: {
      chargeableWeight: {
        label: "Berat Dikenakan Biaya",
        detail: "Detail berat barang",
        totalItem: "Total barang",
        totalGrossWeight: "Total berat kotor",
        totalDimensionWeight: "Total berat dimensi"
      }
    },
    detail: {
      sttInfo: "Informasi STT",
      shipperSection: "Pengirim",
      recipientSection: "Penerima",
      intlShipmentDetail: "Detail pengiriman luar negeri",
      freeTradeZone: "Free trade zone",
      commercialInvoice: "Commercial Invoice",
      viewData: "Lihat Data",
      currentStatus: "Status Terakhir",
      createdFor: "Dibooking Untuk",
      shipperAddress: "Alamat Pengirim",
      shipperPhoneNumber: "No.Telepon Pengirim",
      recipientAddress: "Alamat Penerima",
      recipientPhoneNumber: "No. Telepon Penerima",
      addressType: "Tipe Alamat",
      serviceType: "Produk Pengiriman",
      totalPieces: "Jumlah Barang (Pieces/Koli)",
      totalChargeableWeight: "Total Berat Dikenakan Biaya",
      itemPriceEstimate: "Estimasi Harga Barang",
      shipmentInsurance: "Proteksi pengiriman",
      bookedBy: "Booked By",
      billedTo: "Billed to",
      source: "Source",
      returnDO: "DO Balikan",
      dimensions: "Dimensi (P x L x T)",
      troubledStatus: "Status Bermasalah",
      rejectedDate: "Tanggal Ditolak",
      modifiedDate: "Tanggal Diubah",
      createdDate: "Tanggal Dibuat",
      printReceipt: "Cetak File Resi",
      printThermalReceipt: "Print Thermal Resi",
      printThermalReceiptPDF: "Print Thermal Resi PDF",
      PrintBasic: "Print Basic/Save to PDF",
      PrintCommercialInvoice: "Print Commercial Invoice",
      bookedVia: "Dibooking Via",
      estimatedArrivalTime: "Estimasi tiba"
    },
    bulkPrint: {
      allDataDisplayed: "Semua data ditampilkan"
    },
    action: {
      addItems: "Tambah Barang",
      saveShipperData: "Simpan Data Pengirim",
      saveRecipientData: "Simpan Data Penerima",
      cancelBooking: "Batalkan Booking",
      editBooking: "Ubah Booking",
      buttonQuit: "Keluar",
      buttonStay: "Kembali"
    },
    weightPieces: {
      no: "No",
      remove: "Hapus",
      weightAbove: "Berat diatas",
      charged:
        " akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi.",
      infobarWeightComma:
        "Gunakan koma (,) untuk berat <1 kg. Contoh: 0,5 untuk 500 gram",
      error: {
        mandatoryWeight: "Berat kotor wajib diisi",
        prohibitedOnePiece: "hanya diperbolehkan 1 koli.",
        changeWeightOrNewBooking: "Ubah berat atau booking baru."
      }
    },
    placeholder: {
      shipperName: "Masukkan nama",
      shipperPhoneNumber: "Masukkan nomor telepon",
      recipientName: "Masukkan nama",
      shipperAddress: "Masukkan alamat",
      recipientAddress: "Masukkan alamat",
      districtOriginCity: "Ketik atau pilih alamat asal",
      districtDestinationCity: "Masukkan & pilih kecamatan/kota tujuan",
      postalCode: "Masukkan & pilih kode pos",
      commodity: "Pilih komoditas",
      itemPrice: "Harga barang minimum Rp10.000",
      taxIdentificationNumber: "00.000.000.0-000.000",
      shipmentStatus: "Pilih status pengiriman yang akan dikirim",
      commodityDetails: "Masukan detail komoditas",
      dimensionsPackage: "P x L x T",
      codFee: "Tagihan COD minimum Rp10.000",
      email: "Masukan email penerima",
      sttIdentityNumber: "Masukan nomor ID penerima",
      sttInterTaxNumber: "Masukan nomor tax ID penerima",
      shipmentId: "Masukkan shipment ID"
    },
    description: {
      logisticsDocumentationPhotoOne:
        "Foto pendukung dapat berupa foto paket sebelum dipacking, foto paket sesudah dipacking, foto ID (KTP) dan foto Tax Id (NPWP) Penerima.",
      logisticsDocumentationPhotoTwo:
        "Maks. file: 5 MB, Format: jpg, png. Rekomendasi dimensi 2 : 4 (contoh: 200px X 800px)"
    },
    product: {
      tagline: "Pengiriman Internasional",
      sla: "hari kerja",
      descAgent: "Diskon Agen",
      zeroCurrency: "Rp-"
    },
    validate: {
      uploadPhotos: "Harap unggah minimal 3 foto",
      itemPrice: "Harga barang minimal Rp10.000"
    },
    estimation: {
      totalCost: "Total Tarif",
      title: "Detail Pembayaran",
      cityRate: "City Rate",
      forwardRate: "Forward Rate",
      shipmentRates: "Biaya Pengiriman",
      commoditySurcharge: "Biaya Tambahan Komoditas",
      weightAdditionalCharge: "Biaya Tambahan Berat",
      additionalDocumentCost: "Biaya Tambahan Dokumen",
      woodpackingCost: "Biaya Packing Kayu",
      additionalCost: "Biaya Tambahan",
      codFee: "COD Fee",
      padFee: "PAD Fee",
      insurance: "Proteksi",
      shippingProtectionFee: "Proteksi",
      adminCost: "Biaya Admin",
      taxEstimate: "Est. Pajak",
      returnCost: "Biaya Retur",
      protection: "Proteksi pengiriman",
      protectionCost: "Biaya admin proteksi pengiriman"
    },
    payment: {
      title: "Jenis Pembayaran",
      cash: "Tunai",
      choose: "Pilih jenis pembayaran"
    },
    bookButton: {
      printLater: "Booking, Print Nanti",
      printThermal: "Booking, Print Thermal Resi",
      printThermalPdf: "Booking, Print Thermal Resi PDF",
      printBasic: "Booking, Print Basic/Save to PDF",
      failedBook: "Booking Gagal !"
    },
    placeholderSelect: {
      selectDistrictOriginCity: "Pilih kecamatan, kota asal",
      SelectDistrictDestinationCity: "Pilih kecamatan, kota tujuan",
      SelectclientPartner: "Pilih client/partner",
      selectDate: "Pilih tanggal"
    },
    list: {
      tabBookingList: "Daftar booking",
      searchStt: "Search for STT number",
      handoverSummary: "Ringkasan handover",
      dataUpdatedEvery10Min: "Data diupdate setiap 10 menit",
      refresh: "Refresh",
      handoverStiNow: "Handover STI sekarang, <br /> hindari telat!",
      handoverStiLate: "Handover STI telat, proses sekarang!",
      emptyHeaderMessage: "Belum ada daftar booking",
      emptyHeaderMessageFiltered: "Data tidak ditemukan",
      emptyMessage: "Yuk! Mulai booking pengiriman customer Anda.",
      emptyMessageFiltered: "Cek dan atur ulang data yang anda cari",
      createBooking: "Create Booking",
      bookingRetail: "Booking Retail",
      bookingClient: "Booking klien",
      others: "Lainnya",
      bookingAppMarketplace: "Booking aplikasi & marketplace",
      bookingInstant: "Booking instant",
      copySttNumber: "Salin nomor STT",
      trackShipment: "Lacak pengiriman",
      reportIssue: "Laporkan kendala",
      printThermalResiPdf: "Print thermal resi PDF",
      printResiA4Pdf: "Print resi A4 PDF",
      printCommercialInvoiceA4: "Commercial Invoice A4",
      printCommercialInvoiceA6: "Commercial Invoice A6",
      copySttSuccess: "Nomor STT tersalin ke clipboard",
      adjustmentAccepted: "Diterima",
      adjustmentRejected: "Ditolak",
      adjustmentPending: "Menunggu",
      filter: {
        bookingPeriod: "Periode",
        BookedFor: "Booked For",
        shipperPhoneNumber: "No Telepon Pengirim",
        recipientPhoneNumber: "No Telepon Penerima",
        serviceType: "Produk",
        selectServiceType: "Pilih Produk",
        selectStatus: "Pilih Status",
        status: "Status",
        shipmentInsurance: "Asuransi Pengiriman",
        statusAdjusted: "STT ADJUSTED",
        statusAdjustedPod: "STT ADJUSTED POD",
        assessmentStatusAll: "Semua",
        assessmentStatusWaiting: "Menunggu",
        assessmentStatusRejected: "Ditolak",
        assessmentStatusApproved: "Diterima"
      },
      table: {
        noSTTGenesis: "No. STT Genesis",
        shipmentID: "Shipment ID",
        noSttAndShipment: "No. STT",
        noShipment: "No. shipment",
        destinationAddress: "Alamat Tujuan",
        status: "Status",
        bookingDate: "Tanggal Booking",
        totalPieces: "Total Koli",
        totalWeight: "Total Berat",
        serviceType: "Jenis pengiriman",
        serviceTypeAndChargeableWeight: "Jenis pengiriman",
        chargeableWeight: "Berat dikenakan biaya",
        commodity: "Komoditas",
        createdFor: "Dibuat Untuk",
        insurance: "Asuransi",
        troubledStatus: "Status Bermasalah",
        clientName: "Nama Klien",
        lastStatus: "Status Terakhir",
        bookedFor: "Dibooking untuk",
        destinationCity: "Kota tujuan",
        atur: "Atur"
      },
      action: {
        createBooking: "Booking Retail",
        edit: "Ubah Booking",
        thermalReceipt: "Print Thermal Resi",
        thermalPdf: "Print Thermal Resi  PDF",
        basicPdf: "Print Basic/Save to PDF"
      }
    },
    tooltip: {
      manualStt: "Manual STT (Opsional)",
      manualSttMsg: "Isi jika ingin menggunakan STT Manual.",
      insurance: "Biaya proteksi:",
      insuranceMsg: `
          <ul class="custom-list">
            <li>Tier 1: Harga barang Rp1 - Rp1.000.000, <b>biaya proteksi flat Rp950</b></li>
            <li>Tier 2: Harga barang di atas Rp1.000.000 - Rp3.000.000, <b>biaya proteksi flat Rp4.750</b></li>
            <li>Tier 3: Harga barang di atas Rp3.000.000 - Rp5.000.000, <b>biaya proteksi flat Rp8.550</b></li>
            <li>Tier 4: Harga barang di atas Rp5.000.000 - Rp10.000.000, <b>biaya proteksi flat Rp19.000</b></li>
            <li>Tier 5: Harga barang di atas Rp10.000.000 - Rp20.000.000, <b>biaya proteksi flat Rp38.000</b></li>
            <li>Tier 6: Harga barang di atas Rp20.000.000 - Rp1.000.000.000, <b>biaya proteksi flat 0,27% dari harga barang</b></li>
          </ul>`,
      tax: "No. Registrasi Pajak (NPWP)",
      taxMsg:
        "Wajib Pajak bisa individu atau perusahaan sesuai dengan yang sudah terdaftar.",
      shipmentStatus: "Status Pengiriman",
      shipmentStatusMsg:
        "Status pengiriman berlaku untuk pengiriman dari Kota Asal FTZ. Isi dengan kondisi barang yang akan dikirimkan.",
      detailCommodity: "Detail Komoditas",
      detailCommodityMsg:
        "Isi dengan informasi detail dari komoditas pengiriman",
      weight: "Berat Barang (kg)",
      weightMsg:
        "Minimum berat barang adalah 1 kg. Masukan desimal dengan “,” bila dibutuhkan.",
      updateCost: "Perbarui Harga",
      shipmentId: "Khusus booking shipment korporat pickup (CP)"
    },
    error: {
      noRef: "No. Referensi eksternal wajib diisi",
      minimumRef: "Nomor referensi eksternal minimum 3 angka.",
      senderName: "Nama pengirim wajib diisi",
      recipientName: "'Nama penerima wajib diisi",
      senderNamePhone: "No. Telepon pengirim wajib diisi",
      recipientNamePhone: "No. Telepon penerima wajib diisi",
      invalidNumber: "Nomor telpon tidak valid, mohon ulangi kembali",
      senderAddress: "Alamat pengirim wajib diisi",
      recepientAddress: "Alamat penerima wajib diisi",
      destination: "Kecamatan, Kota Tujuan wajib diisi",
      addressType: "Tipe Alamat wajib diisi",
      postalCode: "Kode Pos wajib diisi",
      commodity: "Komoditas ini tidak aktif",
      mandatoryCommodity: "Komoditas wajib dipilih.",
      itemPrice: "Harga barang wajib diisi",
      detailCommodity: "Detail komoditas wajib diisi",
      serviceType: "Produk pengiriman wajib dipilih",
      embargoStatus: "Kota tujuan pengiriman masih berstatus Embargo",
      sameOriginDestination: "Alamat pengirim dan penerima tidak boleh sama",
      phoneCountryCode: "Masukan code negara dengan benar",
      phoneCharacter: "No. Telepon tidak boleh kurang dari 5 karakter",
      inactiveCity: "Kota dan atau Kecamatan Tidak Aktif",
      inactiveCommodity: "Komoditas tidak aktif",
      commodityNotFound: "Data tidak ditemukan",
      insurance: "Asuransi pengiriman wajib diisi",
      inactiveInsurance: "Asuransi tidak aktif",
      shipmentStatus: "Status pengiriman wajib diisi",
      uploadPhoto:
        "Gagal mengunggah Foto {value} ke storage. Harap hapus dan coba lagi.",
      weightMaximum:
        "Total berat barang melebihi batas maksimum yaitu 400 kg/STT",
      totalPayment: "Total Pembayaran",
      additionalInfoEmailRequired: "Email wajib diisi",
      additionalInfoEmailFormat: "Format email tidak valid",
      sttIdentityNumberRequired: "Nomor identitas penerima wajib diisi",
      sttIdentityNumberMaxLength: "Nomor ID penerima maksimum 100 karakter",
      sttInterTaxNumberRequired: "Nomor registrasi pajak penerima wajib diisi",
      sttInterTaxNumberMaxLength: "Nomor Tax ID penerima maksimum 100 karakter",
      embargo: "Rute sedang embargo",
      routeNotFound: "Rute belum tersedia",
      exceedMaxWeightCheck:
        "Total berat barang melebihi batas maksimum 400kg/STT, cek & ubah lagi."
    },
    message: {
      updated: "berhasil diubah"
    },
    filter: "Filter",
    filterLabels: {
      bookingPeriod: "Periode booking",
      dateRange: "Dari tanggal - sampai tanggal",
      dateRangeLabel: "Rentang tanggal",
      originDistrictCity: "Kecamatan, kota asal",
      destinationDistrictCity: "Kecamatan, kota tujuan",
      bookedFor: "Dibooking untuk",
      selectClientPartner: "Pilih client/partner",
      senderPhone: "No. telepon pengirim",
      receiverPhone: "No. telepon penerima",
      shipmentType: "Jenis pengiriman",
      selectShipmentType: "Pilih jenis pengiriman",
      status: "Status",
      selectStatus: "Pilih status",
      troubledStatus: "Status bermasalah",
      finalStatus: "Status final",
      ongoingStatus: "Status ongoing",
      deliveryServiceType: "Tipe layanan pengiriman",
      shippingProtection: "Proteksi pengiriman",
      yes: "Ya",
      no: "Tidak",
      apply: "Terapkan"
    }
  },
  bookingCbp: {
    tabTitle: "Daftar booking client CBP",
    bannerSearchClientFirst:
      "<strong>PENTING!</strong> Cari dan pilih nama klien dulu <strong>sebelum membuat manifest.</strong>",
    placeholderSearchClient: "Cari atau pilih nama klien",
    buttonCreateManifest: "Buat Manifest",
    emptyListMessage: "Belum ada daftar booking client CBP",
    columnStt: "No. STT",
    columnStatusManifest: "Status manifest",
    tooltipCopyStt: "Salin nomor STT",
    statusUnprinted: "Belum manifest",
    statusPrinted: "Sudah manifest",
    errorPrintManifest: "Gagal Print Manifest!",
    sidebarMenuName: "Booking Korporat (CBP)",
    copySttSuccess: "Nomor STT tersalin ke clipboard"
  },
  bookingShipmentV2: {
    action: {
      duplicateRetail: "Duplicate STT untuk retail",
      duplicateClient: "Duplicate STT untuk client"
    }
  },
  selecDate: "Pilih tanggal",
  manifest: {
    product: "Produk"
  },
  pickup: {
    confirmTitleCreate: "Konfirmasi Pembuatan",
    confirmTextSuccess: "Process",
    printLabel: "Cetak label",
    detail: {
      printLabel: "Cetak label",
      dhlCourierNamePrefix: "[Kurir DHL]",
      labelUnavailable: "Label belum tersedia",
      confirmTitleCreate: "Konfirmasi Pembuatan",
      confirmTextSuccess: "Process",
      header: {
        title: "Detail - {pickupId}",
        woodPacking: "KAYU"
      },
      summary: {
        shared: {
          sttUnit: "STT",
          koliUnit: "koli",
          weightUnit: "kg",
          additionalLabel: "+ Tambahan"
        },
        totalRequest: {
          title: "Total Request"
        },
        totalPickup: {
          title: "Total di Pick Up",
          additionalKoli: "Tambahan {additionalKoli} koli"
        },
        agentHub: {
          title: "Diproses Agen/Hub"
        }
      },
      stt: {
        sectionTitle: "Daftar STT yang di Pick Up",
        emptyTitle: "Belum ada daftar STT",
        table: {
          colNo: "No",
          colSttNo: "Nomor STT",
          colKoli: "Koli",
          colBerat: "Berat",
          weightSuffix: "{weight} kg"
        },
        pagination: {
          caption: "{shown} dari {total} data"
        }
      },
      sidebar: {
        title: "Status Pick Up",
        createdAtLabel: "Tanggal dibuat",
        createdBy: "Oleh {name}",
        courierSection: "Informasi Kurir",
        courierEmpty: "Kurir belum ditugaskan",
        proofPhotos: "Bukti foto",
        merge: {
          infoMessage:
            "Shipment ini gabungan dari {shipmentCount} dengan total koli dan berat yang dihitung keseluruhannya.",
          shipmentUnit: "shipment",
          viewLink: "Lihat shipment",
          listTitle: "Daftar shipment tergabung",
          listItem: "{shipmentId} ({koliCount} koli - {weightKg} kg)",
          listItemIdOnly: "{shipmentId}"
        }
      },
      status: {
        waitingCourier: "Menunggu Kurir",
        pickUpPackage: "Paket di Pick Up",
        mergedPickUp: "Pick Up Digabung",
        cancelled: "Dibatalkan",
        done: "Selesai"
      }
    },
    scheduleConfig: {
      pageTitle: "Atur jadwal Pick Up",
      breadcrumb: {
        parent: "Konfigurasi Jadwal Pick Up"
      },
      shipment: {
        sectionTitle: "Informasi Shipment",
        clientLabel: "Klien",
        estimateAdditionalKoli: "Estimasi tambahan koli",
        estimateWeight: "Estimasi berat",
        weightSuffix: "kg",
        serviceType: "Jenis pengiriman",
        placeholderKoli: "Masukkan estimasi tambahan koli",
        placeholderWeight: "Masukkan estimasi berat",
        placeholderService: "Pilih jenis pengiriman"
      },
      clientSelector: {
        title: "Pilih Client",
        fieldLabel: "Klien",
        fieldPlaceholder: "Pilih client",
        continueButton: "Lanjutkan",
        clientPlaceholder: "Pilih klien",
        continue: "Pilih",
        cancel: "Batalkan"
      },
      scheduleSectionTitle: "Jadwal Pick Up",
      regular: {
        title: "Jadwal reguler",
        tooltip: "Jadwal Pick Up terbaru akan diterapkan mulai besok.",
        maxSlotsNote: "(Maks. 3 jadwal per hari.)",
        addTime: "Tambah jam",
        emptySlots: "Jam belum dipilih",
        popoverTitle: "Pilih jam Pick Up",
        durationFooter: "Durasi 1 jam",
        duplicateTime: "Jam ini sudah ditambahkan",
        confirmTime: "Pilih",
        emptyTimeOptions: "Pilihan jam tidak tersedia",
        days: {
          monday: "Senin",
          tuesday: "Selasa",
          wednesday: "Rabu",
          thursday: "Kamis",
          friday: "Jumat",
          saturday: "Sabtu",
          sunday: "Minggu"
        }
      },
      sidebar: {
        addressTitle: "Alamat Pick Up",
        changeAddress: "Ubah alamat",
        addAddress: "Tambah alamat",
        saveSchedule: "Simpan jadwal",
        defaultBadge: "Utama",
        coordinatesLabel: "Titik koordinat :",
        empty: "Belum ada alamat tersimpan"
      },
      special: {
        modalTitle: "Pilih jadwal Pick Up",
        pickDateLabel: "Pilih tanggal",
        pickTimeLabel: "Pilih jam",
        save: "Simpan",
        duplicateDate: "Tanggal ini sudah ditambahkan",
        modalMaxSlotsNote: "Maks. 3 jadwal per hari.",
        title: "Jadwal Khusus",
        tooltipTitle: "Jadwal Khusus",
        tooltipDescription:
          "Jadwal khusus akan menggantikan jadwal rutin pada tanggal yang dipilih.",
        maxDatesNote: "(Maks. 3 tanggal.)",
        addDate: "Pilih tanggal Pick Up",
        reset: "Reset",
        addTime: "Tambah jam"
      },
      successModal: {
        title: "Jadwal Pick Up berhasil disimpan",
        description:
          "Konfigurasi telah tersimpan & akan diterapkan dimulai besok.",
        buttonClose: "Tutup"
      },
      successNotification: "Jadwal Pick Up berhasil disimpan",
      leaveModal: {
        title: "Yakin ingin keluar?",
        description: "Semua perubahan akan dibatalkan jika Anda keluar.",
        buttonCancel: "Tetap disini",
        buttonConfirm: "Ya, keluar"
      }
    },
    activePickupWarning: {
      title: "Lanjutkan request Pick Up baru?",
      body:
        "Sistem akan menambahkan shipment baru dan shipment sebelumnya masih tetap berjalan.",
      buttonBack: "Kembali",
      buttonConfirm: "Lanjutkan"
    },
    requestSuccess: {
      title: "Request Pick Up Terkirim",
      description: "Request Pick Up dengan Order ID",
      description2: " telah dibuat.",
      summary: {
        totalLabel: "Total request",
        totalValue: "{totalKoli} koli • {totalWeightKg} kg",
        dateLabel: "Tanggal Pick Up",
        timeLabel: "Jam Pick Up"
      },
      button: {
        close: "Tutup",
        viewDetail: "Lihat detail shipment",
        viewDetailAWB: "Lihat detail"
      }
    },
    cancel: {
      button: "Batalkan",
      confirm: {
        title: "Yakin ingin membatalkan shipment?",
        instruction: "Masukkan alasan pembatalan sebelum melanjutkan.",
        reasonPlaceholder: "Alasan pembatalan",
        back: "Batalkan",
        continue: "Lanjutkan",
        charCounter: "{current}/{max}"
      },
      success: {
        title: "Shipment berhasil dibatalkan",
        body: "Pembatalan shipment telah berhasil diproses.",
        close: "Tutup"
      },
      failed: {
        title: '"{shipmentId}" gagal dibatalkan',
        body: "Pembatalan Pick Up gagal. Cek & coba kembali.",
        back: "Kembali",
        retry: "Ulangi"
      },
      sidebar: {
        reasonLabel: "Alasan pembatalan"
      }
    },
    bookingSummary: {
      titleSuggestion: "Rekomendasi di Pick Up",
      titleBucket: "Siap di Pick Up",
      changeAddress: "Ubah alamat",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Jadwal terdekat:",
      viewStt: "Lihat STT",
      viewActivePickup: "Lihat Pick Up aktif {count}",
      empty:
        "Data Pick Up request belum tersedia. Silakan buat Pick Up secara manual",
      createManual: "Buat Pick Up manual",
      piece: "koli",
      wood: "KAYU",
      addressIsEmpty: "Alamat Pick Up belum ditambah.",
      addAddress: "Tambah alamat"
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Buat Pick Up Manual"
      },
      banner: {
        sttPrefix: "Anda memiliki ",
        sttSuffix: " yang dapat diproses",
        viewAll: "Lihat semua"
      },
      field: {
        clientLabel: "Klien",
        clientPlaceholder: "Pilih klien",
        addressLabel: "Alamat Pick Up",
        koliLabel: "Estimasi koli",
        koliPlaceholder: "Masukkan estimasi koli",
        weightLabel: "Estimasi berat",
        weightPlaceholder: "Masukkan estimasi berat",
        weightUnit: "kg",
        serviceLabel: "Jenis pengiriman",
        servicePlaceholder: "Pilih jenis pengiriman",
        dateLabel: "Tanggal",
        selectDatePlaceholder: "Pilih tanggal",
        timeLabel: "Jam",
        courierNoteLabel: "Catatan untuk kurir",
        courierNotePlaceholder: "Masukkan catatan Anda untuk kurir"
      },
      specialHandling: {
        dangerousGoods: "Barang Berbahaya (DG)",
        quarantine: "Karantina (K)",
        woodPacking: "Packing Kayu (WP)"
      },
      address: {
        mainBadge: "Utama",
        coordinate: "Titik koordinat : {lat}"
      },
      addressEmpty: "Belum ada alamat tersimpan",
      addressListTitle: "Daftar Alamat",
      recommendationLabel: "Rekomendasi koli dan berat",
      recommendationChip: "{koli} koli • {weight} kg",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimasi koli wajib diisi",
        weight: "Estimasi berat wajib diisi",
        date: "Tanggal wajib dipilih",
        time: "Jam wajib dipilih",
        service: "Jenis pengiriman wajib dipilih",
        address: "Alamat Pick Up wajib dipilih"
      },
      changeAddress: "Ubah alamat",
      chooseAddress: "Pilih alamat",
      timePlaceholder: "Pilih jam Pick Up",
      back: "Kembali",
      retry: "Ulangi",
      submit: "Kirim",
      sttListTitle: "Daftar STT yang dapat di Pick Up ({count})",
      sttListEmpty: "Daftar STT belum tersedia",
      success: {
        title: "Permintaan Pick Up berhasil dikirim",
        message: "Pick Up akan segera diproses oleh kurir.",
        button: "Oke, mengerti"
      },
      error: {
        title: "Permintaan Pick Up gagal",
        message: "Silakan coba beberapa saat lagi.",
        button: "Tutup"
      }
    },
  },
  pickupManifest: {
    breadcrumb: "Proses PUP",
    placeholderPickupDate: "Pilih tanggal pickup",
    inputSttLabel: "Input STT Menggunakan",
    scanStt: "Scan STT",
    listBkd: "List BKD",
    exampleStt: "Contoh : 99LP1234567890123/88-22-12345678",
    buatPickupPrintPdf: "Buat Pickup & Print PDF",
    download: "Download",
    ok: "OK"
  },
  pickupDashboard: {
    menuName: "Pickup Dashboard",
    tabCourierList: "Daftar Kurir",
    tabPickup: "Pick Up",
    tabAllPickUp: "Semua Pick Up",
    searchPlaceholder: "Nama pengirim, nomor HP pengirim, Shipment ID",
    shipmentType: "Tipe Shipment",
    downloadDataCourier: "Data Kurir",
    downloadDataPickUp: "Data Pick Up",
    column: {
      no: "No.",
      sttNo: "No. STT",
      shipmentId: "Shipment ID",
      senderName: "Nama Pengirim",
      courierName: "Nama Kurir",
      shipmentType: "Tipe Shipment",
      totalShipment: "Total Shipment (koli)",
      totalKoli: "Total Koli",
      pickUpDate: "Tanggal Pick Up",
      pickUpProof: "Bukti Pick Up",
      depositTime: "Waktu Setor",
      depositProof: "Bukti Setor",
      bkdDate: "Tanggal BKD",
      cancelDate: "Tanggal Pembatalan",
      cancelReason: "Alasan",
      proof: "Bukti",
      assign: "Assign",
      booking: "Booking",
      remainingTime: "Sisa Waktu",
      address: "Alamat",
      transferPickUp: "Transfer Pick Up",
      areaName: "Nama Area",
      dedicatedCourier: "Dedicated Kurir",
      createdDate: "Dibuat Tanggal",
      createdBy: "Dibuat Oleh",
      lastUpdated: "Terakhir Diubah",
      updatedBy: "Diubah Oleh",
      action: "Aksi"
    },
    transferSuccess: "Transfer Berhasil",
    transferFailed: "Transfer Gagal !",
    transferSuccessMessage:
      "Kurir {courierName} telah ditugaskan untuk Pick Up <b>{packageCount} Paket.</b>",
    transferPickUp: "Transfer Pick up",
    transferMultiplePickUp: "Transfer Multiple Pick Up",
    assignPickUp: "Assign Pick Up",
    dataPickUp: "Data Pick Up",
    selectCourier: "Pilih kurir",
    selectCourierPlaceholder: "Pilih kurir tujuan",
    assign: "Assign",
    totalSender: "Total Pengirim",
    package: "Paket",
    shipment: "Shipment",
    koli: "koli",
    sender: "Pengirim",
    selectedSender: "pengirim terpilih",
    selectedShipment: "shipment terpilih",
    viewDetail: "Lihat Detail",
    viewProof: "Lihat Bukti",
    booking: "Booking",
    manualAssign: "Manual Assign",
    multipleManualAssign: "Multiple Manual Assign",
    scheduleAssign: "Atur jadwal assign",
    date: "Tanggal",
    time: "Jam",
    selectTime: "Pilih jam",
    noTimeOptions: "Tidak ada pilihan jam",
    manualAssignSuccessTitle: "Manual Assign Berhasil",
    manualAssignSuccessMessage: "Kurir telah ditugaskan untuk Pick Up paket.",
    manualAssignFailedTitle: "Gagal Assign",
    manualAssignPartialMessage:
      "{count} shipment sudah diassign ke kurir sebelumnya.",
    downloadFailedTitle: "Gagal Download Data !",
    systemError: "Terjadi kendala sistem",
    today: "Hari ini",
    yesterday: "Kemarin",
    custom: "Custom",
    selectDate: "Pilih tanggal",
    bookingPickUp: "Booking Pick Up",
    totalPickUp: "Total Pick Up",
    belumDiPickUp: "Belum Di Pick Up",
    belumDisetor: "Belum Disetor",
    belumBkd: "Belum BKD",
    sudahBkd: "Sudah BKD",
    courier: "Kurir",
    waitingAssign: "Menunggu Assign",
    riwayatGagal: "Riwayat Gagal",
    belumDiassign: "Belum Diassign",
    manageArea: {
      title: "Manajemen Area Pick Up",
      viewYourArea: "Lihat Wilayah Anda",
      yourAreaTitle: "Wilayah Anda",
      yourAreaData: "data Wilayah Anda",
      setDedicatedCourier: "Atur Dedicated Kurir",
      assignCourierTitle: "Atur Kurir",
      setShift: "Atur Shift",
      selectCourierPlaceholder: "Pilih kurir",
      noCourierAvailable: "Tidak ada kurir tersedia",
      searchPlaceholder: "Cari dengan ID, Nama kurir, Area",
      search: "Cari",
      sort: "Urutkan",
      sortAZ: "A - Z",
      sortZA: "Z - A",
      unassignedBanner:
        "{count} kelurahan belum memiliki area dan dedicated kurir.",
      createTitle: "Atur Area Dedicated",
      save: "Simpan",
      confirmTitle: "Simpan Area Dedicated?",
      confirmMessage:
        "Area dan dedicated kurir yang Anda pilih akan ditambahkan. Pengaturan ini masih dapat diubah",
      cancel: "Batal",
      successTitle: "Area Dedicated Ditambahkan",
      successMessage:
        "Area dan kurir dedicated yang Anda pilih berhasil disimpan. ",
      ok: "Oke",
      column: {
        areaName: "Nama Area",
        dedicatedCourier: "Dedicated Kurir",
        shipmentType: "Tipe Shipment",
        createdDate: "Dibuat Tanggal",
        createdBy: "Dibuat Oleh",
        lastUpdated: "Terakhir Diubah",
        updatedBy: "Diubah Oleh",
        action: "Aksi"
      },
      transferColumn: {
        no: "No.",
        village: "Kelurahan",
        subDistrict: "Kecamatan",
        district: "Kota/Kabupaten",
        province: "Provinsi"
      },
      subDistrict: "kelurahan",
      moreCourier: "kurir",
      edit: "Edit",
      transferArea: "Transfer Wilayah",
      transfer: "Transfer",
      transferAreaTitle: "Transfer Wilayah Area {areaName}",
      destinationAreaLabel: "Pilih Area Tujuan",
      destinationAreaPlaceholder: "Pilih Area",
      noDestinationArea: "Tidak ada area tujuan",
      searchSubDistrictPlaceholder: "Cari Wilayah",
      transferFailedTitle: "Gagal Transfer Paket",
      transferFailedMessage:
        "Sistem gagal melakukan transfer paket. Silakan coba lagi.",
      transferConfirmTitle:
        "Transfer {count} Kelurahan ke Distrik {destinationAreaName}?",
      transferConfirmMessage:
        "Jika wilayah ditransfer, maka area & dedicated kurir akan diatur sesuai area tujuan.",
      confirmTransfer: "Ya, Transfer",
      back: "Kembali",
      delete: "Hapus",
      emptyHeader: "Belum ada data area",
      emptyHeaderWithUnassigned: "Area dan kurir dedicated belum diatur",
      emptyMessage: "Anda belum memiliki area dedicated",
      emptyMessageWithUnassigned: "Silakan mulai atur area & kurir dedicated",
      searchNotFound: "Hasil tidak ditemukan",
      searchNotFoundHint: "Silakan cek kata kunci Anda atau ubah filter ",
      deleteSuccess: "Area {areaName} & dedicated kurir telah dihapus.",
      deleteFailed: "Gagal Menghapus Data",
      deleteFailedMessage:
        "Silakan coba lagi dan pastikan koneksi internet Anda stabil.",
      createFailedTitle: "Gagal Mengatur Dedicated Area",
      createFailedDefaultMessage:
        "Sistem gagal menyimpan area atau kurir Anda. Silakan coba lagi.",
      createFailedInternetMessage:
        "Silakan coba lagi dan pastikan koneksi internet Anda stabil.",
      editSuccess: "Detail area berhasil diubah.",
      editFailed: "Gagal Mengedit Data",
      editFailedDefaultMessage:
        "Sistem gagal menyimpan perubahan area atau kurir Anda. Silakan coba lagi.",
      editFailedInternetMessage:
        "Silakan coba lagi dan pastikan koneksi internet Anda stabil.",
      leaveConfirmTitle: "Yakin keluar halaman?",
      leaveConfirmMessage:
        "Proses yang sedang berjalan akan dibatalkan dan data akan terhapus.",
      leaveConfirmSuccess: "Ya, Keluar"
    },
    emptyState: {
      noCourier: "Belum ada data kurir",
      noCourierHint: "Silakan menambahkan kurir baru di menu manajemen kurir",
      noPackage: "Belum ada paket",
      noPackageHint: "Belum ada paket pada daftar ini",
      searchNotFound: "Hasil tidak ditemukan",
      searchNotFoundHint: "Silakan cek kata kunci Anda atau ubah filter "
    },
    tryAgain: "Coba Lagi",
    partialTransferSuccess: "Transfer Berhasil Sebagian",
    partialTransferMessage: "Terdapat {count} shipment masih gagal ditransfer.",
    transferAllFailed: "Gagal Transfer",
    transferAllFailedMessage: "{count} shipment tidak bisa ditransfer.",
    pickUpRemaining: "Waktu Pick Up untuk {count} seller tersisa 30 menit.",
    allTime: "Semua waktu",
    dateRangeTitle: "Rentang tanggal",
    reset: "Atur Ulang",
    downloadData: "Download Data",
    dateRangePicker: {
      selectDate: "Pilih tanggal",
      customRange: "Tentukan tanggal",
      last7Days: "7 hari terakhir",
      last14Days: "14 hari terakhir",
      last30Days: "30 hari terakhir",
      allTime: "Semua waktu",
      weekdays: {
        mon: "Sen",
        tue: "Sel",
        wed: "Rab",
        thu: "Kam",
        fri: "Jum",
        sat: "Sab",
        sun: "Min"
      },
      reset: "Atur Ulang",
      apply: "Terapkan"
    }
  },
  "Transfer Berhasil": "Transfer Berhasil",
  "Transfer Gagal !": "Transfer Gagal !",
  pickupCorporate: {
    menuPickUp: "Pick Up",
    menuListPickUp: "Daftar Pick Up",
    menuScheduleConfig: "Konfigurasi Jadwal",
    menuCreateConfig: "Buat konfigurasi baru",
    menuCreatePickUp: "Buat Pick Up baru",
    menuEditConfig: "Ubah konfigurasi",
    buttonCreateInstant: "Buat Pick Up Langsung",
    searchPlaceholder: "Cari no Shipment",
    periodeTitle: "Jadwal Pick Up",
    filterVehicleType: "Tipe Armada",
    filterVehiclePlaceholder: "Pilih tipe armada",
    filterPickupType: "Tipe Pick Up",
    filterServiceType: "Jenis Pengiriman",
    emptyHeaderMessage: "Belum ada daftar Pick Up",
    emptyMessage: "Yuk, buat pick up langsung dan cek daftarnya disini.",
    typeScheduled: "Pick Up terjadwal",
    typeInstant: "Pick Up langsung",
    sortLabel: "Urutkan",
    sortNearest: "Jadwal Pick Up terdekat",
    sortFarthest: "Jadwal Pick Up terjauh",
    sortMaxPickup: "Jumlah tonase terbanyak",
    sortMinPickup: "Jumlah tonase terkecil",
    sortMaxKoli: "Jumlah koli terbanyak",
    sortMinKoli: "Jumlah koli terkecil",
    columnNo: "No",
    columnShipmentId: "Shipment ID",
    columnClientRef: "Referensi klien",
    columnSchedule: "Jadwal Pick Up",
    columnVehicleType: "Tipe armada",
    columnEstKoli: "Estimasi jumlah koli",
    columnPickupType: "Tipe Pick Up",
    columnServiceType: "Jenis pengiriman",
    columnStatus: "Status",
    actualKoli: "Aktual",
    koli: "Koli",
    seeAll: "(Lihat semua)",
    statusFindingCourier: "Mencari Kurir",
    statusCourierAssigned: "Kurir Ditugaskan",
    statusPickedUp: "Paket di Pick Up",
    statusDone: "Selesai",
    statusCancelledCourier: "Dibatalkan Kurir",
    statusCancelledClient: "Dibatalkan Klien",
    statusCancelledAdmin: "Dibatalkan Admin",
    selectStatus: "Pilih Status",
    bannerNewFeatureTitle: "Fitur baru: Sekarang Anda bisa Pick Up langsung!",
    bannerNewFeatureDesc:
      'Mau paketnya di Pick Up langsung? Tinggal klik "Buat Pick Up langsung", isi informasi Pick Up, dan selesai dah!',
    detailInfo: "Detail Informasi",
    the3lcPickUp: "3LC Pick Up",
    addressPickUp: "Alamat Pick Up",
    coordLabel: "Titik koordinat",
    coordLabelGoogle: "Titik Kordinat Google Maps",
    datePickUp: "Tanggal Pick Up",
    timePickUp: "Jam Pick Up",
    statusRequest: "Status permintaan Pick Up",
    cancelPickUp: "Batalkan Pick Up",
    cancelButton: "Batalkan",
    modalCancelTitle: "Batalkan Pick Up?",
    modalCancelMessage:
      "Permintaan Pick Up tidak akan diproses jika membatalkan Pick Up ini.",
    modalCancelSuccessTitle: "Pick Up berhasil dibatalkan",
    modalCancelSuccessMessage:
      'Pick Up dengan nomor shipment "{shipmentId}" berhasil dibatalkan.',
    cancelFailedMessage: "Pembatalan Pick Up gagal. Cek & coba kembali.",
    copySuccess: "Shipment ID berhasil disalin",
    clientRef: "Referensi Klien",
    districtCity: "Kecamatan, Kota",
    courierNote: "Catatan untuk kurir",
    estimateKoli: "Estimasi Jumlah Koli",
    actualKoliLabel: "Aktual jumlah koli",
    estimateTonase: "Estimasi jumlah tonase",
    vehicleType: "Tipe Armada",
    serviceType: "Jenis Pengiriman",
    proofPhoto: "Bukti Foto Pickup",
    photoN: "Foto {n}",
    listStt: "Daftar STT",
    emptyStt: "Belum ada daftar STT",
    emptySttMessage: "Tunggu STT Anda diproses oleh Agen/POS Lion Parcel.",
    vehicleNo: "Nomor Kendaraan",
    courierName: "Nama kurir",
    courierPhone: "Nomor kontak kurir",
    cancelReason: "Alasan pembatalan",
    dateCreated: "Tanggal Dibuat",
    dateUpdated: "Tanggal Diperbarui",
    back: "Kembali",
    retry: "Ulangi",
    yesCancel: "Ya, batal",
    titleCreate: "Buat Pick Up langsung",
    placeholderClient: "Pilih referensi klien",
    placeholderCourierNote: "Masukkan catatan Anda untuk kurir",
    fleetAndSchedule: "Armada dan Jadwal",
    placeholderService: "Pilih jenis pengiriman",
    placeholderTime: "Minimal 4 jam dari waktu permintaan",
    modalSuccessTitle: "Pick Up langsung berhasil dibuat",
    modalSuccessMessage:
      'Permintaan Pick Up dengan nomor shipment "{shipmentId}" telah dibuat.',
    modalFailedTitle: "Pick Up langsung gagal dibuat",
    modalFailedMessage:
      "Permintaan konfigurasi jadwal baru Pick Up gagal dibuat. Cek & coba kembali.",
    errorTimeTitle: "Waktu Pick Up minimal 4 jam dari sekarang",
    errorTimeMessage: "Silahkan atur ulang waktu Pick Up Anda.",
    transportType: "Tipe Armada",
    pickupDate: "Tanggal Pickup",
    pickupDay: "Hari Pickup",
    jamPickup: "Jam Pickup",
    save: "Simpan",
    ok: "OK",
    buttonCreateConfig: "Buat Konfigurasi Baru",
    bannerScheduleTitle:
      "Fitur baru: Sekarang bisa atur konfigurasi jadwal Pick Up!",
    bannerScheduleDesc:
      'Mau jadwalkan Pick Up rutin? Tinggal klik "Buat konfigurasi baru", isi informasi Pick Up, dan pilih pengulangan waktunya yah!',
    emptyScheduleHeader: "Tidak Ada Daftar Konfigurasi Jadwal",
    emptyScheduleMessage:
      "Mulai buat Daftar Konfigurasi Jadwal dan cek daftarnya disini",
    columnConfigName: "Nama konfigurasi jadwal",
    dateStart: "Tanggal Dimulai",
    dateEnd: "Tanggal Selesai",
    repeatPickup: "Pengulangan Pickup",
    titleCreateConfig: "Buat Konfigurasi Baru",
    titleEditConfig: "Ubah konfigurasi",
    placeholderConfigName: "Cth : Pick Up JABODETABEK",
    dateStartPickUp: "Tanggal mulai Pick Up",
    dateEndPickUp: "Tanggal berakhir Pick Up",
    validationEndBeforeStart:
      "Tanggal berakhir Pick Up tidak boleh kurang dari Tanggal mulai Pick Up",
    maxPickupTime: "Maksimal Pick Up dijemput jam 16.00 WIB",
    modalConfirmTitle: "Simpan perubahan konfigurasi jadwal Pick Up?",
    modalConfirmMessage: "Pastikan data yang Anda masukkan sudah benar.",
    modalSuccessConfigTitleCreated: "berhasil dibuat",
    modalSuccessConfigTitleUpdated: "berhasil diperbarui",
    modalSuccessConfigCreated:
      "Permintaan konfigurasi jadwal baru Pick Up telah dibuat.",
    modalSuccessConfigUpdated:
      "Perubahan konfigurasi jadwal baru Pick Up telah tersimpan.",
    modalFailedConfigMessage:
      "Permintaan konfigurasi jadwal baru Pick Up gagal dibuat. Cek & coba kembali.",
    pickupInterval: "Pickup",
    weekOnce: "Minggu Sekali",
    hariPickup: "Hari Pickup",
    tanggalMulaiPickup: "Tanggal Mulai Pickup",
    tanggalBerakhirPickup: "Tanggal Berakhir Pickup",
    configName: "Nama konfigurasi jadwal",
    repeatPickUpLabel: "Pengulangan Pick Up",
    nextPickUpDay: "Pick up selanjutnya hari",
    statusSchedule: "Status jadwal Pick Up",
    statusConfig: "Status Konfigurasi Jadwal",
    editButton: "Ubah",
    clickToActivateStatus:
      "Klik tombol di bawah ini untuk mengaktifkan atau menonaktifkan status",
    statusActive: "Aktif",
    statusInactive: "Tidak Aktif",
    filterPlaceholderClient: "Pilih referensi klien",
    filterPlaceholderVehicle: "Pilih tipe armada",
    utama: "Utama",
    addAddress: "Tambah alamat baru",
    selectOtherAddress: "Pilih alamat lain",
    noAddressSaved: "Belum ada alamat tersimpan",
    placeholderAddress: "Masukkan alamat Pick Up",
    successAddressSaved: "Sekarang Anda bisa pakai alamat ini untuk Pick Up.",
    searchAndSelectAddress: "Cari & pilih lokasi alamat Pick Up.",
    namaAlamat: "Nama alamat",
    namaPIC: "Nama PIC",
    noHP: "Nomor handphone",
    kecamatanKota: "Kecamatan Kota",
    simpanAlamat: "Simpan alamat",
    placeholderNamaAlamat: "Masukkan nama alamat",
    placeholderNamaPIC: "Masukkan nama PIC",
    okeMengerti: "Oke, mengerti",
    titleAddAddress: "Tambah alamat baru",
    titleEditAddress: "Ubah alamat",
    searchDistrictCity: "Ketik atau pilih kecamatan, kota",
    postalCode: "Kode pos",
    placeholderPostalCode: "Masukkan kode pos",
    placeholderCoordinate: "Contoh : -6.523523523523",
    successAddAddressTitle: '"{name}" berhasil ditambah',
    successEditAddressTitle: '"{name}" berhasil diubah',
    geoHelpText: "Anda bingung cari titik lokasi koordinat?",
    geoCheckHere: "Cek disini.",
    geoModalTitle: "Cara cari titik lokasi koordinat",
    savedAddressListTitle: "Daftar alamat tersimpan",
    editAddress: "Ubah alamat",
    selectAndSetDefault: "Pilih & jadikan alamat utama",
    delete: "Hapus",
    select: "Pilih",
    cancel: "Batalkan",
    deleteAddressTitle: "Hapus alamat ini?",
    deleteAddressMessage:
      "Anda akan kehilangan alamat ini dari daftar alamat tersimpan.",
    placeholderEstimateTonase: "Masukkan estimasi tonase",
    placeholderEstimateKoli: "Masukkan estimasi koli",
    selecDate: "Pilih tanggal",
    pickupTimeLabel: "Barang dipickup tanggal {date} - {time}",
    modalFailedConfigTitle: '"{client}" gagal {action}',
    updated: "diperbarui",
    created: "dibuat",
    repeatInterval: "Pengulangan setiap",
    repeatEvery: "Ulangi setiap",
    week: "Minggu",
    weekOption: "{count} Minggu",
    monday: "Senin",
    tuesday: "Selasa",
    wednesday: "Rabu",
    thursday: "Kamis",
    friday: "Jumat",
    saturday: "Sabtu",
    sunday: "Minggu",
    andDay: "dan {day}",
    repeatScheduleLabel: "Hari {days} {time}, setiap {interval} minggu sekali",
    errorGetData: "Gagal mengambil data!",
    errorSystem: "Terjadi kesalahan pada system. Silahkan coba lagi nanti.",
    successDeleteAddressTitle: '"{name}" berhasil dihapus',
    successDeleteAddressMessage: "Anda bisa tambahkan ulang alamat yang baru.",
    geolocation: {
      step1: "Buka",
      onLaptop: "di laptop/komputer Anda.",
      rightClickCoordinate:
        "Klik kanan pada lokasi & klik kiri pada titik koordinat.",
      enterCoordinate: "Masukkan titik kordinat ke form yang telah disediakan."
    },
    bookingSummary: {
      titleSuggestion: "Rekomendasi di Pick Up",
      titleBucket: "Siap di Pick Up",
      changeAddress: "Ubah alamat",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Jadwal terdekat:",
      viewStt: "Lihat STT",
      viewActivePickup: "Lihat Pick Up aktif {count}",
      empty:
        "Data Pick Up request belum tersedia. Silakan buat Pick Up secara manual",
      createManual: "Buat Pick Up manual",
      piece: "koli",
      wood: "KAYU",
      addressIsEmpty: "Alamat Pick Up belum ditambah.",
      addAddress: "Tambah alamat"
    },
    requestModal: {
      title: {
        requestPickup: "Request Pick Up",
        manual: "Buat Pick Up Manual"
      },
      banner: {
        sttPrefix: "Anda memiliki ",
        sttSuffix: " yang dapat diproses",
        viewAll: "Lihat semua"
      },
      field: {
        addressLabel: "Alamat Pick Up",
        koliLabel: "Estimasi koli",
        koliPlaceholder: "Masukkan estimasi koli",
        weightLabel: "Estimasi berat",
        weightPlaceholder: "Masukkan estimasi berat",
        weightUnit: "kg",
        serviceLabel: "Jenis pengiriman",
        servicePlaceholder: "Pilih jenis pengiriman",
        dateLabel: "Tanggal",
        timeLabel: "Jam",
        courierNoteLabel: "Catatan untuk kurir",
        courierNotePlaceholder: "Masukkan catatan Anda untuk kurir"
      },
      specialHandling: {
        dangerousGoods: "Dangerous goods",
        quarantine: "Karantina",
        woodPacking: "Packing Kayu"
      },
      address: {
        mainBadge: "Utama",
        coordinate: "Titik koordinat : {lat}"
      },
      suggestionHint:
        "Data diisi otomatis berdasarkan rekomendasi, Anda dapat mengubahnya",
      addressEmpty: "Belum ada alamat tersimpan",
      addressListTitle: "Daftar Alamat",
      specialHandlingLabel: "Special Handling",
      validation: {
        koli: "Estimasi koli wajib diisi",
        weight: "Estimasi berat wajib diisi",
        date: "Tanggal wajib dipilih",
        time: "Jam wajib dipilih",
        service: "Jenis pengiriman wajib dipilih",
        address: "Alamat Pick Up wajib dipilih",
        client: "Klien wajib dipilih",
        clientLoadFailed:
          "Gagal memuat detail klien. Silakan pilih klien kembali."
      },
      changeAddress: "Ubah alamat",
      chooseAddress: "Pilih alamat",
      addAddress: "Tambah alamat",
      submit: "Kirim",
      sttListTitle: "Daftar STT yang dapat di Pick Up ({count})",
      sttListEmpty: "Daftar STT belum tersedia",
      success: {
        title: "Permintaan Pick Up berhasil dikirim",
        message: "Pick Up akan segera diproses oleh kurir.",
        button: "Oke, mengerti"
      },
      error: {
        title: "Permintaan Pick Up gagal",
        message: "Silakan coba beberapa saat lagi.",
        button: "Tutup"
      }
    }
  },
  partnerManagement: {
    route: {
      partnerManagement: "Manajemen Partner",
      partnerManagementDetail: "Manajemen Partner | Detail",
      detailPartner: "Detail Partner",
      consolidatorCreate: "Consolidator | Buat",
      buatConsolidator: "Buat Consolidator",
      subConsolidatorCreate: "Sub Consolidator | Buat",
      buatSubConsolidator: "Buat Sub Consolidator",
      posCreate: "POS | Buat",
      buatPos: "Buat POS",
      hubCreate: "Hub | Buat",
      buatHub: "Buat Hub",
      detailHub: "Detail Hub",
      hubEdit: "Hub | Ubah",
      ubahHub: "Ubah Hub",
      consolidatorEdit: "Consolidator | Ubah",
      ubahConsolidator: "Ubah Consolidator",
      subConsolidatorEdit: "Sub Consolidator | Ubah",
      ubahSubConsolidator: "Ubah Sub Consolidator",
      posEdit: "POS | Ubah",
      ubahPos: "Ubah POS",
      changePartnerName: "Masukan nama partner",
      posReturnStt: "POS Pengembalian STT",
      posReturnSttDesc:
        "Akun untuk booking STT yang dikembalikan ke pengirim atau diteruskan ke alamat yang benar",
      choosePosName: "Pilih nama POS",
      address: "Alamat",
      partnerAddress: "Masukan alamat partner"
    },
    fileAttachment: "Berkas Pendukung",
    validate: {
      minimumUpload: "Harap unggah minimal 3 file",
      processUpload: "Sedang mengunggah file ke storage",
      processDelete: "Sedang menghapus file dari storage"
    },
    description: {
      fileOne:
        "Berkas pendukung dapat berupa foto/file NPWP, KTP, KK, Dokumen Penutupan POS atau berkas lainnya. ",
      fileTwo:
        "Maks. file: 3 MB, Format: jpg, png, pdf. Rekomendasi dimensi 2 : 4 (contoh: 200px X 800px)"
    },
    label: {
      attachment: "Lampiran",
      noHandphone: "No. Handphone"
    },
    error: {
      uploadFile:
        "Gagal mengunggah Lampiran {value} ke storage. Harap hapus dan coba lagi.",
      phoneInvalid: "Masukan No. Telepon dengan benar",
      phoneHandphoneInvalid: "Masukan No. Handphone dengan benar"
    },
    button: {
      unfreeze: "Unfreeze",
      freeze: "Freeze"
    },
    detail: {
      contactInfo: "Informasi Kontak",
      name: "Nama",
      phone: "No. Telepon",
      jobTitle: "Jabatan",
      email: "Email",
      additionalInfo: "Informasi Tambahan",
      saldoDeposit: "Saldo Deposit",
      firstTopUp: "Top Up Pertama",
      firstTransaction: "Transaksi Pertama",
      firstPickupManifest: "Pick Up Manifest Pertama",
      lastTransaction: "Transaksi terakhir",
      tabPosParent: "Detail POS Induk",
      tabPosBranch: "Daftar POS Cabang & Di Pickup",
      createdAt: "Tanggal Dibuat",
      lastUpdated: "Terakhir Diperbarui",
      enterDeposit: "Masukkan saldo deposit",
      bankInfo: "Informasi Bank",
      dateChanged: "Tanggal Diubah"
    },
    filter: {
      selectStatus: "Pilih status"
    },
    list: {
      searchConsolidator: "Cari nama consolidator",
      searchSubConsolidator: "Cari nama sub consolidator",
      searchPos: "Cari nama/kode POS",
      searchHub: "Cari nama/kode hub",
      createConsolidator: "Buat Consolidator",
      createSubConsolidator: "Buat Sub Consolidator",
      createPos: "Buat POS",
      createHub: "Buat Hub",
      emptyConsolidator: "data Consolidator",
      emptySubConsolidator: "Partner management",
      emptyPos: "data POS",
      emptyHub: "data Hub",
      no: "No.",
      codeConsolidator: "Kode Consolidator",
      nameConsolidator: "Nama Consolidator",
      totalKota: "Total Kota",
      totalKotaTooltip:
        "Total Kota adalah jumlah kota yang ditangani oleh Partner.",
      kotaAsal: "Kota Asal",
      akhirKontrak: "Akhir Kontrak",
      statusKontrak: "Status Kontrak",
      statusPartner: "Status Partner",
      freezed: "Freezed",
      action: "Action",
      codeSubConsolidator: "Kode Sub Consolidator",
      nameSubConsolidator: "Nama Sub Consolidator",
      kecamatanKota: "Kecamatan, Kota",
      namaConsolidator: "Nama Consolidator",
      codePos: "Kode POS",
      namePos: "Nama POS",
      tipePos: "Tipe POS",
      lastTransaction: "Transaksi terakhir",
      saldoTersedia: "Saldo Tersedia",
      namaPartnerArea: "Nama Partner Area",
      codeHub: "Kode Hub",
      nameHub: "Nama Hub",
      consolidator: "Consolidator",
      kotaHub: "Kota Hub",
      status: "Status",
      enterLocation: "Masukan atau pilih lokasi",
      additionalCity: "Kota Tambahan",
      additionalCityDesc:
        "Masukan kota tambahan yang ingin ditangani. Partner dapat menangani lebih dari satu (1) kota.",
      maxAdditionalCity: "Kota tambahan maksimal 5",
      enterCity: "Masukan atau pilih kota tambahan",
      consoleName: "Nama Kepemilikan Subkonsolidator",
      consoleNameDesc: "Masukan atau pilih kepemilikan subkonsolidator",
      enterPartner: "Masukan atau pilih partner area",
      tax: "No. Registrasi Pajak (NPWP)",
      enterTax: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
      partnerType: "Tipe Partner Area",
      enterLatitude: "Masukan Latitude",
      enterLongtitude: "Masukan Longitude",
      choosePosParent: "Ketik atau pilih pos parent",
      posOwnerName: "Nama Kepemilikan POS",
      typePosOwner: "Ketik atau pilih kepemilikan pos",
      posCommition: "Komisi POS Cabang",
      enterPosCommition: "Masukkan komisi POS cabang",
      optional: "(Opsional)",
      name: "Name",
      enterName: "Masukan nama",
      position: "Jabatan",
      enterPosition: "Masukan jabatan",
      addPhone: "Tambah No. Telp",
      enterEmailError: "Masukan format email dengan benar",
      accountWillActive:
        "Akun akan aktif dan berakhir sesuai dengan tanggal yang dipilih.",
      startFrom: "Dimulai Dari",
      until: "Sampai",
      noBank: "Belum ada rekening bank yang tersimpan.",
      addAccount: "Tambah Rekening",
      referral: "Kode Referral",
      enterReferral: "Masukan kode referral",
      referralNotFound: "Kode Referral tidak ditemukan",
      confirmCreation: "Konfirmasi Pembuatan",
      areUsure: "Anda yakin ingin menyimpan pembuatan Partner",
      success: "berhasil dibuat",
      city: "Kota",
      typePosParent: "Ketik atau pilih pos induk",
      posCommitionDesc:
        "Aturan baru: nilai Komisi POS Cabang berasal dari Komisi Cabang yang ada pada konfigurasi Komisi Booking",
      successChange: "berhasil diubah",
      elexys: "Kode Elexys",
      contract: "Periode Kontrak"
    },
    code: "Kode",
    name: "Nama",
    districts: "Daftar district",
    accountName: "Nama Rekening",
    bank: "Nama Bank",
    accNo: "No. Rekening",
    startFrom: "Dimulai Dari",
    sampai: "Sampai",
    chooseBank: "Pilih bank",
    inputAccount: "Masukan No. Rekening",
    check: "Periksa",
    choose3lc: "Pilih 3LC"
  },
  uploadFile: {
    loading: "Loading...",
    clickToUpload: "Klik untuk upload",
    orDragAndDrop: "atau drag and drop"
  },
  bulkBooking: {
    repair: "Perbaiki",
    booking: "Booking",
    invalidShipmentId: "Shipment ID tidak valid",
    bookingFailed: "Booking Gagal!",
    manualSttMinimum: "Format nomor STT manual minimum 3 angka.",
    deleteRepairFailed: "Gagal menghapus perbaikan booking gagal!",
    repairDetailFetchFailed: "Gagal memuat detail perbaikan booking!",
    codConfigurationFailed: "Gagal mendapatkan konfigurasi COD!",
    editCustomerNameInvalid: "Nama tidak valid, mohon ulangi kembali",
    editCustomerAddressInvalid: "Alamat tidak valid, mohon ulangi kembali",
    uploadActivityFailedTitle: "Aktivitas Upload Gagal",
    uploadActivityFailedMessage: "Aktivitas “{fileName}” gagal terupload",
    searchPlaceholder: "Cari upload ID atau nama",
    uploadBulkBooking: "Upload Bulk Booking",
    columnUploadId: "Upload ID",
    columnNamaAktivitas: "Nama aktivitas",
    columnTipeBerkas: "Tipe berkas",
    columnNamaBerkas: "Nama berkas",
    columnStatus: "Status",
    columnDibuatUntuk: "Dibuat untuk",
    columnTanggalDibuat: "Tanggal dibuat",
    columnAtur: "Atur",
    columnTipeBooking: "Tipe booking",
    columnNamaFile: "Nama file",
    columnCatatan: "Catatan",
    statusSuccess: "Berhasil",
    statusFailed: "Gagal",
    statusPartially: "Sebagian",
    statusUploading: "Mengupload",
    repairedCount: "Berhasil diperbaiki",
    downloadSuccessFile: "Download berkas berhasil",
    downloadFailedFile: "Download berkas gagal",
    downloadOriginalFile: "Download berkas original",
    repairFailedBooking: "Perbaiki booking gagal",
    repairBannerFailed: "Ada {count} data yang gagal, perbaiki dan ubah lagi.",
    printStt: "Print STT",
    bookingUlang: "Booking Ulang",
    resubmitBooking: "Resubmit Booking",
    emptyState: "Bulk Booking",
    emptyStateFailed: "Failed Booking",
    downloadTemplate: "Download Template",
    bulkPrintResiThermal: "Bulk Print Resi Thermal",
    bulkPrintResiBasic: "Bulk Print Resi Basic",
    columnTotalStt: "Total STT",
    actionMore: "More",
    saveSenderDetail: "Simpan detail pengirim",
    saveRecipientDetail: "Simpan detail penerima",
    vendorNinjaInfo: "Untuk tujuan yang dipilih maksimal 1 koli",
    deleteBooking: "Hapus booking ini",
    clientName: "Nama Klien",
    filterClientName: "Filter Pencarian klien",
    cityOriginClient: "Kota asal klien (3LC)",
    insertName: "Masukkan & pilih kota asal klien (3LC)",
    serviceType: "Tipe Layanan Pengiriman",
    chooseType: "Pilih tipe layanan pengiriman",
    insertAlias: "Masukkan & pilih nama/alias/kode klien cabang",
    clientNameMustInsert: "Nama client wajib diisi",
    clinetNotBook: "Client tidak dapat melakukan booking",
    clientList: "Daftar Klien",
    searchbyName: "Cari berdasarkan nama/alias klien",
    originCity: "Kota Asal",
    clientType: "Tipe Klien",
    service: "Layanan Pengiriman",
    clientCode: "Kode Klien",
    districtRequired: "Kecamatan, Kota Asal wajib diisi",
    errormessageName: "Nama pengirim minimum 3 karakter.",
    messageNameRequired: "Nama pengirim wajib diisi.",
    senderAddress3: "Alamat pengirim minimum 3 karakter.",
    senderAddressReq: "Alamat pengirim wajib diisi.",
    phoneNumberInvalid: "Nomor telepon tidak valid, mohon ulangi kembali",
    sender: "Pengirim",
    home: "Rumah",
    recepientNameError: "Nama penerima minimum 3 karakter.",
    repientNameReq: "Nama penerima wajib diisi.",
    recipientNameError: "Nama penerima minimum 3 karakter.",
    recipientNameReq: "Nama penerima wajib diisi.",
    recAddresMin3: "Alamat penerima minimum 3 karakter.",
    recAddresReq: "Alamat penerima wajib diisi.",
    download: "Unduh",
    form: {
      goodsCategory: "Kategori barang",
      phoneNumberExample: "Contoh: 8123456789012",
      weightExample: "contoh 20",
      totalPiecesPerPackage: "Masukkan total koli per kemasan",
      nextCommodity: "Komoditas selanjutnya",
      nextCommodityPlaceholder: "Masukkan komoditas selanjutnya",
      externalReferenceExample: "DOR00989",
      termsAndConditions: "syarat dan ketentuan.",
      nextCommodityHint:
        "Isi dengan komoditas barang yang ada dalam satu koli.",
      nextCommodityRequired: "Komoditas selanjutnya wajib diisi",
      totalPiecesPerPackageRequired: "Total koli per kemasan wajib diisi",
      taxNumberInvalid: "Masukkan No. NPWP dengan benar",
      shipmentStatusRequired: "Status pengiriman wajib diisi."
    },
    estimation: {
      publishRate: "Tarif publik + biaya tambahan pengiriman",
      originForwardRate: "Tarif lanjutan asal",
      destinationForwardRate: "Tarif lanjutan tujuan",
      codGoodsValue: "Harga barang COD",
      codFee: "Biaya COD",
      promotion: "Promo",
      off: "Diskon",
      until: "sampai dengan"
    },
    filter: {
      label: "Filter",
      uploadStatus: "Status upload",
      fileType: "Tipe berkas",
      createdFor: "Dibuat untuk",
      placeholderUploadStatus: "Pilih status upload",
      placeholderFileType: "Pilih tipe berkas",
      placeholderClientPos: "Pilih klien/pos",
      reset: "Reset",
      apply: "Terapkan",
      statusSuccess: "Berhasil",
      statusPartially: "Sebagian",
      statusFailed: "Gagal",
      statusUploading: "Mengupload",
      typeClient: "Klien",
      typeRetail: "Retail",
      date: "Tanggal"
    },
    create: {
      uploadFileTitle: "Upload berkas",
      clickToUpload: "Klik untuk upload",
      uploadHint: "Format .xlsx, maks. {maxFileMb} MB & {maxStt} STT.",
      uploadHintLimit: "Hanya {maxStt} kolom data pertama yang akan diproses",
      activityNamePlaceholder: "Beri nama atau catatan untuk aktivitas ini",
      changeFile: "Ubah",
      downloadTemplateHint:
        "Silakan download template booking, lengkapi data sesuai petunjuk pengisian format, lalu upload kembali file Anda.",
      templateInternational: "Booking internasional",
      templateDomestic: "Booking domestik",
      checkFormatTitle: "Cek format pengisian data di setiap kolom",
      checkFormatHint:
        "Pastikan sebelum upload bulk booking, seluruh data pada kolom yang Anda isi sudah sesuai dengan format yang ada pada data di bawah ini.",
      commodityData: "Data komoditas",
      districtData: "Data kecamatan",
      title: "Upload Bulk Booking",
      upload: "Upload",
      activityName: "Nama aktivitas",
      placeholderActivityName: "Masukkan Nama Aktivitas",
      infoBadgeInterpackFtz:
        "Saat ini belum tersedia untuk jenis pengiriman INTERPACK dan Free Trade Zone.",
      fileType: "Tipe berkas",
      retail: "Retail",
      client: "Klien",
      uploadFile: "Upload Berkas",
      change: "Ubah",
      validationChars: "karakter",
      templateRetail: "Template booking retail",
      templateClient: "Template booking klien",
      dataCommodity: "Data komoditas",
      dataDistrict: "Data kecamatan",
      downloadTemplate: "Download Template",
      downloadTemplateDescription:
        "Mulai download template, isi kolom data, cek format pengisian, & upload disini!",
      checkFormat: "Cek format pengisian data di setiap kolom",
      checkFormatDescription:
        "Pastikan sebelum upload bulk booking, seluruh data kolom yang Anda isi sesuai dengan data dibawah ini!",
      modalProcessingTitle: "Bulk booking sedang di proses!",
      modalProcessingMessage:
        'Proses booking "{name}" sedang berlangsung. Tunggu beberapa saat.',
      modalSuccessTitle: "OK",
      uploadSuccessTitle: "Bulk booking berhasil diunggah",
      download: "Download",
      booking: "Booking",
      modalErrorRowEmpty: "Ada baris yang kosong!",
      modalErrorDataExceed: "Data booking melebihi batas!",
      modalErrorHeaderInvalid: "Header berkas tidak valid!",
      modalErrorRowEmptyAlt: "Ada baris yang kosong!",
      modalErrorQueueFull: "Antrian bulk booking penuh",
      modalErrorFileSize: "Ukuran file bulk booking melebihi {size} MB",
      modalErrorSystem: "Terjadi kendala sistem",
      modalSubtitleRowEmpty: "Cek berkas, lengkapi semua baris & upload ulang.",
      modalSubtitleDataExceed:
        "Data maksimal 100 baris. Silahkan hapus beberapa data yang diupload.",
      modalSubtitleHeaderInvalid:
        "Cek berkas & upload ulang sesuai format template",
      modalSubtitleRowEmptyAlt:
        "Cek berkas, lengkapi semua baris & upload ulang.",
      modalSubtitleQueueFull: "Tunggu beberapa saat dan coba lagi.",
      modalSubtitleFileSize: "Ubah file dan upload ulang file Anda.",
      modalSubtitleSystem: 'Klik "Muat ulang" atau tunggu beberapa saat lagi.',
      btnUploadAgain: "Upload ulang",
      btnReload: "Muat ulang",
      btnUnderstand: "Ok, mengerti",
      btnBack: "Kembali",
      uploadFileCaption:
        "Format .xlsx. Maksimum {maxStt} STT dan file {maxMb} MB.<br/>Hanya 500 data row pertama yang akan diproses.",
      uploadFileErrorFormat: "Format berkas tidak sesuai",
      modalOnProcess: "Silakan tunggu proses upload selesai dan cek detailnya.",
      searchPlaceholder: "Cari Upload ID/Nama Aktivitas",
      selectPlaceholder: "Pilih client/partner/Internal",
      clientNameTitle: "Nama Client / Partner",
      clientNamePlaceholder: "Cari client / partner",
      templatePlaceholder: "Pilih template format",
      attachment: "Berkas Lampiran",
      hintSection1:
        "Pastikan seluruh data yang Anda masukan telah benar dan sesuai",
      hintSection2:
        "dengan berkas yang akan diupload. Pelajari cara mengisi template",
      hintSection3: "disini",
      errorClient: "Partner atau Client Sedang Tidak Aktif",
      successBookingTitle: "Upload Berkas Berhasil",
      successBookingMessage: "Data pada berkas pengiriman berhasil terbooking",
      errorPartial:
        "Beberapa data pengiriman berhasil terbooking menjadi STT, namun terdapat kegagalan pada beberapa data. Silahkan download untuk mengatahui kesalahan.",
      failedBookingTitle: "Upload Berkas Gagal",
      failedBookingMessage: "Data pada berkas pengiriman gagal terbooking"
    },
    modal: {
      delete: "Ya, hapus",
      back: "Kembali",
      deleteTitle: "Hapus booking ({value})?",
      deleteMessage:
        "Pengiriman Anda tidak akan diproses jika menghapus booking ini.",
      successDeleteTitle: "Perbaiki booking berhasil dihapus!",
      successDeleteMessage:
        "Anda masih bisa melakukan pengiriman baru dengan bulk booking ulang.",
      successTitle: "Booking berhasil ({value})",
      done: "Selesai",
      nextBooking: "Booking selanjutnya",
      printThermalReceipt: "Print thermal resi",
      productType: "Jenis Pengiriman",
      deliveryEst: "Estimasi pengiriman",
      recipient: "Penerima",
      districtCity: "Kecamatan, kota tujuan",
      codCost: "Biaya COD",
      mustPaid: "Biaya yang harus dibayar penerima",
      totalTariff: "Total tarif"
    },
    edit: {
      confirmDeleteTitle: "Hapus booking",
      confirmDeleteMessage:
        "Pengiriman Anda tidak akan diproses jika menghapus booking ini.",
      successDeleteTitle: "Perbaiki booking berhasil dihapus!",
      successDeleteMessage:
        "Anda masih bisa melakukan pengiriman baru dengan bulk booking ulang."
    },
    filterStatus: {
      parent: "Pilih status upload",
      success: "Berhasil",
      partially: "Sebagian",
      failed: "Gagal",
      uploading: "Mengupload"
    },
    client: {
      label: "Klien",
      placeholder: "Masukkan & pilih nama/alias/kode klien cabang",
      errorMandatory: "Nama client wajib diisi",
      errorBooking: "Client tidak dapat melakukan booking",
      buttonList: "Daftar klien",
      modalTitle: "Daftar klien",
      searchPlaceholder: "Cari berdasarkan nama/alias klien",
      filter: {
        searchTitle: "Filter Pencarian klien",
        cityOrigin: "Kota asal klien (3LC)",
        cityOriginPlaceholder: "Masukkan & pilih kota asal klien (3LC)",
        shipmentType: "Tipe Layanan Pengiriman",
        shipmentTypePlaceholder: "Pilih tipe layanan pengiriman"
      },
      table: {
        name: "Nama Klien",
        alias: "Alias",
        originCity: "Kota Asal",
        category: "Tipe Klien",
        packageType: "Layanan Pengiriman",
        code: "Kode Klien"
      }
    },
    templates: {
      international: "Booking internasional",
      domestic: "Booking domestik"
    },
    commodities: {
      commodityData: "Data komoditas",
      districtData: "Data kecamatan"
    },
    common: {
      retailInternational: "Internasional Retail",
      clientInternational: "Internasional Klien",
      retailDomestic: "Domestik Retail",
      clientDomestic: "Domestik Klien",
      bookingInternational: "Booking internasional",
      bookingDomestic: "Booking domestik",
      commodityData: "Data komoditas",
      districtData: "Data kecamatan"
    }
  },
  Process: "Proses",
  Region: "Wilayah",
  revamp: {
    booking: {
      client: "Klien",
      pos: "POS",
      serviceAvailable: "Anda belum tersedia layanan",
      codOrDfod: "COD atau DFOD",
      contactLP: ", hubungi Admin Lion Parcel.",
      detailSender: "Detail pengirim",
      detailRecipient: "Detail penerima",
      detailPackageAndServiceType: "Detail Barang & Jenis Pengiriman",
      itemWeight: "Berat barang",
      insuranceWarning:
        "Pengiriman tanpa asuransi hanya dapat di klaim sebesar 10x ongkir / maksimal Rp2.000.000",
      deliveryInsurance: "Asuransi Pengiriman",
      detailCommodity: "Detail Komoditas",
      additionalPhoto: "Foto Pendukung",
      beforeAndAfterPackingPhoto: "Foto sebelum & sesudah paket packing",
      packageBeforePacking: "Paket sebelum packing",
      packageAfterPacking: "Paket sesudah packing",
      recipientIdPhoto: "Foto ID Penerima",
      recipientId: "ID Penerima",
      recipientTaxIdPhoto: "Foto Tax ID Penerima",
      bookNow: "Booking sekarang",
      selectSchedule: "Pilih jadwal",
      shippingProtection: "Proteksi pengiriman",
      shippingIsProtected: "Pengiriman sudah terproteksi",
      recipientIdNumber: "Nomor ID penerima",
      recipientTaxIdNumber: "Nomor tax ID penerima",
      shippingRate: "Biaya pengiriman",
      codAmount: "Tagihan COD",
      heavyWeightSurcharge: "Berat dikenakan biaya",
      totalPieces: "Total koli",
      billedTo: "Ditagihkan ke",
      paymentMethod: "Metode pembayaran",
      publishRatesShippingSurcharge: "Publish rates + shipping surcharge",
      originForwardRates: "Origin forward rates",
      destinationForwardRates: "Destination forward rates",
      totalShippingRates: "Total Biaya pengiriman",
      commoditySurcharge: "Biaya tambahan komoditas",
      documentSurcharge: "Biaya tambahan dokumen",
      heavyWeightAdditionalSurcharge: "Biaya tambahan berat",
      woodPackingSurcharge: "Biaya packing kayu",
      totalSurcharge: "Total biaya tambahan",
      protectionFee: "Proteksi",
      protectionAdminFee: "Biaya admin proteksi",
      codItemPrice: "Harga barang",
      codCost: "Biaya COD",
      tacticalPromo: "Tactical promo",
      campaignPromo: "Campaign promo",
      totalRates: "Total tarif",
      chargesPayableByRecipient: "Biaya yang dibayar penerima",
      taxEstimate: "Estimasi Pajak",
      returnCost: "Biaya retur",
      free: "Gratis",
      discount10Percent: "Diskon 10%"
    }
  },
  clientManagement: {
    tabs: {
      clientRegistration: "Pendaftaran klien",
      clientManagement: "Manajemen klien"
    },
    managementList: {
      searchPlaceholder: "Cari nama klien / alias / kode",
      filterClientType: "Tipe klien",
      filterPriceStatus: "Status Harga",
      filterClientStatus: "Status Client",
      emptyData: "data Client",
      allPrices: "Semua Harga",
      allClientStatuses: "Semua Status Client",
      frozen: "Dibekukan",
      allClientTypes: "Semua tipe klien",
      parentClient: "Klien induk",
      branchClient: "Klien cabang",
      freeze: "Freeze",
      unfreeze: "Unfreeze",
      columns: {
        clientId: "Klien ID",
        clientName: "Nama klien",
        alias: "Alias",
        clientCode: "Kode klien",
        clientType: "Tipe klien",
        pricePeriod: "Periode harga",
        contractStatus: "Status kontrak",
        priceStatus: "Status harga",
        updateStatus: "Status pembaruan",
        action: "Action",
        pricePeriodStart: "Periode harga mulai",
        pricePeriodEnd: "Periode harga berakhir",
      }
    },
    registrationList: {
      searchPlaceholder: "Cari nama klien / alias / kode",
      createNewClient: "Buat klien baru",
      emptyData: "data Client",
      allStatuses: "Semua status",
      parentClient: "Klien induk",
      branchClient: "Klien cabang",
      columns: {
        clientId: "Klien ID",
        clientName: "Nama klien",
        alias: "Alias",
        clientCode: "Kode klien",
        clientType: "Tipe klien",
        pricePeriod: "Periode harga",
        contractStatus: "Status kontrak",
        pricePeriodStart: "Periode harga mulai",
        pricePeriodEnd: "Periode harga berakhir",
        priceStatus: "Status harga",
      }
    },
    registrationForm: {
      parent: {
        title: "Detail klien induk",
        parentClientName: "Nama klien induk",
        enterClientName: "Masukkan nama klien",
        enterAlias: "Masukkan alias",
        max100Characters: "Maksimal 100 karakter",
        min3Characters: "Minimum 3 karakter",
        selectParentClientCategory: "Pilih kategori klien induk",
        selectParentCompanySize: "Pilih ukuran perusahaan klien induk",
        enterParentClientAddress: "Masukkan alamat klien induk",
        typeAndSelectDistrictCityParent:
          "Ketik & pilih kecamatan, kota klien induk"
      },
      contact: {
        title: "Informasi kontak",
        name: "Nama",
        enterName: "Masukkan nama",
        position: "Jabatan",
        enterPosition: "Masukkan jabatan",
        phone: "No. telepon",
        phoneExample: "Contoh: 8123456789012",
        invalidPhone: "Masukan No. telepon dengan benar",
        emailExample: "Contoh: nama{'@'}email.com",
        invalidEmail: "Masukan Email dengan benar"
      },
      payment: {
        title: "Informasi pembayaran",
        selectPaymentMethod: "Pilih metode pembayaran",
        invoice: "Invoice",
        splitBill: "Split Bill"
      },
      billing: {
        title: "Informasi penagihan",
        invalidWhatsapp: "Masukan No. WhatsApp dengan benar",
        selectBillingSchedule: "Pilih jadwal penagihan",
        selectPaymentTerm: "Pilih jangka waktu pembayaran",
        pressEnterToAddEmail: "Tekan enter untuk menambah Email",
        enterEmail: "Masukan Email",
        emailAlreadyAdded: "Email ini telah dimasukan",
        multipleEmailHint: "*Anda bisa menambahkan lebih dari satu email."
      },
      tax: {
        taxpayerUsesIdCard: "Wajib pajak menggunakan KTP",
        enterNikNumber: "Masukan nomor KTP",
        enterNameAsIdCard: "Masukan nama sesuai KTP",
        enterAddressAsIdCard: "Masukkan alamat sesuai KTP",
        enterNpwpNumber: "Masukan Nomor NPWP",
        nameAsNpwp: "Nama sesuai NPWP",
        enterNameAsNpwp: "Masukkan nama sesuai NPWP",
        enterAddressAsNpwp: "Masukkan alamat sesuai NPWP",
        selectTaxTransactionCode: "Pilih kode transaksi",
        changeFile: "Ubah Berkas"
      },
      agreement: {
        selectStartDate: "Pilih tanggal dimulai",
        invalidDate: "Tanggal mulai tidak boleh lebih dari tanggal akhir",
        selectEndDate: "Pilih tanggal sampai",
        changeFile: "Ubah file"
      },
      bank: {
        optionalHint: "(Opsional)",
        delete: "Hapus",
        bankAccountInfo: "Informasi rekening bank",
        noBankAccountSaved: "Belum ada rekening bank yang tersimpan.",
        addBankAccount: "Tambah rekening Bank",
        deleteConfirmationTitle: "Konfirmasi Penghapusan",
        deleteConfirmationMessage:
          "Pastikan kembali, data rekening bank yang sudah dihapus tidak dapat dikembalikan."
      }
    },
    registrationBranchForm: {
      clientBranch: {
        title: "Detail klien cabang",
        branchClientName: "Nama klien cabang",
        enterClientName: "Masukkan nama klien",
        enterBranchAddress: "Masukkan alamat klien cabang",
        enterAndSelectDistrictCity: "Masukkan & pilih kecamatan, kota",
        enterNpwp16Digits: "Masukkan 16 digit sesuai NPWP sesuai NPWP",
        invalidNpwp: "Masukan No. NPWP dengan benar"
      },
      parentClientDetail: {
        enterOrSelectParentClient: "Masukan atau pilih induk client",
        partnerPosName: "Nama partner POS",
        selectPartnerPos: "Pilih partner POS",
        commissionNumerator: "Pembilang Komisi",
        selectCommissionNumerator: "Pilih pembilang komisi",
        clientPrice: "Harga Client",
        commissionType: "Tipe Komisi",
        posCommission: "Komisi POS",
        commissionCannotBeZeroEmpty: "Komisi tidak boleh nol/kosong",
        commissionCannotExceed100: "Komisi tidak boleh lebih dari 100%",
        selectCommissionType: "Pilih tipe komisi",
        shippingSurcharge: "Shipping surcharge",
        publishRate: "Publish Rate",
        publishRateShippingSurcharge: "Publish Rate + Shipping Surcharge"
      },
      deliveryService: {
        title: "Layanan pengiriman",
        description:
          "Setiap barang yang dibooking oleh klien akan menyesuaikan dengan layanan yang telah dipilih.",
        cashOnDelivery: "Cash on Delivery",
        deliveryOrder: "Delivery Order"
      },
      codType: {
        title: "Tipe COD",
        goodsPrice: "Harga Barang",
        goodsPricePlusClientShipping: "Harga Barang + ongkir klien",
        deliveryFeeOnDelivery: "Delivery Fee on Delivery",
        codFee: "Biaya COD",
        howCodFeeCalculated: "Bagaimana Perhitungan Biaya COD?",
        codFeeCalculatedFromTotalCodAmount:
          "Biaya COD dihitung dari persentase total COD amount",
        codDiscountPercentage: "Persentase Diskon COD",
        codDiscountPercentageInfo: "Info Persentase Diskon COD",
        enterCodDiscountPercentage: "Masukkan persentase diskon COD",
        tooltipCodShipmentDiscount:
          '<ol style="list-style: number; padding-left: 15px;"><li>Klien akan dibebankan biaya booking STT COD sebesar <strong>ongkir klien setelah <br />diskon.</strong></li><li>Tipe COD amount harga barang + ongkir akan menggunakan <strong>ongkir klien <br/>sebelum diskon</strong></li></ol>',
        codFeeCannotBeZeroEmpty: "Biaya COD tidak boleh nol/kosong",
        codFeeCannotExceed100: "Biaya COD tidak boleh lebih dari 100%",
        codDiscountCannotExceed100:
          "Persentase Diskon COD tidak boleh lebih dari 100%"
      },
      sttReturn: {
        title: "Pengembalian STT retur",
        sameAsBranchClientDetail: "Sama dengan detail klien cabang",
        receiverName: "Nama penerima",
        phoneNumber: "No. telepon",
        address: "Alamat",
        districtCity: "Kecamatan, kota"
      },
      deliveryOrderReturn: {
        title: "Pengembalian Delivery Order",
        paymentType: "Tipe Pembayaran Delivery Order",
        selectType: "Pilih Tipe DO",
        free: "Gratis",
        paid: "Berbayar"
      },
      returnConfig: {
        title: "Konfigurasi retur",
        confirmationLimit: "Batas konfirmasi retur",
        enterConfirmationLimit: "Masukkan batas konfirmasi retur",
        reasonNeedsConfirmation: "Alasan retur perlu dikonfirmasi",
        returnReasonList: "Return Reason List",
        selectReason: "Pilih alasan",
        allReasons: "Semua alasan",
        noConfiguration: "Tidak ada konfigurasi"
      }
    },
    registrationFlow: {
      next: "Selanjutnya",
      priceCustomization: "Kustomisasi harga",
      parentRegisterConfirmationTitle: "Konfirmasi pendaftaran klien induk?",
      exitPageTitle: "Yakin Keluar Halaman ?",
      exitPageMessage:
        "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      exit: "Keluar",
      yesRegister: "Ya, daftar",
      creationFailed: "Pembuatan Gagal !",
      invalidCustomRatesFileMessage:
        "Berkas Custom Rates salah atau tidak sesuai.\nSilahkan klik Ubah File untuk perbaiki.",
      ok: "OK",
      branchRegisterConfirmationTitle: "Konfirmasi Pendaftaran Klien Cabang?",
      branchRegisterConfirmationMessage:
        "Pastikan data yang Anda ajukan telah benar & sesuai.",
      branchCreationSuccess:
        "Pembuatan klien cabang “{clientName}” berhasi! Tunggu Admin menyetujui permintaan Anda.",
      parentCreationSuccess:
        "Pembuatan klien induk “{clientName}” berhasil! Tunggu Admin menyetujui permintaan Anda.",
      branchEditSuccess: "Perubahan data klien cabang “{clientName}” berhasil!",
      parentEditSuccess: "Perubahan data klien induk “{clientName}” berhasil!",
      editFailed: "Perubahan Gagal !",
      editBranchDetailQuestion: "Ubah Detail Klien Cabang?",
      editBranchDetailMessage:
        "Pastikan data yang Anda ubah sudah sesuai untuk menghindari data ditolak.",
      editParentDetailQuestion: "Ubah Detail Klien Induk?",
      editParentDetailMessage:
        "Pastikan data yang Anda ubah sudah sesuai untuk menghindari data ditolak.",
      yesChange: "Ya, Ubah",
      uploaded: "Diupload",
      free: "Free",
      clientPrice: "Harga Klien"
    },
    approval: {
      confirmClientSubmission: "Konfirmasi pengajuan klien {clientType}?",
      ensureClientAndPriceDataCorrect:
        "Pastikan seluruh data klien & pengajuan harga sudah benar dan sesuai.",
      reject: "Tolak",
      approve: "Setujui",
      accept: "Terima",
      rejectClientSubmissionQuestion: "Tolak pengajuan klien {clientType}?",
      selectRejectReasonForFixingSubmission:
        "Pilih alasan penolakan untuk mempermudah proses perbaikan pengajuan harga klien.",
      yesReject: "Ya, Tolak",
      enterRejectReason: "Masukan alasan penolakan",
      acceptClientSubmissionQuestion: "Terima pengajuan klien {clientType}?",
      ensureClientDetailCorrectBeforeApproval:
        "Sebelum menyetujui permintaan ini, pastikan seluruh detail klien sudah benar dan sesuai.",
      yesAccept: "Ya, Terima",
      selectRejectReason: "Pilih alasan penolakan",
      discountNotApproved: "Diskon Tidak Disetujui",
      customRatesNotApproved: "Custom Rates Tidak Disetujui",
      discountAndCustomRateNotApproved: "Diskon & Custom Rate Tidak Disetujui",
      insuranceRejected: "Asuransi Ditolak",
      confirmPriceChange: "Konfirmasi perubahan harga",
      renewalApprovalSuccess:
        "Persetujuan pembaruan harga {clientType} “{clientName}” berhasil diterima!",
      clientRequestApprovalSuccess:
        "Pengajuan klien {clientType} “{clientName}” berhasil diterima!",
      renewalRejectionSuccess:
        "Penolakan pembaruan harga klien {clientType} “{clientName}” berhasil ditolak!",
      clientRequestRejectionSuccess:
        "Permintaan klien {clientType} “{clientName}” berhasil ditolak!",
      confirmClientPeriodPriceSubmission: "Terima pengajuan ubah periode harga?",
      confirmClientPeriodPriceSubmissionDesc: "Pengajuan perubahan data periode harga",
      rejectClientPeriodPriceSubmission: "Tolak pengajuan perubahan periode harga?",
      rejectClientPeriodPriceSubmissionSelect: "Silakan pilih alasan penolakan untuk ubah periode harga",
      acceptClientPeriodSubmissionQuestion: "Terima perubahan periode harga?",
      acceptClientPeriodSubmissionQuestionDesc: "Pastikan perubahan periode harga sudah benar dan sesuai. ",
      clientPeriodPriceSubmissionSuccess: "Pengajuan perubahan periode harga berhasil diterima!",
      clientPeriodPriceSubmissionRejected: "Pengajuan perubahan periode harga berhasil ditolak!",
    },
    discountProduct: {
      no: "No",
      shippingType: "Jenis Pengiriman",
      percentage: "Presentase",
      selectShippingType: "Pilih jenis pengiriman",
      discountRangeError: "Masukan diskon 0 sampai 30",
      addDiscount: "Tambah diskon"
    },
    priceTypeForm: {
      insurance: "Asuransi",
      insuranceHint:
        "Jika tidak dicentang, asuransi akan mengikuti retail (Tiering).",
      tiering: "Tiering",
      customRatesPlaceholder: "e.g 20",
      normalPriceVersion: "Versi Harga Normal",
      selectPriceVersion: "Pilih Versi Harga",
      origin3lc: "3LC Origin",
      selectedOrigin3lc: "3LC Origin Terpilih",
      all3lc: "Semua 3LC",
      select3lcByClientNeed: "Pilih 3LC sesuai kebutuhan klien Anda",
      discount: "Diskon",
      customPriceVersion: "Versi Harga Khusus",
      enterPriceVersion: "Masukan versi harga",
      enterCustomPriceVersionName: "Masukan nama versi harga khusus",
      versionNameAlreadyExists: "Data nama versi sudah tersedia",
      price: "Harga",
      uploadDistrictCityByRouteRequest:
        "Upload kecamatan/kota sesuai permintaan rute.",
      attachmentFile: "Berkas Lampiran",
      templateFile: "Template File",
      rateBasedOnDistrict: "Tarif Berdasarkan Kecamatan",
      enableToAddDistrictsFromRetailCities:
        "Aktifkan untuk menambahkan kecamatan dari kota yang tersedia di sistem retail.",
      normalPrice: "Harga Normal",
      updatePriceEffectiveOn: "Update harga berlaku pada",
      startDate: "Tanggal mulai",
      startedFrom: "Dimulai Dari",
      endDate: "Tanggal berakhir",
      until: "Sampai",
      startDateCannotBeLaterOrEqualEndDate:
        "Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir",
      endDateCannotBeLessOrEqualStartDate:
        "Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai",
      selectInsuranceType: "Pilih tipe asuransi",
      custom: "Custom",
      customRates: "Custom Rates",
      bundlingNoInsuranceFee: "Bundling (No Insurance Fee)",
      customRatesMin: "Custom rates minimum 0,2%, cek & ubah lagi.",
      customRatesMax: "Custom rates maximum 0,99%, cek & ubah lagi.",
      configurePriceTypePriceWeightAndInsuranceByClientNeed:
        "Atur tipe harga, harga, berat, dan asuransi sesuai dengan kebutuhan klien Anda.",
      priceFollowsRetailPrice: "Harga akan mengikuti harga retail.",
      insuranceCalculationFollowsRetailTiering:
        "Perhitungan asuransi akan mengikuti retail (Tiering).",
      priceAppliesBasedOnSelectedPeriodDate:
        "Harga akan berlaku sesuai dengan tanggal periode yang dipilih.",
      retailPriceDescription: "Harga akan mengikuti harga retail.",
      normalPriceDescription:
        "Harga akan mengikat selama periode harga yang ditentukan.",
      customPriceDescription:
        "Harga akan mengikuti harga kecamatan/kota yang Anda upload.",
      combinationPriceDescription:
        "Harga akan mengikuti harga kecamatan/kota yang Anda upload & harga retail.",
      priceChangeEffective: "Pilih tanggal dan jam",
      selectDateTime: `Pilih tanggal dan jam`,
      startDateTime: "Tanggal dan jam dimulai",
      selectStartDateTime: "Pilih tanggal dan jam dimulai",
      endDateTime: "Tanggal dan jam berakhir  ",
      selectEndDateTime: "Pilih tanggal dan jam berakhir",
      insuranceSelect: "Pilih jenis asuransi",
      insuranceCustomRates: "Harga khusus",
      insuranceBundling: "Bundling (No Insurance Fee)",
      discountToggle: "Discount client",
      discountToggleDescription: "Aktifkan untuk menggunakan konfigurasi discount client",
    },
    renewalRateCard: {
      updatePrice: "Update harga",
      changePrice: "Ubah harga",
      changeInsurance: "Ubah asuransi",
      newPrice: "Harga baru",
      accepted: "Diterima",
      requested: "Requested",
      rejected: "Rejected",
      ensurePriceInfoMatches: "Pastikan informasi harga telah sesuai",
      ensurePriceInfoMatchesWithExclamation:
        "Pastikan informasi harga telah sesuai!",
      downloadAttachmentFile: "Download file lampiran",
      clientRequestAcceptedMessage:
        "Permintaan klien berhasil diterima. Harga, berat, & asuransi sudah memenuhi syarat.",
      acceptedDate: "Tanggal diterima:",
      acceptedBy: "Diterima oleh",
      downloadFailedFile: "Download file gagal",
      rejectedDate: "Tanggal ditolak:",
      rejectedBy: "Ditolak oleh",
      lastProcessed: "Terakhir diproses",
      tryAgain: "Coba lagi",
      pricePeriod: "Periode harga",
      priceCustomizationType: "Tipe kustomisasi harga",
      customPrice: "Harga khusus",
      price: "Harga",
      weightCalculation: "Perhitungan berat",
      chargeableWeightRoundingActive: "Chargeable Weight (Pembulatan aktif)",
      insuranceCalculation: "Perhitungan asuransi",
      origin3lc: "3LC Origin",
      viewAll: "Lihat Semua",
      all3lcs: "All 3LCs",
      priceTypeRetail: "Harga Retail",
      priceTypeNormal: "Harga Normal",
      priceTypeCombination: "Harga Kombinasi",
      priceTypeCustom: "Harga Khusus",
      downloadFailed: "Download file gagal!!",
      retailTiering: "Retail (Tiering)",
      bundlingNoInsuranceFee: "Bundling(No Insurance Fee)",
      customRates: "Custom Rates",
      retryProcessDataTitle: "Lanjutkan proses ulang data?",
      retryProcessDataMessage:
        "Harga yang Anda upload akan diproses lagi dan updatenya tetap dilanjutkan.",
      yesContinue: "Ya, lanjutkan",
      cancel: "Batalkan",
      normalPrice: "Harga normal",
      uploaded: "Diupload",
      cancelled: "Dibatalkan",
      updatePeriod: "Ubah periode",
      updatePeriodPrice: "Update periode harga",
      downloadAttachmentEmail: "File akan dikirim via email",
      downloadAttachmentFailed: "Download file lampiran gagal",
      downloadAttachmentFailedError: "Download File Gagal",
      cancelProcessMessage: "Yakin membatalkan proses upload?",
      cancelProcessMessageConfirm: "Data akan hilang dan tidak akan kembali.",
      cancelProcessFailed: "Batalkan proses upload gagal!",
      yesCancel: "Ya, batalkan",
      back: "Kembali",
      start: "Mulai",
      end: "Berakhir",
    },
    changeInsuranceModal: {
      title: "Ubah asuransi klien induk",
      periodHint:
        "Periode asuransi akan berlaku sesuai tanggal periode harga yang telah disimpan.",
      selectInsuranceType: "Pilih tipe asuransi",
      customRatesPlaceholder: "e.g 20",
      customRates: "Custom Rates",
      bundlingNoInsuranceFee: "Bundling (No Insurance Fee)",
      tieringRetail: "Tiering retail",
      customRatesMin: "Custom rates minimum 0,2%, cek & ubah lagi.",
      customRatesMax: "Custom rates maximum 0,99%, cek & ubah lagi.",
      success: "Perubahan asuransi klien induk “{clientName}” berhasil!",
      failed: "Perubahan asuransi klien induk “{clientName}” gagal!",
      serverError: "Server Error"
    },
    changePeriodModal: {
      periodPrice: "Periode harga",
      selectDateRangeDesc: "Tentukan rentang tanggal mulai & tanggal berakhir untuk berlakunya harga custom.",
      dateAndTimeStart: "Tanggal dan jam mulai",
      dateAndTimeEnd: "Tanggal dan jam berakhir",
      selectDateAndTime: "Pilih tanggal dan jam",
      changePeriodPriceFailed: "Gagal Mengubah Periode Harga !",
    },
    ratePopup: {
      addNewParentPrice: "Tambah harga baru klien induk",
      addPriceSuccess: "Penambahan harga klien induk “{clientName}” berhasil!"
    },
    infoDetailClient: {
      parentClient: "Klien induk",
      branchClient: "Klien cabang",
      editDetail: "Ubah detail",
      freeze: "Freeze",
      availableBalance: "Saldo tersedia",
      freezeReason: "Alasan freeze",
      createdDate: "Tanggal dibuat",
      updatedDate: "Tanggal diperbarui",
      price: "Harga",
      detail: "Detail",
      updatedBy: "Diperbarui oleh",
    },
    managementDetail: {
      parentDetailTitle: "Detail klien induk",
      branchDetailTitle: "Detail klien cabang",
      tabs: {
        client: "Klien",
        tax: "Pajak",
        contact: "Kontak",
        payment: "Pembayaran",
        billing: "Billing",
        cooperationAgreement: "Perjanjian kerjasama",
        bank: "Bank",
        bankSettlement: "Bank settlement"
      },
      paymentInfoTitle: "Informasi pembayaran",
      paymentMethod: "Metode pembayaran",
      clientInfoTitle: "Informasi klien",
      clientType: "Tipe klien",
      clientId: "Klien ID",
      clientCode: "Kode klien",
      parentClientName: "Nama induk klien",
      clientCategory: "Kategori klien",
      companySize: "Ukuran perusahaan",
      address: "Alamat",
      districtCity: "Kecamatan, Kota",
      email: "Email",
      phone: "No. Telepon",
      needAssessmentChange: "Perlu assessment perubahan?",
      yes: "Ya",
      no: "Tidak",
      contactInfoTitle: "Informasi kontak",
      name: "Nama",
      position: "Jabatan",
      billingInfoTitle: "Informasi billing",
      whatsappNumber: "No. WhatsApp",
      billingSchedule: "Jadwal Penagihan",
      paymentTerm: "Jangka Waktu Pembayaran",
      day: "Hari",
      taxInfoTitle: "Informasi Pajak",
      taxRegistrationNumber: "No. registrasi pajak (NPWP)",
      taxPayerName: "Nama wajib pajak",
      addressAsTaxId: "Alamat sesuai NPWP",
      taxInvoiceTransactionCode: "Kode transaksi faktur pajak",
      nikNumber: "Nomor KTP (NIK)",
      nameAsIdCard: "Nama sesuai KTP",
      addressAsIdCard: "Alamat sesuai KTP",
      taxIdOrIdCardPhoto: "Foto NPWP/KTP",
      startedFrom: "Dimulai dari",
      until: "Sampai",
      frpDocument: "Dokumen FRP (Form Registrasi Pelanggan)",
      pksDocument: "Dokumen PKS (Perjanjian Kerjasama)",
      bankInfoTitle: "Informasi bank",
      bankSettlementInfoTitle: "Informasi bank settlement",
      accountNameAbbr: "a.n",
      return: "Pengembalian",
      cod: "COD",
      parentClientDetail: "Detail induk klien",
      requiresSOSplit: "Perlu split SO?",
    },
    infoPriceClient: {
      origin3lc: "3LC Origin",
      changeParentClientPriceQuestion: "Ubah harga klien induk?",
      changeParentClientPriceMessage:
        "Harga yang sedang diajukan akan diganti sesuai kebutuhan yang baru.",
      yesChange: "Ya, ubah",
      back: "Kembali",
      changeParentClientPrice: "Ubah harga klien induk",
      save: "Simpan",
      priceChange: "Perubahan Harga",
      renew: "Perpanjang",
      submittedBy: "Diajukan oleh",
      submissionDate: "Tanggal pengajuan",
      activeDate: "Tanggal aktif",
      customPriceType: "Tipe kustomisasi harga",
      price: "Harga",
      insurance: "Asuransi",
      discount: "Diskon",
      allDiscount: "Semua Diskon",
      deliveryType: "Jenis pengiriman",
      percentage: "Persentase",
      all3lcs: "All 3LCs",
      currentPrice: "Harga saat ini",
      freeze: "Freeze",
      ensurePriceInfo: "Pastikan informasi harga telah sesuai!",
      clientRequestAccepted:
        "Permintaan klien berhasil diterima. Harga, berat, & asuransi sudah memenuhi syarat.",
      downloadFailedFile: "Download file gagal",
      date: "Tanggal",
      accepted: "Diterima",
      rejected: "Ditolak",
      cancelled: "Dibatalkan",
      by: "oleh",
      changeInsurance: "Ubah Asuransi",
      changePrice: "Ubah harga",
      downloadAttachmentFile: "Download file lampiran",
      updatePrice: "Update harga",
      lastProcessed: "Terakhir diproses {date}",
      retry: "Coba lagi",
      pricePeriod: "Periode harga",
      specialPrice: "Harga khusus",
      weightCalculation: "Perhitungan berat",
      chargeableWeight: "Chargeable Weight (Pembulatan aktif)",
      insuranceCalculation: "Perhitungan asuransi",
      seeAll: "Lihat Semua",
      seeDiscount: "Lihat Diskon",
      priceRetail: "Harga retail",
      priceRetailDescription: "Harga akan mengikuti harga retail",
      priceNormal: "Harga normal",
      priceNormalDescription:
        "Harga akan mengikat selama periode harga yang ditentukan.",
      priceSpecial: "Harga khusus",
      priceSpecialDescription:
        "Harga akan mengikuti harga kecamatan/kota yang Anda upload.",
      priceCombination: "Harga kombinasi",
      priceCombinationDescription:
        "Harga akan mengikuti harga kecamatan/kota yang Anda upload & harga retail.",
      viewPriceChange: "Lihat Perubahan Harga",
      waitingApprovalPriceChange: "Menunggu persetujuan perubahan harga",
      uploadingPriceFile:
        "File perubahan harga sedang di upload ({process}/{total})",
      failed: "Gagal",
      customRatesFailedBySystem:
        "Perubahan harga custom rates gagal diupdate oleh system",
      customRatesNotApproved: "Perubahan harga custom rates tidak disetujui",
      customRatesCancelled: "Perubahan harga custom rates dibatalkan",
      priceFileFailedUpload: "File perubahan harga gagal di upload",
      priceChangeAccepted: "Perubahan harga diterima",
      priceChangeAcceptedPartially: "Perubahan harga diterima sebagian",
      active: "Aktif",
      waiting: "Menunggu",
      nearlyExpired: "Nearly Expired",
      expired: "Expired",
      pending: "Pending",
      uploadStatus: "upload {progress}",
      retailTiering: "Retail (Tiering)",
      bundlingNoInsuranceFee: "Bundling(No Insurance Fee)",
      customRatesPercent: "Custom Rates {percentage}%",
      downloadFailedError: "Download file gagal!!!",
      parentClientPriceChangeSuccess:
        "Perubahan harga klien induk “{clientName}” berhasil!",
      parentClientPriceChangeFailed:
        "Perubahan harga klien induk “{clientName}” gagal!",
      continueRetryProcess: "Lanjutkan proses ulang data?",
      retryProcessMessage:
        "Harga yang Anda upload akan diproses lagi dan updatenya tetap dilanjutkan.",
      yesContinue: "Ya, lanjutkan",
      cancel: "Batalkan",
      districtRetailPrice: "Tarif retail kecamatan",
      startDate: "Tanggal mulai",
      endDate: "Tanggal berakhir",
      customPrice: "Harga khusus",
      customPriceName: "Nama harga khusus",
      uploaded: "Diupload",
      cancelProcess: "Batalkan Proses",
      start: "Mulai",
      end: "Berakhir",
      downloadAttachmentEmail: "File akan dikirim via email",
      downloadAttachmentFailed: "Download file lampiran gagal",
      downloadAttachmentFailedError: "Download File Gagal",
      priceUnknown: "Unknown",
      yesCancel: "Ya, batalkan",
      cancelProcessMessage: "Yakin membatalkan proses upload?",
      cancelProcessMessageConfirm: "Data akan hilang dan tidak akan kembali.",
      cancelProcessFailed: "Batalkan proses upload gagal!",
      generate: "Generate",
      dataNotFound: "Data tidak ditemukan",
      download: "Download",
      bulkDownloadList: "Daftar bulk download",
      updatedBy: "Diperbarui oleh",
    },
    clientRateHistory: {
      waiting: "Menunggu",
      requested: "Diajukan",
      rejected: "Ditolak",
      cancelled: "Dibatalkan",
      rejectedPartial: "Ditolak - <span class='font-normal'>Partial</span>",
      active: "Aktif",
      approved: "Disetujui",
      approvedPartial: "Disetujui - <span class='font-normal'>Partial</span>",
      nearlyExpired: "Nearly Expired",
      expired: "Berakhir",
      pending: "Menunggu",
      uploading: "Uploading",
      history: "Riwayat",
      all: "Semua",
      status: "Status",
      type: "Type",
      reset: "Reset",
      apply: "Terapkan",
      noHistory: "Belum ada riwayat",
      failHistory: "Gagal mendapatkan data riwayat",
    }
  },
  remarks: {
    misbooking: "Kecamatan/kota pada resi tidak sesuai detail alamat.",
    change: "Ubah remark"
  },
  onProcessStt: {
    pageTitle: "STT Dalam Proses",
    editBooking: "Ubah Booking",
    filter: {
      searchPlaceholder: "Cari No. STT genesis/elexys"
    },
    table: {
      sttNumber: "No. STT",
      shipmentNumber: "No. shipment",
      destination: "Alamat tujuan",
      status: "Status terakhir",
      adjustmentStatus: "Status Adjustment",
      serviceType: "Jenis pengiriman",
      bookingDate: "Tanggal booking",
      lastUpdate: "Tanggal diupdate",
      bookingFor: "Dibooking untuk",
      destinationCity: "Kota tujuan",
      action: "Action"
    },
    emptyData: "Data On Process STT",
    deleteTooltip: "Batalkan Booking",
    action: {
      editBooking: "Ubah Booking",
      printThermal: "Print Thermal Resi",
      printThermalPdf: "Print Thermal Resi PDF",
      printBasicPdf: "Print Basic/Save to PDF",
      printCommercialInvoice: "Print Commercial Invoice"
    },
    tooltip: {
      dexAttempt: "Percobaan DEX ke"
    }
  },
  customProcess: {
    selectStatus: "Pilih Status",
    allStatus: "Semua Status",
    updateStatus: "Update Status",
    emptyData: "Custom Process",
    reasonPlaceholder: "Pilih alasan",
    titleModalReroute: "Konfirmasi update status?",
    titleModalMisbooking: "Konfirmasi update status?",
    msgModalRerouteMisbooking:
      "Pastikan kembali seluruh detail STT sudah benar dan sesuai, karena akan dilakukan pemotongan saldo POS terkait.",
    titleModalRejected: "Update status STT ke REJECTED?",
    msgModalRejected: "Pastikan kembali seluruh detail STT sudah sesuai.",
    titleModalDefault: "Konfirmasi Perubahan",
    msgModalDefault:
      "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
    no: "No.",
    totalStt: "Total STT",
    remarks: "Remarks",
    action: "Action",
    print: "Print",
    forStatusOnlyOneStt: "Untuk status ",
    statusRts: "RTS",
    statusRtshq: "RTSHQ",
    and: "dan",
    onlyOneSttSuffix: " hanya bisa memperbaharui 1 No. STT",
    mustChangeAddressMisbooking:
      "Wajib ubah alamat penerima untuk memproses MISBOOKING.",
    addressChangedByBackline:
      "Alamat penerima ini sudah diubah oleh backline, Anda bisa langsung proses saat update misbooking dari akun console",
    hubDestination: "Hub tujuan",
    vehicleNumber: "Nomor kendaraan",
    selectPos: "Pilih POS",
    changeAddress: "Ubah Alamat",
    changeReceiverAddress: "Ubah Alamat Penerima",
    scanSttFailed: "Scan No. STT Gagal",
    addSttFailed: "Tambah No. STT Gagal",
    statusChangeSuccess: "Perubahan Status Berhasil",
    printReceipt: "Print Resi",
    printThermalReceipt: "Print Thermal Resi",
    printBasicPdf: "Print Basic/Save to PDF",
    selectConsoleType: "Pilih Tipe konsol",
    consolidator: "Consolidator",
    subConsolidator: "Sub Consolidator",
    selectRemarks: "Pilih Remarks",
    remarkAddressChangeCustomer: "Permintaan perubahan alamat dari Customer",
    remarkAddressChangePos: "Permintaan perubahan alamat dari POS",
    deliveryDetail: "Detail Pengiriman",
    deliveryProduct: "Produk Pengiriman",
    chooseProduct: "Pilih Produk",
    senderName: "Nama Pengirim",
    receiverName: "Nama Penerima",
    senderAddress: "Alamat Pengirim",
    receiverAddress: "Alamat Penerima",
    senderPhone: "No. Telepon Pengirim",
    receiverPhone: "No. Telepon Penerima",
    receiverPhonePlaceholder: "Masukan No. Telepon dengan benar",
    district: "Kecamatan, Kota Asal",
    districtCity: "Kecamatan, Kota Tujuan",
    chooseCity: "Pilih kota tujuan",
    posCode: "Kode POS",
    addressType: "Tipe Alamat",
    itemDetail: "Detail Barang",
    commodityType: "Tipe Komoditas",
    typeCommodity: "Ketik atau pilih nama komoditas",
    deliveryStatus: "Status Pengiriman",
    deliveryStatusDesc:
      "Status pengiriman berlaku untuk pengiriman dari Kota Asal FTZ. Isi dengan kondisi barang yang akan dikirimkan.",
    chooseStatus: "Pilih status pengiriman yang akan dikirim",
    tax: "No Registrasi Pajak (NPWP)",
    taxDesc:
      "Wajib Pajak bisa individu atau perusahaan sesuai dengan yang sudah terdaftar.",
    pcpDesc: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
    enterPcp: "Masukan piece per pack",
    nextCommodity: "Komoditas Selanjutnya",
    nextCommodityDesc: "Isi dengan komoditas barang yang ada dalam satu koli.",
    enterNext: "Masukan komoditas selanjutnya",
    localBatam: "Produk lokal / Batam",
    outerBatam: "Eks luar Batam / transit",
    wrong: "Salah kirim / return",
    errorCod:
      "Kecamatan & Kota Tujuan yang Anda masukkan belum menyediakan layanan COD, silakan ubah data",
    forwardArea:
      "Kecamatan & Kota Tujuan yang Anda masukkan belum menyediakan layanan DO, silakan ubah data",
    balanceInsufficient: "Saldo POS tidak mencukupi",
    updateFailed: "Gagal Update!",
    understand: "Oke, Saya Mengerti"
  },
  customProcessManifest: {
    detailTitle: "Detail Custom Process",
    customStatus: "Custom Status",
    totalSTT: "Total STT",
    totalKoli: "Total Koli",
    totalGrossWeight: "Total Berat Kotor",
    totalChargeableWeight: "Total Berat Dikenakan Biaya",
    createdAt: "Tanggal Dibuat",
    printReceiptCustomProcess: "Print Resi Custom Process",
    printPdf: "Print PDF",
    consolidatorCity: "Nama Partner",
    createdBy: "Dibuat oleh",
    createdDateAndTime: "Tanggal dibuat",
    status: "Status terbaru",
    totalSTTPieces: "Total STT/koli",
    totalDimensionWeight: "Total berat dimensi",
    noSTT: "No. STT",
    noSTTReplacement: "No. STT pengganti",
    originCity: "Kota asal",
    destinationCity: "Kota tujuan",
    origin: "Origin",
    destination: "Dest.",
    grossWeight: "Berat kotor",
    dimensionweight: "Berat dimensi",
    chargeableWeight: "Berat dikenakan biaya",
    vehicleNumber: "Nomor kendaraan"
  },
  instantBooking: {
    title: "Booking Instant",
    pageTitle: "Booking {'|'} Booking Instant",
    form: {
      originCity: "Kota Asal",
      posName: "Nama POS",
      shipmentIdBookingId: "Shipment ID/Booking ID",
      shipmentIdExample: "Contoh : B29QHDMQEZ",
      shipmentIdPlaceholder: "Masukan shipment id/booking id atau scan barcode"
    },
    summary: {
      totalShipment: "Total Shipment",
      totalBookingSuccess: "Total Booking Sukses",
      totalBookingProgress: "Total Booking Diproses",
      totalBookingFailed: "Total Booking Gagal"
    },
    print: {
      receipt: "Cetak Resi",
      thermalPdf: "Cetak Thermal Resi PDF",
      basicPdf: "Cetak Basic/Simpan ke PDF",
      invoice: "Cetak Tagihan",
      confirmTitle: "Cetak Semua STT yang Sukses?",
      confirmMessage:
        "STT dengan status <strong>{inProgress}</strong> & <strong>{failed}</strong> tidak akan dicetak",
      checkAgain: "Cek Ulang",
      print: "Cetak"
    },
    modal: {
      addShipmentFailedTitle: "Penambahan Shipment ID Gagal !",
      back: "Kembali",
      confirmExitTitle: "Yakin Ingin Keluar?",
      confirmExitMessage:
        "Pastikan kembali Anda telah mencetak resi untuk menyelesaikan proses booking instant",
      exit: "Keluar"
    },
    table: {
      no: "No.",
      shipmentId: "Shipment ID",
      sttNo: "No. STT",
      sender: "Pengirim",
      receiver: "Penerima",
      receiverAddress: "Alamat Penerima",
      totalPieces: "Total Koli",
      totalWeight: "Total Berat",
      totalTariff: "Total Tarif",
      failedReason: "Alasan Gagal",
      status: "Status",
      printLabel: "Print Label",
      action: "Aksi"
    },
    status: {
      success: "Sukses",
      inProgress: "Diproses",
      failed: "Gagal",
      printSuccess: "Sukses",
      printFailed: "Gagal Print",
      printProcessing: "Sedang Diproses"
    },
    error: {
      invalidShipment:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena {reason}",
      duplicateShipment: "No. Shipment ID <b>“{shipmentId}”</b> sudah di input",
      alreadyBooked:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena sudah berstatus booking",
      destinationNotFound:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena alamat atau Kota/Kecamatan tujuan tidak ditemukan",
      mandatoryEmpty:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena terdapat data mandatory yang kosong atau tidak ada",
      emptyGoods:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena barang kosong atau tidak ada",
      pcuOnly:
        "Shipment ID <b>“{shipmentId}”</b> hanya bisa diproses oleh POS PCU karena pengiriman menggunakan produk Jumbopack.",
      unknownShipment:
        "Shipment ID <b>“{shipmentId}”</b> tidak bisa diproses karena {reason}",
      reasonUnknown: "tidak dikenal",
      reasonMultipleDestination: "alamat tujuan lebih dari satu.",
      reasonDisallowed:
        "shipment id tidak diperbolehkan booking melalui instant booking",
      reasonFavorite: "pengiriman berupa Shipment Favorite.",
      failedGetReceiptData: "Gagal mendapatkan data resi"
    }
  },
  bookingV3: {
    shipperPhoneNumber: "No. telepon",
    recipientPhoneNumber: "No. telepon",
    shipperAddress: "Alamat",
    recipientAddress: "Alamat",
    districtCity: "Kecamatan, kota",
    list: {
      searchStt: "Cari no. STT/shipment",
      filter: {
        bookingPeriod: "Periode",
        BookedFor: "Booked For",
        shipperPhoneNumber: "No Telepon Pengirim",
        recipientPhoneNumber: "No Telepon Penerima",
        serviceType: "Produk",
        selectServiceType: "Pilih Produk",
        selectStatus: "Pilih Status",
        status: "Status",
        shipmentInsurance: "Asuransi Pengiriman"
      },
      table: {
        noSTTGenesis: "No. STT Genesis",
        shipmentID: "Shipment ID",
        destinationAddress: "Alamat Tujuan",
        status: "Status",
        bookingDate: "Tanggal Booking",
        totalPieces: "Total Koli",
        totalWeight: "Total Berat",
        serviceType: "Produk",
        commodity: "Komoditas",
        createdFor: "Dibuat Untuk",
        insurance: "Asuransi",
        troubledStatus: "Status Bermasalah",
        clientName: "Nama Klien"
      },
      action: {
        createBooking: "Booking Retail",
        edit: "Ubah Booking",
        thermalReceipt: "Print Thermal Resi",
        thermalPdf: "Print Thermal Resi  PDF",
        basicPdf: "Print Basic/Save to PDF"
      }
    },
    commodity: "Komoditas",
    commodityNote: "Isi komoditas sesuai",
    commodityTnC: "syarat & ketentuan.",
    commodityPlaceholder: "Masukkan atau pilih komoditas",
    commodityRecommendationErrorTitle: "Terjadi kendala sistem",
    commodityRecommendationErrorMessage:
      "Klik “Muat Ulang” untuk memperbarui halaman.",
    commodityRecommendationErrorButton: "Muat Ulang",
    commodityViewAll: "Lihat semua",
    commodityMostUsed: "Paling sering dipilih",
    commodityEmptyByCategory: "Masukkan kata kunci atau pilih kategori.",
    commodityEmptySearch:
      "Pencarian tidak ditemukan. Cek & ubah kata kunci lain.",
    commoditySearchResult: "Hasil pencarian",
    commodityErrorRequired: "Komoditas wajib diisi.",
    commodityErrorInactive: "Komoditas tidak aktif.",
    commodityNotFound: "Komoditas tidak ditemukan.",
    receiptLanguage: "Bahasa resi",
    errorCountryNotFound: "Negara tidak ditemukan",
    searchCountryPlaceholder: "Cari nama negara",
    errorCustomerNotFound: "Data pelanggan tidak ditemukan",
    productType: {
      title: "Jenis pengiriman",
      info: {
        infoPrice: "Harga belum termasuk",
        otherPrice: "biaya lainnya",
        infoTariff: ", cek total tarif di ringkasan!"
      },
      titleToggle: "Diskon Agen",
      tooltip: {
        title: "Biaya lainnya (jika ada):",
        priceMsg: `<ul class="px-2 py-4">
        <li>• Biaya tambahan komoditas</li>
        <li>• Biaya tambahan berat</li>
        <li>• Biaya tambahan dokumen</li>
        <li>• Biaya packing kayu</li>
        <li>• Biaya proteksi</li>
        <li>• Biaya admin proteksi</li>
        <li>• Biaya COD</li>
      </ul>`
      },
      card: {
        labelDay: "hari",
        labelDiscountAgen: "Diskon Agen",
        labelAvailable: "Belum tersedia",
        labelEmbargo: "Embargo",
        labelRecommended: "Direkomendasikan"
      },
      error: {
        errorSystem: {
          title: "Terjadi kendala sistem",
          subtitle: "Klik “Muat Ulang” untuk memperbarui halaman.",
          button: "Muat ulang"
        }
      }
    },
    sttManualReference: {
      labelStt: "No. STT manual",
      placeholderStt: "Masukkan nomor STT manual",
      labelOptional: "(opsional)",
      labelReference: "No. referensi eksternal",
      placeholderReference: "Masukkan nomor referensi eksternal",
      checkStt: "Sedang memeriksa",
      error: {
        sttManual: "Format nomor STT manual tidak valid.",
        required: "No. referensi eksternal wajib diisi",
        minRefExt: "Min. 3 karakter.",
        refExtAlreadyUsed: "Nomor referensi eksternal sudah terpakai",
        refExtFailedSystem: "Gagal karena kendala sistem."
      },
      success: {
        sttApproved: "Nomor referensi eksternal bisa digunakan."
      }
    },
    deliveryService: {
      label: "Layanan pengiriman",
      error: {
        eligibleDestinationCOD: "Kota tujuan belum bisa COD/DFOD.",
        phoneNumberBlacklist: "Tidak bisa COD/DFOD, hubungi CS LP.",
        phoneNumberLimit: "Melebihi limit transaksi COD/DFOD.",
        eligiblePartnerCOD: "Mitra belum bisa COD/DFOD",
        eligibleCOD: "Pengirim tidak bisa COD/DFOD"
      }
    },
    docInternational: {
      title: "Detail pengiriman luar negeri ",
      titleFTZ: "Free trade zone",
      CIPLLabel:
        "Detail barang untuk CIPL (Commercial Invoice and Packing List)",
      CIPLLabelFTZ:
        "Detail barang untuk CIPL (Commercial Invoice and Packing List)",
      commodityPlaceholder: "Masukkan atau pilih barang di lihat semua",
      commodityPlaceholderFTZ: "Masukkan atau pilih barang di lihat semua",
      emailLabel: "Email penerima",
      idNumberLabel: "Nomor identitas penerima",
      taxNumberLabel: "Nomor registrasi pajak penerima",
      shipmentStatusLabel: "Status pengiriman",
      shipmentStatusLabelFTZ: "Status pengiriman",
      emailLabelFTZ: "Email",
      idNumberLabelFTZ: "Nomor identitas",
      taxNumberLabelFTZ: "Nomor registrasi pajak",
      supportingDocumentLabel: "Foto pendukung",
      supportingDocumentLabelFTZ: "Foto pendukung",
      supportingDocumentIdLabel: "Kartu identitas",
      supportingDocumentIdLabelFTZ: "Kartu identitas",
      supportingDocumentTaxLabel: "Kartu registrasi pajak",
      supportingDocumentTaxLabelFTZ: "Kartu registrasi pajak",
      supportingDocumentBeforePackingLabel: "Paket sebelum packing",
      supportingDocumentBeforePackingLabelFTZ: "Paket sebelum packing",
      supportingDocumentAfterPackingLabel: "Paket sesudah packing",
      supportingDocumentAfterPackingLabelFTZ: "Paket sesudah packing",
      supportingDocumentSpec: "Maks. file: 5 MB, Format: jpg, jpeg, png",
      supportingDocumentSpecFTZ: "Maks. file: 5 MB, Format: jpg, jpeg, png",
      emailPlaceholder: "Masukkan email penerima",
      emailPlaceholderFTZ: "Masukkan email penerima",
      idNumberPlaceholder: "Masukkan nomor identitas penerima",
      idNumberPlaceholderFTZ: "Masukkan nomor identitas penerima",
      taxNumberPlaceholder: "Masukkan nomor registrasi pajak penerima",
      taxNumberPlaceholderFTZ: "Masukkan nomor registrasi pajak penerima",
      shipmentStatusPlaceholder: "Masukkan status pengiriman",
      shipmentStatusPlaceholderFTZ: "Masukkan status pengiriman",
      goodsPricePrefix: "Rp",
      goodsPricePrefixFTZ: "Rp",
      deleteCIPLBtnText: "Hapus",
      deleteCIPLBtnTextFTZ: "Hapus",
      addCIPLBtnText: "Tambah barang",
      addCIPLBtnTextFTZ: "Tambah barang",
      itemDetailCIPLHeadingText: "Detail barang",
      itemDetailCIPLHeadingTextFTZ: "Detail barang",
      quantityCIPLHeadingText: "Kuantitas",
      quantityCIPLHeadingTextFTZ: "Kuantitas",
      itemPriceCIPLHeadingText: "Harga barang",
      itemPriceCIPLHeadingTextFTZ: "Harga barang",
      dutyTaxTermsLabel: "Ketentuan bea cukai dan pajak",
      dutyTaxTermsPlaceholder: "Pilih ketentuan bea cukai dan pajak",
      dutyTaxTermsTooltipDescription: `<ul class="custom-list">
        <li><span class="font-bold">Delivered Duty Paid (DDP):</span> Pengirim akan menanggung seluruh biaya bea cukai & pajak. </li>
        <li><span class="font-bold">Delivery At Place (DAP):</span> Penerima akan menanggung seluruh biaya bea cukai & pajak saat paket sampai di tujuan. </li>
      </ul>`,
      dutyTaxTermsBannerPrefix:
        "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke",
      shipper: "Pengirim",
      recipient: "Penerima",
      dutyTaxTermsOptionDDP: "Ditanggung pengirim (DDP)",
      dutyTaxTermsOptionDAP: "Ditanggung penerima (DAP)",
      dutyTaxTermsBannerDDP:
        "DDP dipilih: bea masuk dan pajak ditanggung Pengirim.",
      dutyTaxTermsBannerDAP:
        "DAP dipilih: bea masuk dan pajak ditanggung Penerima.",
      countryCodeLabel: "Kode Negara",
      countryCodePlaceholder: "Contoh: ID",
      dgTypeLabel: "Tipe DG",
      dgTypePlaceholder: "Pilih tipe DG",
      dgTypeOptionNON: "NON - Barang Umum",
      dgTypeOptionBAT: "BAT - Baterai",
      dgTypeOptionLIQ: "LIQ - Cairan Umum",
      dgTypeOptionGAS: "GAS - Gas & Aerosol",
      dgTypeOptionMIX: "MIX - Barang DG Campuran",
      quarantineTypeLabel: "Tipe Karantina",
      quarantineTypePlaceholder: "Pilih tipe karantina",
      quarantineTypeOptionNON: "NON - Barang Umum",
      quarantineTypeOptionPLT: "PLT - Produk Tumbuhan",
      quarantineTypeOptionANM: "ANM - Produk Hewan",
      quarantineTypeOptionFIS: "FIS - Produk Ikan",
      quarantineTypeOptionMIX: "MIX - Barang Karantina Campuran",
      dutyTaxTermsOptionDap: "Ditanggung penerima (DAP)",
      dutyTaxTermsOptionDdp: "Ditanggung pengirim (DDP)",
      dutyTaxTermsTooltipDapDescription:
        "Penerima akan menanggung seluruh biaya bea cukai & pajak saat paket sampai di tujuan.",
      dutyTaxTermsTooltipDdpDescription:
        "Pengirim akan menanggung seluruh biaya bea cukai & pajak.",
      dutyTaxTermsInfoBarDap:
        "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke <strong>penerima</strong>.",
      dutyTaxTermsInfoBarDdp:
        "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke <strong>pengirim</strong>.",
      error: {
        emailMandatory: "Email penerima wajib diisi.",
        idNumberMandatory: "Nomor identitas penerima wajib diisi.",
        taxNumberMandatory: "Nomor registrasi pajak penerima wajib diisi.",
        taxNumberMin: "Nomor registrasi pajak minimal 15 karakter",
        dutyTaxTermsMandatory: "Customs & Tax Payment wajib diisi.",
        emailValid: "Email penerima tidak valid",
        emailValidFTZ: "Email tidak valid",
        itemDetailMandatory: "Detail barang wajib diisi.",
        quantityMandatory: "Kuantitas wajib diisi",
        goodsPriceMandatory: "Harga barang wajib diisi",
        supportingDocumentMandatory: "Foto pendukung wajib diisi",
        supportingDocumentMaxSize: "File foto pendukung maksimum 5 MB."
      }
    },
    modalSuccess: {
      title: "Booking berhasil!",
      createInvoice: "Buat Tagihan",
      print: "Print thermal resi PDF",
      close: "Tutup",
      recipient: "Penerima",
      serviceType: "Jenis pengiriman",
      chargableWeight: "Berat dikenakan biaya",
      destination: "Kecamatan, kota tujuan",
      estimation: "Estimasi pengiriman",
      codFee: "Biaya COD",
      payable: "Biaya yang harus dibayar penerima",
      tariff: "Total tarif"
    },
    modalFailed: {
      title: "Booking gagal!",
      balance: "Saldo POS saat ini",
      price: "Harga booking",
      reason: {
        title: "Alasan:",
        embargo: "Rute terjadi embargo",
        freeze: "Akun dibekukan, hubungi CS Lion Parcel.",
        connection: "Koneksi internet terganggu",
        inactive: "Akun tidak aktif, hubungi CS Lion Parcel.",
        tariff: "Tarif tidak tersedia",
        posFreeze: "Akun POS dibekukan, hubungi CS Lion Parcel.",
        posInactive: "Akun POS tidak aktif, hubungi CS Lion Parcel.",
        codUnavailable: "COD tidak tersedia",
        priceChange: "Harga berubah",
        clientFreeze: "Akun klien dibekukan, hubungi CS Lion Parcel.",
        clientInactive: "Akun klien tidak aktif, hubungi CS Lion Parcel.",
        system: "Terjadi kendala sistem",
        commodity: "Komoditas tidak aktif",
        balance: "Saldo POS tidak cukup",
        balanceNegative: "Saldo minus",
        pieceBalance: "Tidak ada sisa koli yang dapat diproses.",
        pieceBalanceAvailable:
          "Booking tidak dapat diproses karena shipment belum dipickup.",
        pieceBalanceInfucient:
          "Jumlah koli yang dimasukkan melebihi sisa jumlah koli. Silakan periksa kembali."
      },
      button: {
        back: "Kembali",
        understand: "Oke, mengerti",
        reload: "Muat ulang",
        changeDestinationProduct: "Ubah tujuan/jenis pengiriman lain ",
        chooseOther: "Pilih layanan lain",
        changeCommodity: "Ubah komoditas lain",
        topUp: "Top up sekarang"
      }
    },
    senderName: {
      error: {
        required: "Nama wajib diisi.",
        min: "Nama minimum 3 karakter."
      }
    },
    senderPhone: {
      valid: "Nomor telepon valid.",
      fraud: {
        limited1: "Nomor telah melebihi",
        limited2: "limit transaksi",
        limited3: "COD/DFOD per hari.",
        limitedTooltip:
          "Nomor handphone baru memiliki batas transaksi COD/DFOD per hari sebesar 10 STT (tidak termasuk CNX) atau total tarif STT melebihi Rp300.000.",
        suspected: "Nomor memiliki tingkat retur COD/DFOD yang tinggi."
      },
      error: {
        required: "Nomor telepon wajib diisi.",
        invalid: "Nomor telepon tidak valid.",
        checkGuide: "Cek panduan",
        checkGuideTooltip: `<b>Nomor MSISDN (Mobile Subscriber Integrated Services Digital Network)</b></br>
        Nomor harus diawali angka 8 & minimal 11 digit.</br></br>
        <b>Nomor PSTN (Public Switched Telephone Network)</b></br>
        Nomor tidak boleh diawali angka 1 atau 8 & minimal 8 digit.`
      }
    },
    senderAddress: {
      error: {
        required: "Alamat wajib diisi.",
        min: "Alamat minimum 3 karakter.",
        senderRecipientMismatch:
          "Alamat pengirim dan penerima tidak boleh sama."
      }
    },
    receiverName: {
      error: {
        required: "Nama wajib diisi.",
        min: "Nama minimum 3 karakter."
      }
    },
    receiverPhone: {
      valid: "Nomor telepon valid.",
      fraud: {
        limited: "Nomor telah melebihi {highlight} COD/DFOD per hari.",
        limitedKeyword: "limit transaksi",
        limitedTooltip:
          "Nomor handphone baru memiliki batas transaksi COD/DFOD per hari sebesar 10 STT (tidak termasuk CNX) atau total tarif STT melebihi Rp300.000.",
        suspected: "Nomor memiliki tingkat retur COD/DFOD yang tinggi."
      },
      error: {
        required: "Nomor telepon wajib diisi.",
        invalid: "Nomor telepon tidak valid.",
        checkGuide: "Cek panduan",
        checkGuideTooltip: `<b>Nomor MSISDN (Mobile Subscriber Integrated Services Digital Network)</b></br>
        Nomor harus diawali angka 8 & minimal 11 digit.</br></br>
        <b>Nomor PSTN (Public Switched Telephone Network)</b></br>
        Nomor tidak boleh diawali angka 1 atau 8 & minimal 8 digit.`
      }
    },
    receiverAddress: {
      error: {
        required: "Alamat wajib diisi.",
        min: "Alamat minimum 3 karakter.",
        senderRecipientMismatch:
          "Alamat pengirim dan penerima tidak boleh sama."
      }
    },
    receiverDestinationCity: {
      misbookingGuidance:
        "Tujuan ini rawan salah kirim. Pastikan pilihan sesuai alamat penerima.",
      error: {
        notfound: "Kecamatan, kota tujuan tidak ditemukan.",
        required: "Kecamatan, kota tujuan wajib diisi.",
        embargo: "Rute yang Anda pilih terjadi embargo.",
        unavailable: "Rute yang Anda pilih belum tersedia."
      }
    },
    receiverPostalCode: {
      error: {
        notfound: "Kode pos tidak ditemukan.",
        required: "Kode pos wajib diisi."
      }
    },
    create: {
      title: "Buat Booking Baru",
      pageTitle: "Booking {'|'} Create"
    },
    bookingApps: {
      title: "Booking aplikasi & marketplace",
      pageTitle: "Booking {'|'} Apps Booking"
    },
    edit: {
      title: "Ubah booking",
      pageTitle: "Booking {'|'} Ubah"
    },
    bookingSuccess: "Pembuatan Booking Berhasil",
    shipment: {
      chargeableWeight: {
        label: "Berat dikenakan biaya",
        detail: "Detail berat barang",
        totalItem: "Total barang",
        totalGrossWeight: "Total berat kotor",
        totalDimensionWeight: "Total berat dimensi"
      },
      checkTariff: {
        label: "Total tarif",
        detail: {
          title: "Detail pembayaran",
          ratesAndsurcharge: "Publish rates + shipping surcharge",
          originRates: "Origin forward rates",
          destinationRates: "Destination forward rates",
          shippingCost: "Biaya pengiriman",
          surcharge: {
            commodity: "Biaya tambahan komoditas",
            weight: "Biaya tambahan berat",
            document: "Biaya tambahan dokumen",
            woodpacking: "Biaya packing kayu",
            total: "Total biaya tambahan"
          },
          insurance: {
            protection: "Proteksi",
            free: "Gratis",
            basic: "Basic",
            adminFee: "Biaya admin proteksi"
          },
          cod: {
            itemPrice: "Harga barang COD",
            cost: "Biaya COD"
          },
          promo: {
            tactical: "Tactical promo",
            campaign: "Campaign promo",
            validUntil: "{name} sampai dengan {date}"
          },
          chargesPayable: "Biaya yang harus dibayar penerima", // bookingV3.shipment.checkTariff.detail.estimationTax
          estimationTax: "Estimasi pajak",
          returnCost: "Biaya retur",
          error: "Kendala sistem"
        }
      },
      detailItems: {
        label: "Detail koli"
      },
      itemPrice: {
        label: "Harga barang",
        placeholder: "Masukkan harga barang",
        error: {
          mandatory: "Harga barang wajib diisi.",
          minimum: "Minimal harga barang",
          ottopack: "Harga barang harus di atas atau sama dengan 5 juta",
          min: "Harga barang minimum {price}",
          max: "Harga barang maksimum {price}",
          codMax: "Harga barang COD maksimum {price}, cek & ubah lagi.",
          codMin: "Harga barang COD minimum {price}, cek & ubah lagi.",
          dfodMax: "Harga barang DFOD maksimum {price}, cek & ubah lagi.",
          dfodMin: "Harga barang DFOD minimum {price}, cek & ubah lagi."
        }
      },
      codAmount: {
        label: "Tagihan COD",
        placeholder: "Masukkan tagihan COD",
        info: "Jika kosong, tagihan sesuai harga barang."
      },
      insurance: {
        label: "Proteksi",
        protected: "Pengiriman sudah terproteksi",
        protection: "Proteksi pengiriman",
        discount: "diskon agen",
        tooltip: {
          title: "Biaya proteksi:",
          message: `
            <ul class="custom-list">
              <li>Tier 1: Harga barang Rp1 - 1jt, <b>biaya proteksi flat Rp950</b></li>
              <li>Tier 2: Harga barang di atas 1jt - 3jt, <b>biaya proteksi flat Rp4.750</b></li>
              <li>Tier 3: Harga barang di atas 3jt - 5jt, <b>biaya proteksi flat Rp8.550</b></li>
              <li>Tier 4: Harga barang di atas 5jt - 10jt, <b>biaya proteksi flat 0,4%</b></li>
              <li>Tier 5: Harga barang di atas 10jt - 20jt, <b>biaya proteksi flat 0,6%</b></li>
              <li>Tier 6: Harga barang di atas 20jt - 1m, <b>biaya proteksi flat 0,8%</b></li>
            </ul>`
        }
      },
      // sini
      weightPieces: {
        title: "Berat koli",
        no: "No",
        grossWeight: "Berat kotor",
        dimension: "Dimensi/paket (P x L x T)",
        dimensionWeight: "Berat dimensi",
        remove: "Hapus",
        addItems: "Tambah koli",
        weightAbove: "Berat diatas",
        charged:
          " akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi.",
        districtOnePiece: "Kecamatan, kota tujuan hanya 1 koli.",
        infobarWeightComma:
          "Gunakan koma (,) untuk berat <1 kg. Contoh: 0,5 untuk 500 gram",
        error: {
          mandatoryWeight: "Berat kotor wajib diisi",
          mandatoryDimension: "Dimensi paket wajib diisi",
          maximumWeight:
            "Total berat barang melebihi batas maksimum 400 kg/STT.",
          weightAbove: "Berat diatas",
          prohibitedOnePiece: "hanya diperbolehkan 1 koli.",
          changeWeightOrNewBooking: "Ubah berat atau booking baru.",
          prohibitedChangeWeight: "Perubahan penurunan berat tidak diijinkan."
        },
        tooltip: {
          title: "Berat dimensi dihitung :",
          message: `
              <li>Jenis pengiriman <b>BOSSPACK, REGPACK, JAGOPACK</b> dihitung dengan (Panjang x lebar x tinggi)/Rp6.000</li>
              <li>Jenis pengiriman <b>INTERPACK</b> dihitung dengan (Panjang x lebar x tinggi)/Rp5.000</li>
              <li>Jenis pengiriman <b>BIGPACK</b> dihitung dengan (Panjang x lebar x tinggi)/Rp4.000</li>
              <li>Jenis pengiriman <b>OTOPACK 150cc</b> tidak dihitung dengan volume. Langsung terhitung 120 kg</li>
              <li>Jenis pengiriman <b>OTOPACK 250cc</b> tidak dihitung dengan volume. Langsung terhitung 180 kg</li>
            `
        },
        uploadWeightProofPhoto: "Upload bukti foto untuk ubah berat",
        uploadProofPhotoInstruction:
          "Anda wajib upload bukti foto barang untuk ubah berat & dimensi.",
        photoGuideTitle: "Panduan foto :",
        photoGuideGoodResolution: "Foto memiliki resolusi bagus.",
        photoGuideScaleReadable:
          "Timbangan/pengukuran volume terbaca dengan jelas.",
        photoGuideLabelVisible:
          "Foto barang dengan label STT/label shipment/lainnya terbaca dengan jelas.",
        photoGuidePackageVisible: "Keseluruhan paket terlihat.",
        photoScale: "Foto timbangan",
        photoItemIdentity: "Foto barang dengan <br/> identitas",
        additionalPhoto: "Foto tambahan"
      },
      modal: {
        skipBooking: "Lewati booking",
        leaveTitle: "Yakin ingin keluar?",
        leaveMessage: "Perubahan data booking tidak akan tersimpan.",
        leave: "Keluar",
        stayHere: "Tetap disini",
        createSuccessTitle: "Pembuatan Booking Baru Berhasil !",
        deletePhotoFailed: "Gagal menghapus Foto ke storage!"
      }
    },
    bookButton: {
      printLater: "Booking, print nanti",
      printThermal: "Booking, print thermal resi",
      printThermalPdf: "Booking, print thermal resi PDF",
      printBasic: "Booking, print basic/save to PDF",
      failedBook: "Booking Gagal !",
      printA4Pdf: "Booking, print A4 resi ke PDF"
    },
    filterClient: {
      title: "Klien",
      clientPlaceholder: "Masukkan & pilih nama/alias/kode klien cabang",
      clientMandatory: "Nama klien wajib diisi.",
      filter: {
        title: "Filter pencarian klien",
        originLabel: "Kota asal klien (3LC)",
        originPlaceholder: "Masukkan & pilih kota asal klien (3LC)",
        serviceTypeLabel: "Tipe layanan pengiriman",
        serviceTypePlaceholder: "Pilih tipe layanan pengiriman"
      },
      list: {
        title: "Daftar klien",
        searchPlaceholder: "Cari berdasarkan nama klien",
        clientName: "Nama klien",
        clientAlias: "Alias",
        clientOrigin: "Kota asal",
        clientType: "Tipe klien",
        clientServiceType: "Layanan pengiriman",
        clientCode: "Kode klien"
      },
      notFound: {
        title: "Pencarian klien tidak ditemukan",
        subTitle: "Cek kata kunci & coba kembali."
      }
    },
    goodsCategory: "Kategori barang",
    product: {
      minipack: "Paket kecil",
      bosspack: "Prioritas",
      regpack: "Reguler"
    }
  },
  deliveryManifest: {
    title: "Delivery Manifest",
    menuName: "Delivery Manifest",
    createManifest: "Buat Manifest",
    printManifest: "Print Manifest",
    printLabel: "Print Label",
    needRelabel: "Perlu Relabel",
    lastSevenDays: "7 Hari Terakhir",
    searchPlaceholder: "Cari No. Manifest/No. STT",
    update: {
      title: "Buat Manifest"
    },
    form: {
      partnerName: "Nama Partner",
      userType: "Tipe User",
      destinationCity: "Kota Tujuan",
      createdAt: "Tanggal Dibuat",
      sttNo: "No. STT",
      sttExample: "Contoh: 99LP1234567890123/88-22-12345678",
      sttPlaceholder: "Masukan No. STT atau Scan Barcode/QR Code",
      sttOverweightError:
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Delivery Manifest",
      maxStt: "Maks. {max} STT"
    },
    pdf: {
      consolidatorCity: "Kota Konsolidator",
      destinationCity: "Kota Tujuan",
      createdBy: "Dibuat Oleh",
      manifestNo: "No. Delivery Manifest",
      createdAt: "Tanggal Dibuat",
      totalStt: "Total STT",
      totalPiece: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      recipient: "Penerima",
      CODAmount: "Biaya COD",
      nameAndSignature: "Nama dan TTD",
      courier: "Kurir",
      koli: "Koli",
      totalWeight: "Total Berat",
      manifestDate: "Tanggal manifest",
      totalSTTPieces: "Total STT/Koli"
    },
    column: {
      no: "No.",
      manifestNo: "No. Delivery Manifest",
      totalStt: "Total STT",
      totalPiece: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      grossWeight: "Berat Kotor",
      volumeWeight: "Berat Dimensi",
      chargeableWeight: "Berat Dikenakan Biaya",
      createdAt: "Tanggal Dibuat",
      action: "Action",
      sttNo: "No. STT",
      referenceNo: "No. Referensi",
      product: "Produk",
      commodity: "Komoditas",
      deliveryCount: "Pengiriman Ke",
      codFee: "Biaya COD",
      deliveryType: "Layanan",
      piecesWeigght: "Koli/Berat",
      demNo: "Nomor DEM"
    },
    button: {
      add: "Tambah",
      delete: "Hapus",
      process: "Process",
      cancel: "Batal",
      createAndPrint: "Buat & Print PDF"
    },
    error: {
      sttNotFound: "No. STT tidak ditemukan atau sudah terhapus",
      sttNotFoundScan: "No. STT tidak ditemukan",
      sttAlreadyAdded: "No. STT sudah di input",
      adjustmentTitle: "STT perlu konfirmasi adjustment berat",
      adjustmentMessage:
        "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS."
    },
    modal: {
      ok: "OK",
      download: "Download",
      understood: "Oke, mengerti",
      back: "Kembali",
      leave: "Keluar",
      leaveTitle: "Yakin ingin keluar?",
      leaveMessage:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      confirmCreateTitle: "Konfirmasi Pembuatan",
      confirmMessage:
        "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
      scanFailedTitle: "Scan No. STT Gagal",
      addSttFailedTitle: "Tambah No. STT Gagal",
      packagePickupTitle: "Paket akan diambil penerima",
      rtsHalMessage: "STT ini sudah ditandai sebagai RTS/HAL",
      createSuccessTitle: "Pembuatan Berhasil !",
      createSuccessMessage: "Delivery Manifest berhasil dibuat.",
      partialMessage:
        "Beberapa No. STT berhasil dibuat menjadi Delivery Manifest,\nnamun terdapat kegagalan pada beberapa STT.\nSilahkan download untuk mengetahui kesalahan.",
      createFailedTitle: "Pembuatan Gagal !",
      createFailedMessage: "Delivery Manifest gagal dibuat.",
      countSuccess: "{count} No. STT Sukses",
      countFailed: "{count} No. STT Gagal"
    },
    deleteDialog: {
      title: "Hapus Barang",
      description:
        "Masukan No. STT atau Scan Barcode/QR Code\nuntuk barang yang ingin dihapus dari daftar DEL.",
      deleted: "Terhapus"
    }
  },
  updateDelivery: {
    title: "Update DEL",
    menuName: "Delivery",
    emptyState: "Delivery",
    createButton: "Update DEL",
    printButton: "Print",
    timeRangeOptions: "custom, hari ini, 7 hari terakhir, 14 hari terakhir",
    columns: {
      no: "No.",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      driverName: "Nama Kurir",
      driverPhone: "No. Telp Kurir",
      deliveredBy: "Dikirim Oleh",
      createdAt: "Tanggal Dibuat",
      action: "Action"
    },
    form: {
      title: "Update DEL",
      partnerName: "Nama Partner",
      userType: "Tipe User",
      originCity: "Kota Asal",
      dateCreated: "Tanggal Dibuat",
      datePlaceholder: "Pilih atau masukkan No. seri kendaraan",
      deliveredBy: "Dikirim Oleh",
      driverUsesApp: "Apakah kurir menggunakan aplikasi Driver?",
      driverName: "Nama Kurir",
      selectDriver: "Pilih Kurir",
      selectClientPartner: "Ketik atau pilih client/partner",
      deliveryNote:
        "Data pengiriman dari kurir ini tidak akan tercatat di rekonsiliasi.",
      noStt: "No. STT",
      noSttLabel: "Contoh : 99LP1234567890123/88-22-12345678",
      noSttPlaceholder: "Masukan No. STT atau Scan Barcode/QR Code",
      weightExcessError:
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke DEL",
      failedGetDriver: "Gagal Mendapat Data Kurir",
      add: "Tambah",
      confirmationTitle: "Konfirmasi Pembaruan",
      confirmationMessage:
        "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
      textCancel: "Kembali",
      textSuccess: "Process",
      successTitle: "Pembaruan Berhasil !",
      successMessage: "Status STT berhasil diperbarui menjadi DEL.",
      partialMessage:
        "Beberapa status STT berhasil diperbarui menjadi DEL,<br />namun terdapat kegagalan pada beberapa STT.<br />Silahkan download untuk mengatahui kesalahan.",
      failedTitle: "Pembaruan Gagal !",
      failedMessage: "Status DEL gagal diperbarui.",
      download: "Download",
      ok: "OK",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      delete: "Hapus",
      process: "Process",
      updateDel: "Update DEL",
      updateAndPrintPdf: "Update & Print PDF",
      no: "No.",
      noSttCol: "No. STT",
      needRelabel: "Perlu relabel",
      urgentRts: "Segera RTS",
      noRef: "No. Referensi",
      deliveryTo: "Pengiriman Ke",
      codFee: "Biaya COD",
      dest: "Dest.",
      product: "Produk",
      commodity: "Komoditas",
      koli: "Koli",
      grossWeight: "Berat Kotor",
      volumeWeight: "Berat Dimensi",
      chargeableWeight: "Berat Dikenakan Biaya",
      selectPartner: "Pilih partner",
      selectConsole: "Pilih consolidator",
      selectSubConsole: "Pilih subconsolidator",
      selectVendor: "Pilih vendor",
      addVendor: "Tambah vendor",
      placeholderAdd: "Masukan nama vendor"
    },
    deleteStt: {
      title: "Hapus Barang",
      message:
        "Masukan No. STT atau Scan Barcode/QR Code<br />untuk barang yang ingin dihapus dari daftar DEL.",
      removed: "Terhapus",
      cancel: "Batal",
      delete: "Hapus",
      errorNotFound: "No. STT tidak ditemukan atau sudah terhapus"
    },
    pdf: {
      title: "Delivery Manifest",
      consolidatorCity: "Kota konsolidator",
      createdBy: "Dibuat oleh",
      totalWeight: "Total berat",
      totalSttKoli: "Total STT/koli",
      manifestDate: "Tanggal manifest",
      courier: "Kurir",
      no: "No.",
      sttNo: "Nomor STT",
      refNo: "Nomor referensi",
      productType: "Jenis pengiriman",
      service: "Layanan",
      pieceWeight: "Koli/berat",
      demNo: "Nomor DEM",
      ursaCode: "Ursa code",
      courierSignature: "Kurir",
      supervisorSignature: "Operations Supervisor"
    }
  },
  dispatch: {
    searchPlaceholder: "Cari nomor dispacth",
    createDispatch: "Buat dispatch",
    last7Days: "7 hari terakhir",
    reload: "Muat ulang",
    errorSystem: "Terjadi gangguan sistem",
    errorSystemMessage: 'Klik "Muat ulang" atau coba beberapa saat lagi.',
    errorInternet: "Jaringan internet terputus",
    errorInternetMessage:
      'Periksa jaringan internal Anda lalu klik "Muat ulang".',
    no: "No",
    noDispatch: "No. dispatch",
    jumlahSttKoli: "Jumlah STT (koli)",
    totalWeight: "Total berat",
    createdAt: "Tanggal dibuat",
    courierShuttle: "Kurir/Shuttle",
    atur: "Atur",
    downloadData: "Download data",
    printPdf: "Print PDF",
    filterCreatedBy: "Filter dibuat oleh",
    all: "Semua",
    checker: "Checker",
    shuttle: "Shuttle",
    detail: "Detail",
    totalSttKoli: "Total STT (koli)",
    courier: "Kurir",
    courierNotFound: "Kurir tidak ditemukan",
    shuttleNotFound: "Shuttle tidak ditemukan",
    courierOrShuttle: "Kurir/shuttle",
    dispatchDate: "Tanggal dispatch",
    searchSttDem: "Cari nomor STT/DEM",
    printManifest: "Print manifest",
    jenisPengiriman: "Jenis pengiriman",
    noReferensi: "No. referensi",
    koli: "koli",
    ursaCode: "Ursa code",
    noDem: "No. DEM",
    noStt: "No. STT",
    totalBerat: "Total berat",
    dispatchDelivery: "Dispatch delivery",
    manifestSuccess: "Manifest {dispatchNo} berhasil dibuat",
    processFailed: "Proses manifest gagal dibuat",
    totalSttKoliShort: "Total STT/koli",
    weight: "Berat",
    deliveryType: "Layanan",
    piecesGrossWeight: "Koli/berat",
    totalKoli: "Total Koli",
    process: "Proses",
    searchPlaceholderUpdate: "No. Shipment/STT/DEM",
    allStatus: "Semua",
    success: "Berhasil",
    failed: "Gagal",
    ok: "OK",
    scanErrorAlreadyExists: "sudah ada di dalam daftar.",
    scanErrorAlreadyBookedLabel: "Shipment sudah pernah dibooking",
    scanErrorAlreadyBooked: "Shipment sudah dibooking pada ",
    scanErrorSomeAlreadyBooked: "Beberapa shipment sudah dibooking pada ",
    scanErrorInvalid: "tidak valid, cek & ubah kembali.",
    scanErrorServer:
      "gagal diupdate karena terjadi gangguan sistem. Cek & coba kembali.",
    scanErrorInternet:
      "gagal diupdate karena jaringan internet terputus. Cek & coba kembali.",
    updatePrompt: "Yuk, update status ke dispatch!",
    scanFailedListTitle: "Daftar gagal scan",
    scanExample: "Contoh: DEM1234567894/88LP1234567890",
    scanPlaceholder: "Scan/masukkan No. Shipment/STT/DEM",
    scanMessageDemSuccess: "berhasil diupdate.",
    scanMessageDemPartial: "sebagian STT berhasil diupdate.",
    scanMessageDemFailed: "gagal diupdate.",
    scanMessageSttSuccess: "berhasil diupdate.",
    scanMessageSttPartial: "sebagian STT berhasil diupdate.",
    scanMessageSttFailed: "gagal diupdate.",
    scanMessageSttFailedUnpaid: "gagal diupdate karena belum bayar.",
    scanMessageSttFailedDestination:
      "gagal diupdate karena kota tujuan tidak sesuai.",
    scanMessageSttFailedInHub: "STT gagal diupdate karena status belum In Hub",
    scanMessageSttFailedStatusMismatch:
      "gagal diupdate karena status tidak sesuai ({lastStatus}).",
    noPackageDispatch: "Belum ada paket yang di dispatch",
    sttDemNotFound: "No. STT/DEM tidak ditemukan",
    sttDemNotFoundHint: "Cek kembali atau cari nomor STT/DEM lain.",
    pdf: {
      consolidatorCity: "Kota Konsolidator",
      manifestDate: "Tanggal manifest",
      createdBy: "Dibuat oleh",
      totalSttKoli: "Total STT/koli",
      totalBerat: "Total berat"
    },
    pdfFailed: {
      listTitle: "Daftar gagal dispatch",
      consolidatorName: "Nama konsolidator",
      consolidatorCity: "Kota konsolidator",
      createdBy: "Dibuat Oleh",
      unpaid: "Belum bayar",
      wrongDestination: "Kota tujuan tidak sesuai",
      wrongStatus: "Status tidak sesuai ({lastStatus})"
    },
    selectCourierOrShuttle: "Pilih kurir/shuttle",
    selectCourier: "Pilih kurir",
    searchCourierOrShuttle: "Cari data kurir atau shuttle",
    searchCourier: "Cari nama/No. HP",
    referenceNo: "No. Referensi",
    totalPieces: "Total Koli",
    minimalCharacter: "Minimal {remaining} karakter lagi",
    loading: "Memuat data...",
    loadingMore: "Memuat lebih banyak data"
  },
  edit: "Ubah",
  "Station admin": "Station admin",
  handover: {
    menuTitle: "Handover",
    manifest: {
      destinationCity: "Kota tujuan",
      consolidatorName: "Nama konsolidator",
      handoverTo: "Diserahkan ke",
      handoverDate: "Tanggal dibuat",
      totalStt: "Total STT",
      admin: "Station admin",
      operationSupervisor: "Operations supervisor",
      totalSTT: "Total STT",
      totalPieces: "Total koli",
      pieces: "Total\nkoli",
      totalGrossWeight: "Total berat kotor",
      totalDimensionWeight: "Total berat dimensi",
      serviceType: "Produk",
      commodity: "Komoditas",
      grossWeight: "Berat\nkotor",
      dimensionWeight: "Berat\ndimensi",
      origin: "Origin",
      dest: "Dest.",
      note: "Catatan",
      stationAdmin: "Station Admin",
      courier: "Kurir",
      operationsSupervisor: "Operations Supervisor"
    },
    update: {
      pageTitle: "Update Handover",
      metaTitle: "HANDOVER | Update Handover",
      errorWeightExceeded:
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Handover",
      handoverTo: {
        title: "Diserahkan ke",
        placeholder: "Ketik atau pilih Vendor/Partner"
      },
      vendorName: {
        title: "Vendor Internal",
        placeholder: "Tulis nama vendor..."
      },
      sttNumber: {
        title: "No. STT",
        label: "Contoh : 99LP1234567890123/88-22-12345678",
        placeholder: "Masukan No. STT atau Scan Barcode/QR Code"
      },
      add: "Tambah",
      sttInfo: {
        totalStt: "Total STT",
        totalPieces: "Total Koli",
        totalGrossWeight: "Total Berat Kotor",
        totalDimensionWeight: "Total Berat Dimensi",
        delete: "Hapus",
        process: "Process"
      },
      table: {
        noRef: "No. Referensi",
        product: "Produk",
        commodity: "Komoditas",
        pieces: "Total Koli",
        weight: "Berat Kotor",
        dimension: "Berat Dimensi"
      },
      onUpdate: {
        titleSuccess: "Perubahan Status Berhasil !",
        titleFailed: "Perubahan Status Gagal !",
        messageSuccess: "Status STT berhasil diupdate menjadi Handover.",
        messagePartial:
          "Beberapa status STT berhasil diupdate menjadi Handover, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.",
        messageFailed: "Perubahan status Handover gagal dibuat.",
        noSttSuccess: "No. STT Sukses",
        noSttFailed: "No. STT Gagal"
      },
      leave: {
        title: "Yakin ingin keluar?",
        message:
          "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
        textSuccess: "Keluar",
        textCancel: "Kembali"
      },
      confirmation: {
        title: "Konfirmasi Pembuatan",
        message: "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
        textSuccess: "Process",
        textCancel: "Kembali"
      },
      removePieces: {
        title: "Hapus Barang",
        message:
          "Masukan No. STT atau Scan Barcode/QR Code untuk <br /> barang yang ingin dihapus dari daftar Handover.",
        errorCaption: "No. STT tidak ditemukan/sudah terhapus",
        removed: "Terhapus",
        delete: "Hapus",
        cancel: "Batal"
      },
      process: {
        update: "Update Handover",
        print: "Update Handover & Print PDF"
      }
    },
    list: {
      title: "Handover Vendor (HND)",
      detail: {
        title: "Handover Manifest - {id}",
        shipmentDetails: "Detail Pengiriman",
        sttDetails: "Detail STT",
        partnerName: "Nama Partner",
        userType: "Tipe User",
        totalStt: "Total STT",
        totalPieces: "Total Koli",
        totalGrossWeight: "Total Berat Kotor",
        totalVolumeWeight: "Total Berat Dimensi",
        handoverStatus: "Status handover",
        createdAt: "Tanggal Dibuat",
        printHandover: "Print Handover",
        printSummary: "Print Summary",
        printPdf: "Print PDF",
        number: "No.",
        sttNo: "No. STT/Shipment",
        product: "Produk",
        commodity: "Komoditas",
        pieces: "Koli",
        grossWeight: "Berat Kotor",
        volumeWeight: "Berat Dimensi",
        origin: "Asal",
        destination: "Tujuan",
        reason: "Alasan",
        viewReason: "Lihat alasan",
        successTab: "Berhasil handover ({n})",
        failedTab: "Gagal handover ({n})"
      },
      searchId: "Cari ID Manifest",
      searchSubConsole: "Pilih Sub Consolidator",
      update: "Update Handover",
      statusHandover: {
        SUCCESS: "Berhasil",
        FAILED: "Gagal",
        PARTIAL_SUCCESS: "Berhasil sebagian"
      },
      statusHitApi: {
        SUCCESS: "Berhasil Respon",
        FAILED: "Gagal Respon",
        PARTIAL_SUCCESS: "Berhasil Sebagian",
        UNPROCESSED: "API Tidak Dipanggil",
        IN_PROGRESS: "Diproses",
        NON_API: "Belum terintegrasi API"
      },
      table: {
        no: "No.",
        idManifest: "ID Manifest",
        handoverTo: "Vendor tujuan",
        stt: "Total STT",
        pieces: "Total Koli",
        weight: "Total Gross weight",
        dimension: "Total Volume weight",
        date: "Tanggal Handover",
        printSummary: "Print Summary",
        printPdf: "Print PDF",
        download: "Download Excel",
        action: "Atur",
        printVendor: "Print Resi Vendor",
        statusHandover: "Status handover",
        statusHitApi: "Status Respon API",
        viewDetail: "Lihat detail"
      }
    },
    detail: {
      pageTitle: "Handover | Detail",
      sectionDelivery: "Detail Pengiriman",
      sectionStt: "Detail STT",
      partnerName: "Nama Partner",
      userType: "Tipe User",
      destinationCity: "Kota Tujuan",
      totalStt: "Total STT",
      totalPieces: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      createdAt: "Tanggal Dibuat",
      printHandover: "Print Handover",
      printSummary: "Print Summary",
      printPdf: "Print PDF",
      printResiVendor: "Print Resi Vendor",
      table: {
        no: "No.",
        stt: "No. STT",
        product: "Produk",
        commodityName: "Commodity Name",
        pieces: "Total Koli",
        grossWeight: "Gross Weight",
        volumeWeight: "Volume Weight",
        origin: "Origin",
        dest: "Dest."
      },
      failedVendorModal: {
        title: "Daftar {n} STT Gagal Hit API",
        sttNo: "No. STT/Shipment",
        product: "Produk",
        commodity: "Komoditas",
        pieces: "Koli",
        grossWeight: "Berat kotor",
        volumeWeight: "Berat dimensi",
        reason: "Alasan",
        defaultReason: "Tidak ada respon dari vendor",
        copiedReason: "Alasan berhasil disalin",
        close: "Tutup"
      },
      retry: {
        menu: "Ulangi proses",
        confirmTitle: "Ulangi proses handover?",
        confirmBody:
          "Sistem akan mencoba mengirim ulang {n} STT yang gagal ke vendor.",
        confirmCancel: "Kembali",
        confirmSubmit: "Ya, ulangi",
        successTitle: "Berhasil proses handover",
        successBody: "{n} STT sudah selesai diproses handover.",
        successPrint: "Print manifest",
        successOk: "Oke",
        failedPrefix: "Gagal mengulang:",
        processTitle: "Pemanggilan Ulang API Sedang Diproses",
        processBody:
          "<strong>{n} STT</strong> sedang diproses ulang. Silakan tunggu hingga proses selesai.",
        processOk: "Oke",
        failedToast: "Gagal mengulang proses pemanggilan ulang API"
      },
      eligibilityModal: {
        title: "Daftar {n} STT Gagal Handover",
        sttNo: "No. STT/Shipment",
        product: "Produk",
        commodity: "Komoditas",
        pieces: "Koli",
        grossWeight: "Berat kotor",
        volumeWeight: "Berat dimensi",
        reason: "Alasan",
        close: "Tutup"
      }
    }
  },
  handoverV2: {
    update: {
      common: {
        successScan: "Berhasil discan.",
        failedScan: "Gagal discan.",
        failedApi: "Gagal scan barcode STT/Shipment ID",
        failedScanDownloadTitle: "Daftar gagal scan",
        failedNotFound: "No. STT tidak ditemukan",
        failedExist: "No. STT sudah di input",
        failedUnpaid: "No. STT belum dibayar",
        sttNo: "No. STT",
        reason: "Alasan gagal scan",
        product: "Produk",
        commodity: "Komoditas",
        all: "Semua",
        back: "Kembali",
        save: "Simpan",
        ok: "Oke",
        printManifest: "Print manifest"
      },
      scan: {
        placeholder: "Masukkan atau scan barcode STT/shipment ID",
        example: "Contoh : 99LP1234567890123/88-22-12345678",
        errorMax: "Maksimal {max} STT yang dapat di scan"
      },
      filter: {
        search: "Cari No. STT/Shipment"
      },
      table: {
        sttNo: "No. STT/Shipment",
        piece: "Koli",
        grossWeight: "Berat Kotor",
        volumeWeight: "Berat Dimensi",
        action: "Aksi",
        remove: {
          confirmTitle: "Hapus STT {sttNo}?",
          confirmMessage: "Pastikan kembali STT yang Anda pilih sudah benar.",
          confirmButtonText: "Ya, hapus",
          success: "STT {sttNo} berhasil dihapus."
        }
      },
      sidebar: {
        empty: {
          title: "Belum ada STT Handover",
          message:
            "Scan barcode STT atau Shipment ID untuk menampilkan info vendor."
        },
        changeVendor: "Ubah",
        placeholderInputVendorNameInternal: "Masukkan nama vendor",
        totalStt: "Total STT",
        totalPieces: "Total Koli",
        totalGrossWeight: "Total Berat Kotor",
        totalVolumeWeight: "Total Berat Dimensi",
        processHandover: "Proses handover",
        cancel: "Batalkan"
      },
      changeVendor: {
        title: "Ubah Vendor",
        label: "Pilih vendor",
        placeholder: "Pilih vendor",
        success: "Vendor berhasil diubah."
      },
      process: {
        confirmTitle: "Konfirmasi proses handover?",
        confirmMessage:
          "Semua STT yang sudah discan akan di handover ke vendor tujuan.",
        confirmButtonText: "Ya, proses"
      },
      cancelProcess: {
        confirmTitle: "Batalkan proses handover?",
        confirmMessage:
          "Semua STT yang sudah di scan akan dibatalkan untuk dihandover.",
        confirmButtonText: "Ya, lanjutkan",
        success: "Semua STT/ Shipment batal dihandover."
      },
      successProcess: {
        title: "Berhasil proses handover",
        message: "sudah selesai diproses handover"
      },
      partialSuccessProcess: {
        title: "Proses handover Berhasil sebagian",
        total: "Total",
        success: "Berhasil",
        failed: "Gagal"
      },
      errorProcess: {
        title: "Perubahan Status Gagal!",
        message: "Semua STT gagal diproses handover"
      }
    }
  },
  "Shipment id tidak dapat digunakan": "Shipment id tidak dapat digunakan",
  podDex: {
    menuTitle: "POD/DEX",
    menuName: "POD/DEX",
    tabDelDex: "DEL/DEX",
    tabCodrej: "CODREJ",
    tabPod: "POD",
    searchPlaceholder: "Cari No. STT",
    timeRangeDefault: "hari ini",
    emptyStateHeader: "Belum ada data POD/DEX",
    emptyStateMessage:
      "Semua data POD/DEX (DEL/DEX, CODREJ, POD) akan tercatat di sini.",
    updateButton: "Update POD/DEX",
    downloadButton: "Download Data",
    columns: {
      no: "No.",
      noStt: "No. STT",
      noReferensi: "No. Referensi",
      totalKoli: "Total Koli",
      beratDikenakanBiaya: "Berat Dikenakan Biaya",
      produk: "Produk",
      statusTerakhir: "Status Terakhir",
      komoditas: "Komoditas",
      biayaCod: "Biaya COD",
      tipePembayaranCod: "Tipe Pembayaran COD",
      tanggalDel: "Tanggal DEL",
      namaKurir: "Nama Kurir",
      noTelpKurir: "No. Telp Kurir",
      dikirimOleh: "Dikirim Oleh",
      pengirimanKe: "Pengiriman Ke",
      action: "Action"
    },
    statusLatest: "Latest Status",
    statusDel: "DEL",
    statusDex: "DEX",
    updateModalTitle: "Update POD/DEX",
    update: {
      noStt: "No. STT",
      totalKoli: "Total Koli",
      beratDikenakanBiaya: "Berat Dikenakan Biaya",
      biayaCod: "Biaya Cod",
      produk: "Produk",
      komoditas: "Komoditas",
      namaPenerima: "Nama Penerima",
      alamatPenerima: "Alamat Penerima",
      noTelpPenerima: "No. Telp Penerima",
      infoKurir: "Info Kurir",
      terkirim: "Terkirim",
      pilih: "Pilih",
      ya: "Ya",
      tidak: "Tidak",
      placeholderNamaPenerima: "Masukkan nama penerima",
      konfirmasiPerubahan: "Konfirmasi Perubahan",
      confirmMessagePod:
        "Masukan nama penerima dan bukti pengiriman sebagai lampiran untuk perubahan status menjadi POD.",
      confirmMessageDex:
        "Pilih alasan paket tidak terkirim dan masukan bukti pengiriman sebagai lampiran untuk perubahan status menjadi DEX. ",
      pilihRelasi: "Pilih relasi",
      alasanTidakTerkirim: "Alasan Tidak Terkirim",
      alasanKendala: "Alasan Kendala",
      placeholderAlasan: "Jelaskan kendala secara singkat...",
      buktiPengiriman: "Bukti Pengiriman",
      kembali: "Kembali",
      update: "Update",
      successTitle: "Perubahan Status Berhasil !",
      successMessagePod:
        "Status STT berhasil diupdate menjadi POD. Nama penerima akan terlihat pada detail status paket.",
      successMessageDex:
        "Status STT berhasil diupdate menjadi DEX. Alasan paket tidak terkirim akan terlihat pada detail status paket.",
      inginPodDex: "Ingin POD/DEX paket ini ?",
      sttRtsHal: "STT ini sudah ditandai sebagai RTS/HAL",
      pilihAlasan: "Pilih alasan",
      ok: "OK"
    },
    download: {
      modalTitle: "Download Laporan",
      tanggal: "Tanggal",
      timeRangeDefault: "hari ini",
      searchButton: "Cari",
      errorMessage: "Gagal Download Data !"
    },
    unpaidModal: {
      title: "Pastikan Nomor STT Sudah Terbayar",
      message:
        "Cek kembali nomor STT Adjusted atau yang kelebihan berat, pastikan sudah terbayar lunas",
      ok: "OK"
    },
    proofButton: "Bukti",
    filter: {
      filter: "Filter",
      reset: "Reset",
      sttType: "Tipe STT",
      selectSttType: "Pilih tipe STT",
      codPaymentMethod: "Tipe Pembayaran COD",
      selectCodPaymentMethod: "Pilih tipe pembayaran COD",
      all: "Semua",
      free: "GRATIS"
    }
  },
  verificationAccount: {
    passwordExpired: {
      title: "Password Sudah Tidak Berlaku",
      message: "Silakan atur ulang password agar akun tetap aman.",
      button: "Atur password"
    },
    title: "Verifikasi Akun",
    description:
      "Untuk keamanan akun, lakukan verifikasi {method} untuk atur ulang password Anda",
    send: "Kirim",
    useOtherMethod: "Gunakan metode verifikasi lain",
    useMethodWith: "Gunakan metode verifikasi dengan",
    email: "email",
    phoneNumber: "no. handphone",
    helpWhatsApp: "Butuh bantuan? Hubungi via WhatsApp",
    orEmailTo: "atau email ke",
    chooseMethodTitle: "Pilih Metode Verifikasi",
    methods: {
      partnerClientCode: "Kode Partner/Klien",
      partnerClientId: "ID Partner/Klien",
      userEmail: "Email User",
      userPhone: "No. Handphone User",
      partnerClientEmail: "Email Partner/Klien",
      partnerClientPhone: "No. Handphone Partner/Klien"
    },
    captions: {
      partnerClientEmail: "email Partner/Klien",
      partnerClientPhone: "no. handphone Partner/Klien"
    },
    placeholders: {
      email: "e.g email{'@'}gmail.com",
      partnerClientCode: "Masukkan Kode Partner/Klien",
      partnerClientId: "Masukkan ID Partner/Klien",
      yourPhoneNumber: "Masukkan no. handphone Anda"
    },
    otp: {
      title: "Verifikasi kode OTP",
      description: "Masukkan kode verifikasi yang dikirimkan lewat",
      userEmail: "Email user",
      partnerClientEmail: "Email partner/klien",
      partnerClientPhone: "Nomor telpon partner/klien",
      verify: "Verifikasi",
      resendIn: "Kirim ulang kode OTP dalam {countDown}",
      notReceivedCode: "Belum menerima kode?",
      resend: "Kirim Ulang",
      wrongCode: "Kode yang dimasukkan salah, silahkan cek kembali"
    },
    changeAccount: "Ubah Akun",
    haveNoHub: "Tidak memiliki Hub?",
    clickHere: "Klik disini"
  },
  resetPasswordPage: {
    logoAlt: "logo",
    errorIconAlt: "ikon peringatan",
    title: "Atur Ulang Password",
    newPasswordLabel: "Password Baru",
    newPasswordPlaceholder: "Masukan password",
    confirmNewPasswordLabel: "Konfirmasi Password Baru",
    confirmNewPasswordPlaceholder: "Masukkan konfirmasi password",
    passwordReuseError: "Password tidak boleh sama dengan password sebelumnya",
    submitButton: "Atur Ulang Password",
    back: "Back",
    tryAgain: "Try Again",
    ok: "OK",
    successModal: {
      title: "Password Changed!",
      message: "Your password has been changed"
    },
    rules: {
      minEightChars: "Password minimal 8 karakter",
      containsNumber: "Password mengandung angka",
      containsUppercase: "Password mengandung huruf kapital",
      confirmPassword: "Konfirmasi password baru"
    }
  },
  setupPassword: {
    title: "Atur Password Akun Baru",
    passwordLabel: "Password",
    confirmPasswordLabel: "Konfirmasi Password",
    submitButton: "Atur Password",
    rules: {
      eightChars: "Password minimal 8 karakter",
      containsNumber: "Password mengandung angka",
      containsUppercase: "Password mengandung huruf kapital",
      noGenesis: "Tidak boleh mengandung kata 'genesis'",
      passwordMatch: "Konfirmasi password baru"
    },
    helpWA: "Butuh bantuan? Hubungi via WhatsApp",
    helpEmail: "atau email ke",
    success: {
      title: "Password Baru Disimpan",
      message:
        "Sekarang Anda bisa menggunakan password baru untuk masuk ke Genesis.",
      button: "Masuk"
    },
    error: {
      title: "Password Baru Gagal Dibuat",
      message:
        "Terjadi kesalahan server saat memproses permintaan Anda. Silakan coba beberapa saat lagi.",
      button: "OKE"
    },
    loginGenesis: "Masuk ke Genesis",
    urlUsed: "Link Sudah Pernah Digunakan",
    messageUsed:
      "Anda telah mengatur password baru. Silakan masuk ke Genesis <br /> dengan password baru Anda.",
    urlInvalid: "Link Sudah Tidak Aktif",
    messageInvalid: "Silakan hubungi tim helpdesk untuk bantuan lebih lanjut",
    expired: {
      title: "Link Sudah Kedaluwarsa",
      description:
        "Silakan klik tombol dibawah untuk meminta ulang link pengaturan <br /> password baru.",
      requestNewUrl: "Minta Link Baru",
      success: "Link baru telah dikirim"
    },
    placeholderPassword: "Masukan password",
    placeholderConfirmPassword: "Masukkan konfirmasi password"
  },
  forgotPassword: {
    title: "Lupa Password",
    hint: "Jangan khawatir! Masukkan alamat email Anda untuk mereset password",
    emailPlaceholder: "Masukkan email",
    submitButton: "Reset Password",
    backToLogin: "Kembali ke Masuk",
    errorEmptyEmail: "Masukkan email Anda !",
    errorInvalidEmail: "Email Anda salah atau tidak terdaftar. Coba lagi",
    modalSuccessTitle: "Permintaan Diterima!",
    modalSuccessMessage: "Link untuk mereset password telah dikirim ke {email}",
    modalFailTitle: "Tidak Dapat Mengubah Password",
    modalFailMessage:
      "Akun dengan email {email} telah mengubah password 3 kali. Hubungi Lion Parcel untuk informasi lebih lanjut",
    expired: {
      title: "Link Kedaluwarsa",
      body: "Link untuk meminta password baru telah kedaluwarsa…",
      backButton: "Kembali ke Genesis"
    }
  },
  inactiveAccount: {
    title: "Akun Anda Telah Dinonaktifkan",
    body:
      "Demi keamanan, akun yang tidak aktif selama 30 hari akan dinonaktifkan sementara. Silakan hubungi Helpdesk kami untuk mengaktifkan kembali akun Anda.",
    helpPrefix: "Butuh bantuan? Hubungi melalui:",
    helpWhatsApp: "WhatsApp",
    helpEmail: "Email"
  },
  loginErrorModal: {
    title: "Login gagal",
    tryAgain: "Coba lagi",
    close: "Tutup"
  },
  cariStt: {
    menuTitle: "Cari STT",
    menuName: "Manifest cari STT",
    pageTitle: "Manifest cari STT",
    searchPlaceholder: "Cari ID manifest",
    emptyState: "Data belum tersedia",
    emptyStateDescription:
      "Jika sudah ada data, maka akan muncul di sini secara otomatis.",
    searchNotFound: "Hasil pencarian tidak ditemukan",
    searchNotFoundDescription: "Coba periksa kembali kata kunci atau filter.",
    columnNo: "No.",
    columnManifestNo: "No. Manifest",
    columnTotalStt: "Total STT",
    columnTotalKoli: "Total Koli",
    columnTotalSttHanging: "Total STT Hanging",
    columnTanggalManifest: "Tanggal Manifest",
    columnAtur: "Atur",
    scanButton: "Cari STT",
    printManifest: "Print Manifest",
    downloadCsv: "Download CSV",
    scanPageTitle: "Cari STT",
    scanEmptyState: "Belum ada paket yang discan.",
    errorProcessManifest: "Proses Manifest Gagal",
    errorFetchList: "Gagal mengambil data STT",
    filterSearchPlaceholder: "Cari no. STT",
    filterLastStatus: "Status terakhir",
    filterLocation: "Lokasi terakhir",
    processManifestButton: "Proses manifest",
    table: {
      hanging: "Hanging",
      nonHanging: "Non-Hanging",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      no: "No.",
      noStt: "No. STT",
      lastLocation: "Lokasi Terakhir",
      lastStatus: "Status Terakhir",
      note: "Keterangan",
      emptyState: "Data belum tersedia",
      days: "hari"
    },
    pdf: {
      title: "Manifest Cari STT",
      days: "Hari",
      partnerName: "Nama partner",
      partnerCity: "Kota partner",
      totalSttKoli: "Total STT /Koli",
      totalSttHangingKoli: "Total STT Hanging /Koli",
      manifestDateHanging: "Tanggal manifest hanging",
      userManifest: "User manifest",
      noRef: "No. referensi",
      productType: "Jenis pengiriman",
      lastStatus: "Status Terakhir",
      hanging: "Hanging",
      hangingType: "Tipe Hanging",
      originCity: "Kota Asal",
      destCity: "Kota Tujuan",
      staffAdmin: "Staff Admin",
      courier: "Kurir",
      operationsSupervisor: "Operations Supervisor"
    },
    scan: {
      selectLocation: "Pilih lokasi area scan",
      selectLocationDescription:
        "Silahkan pilih area scan dibawah ini sesuai dengan area Anda berada",
      cancel: "Batalkan",
      confirmLocation: "Konfirmasi Lokasi",
      others: "Lainnya",
      othersPlaceholder: "Silahkan masukkan lokasi area scan Anda"
    }
  },
  "Muat Lebih Banyak": "Muat Lebih Banyak",
  managementCustomer: {
    tab: {
      alamat: "Alamat",
      savedPackage: "Paket tersimpan"
    },
    savedPackage: {
      detailTitle: "Detail barang dan koli",
      addButton: "Tambah paket tersimpan",
      empty: "Belum ada paket tersimpan",
      emptyTitle: "Belum ada data",
      emptyDescription: "Belum ada data paket tersimpan untuk ditampilkan saat ini.",
      deleteConfirmTitle: "Konfirmasi hapus",
      deleteConfirmMessage: "Anda yakin ingin menghapus data paket tersimpan ini ?",
      deleteConfirmSubmit: "Hapus data",
      deleteConfirmCancel: "Kembali",
      koli: "koli"
    },
    pageTitle: "Manajemen Pelanggan",
    addPageTitle: "Tambah pelanggan",
    editPageTitle: "Ubah pelanggan",
    searchPlaceholder: "Cari nama atau nomor telepon",
    filterDistrict: "Kecamatan, kota",
    filterZipCode: "Kode pos",
    filterSort: "Urutkan",
    placeholderDistrict: "Pilih kecamatan, kota",
    placeholderZipCode: "Ketik & pilih kode pos",
    column: {
      name: "Nama",
      phone: "No. telepon",
      email: "Email",
      address: "Alamat",
      district: "Kecamatan, kota",
      zipCode: "Kode pos",
      addressType: "Tipe alamat",
      createdAt: "Dibuat",
      updatedAt: "Diperbarui",
      action: "Atur"
    },
    emptyTitle: "Belum ada data pelanggan",
    emptyMessageSearch: "Nama atau nomor telepon pelanggan tidak ditemukan.",
    emptyMessageSearchFilter:
      "Nama atau nomor telepon pelanggan dengan filter tersebut tidak ditemukan",
    bulkButton: "Bulk pelanggan",
    addButton: "Pelanggan",
    actionDetail: "Detail",
    actionEdit: "Ubah",
    actionListStt: "Lihat daftar STT",
    actionDelete: "Hapus",
    form: {
      detailInfo: "Detail Informasi",
      name: "Nama",
      phone: "No. telepon",
      email: "Email",
      commodity: "Komoditas",
      note: "Catatan pelanggan",
      address: "Alamat",
      district: "Kecamatan, kota",
      zipCode: "Kode pos",
      addressType: "Tipe alamat"
    },
    placeholder: {
      name: "Masukkan nama pelanggan",
      email: "Contoh: nama{'@'}email.com",
      commodity: "Cari & pilih komoditas",
      note: "Masukkan catatan pelanggan",
      address: "Masukkan alamat pelanggan",
      district: "Ketik & pilih kecamatan, kota pelanggan",
      zipCode: "Ketik & pilih kode pos",
      addressType: "Pilih tipe alamat "
    },
    validation: {
      phoneRequired: "No. telepon wajib diisi",
      emailInvalid: "Email tidak valid",
      nameRequired: "Nama wajib diisi",
      nameMin: "Nama minimum 3 karakter",
      nameMax: "Nama maksimum 100 karakter",
      addressRequired: "Alamat wajib diisi",
      addressMin: "Alamat minimum 3 karakter",
      addressMax: "Alamat maksimum 200 karakter",
      noteMin: "Catatan minimum 3 karakter",
      noteMax: "Catatan maksimum 200 karakter"
    },
    save: "Simpan",
    detailTitle: "Detail Pelanggan",
    delete: "Hapus",
    edit: "Ubah",
    createdAt: "Dibuat",
    updatedAt: "Diperbarui",
    bulk: {
      title: "Upload Berkas",
      description:
        "Pastikan seluruh data yang Anda masukan benar dan sesuai dengan berkas yang akan diunggah. Pelajari cara mengisi template bulk upload",
      descriptionLink: "disini",
      activityName: "Nama Aktivitas",
      activityNamePlaceholder: "Masukkan nama aktivitas upload",
      uploadFile: "Upload file",
      uploadFileCaption: ".csv hingga 25.000 baris data",
      historyTitle: "Riwayat upload file",
      historyEmpty: "Belum ada riwayat upload file",
      cancel: "Cancel",
      submit: "Upload",
      statusSuccess: "Berhasil",
      statusPartially: "Berhasil sebagian",
      statusFailed: "Gagal",
      statusUploading: "Uploading",
      fileError: "File error",
      fileFailed: "File yang gagal",
      fileOriginal: "File asli",
      download: "Download"
    },
    deleteConfirmTitle: "Konfirmasi hapus",
    deleteConfirmMessage: "Anda yakin ingin menghapus data pelanggan ini ?",
    deleteConfirmSubmit: "Hapus data",
    back: "Kembali",
    confirmEditTitle: "Konfirmasi perubahan",
    confirmEditMessage: "Anda yakin ingin merubah data pelanggan ini ?",
    confirmEditSubmit: "Ubah data",
    modalPhoneExistsTitle: "Nama & nomor telepon sudah terdaftar",
    modalPhoneExistsMessage: "Cek & ganti lagi untuk menyimpan data pelanggan.",
    modalPhoneExistsSubmit: "Ubah",
    orderByNewest: "Terbaru",
    orderByOldest: "Terlama",
    addressTypeHome: "Rumah",
    addressTypeOffice: "Kantor",
    optionalLabel: "Opsional",
    deleteSuccess: 'Penghapusan data pelanggan "{name}" berhasil!',
    addSuccess: 'Penambahan data pelanggan "{name}" berhasil!',
    editSuccess: 'Perubahan data pelanggan "{name}" berhasil!',
    deleteError: "Gagal menghapus pelanggan"
  },
  Beranda: "Beranda",
  "Pengiriman | Detail": "Pengiriman | Detail",
  "Lacak Pengiriman": "Lacak Pengiriman",
  "Daftar Booking": "Daftar Booking",
  "Booking Bulk": "Booking Bulk",
  "Manual STT": "Manual STT",
  "Cetak Tagihan": "Cetak Tagihan",
  "Cetak Resi": "Cetak Resi",
  "CN Manifest": "CN Manifest",
  "Pesanan Kulioner": "Pesanan Kulioner",
  "STT Dalam Proses": "STT Dalam Proses",
  "Manajemen Kiriman Penting": "Manajemen Kiriman Penting",
  "Kiriman Penting": "Kiriman Penting",
  "Request HAL": "Request HAL",
  "Proses STI SC": "Proses STI SC",
  "Proses STO SC": "Proses STO SC",
  "Proses STI": "Proses STI",
  "Proses BAG": "Proses BAG",
  "Proses RTC": "Proses RTC",
  "Proses CARGO": "Proses CARGO",
  "Proses STIDEST": "Proses STIDEST",
  "Delivery Manifest": "Delivery Manifest",
  Delivery: "Delivery",
  "POD/DEX": "POD/DEX",
  "Transfer Hub (IN OUT HUB)": "Transfer Hub (IN OUT HUB)",
  "Proses DISPATCH": "Proses DISPATCH",
  "Handover Vendor (HND)": "Handover Vendor (HND)",
  "STT Shortland": "STT Shortland",
  "Proses Custom Status": "Proses Custom Status",
  "Performa DEX Asesmen": "Performa DEX Asesmen",
  "DEX Asesmen": "DEX Asesmen",
  "Daftar DEX Asesmen": "Daftar DEX Asesmen",
  "Rekon Delivery": "Rekon Delivery",
  "Manajemen Pelanggan": "Manajemen Pelanggan",
  "POS Langganan": "POS Langganan",
  "Manajemen Kurir": "Manajemen Kurir",
  "Manajemen POS Cabang & Di-Pickup": "Manajemen POS Cabang & Di-Pickup",
  "Manajemen Korporat": "Manajemen Korporat",
  "Manajemen Partner": "Manajemen Partner",
  "Manajemen User": "Manajemen User",
  "Pusat Resolusi": "Pusat Resolusi",
  "Base Rate": "Base Rate",
  "Konversi Mata Uang": "Konversi Mata Uang",
  "Konfigurasi Harga": "Konfigurasi Harga",
  "Tarif Komoditas": "Tarif Komoditas",
  "Pajak Barang": "Pajak Barang",
  "Konfigurasi Komisi": "Konfigurasi Komisi",
  "Promo Diskon": "Promo Diskon",
  "Konfigurasi COD": "Konfigurasi COD",
  "Jenis Pengiriman": "Jenis Pengiriman",
  Komoditas: "Komoditas",
  Embargo: "Embargo",
  "Area Cakupan": "Area Cakupan",
  "Manajemen Leg": "Manajemen Leg",
  "Manajemen Rute": "Manajemen Rute",
  "Manajemen Vendor": "Manajemen Vendor",
  "Manajemen Moda": "Manajemen Moda",
  "Bagging Grouping": "Bagging Grouping",
  "Konfigurasi Kargo": "Konfigurasi Kargo",
  "Area Keterlambatan": "Area Keterlambatan",
  "Dokumen Internasional": "Dokumen Internasional",
  "Verifikasi Top Up": "Verifikasi Top Up",
  "Approval Top Up": "Approval Top Up",
  "Manual Transaksi": "Manual Transaksi",
  "Konfigurasi Batas Saldo": "Konfigurasi Batas Saldo",
  "Saldo Terakhir": "Saldo Terakhir",
  "Transaksi Saldo Nett": "Transaksi Saldo Nett",
  "Konfigurasi Denda Saldo Minus": "Konfigurasi Denda Saldo Minus",
  "Konfigurasi Top Up & Cashback": "Konfigurasi Top Up & Cashback",
  "Konfigurasi Kuota Tiket CS": "Konfigurasi Kuota Tiket CS",
  "Automasi Indikasi DEX Palsu": "Automasi Indikasi DEX Palsu",
  "Incoming & Outgoing": "Incoming & Outgoing",
  Pengumuman: "Pengumuman",
  "Konfigurasi Pesan": "Konfigurasi Pesan",
  "Monitoring Integrasi API": "Monitoring Integrasi API",
  Middleware: "Middleware",
  "Konfigurasi Banner": "Konfigurasi Banner",
  "Penghasilan COD": "Penghasilan COD",
  "Daftar Pick Up": "Daftar Pick Up",
  "Konfigurasi Jadwal Pick up": "Konfigurasi Jadwal Pick up",
  "Integrasi API": "Integrasi API",
  Laporan: "Laporan",
  "report.title": "Laporan",
  "Unggah Data": "Unggah Data",
  "Unduh Format & Data": "Unduh Format & Data",
  "Masukan & Saran": "Masukan & Saran",
  Notifikasi: "Notifikasi",
  Keluar: "Keluar",
  Profil: "Profil",
  "Proses STIDEST SC": "Proses STIDEST SC",
  "DEX Asesmen L2": "DEX Asesmen L2",
  "DEX Asesmen L1": "DEX Asesmen L1",
  "Cari STT": "Cari STT",
  "Manifest cari STT": "Manifest cari STT",
  "Manifest cari STT | Scan": "Manifest cari STT | Scan",
  stiDest: {
    searchPlaceholder: "Cari ID Manifest",
    menuName: "Proses STIDEST",
    defaultTimeRange: "7 hari terakhir",
    updateStiDest: "Update STI-DEST",
    emptyData: "station transit in destination",
    print: "Print",
    emptyScan: {
      title: "Yuk! Mulai masukkan/scan nomor STT sekarang."
    },
    table: {
      no: "No.",
      manifestId: "ID Manifest",
      arrivalCity: "Kota Kedatangan",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      tanggalStiDest: "Tanggal STI-DEST",
      action: "Action",
      noBag: "No. Bag",
      noStt: "No. STT",
      productName: "Product Name",
      commodityName: "Commodity Name",
      totalKoliShort: "Total Koli",
      beratKotor: "Berat Kotor",
      beratDimensi: "Berat Dimensi",
      origin: "Origin",
      dest: "Dest.",
      transit: "Transit",
      misroute: "Misroute",
      noReferensi: "No. Referensi",
      tanggalManifest: "Tanggal Manifest",
      segeraPod: "Segera POD",
      segeraRts: "Segera RTS",
      segeraHal: "Segera HAL",
      atur: "Atur",
      jenisPengiriman: "Jenis Pengiriman",
      komoditas: "Komoditas",
      originCity: "Kota Asal",
      destCity: "Kota Tujuan",
      statusReturn: "Penanda Paket"
    },
    not: "Tidak",
    tooltipArrivalCity:
      "Kota Kedatangan adalah kota dimana barang/STT tiba ketika diproses pada fitur STI-DEST.",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    printRingkasan: "Print Ringkasan",
    dataUpdatedEvery10Min: "Data diupdate setiap 10 menit",
    refresh: "Refresh",
    dashboard: {
      headerBeforeStiDest: "Belum STI-DEST, proses sekarang!",
      cargoPlaneTruckShip: "Kargo pesawat {'|'} Truk {'|'} Kapal",
      headerSttNowDel: "Harus DEL saat ini!",
      headerSttOverdueDel: "Telat DEL, proses sekarang!",
      headerSttBar: "Penting untuk diproses hari ini!",
      totalStt: "Total STT",
      tooltipSttAtConsolidator:
        "STT telah sampai di Consolidator (STI DEST). Delivery sekarang!",
      segeraPod: "Segera POD",
      segeraRts: "Segera RTS",
      segeraHal: "Segera HAL",
      intracityIntercity: "Dalam kota / Antar kota"
    },
    detail: {
      title: "Detail Pengiriman",
      partnerName: "Nama Partner",
      userType: "Tipe User",
      arrivalCity: "Kota Kedatangan",
      detailStt: "Detail STT",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      tanggalDibuat: "Tanggal Dibuat",
      printStiDest: "Print STI-DEST",
      printSummary: "Print Summary",
      printPdf: "Print PDF",
      downloadExcel: "Download Excel"
    },
    update: {
      title: "Update STI-DEST",
      consolidatorName: "Nama Consolidator",
      arrivalCity: "Kota Kedatangan",
      tooltipArrivalCity:
        "Kota Kedatangan adalah kota dimana barang/STT tiba ketika diproses pada fitur STI-DEST.",
      tanggalStiDest: "Tanggal STI-DEST",
      noStt: "No. STT",
      placeholderDate: "Pilih atau masukkan No. seri kendaraan",
      placeholderStt: "Masukan No. STT atau Scan Barcode/QR Code",
      labelStackedStt: "Contoh : 99LP1234567890123/88-22-12345678",
      add: "Tambah",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Gross Weight",
      totalVolumeWeight: "Total Volume Weight",
      process: "Process",
      updateStiDestAndPrintPdf: "Update STI-DEST & Print PDF",
      statusStiDest: "STI-DEST",
      statusMisroute: "MIS-ROUTE",
      statusTransit: "Transit",
      hapus: "Hapus",
      hapusBarang: "Hapus Barang",
      deleteSttHint:
        "Masukan No. STT atau Scan Barcode/QR Code untuk barang yang ingin dihapus dari daftar STI-DEST.",
      terhapus: "Terhapus",
      batal: "Batal",
      sttNotFound: "No. STT tidak ditemukan/sudah terhapus",
      sttAlreadyInput: "No. STT sudah di input",
      popUpAlert: {
        success: "Status STT berhasil diupdate menjadi STI-DEST.",
        partial:
          "Beberapa status STT berhasil diupdate menjadi STI-DEST, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.",
        failed: "Perubahan status STI-DEST gagal dibuat."
      },
      lastStt: "STT Terakhir",
      lastBag: "BAG Terakhir",
      manifest: {
        consolidatorName: "Nama Consolidator",
        arrivalCity: "Kota Kedatangan",
        tanggalManifest: "Tanggal Manifest",
        totalSttKoli: "Total STT/Koli",
        GrossWeight: "Total Berat Kotor",
        referenceNo: "No. Referensi",
        productType: "Jenis Pengiriman",
        totalPieces: "Total Koli",
        originCity: "Kota Asal",
        notes: "Penanda Paket",
        adminStaff: "Staff Admin",
        courier: "Kurir"
      },
      downloadCsv: {
        columnBagNo: "Nomor Bagging",
        columnSttNo: "Nomor STT",
        columnReferenceNo: "Nomor Referensi",
        columnProductName: "Nama Product",
        columnPodLimit: "Batas POD",
        columnTotalPieces: "Total Koli",
        columnTotalGrossWeight: "Total Berat Kotor",
        columnOriginCity: "Kota Asal",
        columnDestinationCity: "Kota Tujuan",
        columnTransit: "Transit",
        columnMisroute: "Misroute",
        columnSttMarker: "Penanda STT",
        columnManifestDate: "Tanggal Manifest",
        yes: "Ya",
        no: "Tidak"
      }
    },
    needToStiDestDel: {
      title: "Daftar harus STI DEST & DEL",
      searchPlaceholder: "Cari no. kargo & STT/shipment",
      cargoType: "Tipe Kargo",
      status: "Status",
      pilihStatus: "Pilih Status",
      reset: "Reset",
      terapkan: "Terapkan",
      saatIni: "Saat ini",
      telat: "Telat",
      download: "Download",
      noKargo: "No. Kargo",
      noStt: "No. STT",
      noReferensi: "No. Referensi",
      statusTerakhir: "Status Terakhir",
      jenisPengiriman: "Jenis Pengiriman",
      totalKoli: "Total Koli",
      totalBerat: "Total Berat",
      kotaAsal: "Kota Asal",
      tanggalUpdateStatus: "Tanggal Update Status",
      batasWaktu: "Batas Waktu",
      pilihTipeKargo: "Pilih Tipe Kargo",
      pesawat: "Pesawat",
      truk: "Truk",
      kapal: "Kapal"
    },
    pdf: {
      manifestTitle: "STI-DEST Manifest",
      consolidatorName: "Nama Consolidator",
      arrivalCity: "Kota Kedatangan",
      tanggalStiDest: "Tanggal STI-DEST",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Dimensi",
      no: "No.",
      noBag: "No. Bag",
      noStt: "No. STT",
      produk: "Produk",
      komoditas: "Komoditas",
      totalKoliShort: "Total\nKoli",
      beratKotor: "Berat\nKotor",
      beratDimensi: "Berat\nDimensi",
      origin: "Origin",
      dest: "Dest.",
      catatan: "Catatan",
      kotaConsolidator: "Kota Consolidator",
      totalSttKoli: "Total STT/Koli",
      beratKotorShort: "Berat Kotor",
      tanggalManifest: "Tanggal Manifest",
      noReferensi: "No. Referensi",
      jenisPengiriman: "Jenis Pengiriman",
      kotaAsal: "Kota Asal",
      penandaPaket: "Penanda Paket",
      prosesManifest: "Proses Manifest",
      sttNoAlreadyInput: "No. STT/Bag sudah di input",
      batasPod: "Batas POD",
      kotaTujuan: "Kota Tujuan"
    },
    updateNotification: {
      sttPieces: "No. STT Pieces",
      success: "berhasil",
      failed: "Gagal"
    }
  },
  hubToHub: {
    menuTitle: "Hub to Hub",
    inHub: "In Hub",
    outHub: "Out Hub",
    updateInHub: "Update In Hub",
    updateOutHub: "Update Out Hub",
    searchManifestPlaceholder: "Cari No manifest",
    last30Days: "30 hari terakhir",
    no: "No",
    noManifest: "No. Manifest",
    totalStt: "Total STT",
    totalKoli: "Total koli",
    totalGrossWeight: "Total gross weight",
    manifestDate: "Tanggal manifest",
    plateNumber: "Plat Nomor",
    hubOrigin: "Hub asal",
    hubDestination: "Hub tujuan",
    actions: "Atur",
    printSummary: "Print Ringkasan",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    hubLocation: "Lokasi Hub",
    consolidatorLocation: "Lokasi konsol",
    totalSttKoli: "Total STT/koli",
    totalWeight: "Total Berat",
    createdBy: "Dibuat oleh",
    scanEmptyCta: "Yuk! Mulai masukkan/scan nomor STT sekarang.",
    searchBagSttPlaceholder: "Cari no. Bag/STT",
    totalSttKoliLabel: "Total STT/koli",
    grossWeight: "Berat Kotor",
    processManifest: "Proses manifest",
    bagSttNotFound: "No. bag/STT tidak ditemukan.",
    noPackagesScanned: "Belum ada paket yang discan.",
    partiallyUpdated: "sebagian STT berhasil diupdate.",
    confirmProcessManifest: "Konfirmasi Proses Manifest",
    plateNumberPlaceholder: "Masukkan plat nomor",
    destinationHub: "Tujuan hub",
    back: "Kembali",
    process: "Proses",
    manifestInhub: "Manifest INHUB",
    manifestOuthub: "Manifest OUTHUB",
    inhubManifestTitle: "Inhub Manifest",
    outhubManifestTitle: "Outhub Manifest",
    noBagDem: "No. Bag/DEM",
    noStt: "No. STT",
    refNo: "No. Referensi",
    koli: "Koli",
    weight: "Berat",
    product: "Produk",
    invalidPlate: "Plat nomor tidak valid, mohon ulangi kembali",
    manifest: {
      hubOriginDestination: "Hub asal - hub tujuan",
      hubLocation: "Lokasi hub",
      consoleLocation: "Lokasi konsol",
      totalSttPieces: "Total STT/Koli",
      weight: "Berat",
      manifestDate: "Tanggal manifest",
      createdBy: "Dibuat oleh",
      noReff: "No. Referensi",
      totalPieces: "Total koli",
      product: "Produk"
    },
    adminStaff: "Staff Admin",
    courier: "Kurir",
    operationsSupervisor: "Operations\nSupervisor",
    berhasil: "berhasil diproses",
    gagal: "gagal diproses"
  },
  urgentDeliveryManagement: {
    pageTitle: "Manajemen Kiriman Penting",
    tabPod: "Segera POD",
    tabRts: "Segera RTS",
    tabHal: "Segera HAL",
    tabTakenByRecipient: "Diambil Penerima",
    tabUrgentSearch: "Segera Cari",
    tabMonitorRelabel: "Segera Relabel",
    searchPlaceholder: "Cari no. STT",
    download: "Download",
    downloadData: "Download data",
    sortLatest: "Urutkan terbaru",
    pod: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnDeliveryType: "Layanan Pengiriman",
      columnReason: "Alasan",
      columnUnprocessed: "Belum diproses",
      columnLastStatus: "Status terakhir",
      columnProductType: "Jenis Pengiriman",
      columnDexAttempt: "Jumlah percobaan DEX (Customer)",
      columnRequestDate: "Tanggal permintaan",
      columnBkdDate: "Tanggal BKD",
      columnLastLocation: "Lokasi Terakhir",
      filterUrgent: "Kiriman penting",
      filterOverSla: "Lewat batas SLA",
      filterRedelivery: "Delivery ulang",
      flagUrgentDelivery: "kiriman penting",
      flagOverSlaLimit: "lewat batas sla"
    },
    filter: {
      filter: "Filter",
      deliveryType: "Tipe pengiriman",
      selectDeliveryType: "Pilih tipe pengiriman",
      flaggingDate: "Tanggal Flagging",
      reset: "Reset",
      apply: "Terapkan",
      caseType: "Tipe Kasus",
      selectCaseType: "Pilih tipe kasus",
      sttType: "Tipe STT",
      selectSttType: "Pilih tipe STT",
      customerRequest: "Permintaan Customer",
      lastLocation: "Lokasi terakhir",
      lastLocationPlaceholder: "Pilih lokasi terakhir",
      selectedLastLocation: "{num} Lokasi"
    },
    empty: {
      header: "Belum ada kiriman penting",
      message: "Yuk! Mulai masukkan/scan nomor STT pada menu STI DEST.",
      filterNotFound: "Filter tidak ditemukan",
      filterNotFoundMessage: "Cek dan atur ulang filter yang Anda cari."
    },
    rts: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnCaseType: "Tipe kasus",
      columnReason: "Alasan",
      columnSttType: "Tipe STT",
      columnOriginCity: "Kota Asal",
      columnLastStatus: "Status terakhir",
      columnProductType: "Jenis Pengiriman",
      columnDexAttempt: "Jumlah percobaan DEX (Customer)",
      columnRequestDate: "Tanggal Permintaan",
      columnBkdDate: "Tanggal BKD",
      columnLastLocation: "Lokasi Terakhir",
      requestDatePlaceholder: "Tanggal Permintaan",
      aggregator: "Aggregator",
      nonAggregator: "Non Aggregator"
    },
    urgentTakenByRecipient: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnProductType: "Jenis Pengiriman",
      columnLastStatus: "Status terakhir",
      columnAction: "Atur",
      actionUpdatePod: "Update POD"
    },
    hal: {
      columnNo: "No",
      columnNoStt: "No.STT",
      columnReason: "Alasan",
      columnOriginCity: "Kota Asal",
      columnLastStatus: "Status terakhir",
      columnRequestTime: "Waktu permintaan",
      columnLastLocation: "Lokasi Terakhir",
      flagToday: "hari ini",
      flagOverdue: "lewat"
    },
    detail: {
      requestType: "Tipe permintaan",
      lastStatus: "Status terakhir",
      reason: "Alasan",
      requestDate: "Tanggal permintaan",
      bkdDate: "Tanggal BKD",
      destination: "Tujuan",
      supportingLink: "Link data pendukung",
      notes: "Catatan",
      proofPhoto: "Bukti foto",
      productType: "Jenis Pengiriman",
      weight: "Berat",
      detailReceiver: "Detail Penerima",
      recipientName: "Nama Penerima",
      recipientPhone: "No. Telepon Penerima",
      recipientAddress: "Alamat Penerima"
    },
    error: {
      getDetailFailed: "Gagal mendapatkan detail!",
      getPODSummaryFailed: "Gagal mendapatkan POD summary!"
    },
    formatAgingDays: {
      days: "hari",
      today: "Hari ini"
    },
    photo: {
      title: "Update status ke POD dengan bukti pengiriman!",
      subtitle:
        "Anda wajib masukkan nama penerima & upload bukti foto pengambilan.",
      exampleGuideTitle: "Contoh panduan bukti foto",
      photoTypeKtp: "Foto KTP.",
      photoTypeProxyLetter: "Foto surat kuasa apabila diwakilkan.",
      photoTypeRecipientAndPackage: "Foto penerima & paket."
    },
    upload: {
      recipientName: "Nama Penerima",
      placeholderRecipientName: "Masukkan nama penerima",
      relation: "Relasi",
      proofPhoto: "Bukti Foto",
      photoSizeRequirement:
        "Maks. size : 5 MB, Format : jpg, png. Rekomendasi Dimensi 2 : 4, (contoh: 200px X 800px).",
      updatePod: "Update POD",
      successTitle: "Update POD berhasil!",
      successMessage: "Paket berhasil diperbarui menjadi POD.",
      buttonOk: "OK",
      confirmationTitle: "Update status ke POD?",
      confirmationMessage:
        "Pastikan kembali, paket yang akan di POD ke penerima sudah sesuai.",
      buttonCheckAgain: "Cek Kembali",
      buttonYesUpdate: "Ya, Update",
      errorTitle: "Update POD Gagal !",
      errorDeletePhoto: "Gagal menghapus Foto ke storage!"
    }
  },
  dexAssessment: {
    menuTitle: "Dex Asesmen",
    listTicketTitle: "Daftar Tiket DEX",
    detailTitle: "Daftar Tiket DEX | Detail",
    downloadData: "Download Data",
    searchPlaceholder: "Cari Tiket / No. STT",
    timeRangeDefault: "hari ini",
    filterReasonDex: "Alasan DEX",
    placeholderReasonDex: "Pilih Alasan DEX",
    statusDexAsesmen: "Status DEX Asesmen",
    placeholderStatusDex: "Pilih Status DEX",
    statusDisputeConsolidator: "Status Sanggah Konsolidator",
    placeholderStatusDispute: "Pilih Status Sanggah",
    searchCsName: "Cari Nama CS",
    placeholderCsName: "Ketik atau pilih nama cs",
    consolidator: "Konsolidator",
    placeholderConsolidator: "Ketik atau pilih 3LC",
    totalReasonFormat: "{count} Alasan DEX",
    statusValid: "Sesuai",
    statusInvalid: "Tidak Sesuai",
    statusNoStatus: "Belum Ada Status",
    statusDisputeRequested: "pengajuan",
    statusDisputeRejected: "tidak disetujui",
    statusDisputeApproved: "disetujui",
    columnTicketId: "Tiket ID",
    columnNoStt: "No. STT",
    columnTanggalDex: "Tanggal DEX",
    columnAlasanDex: "Alasan DEX",
    columnStatusDexAsesmen: "Status DEX Asesmen",
    columnStatusDitentukanOleh: "Status Ditentukan Oleh",
    columnStatusSanggah: "Status Sanggah",
    columnNamaCsL1: "Nama CS L1",
    columnTanggalDitugaskanCsL1: "Tanggal Ditugaskan CS L1",
    columnTanggalDiselesaikanCsL1: "Tanggal Diselesaikan CS L1",
    columnNamaCsL2: "Nama CS L2",
    columnTanggalDitugaskanCsL2: "Tanggal Ditugaskan CS L2",
    columnTanggalDiselesaikanCsL2: "Tanggal Diselesaikan CS L2",
    columnNamaKonsolidator: "Nama Konsolidator",
    columnTanggalDitugaskanKonsolidator: "Tanggal Ditugaskan Konsolidator",
    columnTanggalDiselesaikanKonsolidator: "Tanggal Diselesaikan Konsolidator",
    columnNamaCsL2Sanggah: "Nama CS L2 Sanggah",
    columnTanggalDitugaskanCsL2Sanggah: "Tanggal Ditugaskan CS L2 Sanggah",
    columnTanggalDiselesaikanCsL2Sanggah: "Tanggal Diselesaikan CS L2 Sanggah",
    emptyHeaderMessage: "Tidak Ada Daftar Tiket DEX",
    emptyMessage: "Mulai buat Daftar Tiket DEX dan cek daftarnya disini",
    infoSanggahanKonsol: "Informasi Sanggahan Konsol",
    fotoSanggahanKonsol: "Foto Sanggahan Konsol",
    catatanDariKonsol: "Catatan Dari Konsol",
    fotoDex: "Foto DEX",
    lampirkanFotoSanggahan: "Lampirkan Foto Sanggahan",
    lampirkanFoto: "Lampirkan Foto",
    komentarSanggahan: "Komentar Sanggahan",
    placeholderSanggahan: "Masukkan Sanggahan Anda Disini",
    proofPhoto: "Foto Bukti",
    automaticBySystem: "Otomatis oleh sistem",
    buttonSanggah: "Sanggah",
    buttonTerima: "Terima",
    disputeBefore: "Sanggah sebelum {timeLeft}",
    timeOverDispute: "Waktu Anda untuk sanggah telah berakhir",
    submitFailed: "Submit Dex Assessment Gagal !",
    statusSanggah: "Status Sanggah",
    statusFinalAsesment: "Status Final Asesment",
    lihatDetail: "Lihat Detail",
    summaryTicketInvalid: "Tiket Tidak Sesuai",
    summaryDisputeRequested: "Pengajuan Sanggah",
    summaryDisputeApproved: "Sanggah Disetujui",
    summaryDisputeRejected: "Sanggah Tidak Disetujui",
    summaryAcceptDex: "Terima DEX",
    summaryTotalTicket: "Total Tiket",
    summaryTicketQuota: "Tiket/Kuota",
    summaryTicketFinished: "Tiket Selesai",
    summaryTicketValid: "Tiket Sesuai",
    summaryTicketL1Finished: "Tiket L1 Selesai",
    summaryTicketDisputeFinished: "Tiket Sanggah Selesai",
    component: {
      informationDex: "Informasi DEX",
      informationDetailTicketDex: "Informasi Tiket DEX",
      statusFinalAssesmen: "Status Final Assesmen",
      statusSanggah: "Status Sanggah",
      informationDetailStt: "Informasi Detail STT",
      noStt: "No. STT",
      addressType: "Tipe Alamat",
      timeDex: "Waktu DEX",
      route: "Rute",
      productType: "Jenis Pengiriman",
      dexAttempt: "Percobaan DEX",
      slaLimit: "Batas SLA",
      customerDispute: "Sanggah Customer",
      partnerInformation: "Informasi Partner",
      contactInformation: "Informasi Kontak",
      filterSelectReason: "Pilih Alasan",
      disputeCheckbox: "Sanggah"
    },
    dashboard: {
      breakdownTicketDex: "Breakdown Tiket DEX",
      top20Console: "Top 20 Konsol Tiket DEX Terbanyak",
      selectReason: "Pilih Alasan DEX",
      breakdownTicketDexDispute: "Breakdown Tiket DEX Sanggah L2",
      top10ConsoleDispute: "Top 10 Konsol Tiket DEX Sanggah L2 Terbanyak",
      totalTicketByTimeRange: "Total Tiket DEX Berdasarkan Rentang Waktu",
      failedGetTotalTicket:
        "Gagal Mendapatkan Total Tiket DEX Berdasarkan Rentang Waktu",
      totalCsDexAssessment: "Total CS DEX Asesmen",
      summaryConsolidator: "Ringkasan Consolidator"
    },
    listTicketDex: {
      downloadReport: "Download Laporan",
      dateRangeDex: "Tanggal DEX",
      searchButton: "Cari",
      selectStatus: "Pilih Status",
      selectReason: "Pilih Alasan",
      selectDealWith: "Pilih Ditangani Oleh",
      emptyMessageNoData: "Tidak ada data yang dapat ditampilkan",
      noData: "Belum ada data"
    },
    notificationFinished: "Tiket ID {ticketId} telah berhasil diselesaikan",
    notificationDisputeFinished:
      "Tiket ID {ticketId} telah berhasil diselesaikan dengan status sanggahan {status}",
    notificationConsoleAction: "Tiket ID {ticketId} telah berhasil {action}",
    notificationStatusResult:
      "Tiket ID {ticketId} telah berhasil diselesaikan dengan status {status}",
    disputeApproved: "Disetujui",
    disputeRejected: "Tidak Disetujui",
    accepted: "Diterima",
    disputed: "Disanggah",
    reasonDex: "Alasan DEX",
    locationDex: "Lokasi DEX",
    sourceDex: "Asal DEX",
    recipientAddress: "Alamat Penerima",
    automaticFromSystem: "Otomatis dari sistem",
    finish: "Selesai",
    recipient: "Penerima",
    sender: "Pengirim",
    courier: "Kurir",
    courierCaptain: "Kapten Kurir",
    ticketId: "Tiket ID",
    viewDetail: "Lihat Detail",
    sttNumber: "No. STT",
    route: "Rute",
    addressType: "Tipe Alamat",
    dexAttempt: "Percobaan DEX",
    productType: "Jenis Pengiriman",
    sla: "SLA",
    yes: "Ya",
    no: "Tidak",
    dexTime: "Waktu DEX",
    customerDispute: "Sanggah Customer",
    agree: "Setujui",
    disagree: "Tidak Setujui",
    accept: "Terima",
    dispute: "Sanggah",
    assessedBy: "Diasses oleh",
    contactInformation: "Informasi Kontak",
    name: "Nama",
    contact: "Kontak",
    console: "Konsol",
    assessByAI: "Assess oleh AI",
    consoleDisputeInformation: "Informasi Sanggahan Konsol",
    dexPhoto: "Foto DEX",
    notesFromConsole: "Catatan Dari Konsol",
    notesFromCS: "Catatan dari CS",
    processRTS: "Proses RTS",
    disputeRejectNotesFromCS: "Catatan Tolak Sanggah dari CS",
    csL1Name: "Nama CS L1",
    assignedToL1: "Ditugaskan ke L1",
    finishedByL1: "Diselesaikan ke L1",
    csL2Name: "Nama CS L2",
    assignedToL2: "Ditugaskan ke L2",
    finishedByL2: "Diselesaikan ke L2",
    consoleName: "Nama Konsol",
    consoleDispute: "Sanggah Konsol",
    csL2DisputeName: "Nama CS L2 Sanggah",
    assignedToL2Dispute: "Ditugaskan ke L2 Sanggah",
    finishedByL2Dispute: "Diselesaikan ke L2 Sanggah",
    home: "Rumah",
    office: "Kantor"
  },
  dexAssessmentConsolidator: {
    pageTitle: "Dashboard DEX Asesmen",
    summaryDex: "Ringkasan DEX",
    summaryDexDetail: {
      sttDex: "STT DEX",
      sttDexDetail: {
        totalSttIncoming: "Total STT Incoming",
        totalDex: "Total DEX",
        totalDexInvalid: "Total DEX Invalid",
        totalDexValid: "Total DEX Valid"
      },
      dexDispute: "DEX Sanggah",
      dexDisputeDetail: {
        totalDexInvalid: "Total DEX Invalid",
        totalDexRequested: "Total DEX sanggah Diajukan",
        totalDexApproved: "Total DEX Invalid sanggah disetujui",
        totalDexRejected: "Total DEX Invalid sanggah Ditolak",
        totalDexAccepted: "Total DEX Invalid Diterima"
      }
    },
    ticket: "Tiket",
    downloadData: "Download Data",
    downloadFailed: "Download Gagal!",
    sectionSttDex: "STT DEX",
    sectionDexDispute: "DEX Sanggah",
    sectionTotalDexByReason: "Total DEX berdasarkan alasan",
    sectionTotalDexByTimeRange: "Total DEX berdasarkan rentang waktu",
    sectionTotalCourierInvalidDex: "Total kurir DEX invalid",
    placeholderStatus: "Pilih status",
    sectionPercentageDexAttempt: "Persentase percobaan DEX",
    sectionDexFromSourceDex: "Persentase DEX dari asal DEX",
    sectionPercentageRtsDex: "Persentase DEX yang perlu di RTS",
    sectionTotalDexPerDay: "Total DEX per hari",
    sectionCourierDex: "Kurir DEX",
    sortOrder: "Urutkan",
    searchCourierName: "Cari nama kurir",
    emptyNoCourierDex: "Tidak Ada Kurir DEX",
    emptyMessageCourierDex: "Mulai buat Kurir DEX dan cek daftarnya disini",
    emptyNoReasonDex: "Tidak Ada Alasan DEX",
    emptyMessageReasonDex: "Mulai buat Alasan DEX dan cek daftarnya disini",
    columnNo: "No",
    columnCourierName: "Nama Kurir",
    columnTotalDel: "Total DEL",
    columnTotalDex: "Total DEX",
    columnPercentageDex: "Persentase DEX",
    columnTotalDexMismatch: "Total DEX tidak sesuai",
    columnPercentageDexMismatch: "Persentase DEX tidak sesuai",
    columnTotalDexMatch: "Total DEX sesuai",
    columnPercentageDexMatch: "Persentase DEX sesuai",
    columnReasonDex: "Alasan DEX",
    sortTotalDexHighest: "Total DEX Tertinggi",
    sortTotalDexLowest: "Total DEX Terendah",
    sortTotalInvalidHighest: "Total DEX Invalid Tertinggi",
    sortTotalInvalidLowest: "Total DEX Invalid Terendah",
    sortTotalRejectedHighest: "Total DEX Invalid Sanggah Ditolak Tertinggi",
    sortTotalRejectedLowest: "Total DEX Invalid Sanggah Ditolak Terendah",
    sortCourierRejectedHighest: "Total Sanggah Ditolak Tertinggi",
    sortCourierRejectedLowest: "Total Sanggah Ditolak Terendah",
    sortPercentageDexHighest: "Percentage DEX Tertinggi",
    sortPercentageDexLowest: "Percentage DEX Terendah",
    sortPercentageInvalidHighest: "Percentage DEX Invalid Tertinggi",
    sortPercentageInvalidLowest: "Percentage DEX Invalid Terendah",
    statusAll: "All Status",
    statusDexValid: "DEX Valid",
    statusDexInvalid: "DEX Invalid",
    statusDexRequested: "DEX Invalid Disanggah",
    statusDexApproved: "DEX Invalid Sanggah Disetujui",
    statusDexRejected: "DEX Invalid Sanggah Ditolak",
    statusDexAccepted: "DEX Invalid Diterima",
    suffixDex: "DEX",
    suffixCourier: "kurir",
    ticketCount: "Tiket",
    sourceDriverApp: "Driver Apps",
    sourceGenesis: "Genesis",
    attemptOne: "1 Kali",
    attemptTwo: "2 Kali",
    attemptThreePlus: ">= 3 Kali"
  },
  processSti: {
    title: "Station Transit In",
    updateSti: "Update STI",
    synchSti: "Data diupdate setiap 10 menit",
    refresh: "Refresh",
    unprocessedSti: "Total yang belum diproses STI",
    partner: "Partner",
    stiNow: "STI saat ini",
    lateSti: "Telat STI",
    manifestId: "ID Manifest",
    totalStt: "Total STT",
    totalKoli: "Total Koli",
    manifestDate: "Tanggal Manifest",
    stiDestination: "STI - DEST",
    podSoon: "Segera POD",
    halSoon: "Segera HAL",
    rtsSoon: "Segera RTS",
    action: "Atur",
    printSummary: "Print Ringkasan",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    printSttNotSti: "Print STT Belum STI",
    downloadSttNotSti: "Download STT Belum STI",
    shippingDetail: "Detail pengiriman",
    originCity: "Kota asal",

    sttDetail: "Detail STT",
    totalGrossWeight: "Total berat kotor",
    totalVolumeWeight: "Total berat dimensi",

    createdDate: "Tanggal dibuat",
    printStiDest: "Print STI Dest",

    no: "No.",
    bagNumber: "No. Bag",
    sttNumber: "No. STT",
    referenceNumber: "No. Referensi",
    productType: "Jenis Pengiriman",
    commodity: "Komoditas",
    destinationCity: "Kota tujuan",

    scanStartMessage: "Yuk! Mulai masukkan/scan nomor STT sekarang.",
    scanExample: "Contoh : 99LP1234567890123/88-22-12345678",
    scanPlaceholder: "Masukan no. STT atau scan barcode/QR code",
    searchBagStt: "Cari no. Bag/STT",
    allPartners: "Semua Partner",
    processManifest: "Proses manifest",
    totalSttKoli: "Total STT/koli",
    grossWeight: "Berat Kotor",
    packageMarker: "Penanda Paket",
    noPackageScanned: "Belum ada paket yang discan",

    confirmManifestTitle: "Ada STT belum di STI, lanjutkan proses manifest?",
    confirmManifestDesc:
      "Jika melanjutkan, maka STT yang belum di STI akan ditandai sebagai telat STI.",
    confirmManifestButton: "Ya, lanjutkan manifest",
    yes: "YA",
    noValue: "TIDAK",

    all: "Semua",
    needRelabel: "Perlu relabel",
    underpaid: "Kurang bayar",
    sttNeedAdjust: "STT perlu diadjust",

    partnerName: "Nama Partner",
    productName: "Nama Produk",
    podDeadline: "Batas POD",
    region: "Wilayah",

    stiManifest: "STI Manifest",

    updateSuccessTitle: "Perubahan Status Berhasil!",
    updateSuccessMessage: "Status STT berhasil diupdate menjadi STI.",
    updateFailed: "Perubahan Status Gagal!",
    ok: "OK",

    stiRequiredList: "Daftar harus STI",
    searchSttBagShipment: "Cari no. STT/bag/shipment",
    allPartner: "Semua Partner",
    now: "Saat ini",
    overdue: "Telat",
    download: "Download",

    lastStatus: "Status terakhir",
    shippingType: "Jenis pengiriman",
    totalWeight: "Total berat",
    bookingDate: "Tanggal booking",
    deadline: "Batas waktu",
    penandaPaket: "Penanda Paket"
  },
  feedback: {
    title: "Berikan penilaian Anda",
    subtitle: "Penilaian Anda sangat berharga untuk kami",
    titleV2: "Berikan Penilaian Anda",
    subtitleV2: "Penilaian Anda sangat Berharga untuk perbaikan",
    rate: "Nilai",
    modal: {
      title: "Beri penilaian",
      subtitle: "Silahkan berikan penilaian untuk Genesis",
      rating: "(1 mengecewakan, 5 sangat memuaskan)",
      disappointing: "(Mengecewakan)",
      slightlyDisappointing: "(Sedikit Mengecewakan)",
      okay: "(Cukup)",
      satisfying: "(Memuaskan)",
      excellent: "(Sangat Memuaskan)",
      reviewTitle: "Berikan ulasan anda",
      reviewPlaceholder: "Masukan ulasan terkait penggunaan Genesis",
      cancel: "Batal",
      send: "Kirim",
      success: {
        title: "Terima kasih untuk penilaian Anda",
        message: "Lion Parcel akan memberikan yang terbaik untuk Anda",
        done: "Selesai"
      },
      exit: {
        title: "Anda belum memberikan penilaian",
        message:
          "Silakan berikan penilaian serta ulasan Anda terkait penggunaan sistem Genesis",
        close: "Keluar",
        review: "Berikan Penilaian"
      }
    }
  },
  "Buat STT baru untuk pengembalian paket":
    "Buat STT baru untuk pengembalian paket",
  "Ubah Data Alamat": "Ubah Data Alamat",
  trackDelivery: {
    tabPengiriman: "Pengiriman",
    tabLacakStt: "Lacak STT",
    tabPengirimanAktif: "Pengiriman Aktif",
    tabRiwayatPengiriman: "Riwayat Pengiriman",
    tabPaketKirimanAnda: "Paket Kiriman Anda",
    tabPaketUntukAnda: "Paket Untuk Anda",
    searchPlaceholderResi: "Cari No. Resi",
    emptyPackages: "paket kiriman Anda",
    pageTitleDetail: "Pengiriman | Detail",
    dataNotAvailableTitle: "Data Belum Dapat Ditampilkan",
    dataNotAvailableMessage:
      "Data ini hanya bisa diakses jika status paket memiliki kendala atau perlu tindakan lebih lanjut.",
    understood: "Mengerti",
    partyRequest: "Pihak yang mengajukan klaim",
    chooseClaimer: "Pilih klaimer",
    cliamType: "Tipe Klaim",
    chooseClaimType: "Pilih tipe klaim",
    changePhoto: "Ubah Foto",
    itemPhoto: "Foto Barang",
    itemPhotoDesc:
      "Upload foto barang dengan 6 sisi (Sisi kanan, kiri, atas, bawah, depan, belakang)",
    isDataValid:
      "Data yang dikirim sudah sesuai? Pastikan data yang Anda kirim telah benar dan megikuti syarat & ketentuan klaim",
    codeInvalid:
      "Kode yang anda masukkan salah. Muat ulang atau masukkan kode kembali",
    claimSuccess: "Pengajuan Klaim Berhasil !",
    claimMessage:
      "Jika ingin melacak status klaim, bisa anda cek di menu klaim",
    claimFailed: "Pengajuan Klaim Gagal !",
    reportIssue: "Laporkan Kendala",
    sttHistory: "Riwayat Pengiriman STT",
    before: "Sebelumnya",
    replacement: "Pengganti",
    columns: {
      colSttNoResi: "STT/No. Resi",
      colShipmentId: "Shipment ID",
      colPackageWeight: "Berat Paket",
      colShippingCost: "Biaya Kirim",
      colRecipientDetail: "Detail Penerima",
      colPackageStatus: "Status Paket",
      colDeliveryPerformance: "Performa Pengiriman",
      colClaimNo: "No Klaim",
      colClaimPackage: "Klaim Paket",
      statusLate: "Terlambat",
      statusOnTime: "Tepat Waktu",
      submitClaim: "Ajukan Klaim",
      claimSubmitted: "Klaim diajukan",
      claimStatusTip:
        "Cek status klaim di menu Klaim <br /> atau Lacak Klaim paket Lion Parcel"
    },
    claim: "Ajukan Klaim",
    claimer: "Klaimer",
    claimType: "Tipe Klaim",
    dataSentQuestion:
      "Data yang dikirim sudah sesuai? Pastikan data yang Anda kirim telah benar dan mengikuti syarat & ketentuan klaim",
    success: "Pengajuan Klaim Berhasil !",
    failed: "Pengajuan Klaim Gagal !",
    checkDetail: "Cek detail status klaim di menu klaim",
    yourClaimFailed: "Klaim yang anda ajukan gagal",
    sender: "Pengirim",
    receiver: "Penerima",
    late: "Keterlambatan",
    product: "Produk"
  },
  bulkPrintReceipt: {
    title: "Cetak Resi",
    listStt: "Daftar No. STT",
    maxStt: "Jumlah maksimum yang dapat diproses adalah {maxStt} STT.",
    placeholder: "Masukan No. STT atau scan barcode",
    sttNotFound: "Data stt tidak ditemukan",
    showStt: "Tampilkan No. STT",
    deleteAll: "Hapus Semua",
    showDetailStt: "Menampilkan {count} detail STT",
    duplicated: "{removedCount} No. STT duplikat telah dihapus.",
    overlimitStt:
      "Jumlah STT melebihi batas maksimum {maxSttInput}. Hapus {excessSttCount} STT yang melebihi batas.",
    printReceipt: "Resi/STT Print",
    printA4: "Print Ukuran A4",
    printA6: "Print Ukuran A6",
    table: {
      title: "Daftar STT Print",
      name: "Nama Client / Partner",
      totalCost: "Total Biaya",
      noRef: "No. Referensi",
      totalPieces: "Total Koli",
      totalChargeableWeight: "Total Berat Dikenakan Biaya",
      destinationAddress: "3LC Tujuan",
      sender: "Nama Pengirim",
      recipient: "Nama Penerima",
      insurance: "Asuransi",
      shippingCost: "Biaya Pengiriman",
      insuranceCost: "Biaya Asuransi",
      totalTarif: "Total Tarif",
      shipmentNo: "No. Shipment"
    }
  },
  claim: {
    title: "Klaim",
    detailTitle: "Resi {stt}",
    pageTitle: "Klaim | Detail",
    searchPlaceholderResi: "Cari No. Resi",
    claimStatus: "Status Klaim",
    apply: "Terapkan",
    submitted: "Diajukan",
    approved: "Disetujui",
    rejected: "Ditolak",
    finished: "Selesai",
    missing: "Hilang",
    damaged: "Rusak",
    overdue: "Keterlambatan",
    emptyPackages: "paket kiriman Anda",
    pageTitleDetail: "Pengiriman | Detail",
    dataNotAvailableTitle: "Data Belum Dapat Ditampilkan",
    dataNotAvailableMessage:
      "Data ini hanya bisa diakses jika status paket memiliki kendala atau perlu tindakan lebih lanjut.",
    understood: "Mengerti",
    filter: {
      filter: "Filter",
      reset: "Reset",
      selectStatusClaim: "Pilih status klaim",
      selectCategory: "Pilih kategori"
    },
    columns: {
      colSttNoResi: "No. Resi",
      colShipmentId: "Shipment ID",
      colProduct: "Produk",
      colCategory: "Kategori",
      colClaimStatus: "Status Klaim",
      colUpdatedStatus: "Tanggal Update Status"
    },
    detail: {
      createdAt: "Tanggal Dibuat",
      updatedAt: "Tanggal Diubah",
      deliveryDetail: "Detail Pengiriman",
      itemDetail: "Detail Barang",
      noSTTGenesis: "No. STT Genesis",
      shipmentID: "Shipment ID",
      externalRefNumber: "No. Referensi Eksternal",
      districtOriginCity: "Kecamatan, Kota Asal",
      districtDestinationCity: "Kecamatan, kota tujuan",
      bookedFor: "Dibooking untuk",
      shipperName: "Nama Pengirim",
      recipientName: "Nama Penerima",
      shipperPhoneNumber: "No. Telepon Pengirm",
      recipientPhoneNumber: "No. Telepon Penerima",
      shipperAddress: "Alamat Pengirim",
      recipientAddress: "Alamat Penerima",
      addressType: "Tipe Alamat",
      home: "Rumah",
      office: "Kantor",
      commodity: "Komoditas",
      product: "Produk",
      totalItemsPiecesKoli: "Total Barang (Pieces/Koli)",
      totalChargeableWeight: "Total Berat Dikenakan Biaya",
      itemPriceEstimate: "Estimasi Harga Barang",
      taxRegistrationNumber: "No. Registrasi Pajak (NPWP)",
      insurance: "Asuransi",
      createdBy: "Resi Dibuat Oleh",
      billedTo: "Billed to",
      source: "Source",
      cod: "COD",
      returnDO: "DO Balikan",
      yes: "Ya",
      no: "Tidak",
      dimensionLwh: "Dimensi (P x L x T)",
      paymentDetail: "Detail Pembayaran",
      shippingCost: "Biaya Pengiriman",
      cityRate: "City Rate",
      forwardRate: "Forward Rate",
      commoditySurcharge: "Biaya Tambahan Komoditas",
      weightAdditionalCharge: "Biaya Tambahan Berat",
      additionalDocumentCost: "Biaya Tambahan Dokumen",
      taxEstimate: "Estimasi Pajak",
      totalTarif: "Total Tarif"
    }
  },
  sti: {
    pageTitle: "Station Transit In",
    searchPlaceholder: "Cari Manifest ID",
    searchPlaceholderReverseScan: "Cari ID Manifest",
    timeRangeDefault: "7 hari terakhir",
    updateButton: "Update STI",
    printSummary: "Print Summary",
    printPdf: "Print PDF",
    downloadExcel: "Download Excel",
    manifestId: "Manifest ID",
    no: "No.",
    action: "Action",
    actionArrange: "Atur",
    detailTitle: "STI Manifest - {id}",
    printSti: "Print STI",
    dataUpdatedEvery10Min: "Data diupdate setiap 10 menit",
    refresh: "Refresh",
    totalUnprocessedSti: "Total yang belum diproses STI",
    partner: "Partner",
    stiCurrent: "STI saat ini",
    stiOverdue: "Telat STI",
    unitStt: "STT",
    printSttNeedSti: "Print STT belum STI",
    downloadSttNeedSti: "Download STT belum STI",
    printRingkasan: "Print ringkasan",
    downloadExcelLower: "Download excel",
    tanggalManifest: "Tanggal Manifest",
    noStt: "No. STT",
    origin: "Origin",
    sttLabel: "STT",
    datePlaceholder: "Pilih tanggal",
    listFailedTitle: "Daftar gagal scan",
    reasonFailed: "Alasan gagal",
    nomorStt: "Nomor STT",
    sttFailedScan: "STT gagal scan",
    needToSti: {
      pageTitle: "Daftar harus STI",
      searchPlaceholder: "Cari no. STT/bag/shipment",
      allPartner: "Semua Partner",
      filterNow: "Saat ini",
      filterOverdue: "Telat",
      download: "Download",
      no: "No.",
      noBag: "No. bag",
      noStt: "No. STT",
      noReferensi: "No. referensi",
      lastStatus: "Status terakhir",
      productType: "Jenis pengiriman",
      totalPieces: "Total koli",
      totalWeight: "Total berat",
      destinationCity: "Kota tujuan",
      bookingDate: "Tanggal booking",
      partnerName: "Nama Partner",
      deadline: "Batas waktu",
      overdue: "Telat"
    },
    updateSti: {
      scanPromptEmpty: "Yuk! Mulai masukkan/scan nomor STT sekarang.",
      searchPlaceholderBagStt: "Cari no. Bag/STT",
      allPartner: "Semua Partner",
      packageMarker: "Penanda Paket",
      processManifest: "Proses manifest",
      totalSttKoli: "Total STT/koli",
      grossWeight: "Berat Kotor",
      notFoundFilter: "No. bag/STT tidak ditemukan.",
      noPackageScanned: "Belum ada paket yang discan.",
      modalConfirmMessage: "Ada STT belum di STI, lanjutkan proses manifest?",
      modalConfirmSubtext:
        "Jika melanjutkan, maka STT yang belum di STI akan ditandai sebagai telat STI.",
      modalConfirmButton: "Ya, lanjutkan manifest",
      productType: "Jenis Pengiriman",
      partnerName: "Nama Partner",
      podDeadline: "Batas POD",
      seeMore: "Lihat selengkapnya"
    },
    pdf: {
      listSttNeedToSTI: "Daftar STT harus STI",
      consolidatorName: "Nama Konsolidator",
      consolidatorCity: "Kota Konsolidator",
      totalSttPieces: "Total STT/koli",
      grossWeight: "Berat Kotor",
      manifestDate: "Tanggal Manifest",
      totalSttNotReceived: "Total STT belum diterima",
      referenceNo: "No. referensi",
      totalPieces: "Total koli",
      destinationCity: "Kota tujuan",
      region: "Wilayah",
      packageMarker: "Penanda paket",
      courier: "Kurir",
      adminStaff: "Staff Admin",
      yes: "Ya",
      no: "Tidak",
      arrivalCity: "Kota kedatangan",
      PODSoon: "Segera POD",
      RTSSoon: "Segera RTS",
      HALSoon: "Segera HAL",
      notSTIOnTime: "Belum di STI pada waktu",
      timeLimit: "Batas waktu",
      weight: "Berat"
    }
  },
  requestHal: {
    title: "Permintaan Kiriman Penting",
    createRequest: "Buat permintaan",
    download: "Download",
    sort: "Urutkan",

    searchStt: "Cari No. STT",
    last7Days: "7 hari terakhir",
    createdDate: "Tanggal dibuat",

    emptyRequestHeader: "Belum ada permintaan",
    emptyRequestMessage:
      "Yuk! Mulai buat permintaan dan cek statusnya di sini.",

    importantShipmentRequest: "Permintaan kiriman penting",

    sttNumber: "No STT",
    enterSttNumber: "Masukkan No STT",

    requestType: "Tipe permintaan",
    lastStatus: "Status terakhir",
    requestStatus: "Status permintaan",
    requestBy: "Diajukan oleh",

    selectRequestType: "Pilih tipe permintaan",
    selectLastStatus: "Pilih status terakhir",
    selectRequestStatus: "Pilih status permintaan",
    selectRequestBy: "Pilih diajukan oleh",

    number: "No",
    deadline: "Batas waktu",
    destination: "Tujuan",
    createdAt: "Tanggal dibuat",
    updatedAt: "Tanggal diubah",

    reason: "Alasan",
    selectReason: "Pilih Alasan",

    notes: "Catatan",
    enterNotes: "Masukkan catatan",

    proof: "Bukti",

    supportingLink: "Link data pendukung",
    enterSupportingLink:
      "Tekan enter atau spasi untuk menambah link data pendukung",
    enterLinks: "Masukkan link, pisahkan dengan spasi jika lebih dari satu.",

    uploadProof: "Upload bukti",

    cancel: "Batal",
    save: "Simpan",
    confirmCancel: "Ya, batalkan",
    back: "Kembali",
    ok: "Oke",

    importantShipment: "Kiriman penting",
    redelivery: "Delivery ulang",
    rts: "RTS",
    hal: "HAL",

    all: "Semua",
    pos: "POS",
    internal: "Internal",

    success: "Berhasil",
    cancelled: "Dibatalkan",

    failedGetDetail: "Gagal mendapatkan detail!",
    requestCreated: "Permintaan berhasil dibuat",
    requestCreateFailed: "Permintaan gagal dibuat",

    cancelSuccess: "Permintaan HAL berhasil dibatalkan",
    cancelFailed: "Gagal Membatalkan Kiriman",

    cancelHalRequestTitle: "Batalkan permintaan HAL untuk STT ini?",
    cancelHalRequestMessage:
      "Jika permintaan HAL dibatalkan, POS akan tetap dikenakan penalti.",
    cancelHalSuccessMessage:
      "Permintaan HAL untuk STT ini berhasil dibatalkan & POS akan tetap dikenakan penalti.",

    invalidSttNumber: "Nomor STT tidak valid, cek & ubah lagi.",
    jumboPackPickup: "Paket Jumbopack akan diambil oleh penerima",

    retailOnly: "Hanya untuk STT booking retail",
    invalidRetailStt:
      "No. STT <b>“{stt}”</b> tidak diperkenankan. Cek & ubah menggunakan STT booking retail.",

    requestCreatedMessage:
      "Permintaan kiriman penting <b>“No. STT {stt}”</b> berhasil dibuat.",

    reasonHoldAtHub: "Permintaan customer paket ditahan di lokasi HUB",
    reasonReturnCustomer: "Permintaan retur dari customer",

    specialEvent: "Acara Khusus",
    food: "Makanan",
    medicineShipment: "Kiriman Obat",
    livePlants: "Tanaman Hidup",

    doubleStt: "Double STT",
    lessPackage: "Kurang Koli",
    receiverPickup: "Penerima Ambil Paket Sendiri",
    senderUnderpaid: "Pengirim Kurang Bayar Customer Apps",
    changeAddressRequest: "Permintaan Perubahan Alamat",
    returnRequestCustomer: "Permintaan Retur Dari Customer",

    posPenaltyMessagePercentage:
      "POS akan dikenakan penalti {amount}% dari ongkir (min. {min} & maks. {max}).",

    posPenaltyMessageFlat: "POS akan dikenakan penalti {amount} dari ongkir.",

    maxUploadPhoto:
      "Maksimal upload {max} bukti foto. Anda tidak bisa upload lagi",

    uploadSuccess: "Upload sukses",

    uploadFailed: "Upload gagal",

    deletePhotoFailed: "Gagal menghapus foto ke storage!"
  },
  posFavourite: {
    title: "Pos Langganan",
    member: "Member",
    outstandingMember: "Tagihan Member",
    searchPlaceholder: "Cari",
    invoiceStatus: {
      filter: "Filter",
      unpaid: "Belum Dibayar",
      paid: "Lunas"
    },
    table: {
      no: "No.",
      invoiceId: "ID Invoice",
      createdAt: "Tanggal Dibuat",
      totalInvoice: "Total Invoice",
      invoiceStatus: "Status Invoice",
      totalStt: "Total STT",
      memberName: "Nama Member",
      address: "Alamat",
      phoneNumber: "No Telp"
    },
    defaultDiscountSettings: {
      title: "Pengaturan Diskon Default",
      discount: "Diskon",
      maxDiscount: "Maks. 25 %",
      lastUpdated: "Terakhir Diubah",
      cancel: "Batal",
      save: "Simpan",
      confirmTitle: "Konfirmasi Perubahan",
      confirmMessage: "Anda yakin ingin menyimpan perubahan diskon default?",
      successTitle: "Perubahan Disimpan",
      successMessage: "Detail diskon default berhasil diubah.",
      ok: "Oke",
      back: "Kembali",
      select: "Pilih",
      shippingSurcharge: "Biaya Tambahan Pengiriman",
      publishRate: "Tarif Publikasi",
      shippingAndPublish: "Biaya Tambahan Pengiriman + Tarif Publikasi"
    },
    editMemberModal: {
      title: "Edit Member",
      name: "Nama Member",
      address: "Alamat",
      phone: "No. Telp",
      discount: "Diskon",
      cancelButton: "Batal",
      saveButton: "Simpan",
      backButton: "Kembali",
      confirmTitle: "Konfirmasi Perubahan",
      confirmMessage:
        "Anda yakin ingin menyimpan perubahan diskon Member “{name}” ?",
      successTitle: "Perubahan Berhasil Disimpan !",
      successMessage: "Detail Member “{name}” berhasil diubah.",
      exitConfirmTitle: "Yakin ingin keluar?",
      exitConfirmMessage:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      exitButton: "Keluar",
      select: "Pilih",
      maxDiscount: "Maks. 25 %"
    },
    memberTabs: {
      searchPlaceholder: "Cari No. telp",
      defaultDiscountSettings: "Pengaturan Diskon Default",
      emptyStateLabel: "Pos Favorit",
      tableHeaders: {
        no: "No.",
        memberName: "Nama Member",
        address: "Alamat",
        phone: "No. Telp",
        discount: "Diskon",
        subscriptionDate: "Tanggal Berlangganan",
        updatedAt: "Diperbarui",
        spending: "Spending",
        action: "Aksi"
      }
    }
  },
  kulioner: {
    merchant: {
      title: "Daftar pesanan merchant",
      cycleName: "Cycle {index} - {time}",
      emptyHeader: "Belum ada pesanan",
      emptyMessage:
        "Jika sudah ada pesanan, maka akan muncul di sini secara otomatis.",
      processAriaLabel: "Proses Pengolahan",
      table: {
        no: "No",
        merchant: "Merchant",
        totalProduct: "Total produk",
        totalItem: "Total item",
        status: "Status",
        subtotal: "Subtotal"
      },
      viewMoreMerchant: "Lihat {count} merchant lainnya",
      viewLess: "Lihat lebih sedikit",
      acceptOrder: "Terima pesanan",
      processShipment: "Proses pengiriman",
      trackShipment: "Lacak pengiriman",
      seeLocation: "Lihat lokasi",
      tabs: {
        processed: "Diproses",
        unprocessed: "Belum diproses"
      },
      summary: {
        totalTransaction: "Total transaksi",
        totalMerchant: "Total merchant",
        totalProduct: "Total produk",
        totalItem: "Total item"
      }
    },
    customer: {
      title: "Daftar pesanan customer",
      searchBy: {
        merchantName: "Nama merchant",
        customerName: "Nama customer",
        merchantPhone: "No telp merchant",
        orderId: "Order ID",
        sttNumber: "Nomor STT"
      },
      emptyHeader: "Belum ada pesanan",
      emptyMessage:
        "Cek status pesanan customer Kulioner dari awal hingga selesai di sini.",
      systemErrorHeader: "Terjadi gangguan sistem",
      systemErrorMessage: 'Klik "Muat ulang" atau coba beberapa saat lagi.',
      searchNotFoundHeader: "Pencarian tidak ditemukan",
      searchNotFoundMessage:
        "Pastikan kata kunci sudah sesuai, cek & ubah lagi.",
      internetErrorHeader: "Jaringan internet terputus",
      internetErrorMessage:
        'Periksa jaringan internal Anda lalu klik "Muat ulang".',
      reload: "Muat ulang"
    }
  },
  chips: {
    active: "Aktif",
    inactive: "Tidak Aktif",
    crrnfd: "Mencari Kurir",
    crrotw: "Kurir Ditugaskan",
    crrpic: "Paket di Pick Up",
    crrdon: "Selesai",
    crrcnc: "Dibatalkan Kurir",
    cstcnc: "Dibatalkan Klien",
    admcnc: "Dibatalkan Admin"
  },
  Urutkan: "Sorting",
  banner: {
    main: "Saya sudah membaca & memahami informasi yang disampaikan diatas.",
    submain:
      "Untuk keterangan lebih lanjut hubungi whatsapp +62 811-1956-1000 atau email help{'@'}thelionparcel.com"
  },
  tableV2: {
    tooltips: {
      isCargo: "Telah mendapatkan No. kargo",
      isRtcProcess: "Dalam proses Siap Dikargo/RTC",
      isAlreadyRTC: "Telah Siap Dikargo",
      isAbleRTC: "Pilih untuk proses ke Siap Dikargo"
    }
  },
  "Tipe COD": "Tipe COD",
  "STT tidak valid": "Invalid STT",

  stiSc: {
    router: {
      menuTitle: "Proses STI SC",
      updatePageTitle: "STI-SC | Pembaruan",
      updatePageName: "Pembaruan STI SC",
      needToStiScPageName: "Daftar harus STI SC"
    },
    update: {
      pageTitle: "Update STI-SC",
      emptyStatePrompt: "Yuk! Mulai masukkan/scan nomor STT sekarang.",
      sttExampleLabel: "Contoh : 99LP1234567890123/88-22-12345678",
      sttInputPlaceholder: "Masukan no. STT atau scan barcode/QR code",
      searchSttShipmentPlaceholder: "Cari no. STT/Shipment",
      allPosClient: "Semua POS/klien",
      processManifest: "Proses manifest",
      totalSttPieces: "Total STT/Koli",
      grossWeight: "Berat Kotor",
      notFoundFilter: "No. bag/STT tidak ditemukan.",
      noPackageScanned: "Belum ada paket yang discan.",
      modalConfirmManifestTitle:
        "Ada STT belum di STI SC, lanjutkan proses manifest?",
      modalConfirmManifestBody:
        "Jika melanjutkan, maka STT yg belum di STISC akan di anggap belum di handover.",
      modalConfirmButton: "Ya, lanjutkan manifest",
      manifestSuccessTitle: "Pembuatan manifest berhasil!",
      statusChangeFailed: "Perubahan Status Gagal!"
    },
    list: {
      buttonUpdate: "Update STI-SC",
      dataRefreshNote: "Data diupdate setiap 10 menit",
      refresh: "Refresh",
      bannerTotalPending: "Total yang belum diproses STI SC",
      posPerClient: "POS/klien",
      bannerCurrentStiSc: "STI SC saat ini !",
      searchManifestIdPlaceholder: "Cari ID Manifest",
      last7Days: "7 hari terakhir",
      actionPrintPdfDoneStiSc: "Print PDF sudah STI SC",
      actionDownloadSttNotYetStiSc: "Download STT belum STI SC"
    },
    listV1: {
      last7Days: "7 hari terakhir",
      buttonUpdate: "Perbarui STI-SC",
      print: "Cetak"
    },
    table: {
      columnNo: "No.",
      manifestId: "ID manifest",
      totalStt: "Total STT",
      totalWeight: "Total berat",
      totalPieces: "Total koli",
      manifestDate: "Tanggal manifest",
      actions: "Atur",
      productType: "Jenis pengiriman",
      posClientName: "Nama POS/Klien",
      destinationCity: "Kota tujuan",
      podDeadline: "Batas POD",
      sttNo: "No. STT",
      underpaid: "Kurang bayar",
      referenceNo: "No. referensi",
      lastStatus: "Status terakhir",
      bookingDate: "Tanggal booking",
      subConsolidatorName: "Nama Sub Consolidator",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Volume",
      stiScDate: "Tanggal STI-SC",
      action: "Aksi",
      product: "Produk",
      grossWeight: "Berat Kotor",
      volumeWeight: "Berat Dimensi",
      destination: "Destinasi",
      status: "Status"
    },
    pdf: {
      featureNameStiSc: "STI-SC",
      subConsolidatorName: "Nama sub consol",
      subConsolidatorCity: "Kota sub consol",
      totalSttKoli: "Total STT/Koli",
      totalGrossWeight: "Total berat kotor",
      manifestDate: "Tanggal manifest",
      totalSttNotReceived: "Total STT belum diterima",
      columnNo: "No.",
      sttNo: "No. STT",
      referenceNo: "No. referensi",
      destinationCity: "Kota Tujuan",
      totalKoli: "Total Koli",
      totalWeight: "Total Berat",
      signatoryStationAdmin: "Station Admin",
      signatoryCourier: "Kurir",
      signatoryOpsSupervisor: "Operation Supervisor"
    },
    needToList: {
      pageTitle: "Daftar harus STI SC",
      searchPlaceholder: "Cari no. STT/shipment",
      allPosClient: "Semua POS/klien",
      download: "Download"
    },
    scanFailed: {
      title: "Daftar gagal scan",
      excelColSttNo: "Nomor STT",
      excelColReason: "Alasan gagal scan",
      excelSheetName: "STT gagal scan",
      excelFileName: "STT gagal scan.xlsx"
    },
    updateV2: {
      pageTitle: "Update STI-SC",
      partnerName: "Nama Partner",
      userType: "Tipe User",
      stiScDate: "Tanggal STI-SC",
      vehicleSerialPlaceholder: "Pilih atau masukkan No. seri kendaraan",
      sttPlaceholder: "Masukan No. STT atau Scan Barcode/QR Code",
      sttLabel: "Contoh : 99LP1234567890123/88-22-12345678",
      processManifest: "Proses Manifest",
      processAndPrintManifest: "Proses & Print Manifest",
      leaveTitle: "Yakin ingin keluar?",
      leaveBody:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      leaveExit: "Keluar",
      leaveBack: "Kembali",
      badgeUpdatedOk: "Berhasil Diperbarui ke STI-SC",
      badgeUpdatedFail: "Gagal Diperbarui ke STI-SC",
      badgeNotFound: "Gagal Diperbarui ke STI-SC",
      badgeExist: "Gagal Diperbarui ke STI-SC",
      toastManifestCreated: "Berhasil Membuat Manifest STI-SC Baru",
      addSttFailed: "Tambah No. STT Gagal!",
      getSessionFailed: "Gagal Mendapatkan List Session!",
      summaryTotalStt: "Total STT",
      summaryTotalPieces: "Total Koli",
      summaryTotalGrossWeight: "Total Gross Weight",
      summaryTotalVolumeWeight: "Total Volume Weight"
    },
    common: {
      unitStt: "STT",
      unitKg: "kg",
      userFallback: "User",
      ok: "OK"
    }
  },
  stoSc: {
    router: {
      menuTitle: "STO-SC"
    },
    shell: {
      last7Days: "7 hari terakhir",
      tabProcessToStoSc: "Proses ke STO-SC",
      tabListStoSc: "STO-SC",
      tooltipVariantA:
        "Daftar paket dengan status STI-SC yang siap di proses ke STO-SC",
      tooltipVariantB:
        "Paket telah diserahkan oleh POS Cabang Utama/Sub consolidator ke Shuttle"
    },
    list: {
      searchPlaceholder: "Cari Berdasarkan Id Manifest",
      empty: "Belum ada STO-SC yang dapat ditampilkan",
      printLabel: "Cetak Label",
      printManifest: "Cetak Manifest"
    },
    table: {
      columnNo: "No.",
      manifestId: "Id. Manifest",
      subConsolidatorName: "Nama Sub Consolidator",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Volume",
      stoScDate: "Tanggal STO-SC",
      action: "Action"
    },
    common: {
      unitKg: "kg",
      userFallback: "User"
    },
    process: {
      emptyStiScList: "Belum ada STI-SC yang dapat ditampilkan",
      bulkBannerDataWord: "data",
      bulkBannerMiddle: "akan diperbarui & dicetak label ke status",
      bulkBannerStatusLabel: "STO-SC",
      buttonSubmit: "Proses ke STO-SC",
      errorUpdateFailed: "Gagal Update ke STO-SC!"
    },
    pdf: {
      nameLabel: "Nama",
      dateLabel: "Tanggal",
      originCity: "Kota Asal",
      totalStt: "Total STT",
      sttNo: "No STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalWeight: "Total Berat",
      totalVolumeWeight: "Total Berat Volume",
      stoScDate: "Tanggal STO-SC",
      updatedAt: "Tanggal Update",
      updatedBy: "Diperbarui Oleh",
      summaryTitle: "STO-SC{id}",
      signatoryStationAdmin: "Station Admin",
      signatoryCourier: "Kurir",
      signatoryOpsSupervisor: "Operations Supervisor"
    },
    manifest: {
      featureName: "STO-SC{id}"
    },
    error: {
      printFailed: "Gagal Print!",
      detailFailed: "Gagal Get Detail STO-SC!"
    }
  },
  stiDestSc: {
    router: {
      pageTitle: "Station Transit In Destination Sub Consolidator",
      menuName: "STI DEST-SC",
      updatePageTitle:
        "Update STI DEST-SC | Station Transit In Destination Sub Consolidator",
      updatePageName: "Update STI DEST-SC",
      parentBreadcrumb: "STI DEST-SC"
    },
    list: {
      searchCargoPlaceholder: "Cari No. Kargo",
      last7Days: "7 hari terakhir",
      buttonUpdate: "Update STI DEST-SC",
      emptyEntityNoun: "station transit in destination sub-consolidator",
      emptyMessage:
        "No station transit in destination sub-consolidator data to display",
      print: "Print"
    },
    table: {
      columnNo: "No.",
      arrivalCity: "Kota Kedatangan",
      arrivalCityTooltipTitle: "Kota Kedatangan",
      arrivalCityTooltipBody: "Kota tempat paket tiba",
      totalStt: "Total STT",
      totalPieces: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalVolumeWeight: "Total Berat Volume",
      stiDestScDate: "Tanggal STI-DEST-SC",
      action: "Action"
    },
    common: {
      unitKg: "kg",
      ok: "OK",
      cancel: "Batal",
      yes: "Ya",
      no: "Tidak"
    },
    update: {
      pageTitle: "Update STI DEST-SC",
      subConsolidatorName: "Sub-consolidator name",
      arrivalCity: "Kota Kedatangan",
      arrivalCityTooltipTitle: "Kota Kedatangan",
      arrivalCityTooltipDescription:
        "Kota Kedatangan adalah kota dimana barang/STT tiba ketika diproses pada fitur STI-DEST.",
      stiDestScDateLabel: "Tanggal STI DEST-SC",
      datePlaceholder: "Pilih atau masukan No. seri kendaraan",
      sttNumberLabel: "No. STT",
      sttExampleLabel: "Contoh : ...",
      sttInputPlaceholder: "Masukan No. STT atau Scan Barcode/QR Code",
      overweightCannotUpdate:
        "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke STI Dest-SC",
      badgeMisRoute: "MIS-ROUTE",
      badgeTransit: "Transit",
      badgeStiDestSc: "STI DEST-SC",
      add: "Tambah",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalDimWeight: "Total Berat Dimensi",
      delete: "Hapus",
      process: "Process",
      updateOnly: "Update STI DEST-SC",
      updateAndPrintPdf: "Update STI DEST-SC & Print PDF",
      modalDownload: "Download",
      partialSuccessCount: "{count} No. STT Sukses",
      partialFailCount: "{count} No. STT Gagal",
      leaveTitle: "Yakin ingin keluar?",
      leaveBody:
        "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      leaveConfirm: "Keluar",
      leaveBack: "Kembali",
      confirmCreateTitle: "Konfirmasi Pembuatan",
      confirmCreateBody:
        "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
      confirmProcess: "Process",
      deleteGoodsTitle: "Hapus Barang",
      deleteGoodsBody:
        "Masukan No. STT atau Scan Barcode/QR Code untuk dihapus dari list STI-DEST-SC.",
      deletedSection: "Terhapus",
      sttNotFoundOrRemoved: "No. STT tidak ditemukan/sudah terhapus",
      sttAlreadyEntered: "No. STT sudah di input",
      statusChangeSuccessTitle: "STT status updated",
      statusChangeSuccessBody: "Updated to STI-DEST-SC.",
      addSttFailedTitle: "Add STT failed",
      scanSttFailedTitle: "STT scan failed",
      partialSuccessTitle: "Partial success",
      partialSuccessBody: "Silakan download hasil",
      statusChangeFailedTitle: "Status change failed",
      statusChangeFailedBody: "STI-DEST-SC update failed.",
      table: {
        columnNoBag: "No. Bag",
        columnNoStt: "No. STT",
        columnNoRef: "No. Referensi",
        columnProduct: "Produk",
        columnKomoditas: "Komoditas",
        columnTotalKoli: "Total Koli",
        columnGrossWeight: "Berat Kotor",
        columnDimWeight: "Berat Dimensi",
        columnDestination: "Dest.",
        columnTransit: "Transit",
        columnMisroute: "Misroute"
      },
      errors: {
        addSttFailed: "Tambah No. STT Gagal!",
        updateFailed: "Pembaruan Gagal !"
      }
    },
    pdf: {
      manifestTitle: "STI DEST-SC manifest",
      subConsolidatorName: "Sub-consolidator name",
      arrivalCity: "Kota Kedatangan",
      stiDestScDate: "Tanggal STI DEST-SC",
      totalStt: "Total STT",
      totalKoli: "Total Koli",
      totalGrossWeight: "Total Berat Kotor",
      totalDimWeight: "Total Berat Dimensi",
      colNo: "No.",
      colNoBag: "No. Bag",
      colNoStt: "No. STT",
      colNoRef: "No. Referensi",
      colProduct: "Produk",
      colKomoditas: "Komoditas",
      colTotalKoli: "Total Koli",
      colGrossWeight: "Berat Kotor",
      colDimWeight: "Berat Dimensi",
      colDestination: "Dest.",
      colTransit: "Transit",
      colMisroute: "Misroute",
      colNotes: "Keterangan",
      colOrigin: "Asal",
      signatoryStationAdmin: "Station Admin",
      signatoryCourier: "Kurir",
      signatoryOpsSupervisor: "Supervisor Operasi"
    }
  },
  notFoundPage: {
    title: "Halaman Tidak Ditemukan",
    subtitle:
      "Halaman yang Anda minta tidak ditemukan. Silahkan kembali ke halaman awal atau hubungin kami di",
    button: "Kemballi ke Dasboard"
  },
  authenticator: {
    alert: {
      title: "Verifikasi OTP belum aktif",
      message:
        "Lindungi akun Anda dengan verifikasi OTP untuk menjaga akun tetap aman.",
      buttonText: "Aktifkan sekarang"
    },
    alertChangePassword: {
      title: "Password akan kadaluarsa.",
      titleWithDiff: "Password akan kadaluarsa dalam {day} hari.",
      titleToday: "Password akan kadaluarsa hari ini.",
      message: "Segera perbarui password Anda demi menjaga keamanan akun.",
      buttonText: "Perbarui sekarang"
    },
    profile: {
      title: "Verifikasi kode OTP",
      statusNotActive: "Belum diaktifkan",
      statusActive: "Aktif",
      notEnrolled: `Berikan keamanan tambahan dengan mengaktifkan verifikasi kode OTP via <span class="font-bold">email</span>. Kode OTP akan diminta setiap kali login.`,
      enrolled: `Verifikasi kode OTP akan dikirim via <span class="font-bold">email</span>. Kode OTP akan diminta setiap kali login.`,
      buttonText: "Aktifkan sekarang"
    },
    login: {
      modalTitle: "Aktifkan verifikasi OTP",
      modalMesssage:
        "Berikan keamanan tambahan dengan mengaktfikan verifikasi kode OTP untuk akun Anda.",
      modalButton: "Aktifkan sekarang"
    },
    verifyOtp: {
      title: "Verifikasi kode OTP",
      message: "Masukkan kode OTP yang dikirimkan melalui email ke",
      verification: "Verifikasi",
      resendTime: "Kirim ulang dalam",
      notGetCode: "Belum menerima kode?",
      resend: "Kirim ulang",
      helpWhatsApp: "Butuh bantuan? Hubungi via WhatsApp",
      orEmailTo: "atau email ke"
    }
  },
  layout: {
    firebaseNotification: {
      cancel: {
        success: "<b>No. Kargo {cargoNo}</b> Berhasil dibatalkan",
        failed:
          "<b>No. Kargo {cargoNo}</b> -  Gagal dibatalkan karena <b>{reason}</b>."
      },
      booking: {
        success:
          "<b>No. Kargo {cargoNo}</b> Berhasil Booking kargo ke <b>{destination}</b>",
        failed:
          "<b>No. Kargo {cargoNo}</b> Gagal Booking karena <b>{reason}</b>"
      }
    }
  },
  cargoV2: {
    create: {
      index: {
        title: "Booking CARGO",
        manualBookingBtn: "Booking Manual",
        tab: {
          plane: "Pesawat",
          truck: "Truk",
          ship: "Kapal"
        }
      },
      common: {
        backAlt: "kembali",
        selectSchedule: "Pilih Jadwal",
        selectScheduleLower: "Pilih jadwal",
        booking: "Booking",
        ok: "Ok",
        okUpper: "OK",
        kg: "kg",
        othersMode: "Moda lain"
      },
      nonRtcLayout: {
        title: "Booking manual"
      },
      rtc: {
        error: {
          getDetailRtc: "Gagal mengambil detail RTC",
          bookingFailed: "Booking kargo gagal"
        }
      },
      rtcList: {
        emptyTitle: "Daftar Siap Dikargo",
        notFound: {
          title: "Hasil tidak ditemukan",
          message: "Cek dan atur ulang filter yang Anda cari."
        }
      },
      cargoType: {
        error: {
          getListCargoType: {
            title: "Gagal mengambil data tipe cargo"
          }
        }
      },
      searchFlightHeader: {
        totalKoli: "Total Koli",
        grossVolume: "Gross w./ Volume w.",
        alt: {
          plane: "Pesawat",
          briefcase: "Briefcase",
          box: "Box"
        }
      },
      searchFlight: {
        title: "Pilih jadwal",
        reload: "Muat ulang",
        status: {
          loading: {
            header: "Daftar jadwal pesawat sedang dimuat",
            body: "Kami sedang mencari jadwal yang sesuai untuk Anda."
          },
          server: {
            header: "Terjadi gangguan sistem",
            body: "Silahkan coba beberapa saat lagi"
          },
          internet: {
            header: "Jaringan internet terputus",
            body: "Silahkan periksa jaringan internet Anda"
          },
          filteredEmpty: {
            header: "Hasil tidak ditemukan",
            body: "Cek dan atur ulang filter yang Anda cari."
          },
          empty: {
            header: "Tidak ada jadwal penerbangan yang tersedia",
            body:
              "Ubah tanggal atau filter untuk menemukan jadwal penerbangan lainnya "
          }
        },
        error: {
          networkTitle: "Booking gagal!",
          bookingFailed: "Booking gagal"
        }
      },
      modal: {
        bookingProcessing: {
          title: "Booking kargo {bookingRequestId} <br/> Sedang Diproses",
          message: "Anda akan mendapat notifikasi jika booking kargo berhasil"
        },
        bookingFailed: {
          title: "Booking gagal",
          message:
            "Kargo dengan <b>rute {origin} - {destination}</b> gagal dibooking karena {reason}. Silahkan coba beberapa saat lagi!"
        }
      },
      snackbar: {
        booked:
          "Kargo <b>{cargoNo}</b> tujuan {destination} berhasil dibooking."
      },
      error: {
        failedToCargoBooking: "Failed to Cargo Booking !",
        creationFailed: "Pembuatan Gagal !",
        bookingFailedTitle: "Gagal Booking !"
      }
    },
    components: {
      common: {
        backAlt: "kembali",
        closeAlt: "tutup",
        transportAlt: "transport",
        infoAlt: "info",
        save: "Simpan",
        cancel: "Batal",
        reset: "Reset",
        apply: "Terapkan",
        booking: "Booking",
        all: "Semua",
        process: "Process",
        back: "Kembali",
        completeBookingData: "Lengkapi data booking",
        destinationCity: "Kota tujuan",
        destinationCityTitle: "Kota Tujuan",
        selectDestinationCity: "Pilih kota tujuan",
        transportMode: "Moda",
        selectMode: "Pilih moda",
        dangerousGoods: "Dangerous Goods",
        quarantine: "Karantina",
        kg: "kg",
        kgCapital: "Kg",
        vehicleSerialNumber: "No. Seri kendaraan",
        searchVehicleSerialNumber: "Cari No. Seri kendaraan",
        commodity: "Komoditas",
        selectCommodity: "Pilih komoditas",
        product: "Produk",
        selectCargoProductType: "Pilih tipe produk kargo",
        cargoNumber: "No. Kargo",
        nog: "NOG",
        inputNog: "Masukan NOG",
        nogTooltip: "Isi NOG sesuai komoditas barang dalam kargo.",
        shc: "SHC",
        selectShc: "Pilih shc",
        shcTooltip:
          "SHC akan terisi otomatis berdasarkan komoditas kargo yang dipilih.",
        other: "Lainnya",
        errorGetData: "Gagal mengambil data!",
        plane: "Pesawat",
        truck: "Truk",
        ship: "Kapal",
        train: "Kereta",
        confirmCreationTitle: "Konfirmasi Pembuatan",
        confirmCreationMessage:
          "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
        sttBagCannotUpdateTitle: "Ada STT/Bag tidak dapat update Kargo.",
        sttBagCannotUpdateMessage:
          "Ada STT/bag yang tidak bisa diproses sebagai kargo, silahkan cek kembali.",
        checkData: "Cek Data",
        errorCheckEligible: "Terdapat Error Saat Check Eligible",
        confirmEditCargoTitle: "Konfirmasi Ubah Kargo",
        confirmEditCargoMessage:
          "Pastikan kembali, Anda akan mengubah kargo <b>{cargoNo}</b>.",
        errorEditCargo: "Gagal Update Kargo",
        successEditCargo: "Kargo <b>{cargoNo}</b> berhasil diubah",
        errorGetDetailCargo: "Gagal Mengambil Detail Kargo",
        susccessDeleteDataTitle: "Data Berhasil Dihapus",
        susccessDeleteDataMessage: "No. Kargo {cargoNo} telah dihapus",
        failedGetData: "Gagal mendapatkan data!"
      },
      editLayout: {
        title: "Ubah kargo"
      },
      sectionSelectDestCargoType: {
        error: {
          getCity: "Gagal mengambil data city",
          getCargoType: "Gagal mengambil data tipe cargo"
        }
      },
      cardRtc: {
        minimumPiecesWeight: "Minim koli & berat",
        minimumPieces: "Minim koli",
        minimumWeight: "Minim berat",
        bosspackProduct: "Produk kargo bosspack",
        departurePlusTwoDays: "Keberangkatan +2 hari",
        departurePlusTwoDaysTooltip:
          "Estimasi keberangkatan belum dikonfigurasi untuk 2 hari ke depan. Silahkan pilih jadwal",
        departureStart: "Keberangkatan mulai:",
        totalPieces: "Jumlah Koli",
        totalPiecesTooltip: "Jumlah koli kargo (STT dan bag)",
        grossWeight: "Gross w.",
        grossWeightTooltip: "Jumlah berat kotor kargo (STT dan bag)"
      },
      searchFlightFilter: {
        airport: "Bandara",
        selectAirport: "Pilih bandara",
        originAirport: "Bandara asal",
        destinationAirport: "Bandara tujuan",
        transitCount: "Jumlah transit",
        selectTransitCount: "Pilih jumlah transit",
        sort: "Urutkan",
        sortFrom: "Urutkan dari",
        searchTimeLimit: "Batas waktu pencarian",
        timeLimit: "Batas waktu",
        origin: "asal",
        destination: "tujuan",
        legs: {
          direct: "Langsung",
          oneTransit: "1 transit",
          twoTransit: "2 transit",
          moreThanThreeTransit: ">3 transit"
        },
        sortOption: {
          etaFastest: "ETA tercepat",
          etdFastest: "ETD tercepat"
        },
        threshold: {
          twelveHours: "12 jam dari sekarang",
          twentyFourHours: "24 jam dari sekarang"
        }
      },
      modalDelayConfirmation: {
        title: "Pastikan jadwal yang Anda pilih sudah sesuai",
        transit: "{count} Transit",
        flightRoute: "RUTE PENERBANGAN",
        estimatedDeparture: "ESTIMASI KEBERANGKATAN",
        body:
          'Jadwal penerbangan ini <span class="font-bold">potensi delay</span>, apakah kamu ingin<br />melanjutkan booking?',
        changeSchedule: "Ganti jadwal",
        confirmBooking: "Ya, Booking"
      },
      cardFlight: {
        arrivalDayDiff: "+{count} hari",
        volumeUnavailable: "Volume pesawat tidak mencukupi",
        dimensionUnavailable: "Dimensi pesawat tidak mencukupi",
        capacityUnavailable: "Kapasitas pesawat tidak mencukupi",
        embargoRoute: "Rute Embargo",
        dgNotAllowed: "Tidak bisa kirim barang DG",
        potentialDelay: "Potensi delay",
        onTime: "On-time",
        availableCapacity: "Kapasitas tersedia",
        flyIn: "Terbang dalam",
        flyInValue: "{hours} jam {minutes} menit",
        viewTransitDetail: "Lihat detail transit",
        close: "Tutup",
        direct: "Langsung",
        originCity: "Kota asal",
        destinationCity: "Kota tujuan",
        transit: "Transit {count}",
        capacity: "Kapasitas"
      },
      modalPlaneAuto: {
        commodityGroup: "Komoditas Group (Kargo)",
        productType: "Tipe produk kargo"
      },
      modalBookingTruck: {
        error: {
          getCourierData: "Gagal Mendapat Data Kurir"
        }
      },
      modalBookingShip: {
        inputCargo: "Masukan kargo"
      },
      manualInput: {
        cargoNumberManual: "No. kargo/SMU manual",
        inputCargoNumberManual: "Masukkan No kargo/SMU Manual",
        track: "Lacak",
        cargoNumberTooltip:
          "Nomor SMU diperlukan jika booking dilakukan di sistem eksternal. Nomor SMU berisi kode Airline - nomor unik",
        checkInternet: "Cek kembali internet anda!",
        selectProduct: "Pilih Produk",
        errorGetCourierData: "Gagal Mendapat Data Kurir",
        flightDuration: {
          minutes: "{count} menit",
          hours: "{count} jam",
          hoursMinutes: "{hours} jam {minutes} menit"
        }
      },
      inputVehicleNo: {
        placeholder: "B 1234 XYZ",
        invalidFormat: "Format tidak sesuai"
      },
      photoDispute: {
        infoAlt: "Info",
        title: "WAJIB UPLOAD BUKTI FOTO",
        viewPhoto: "Lihat foto",
        guide: {
          clearPhoto: "Foto jelas dan tidak blur.",
          readableWeightVolume: "Angka berat/volume terbaca jelas.",
          fullCargoFrame: "Seluruh barang terlihat dalam satu frame."
        },
        photoType: {
          weighingAndCargo: "Timbang + Barang",
          additionalPhoto: "Foto tambahan"
        },
        error: {
          upload: "Gagal Upload Foto Dispute",
          delete: "Gagal Hapus Foto Dispute"
        }
      },
      cargoDisputeForm: {
        pieces: "Koli",
        stt: "STT",
        bag: "bag",
        reweighTitle: "Timbang ulang",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w.",
        chargeableWeight: "Chargeable w.",
        grossWeightCargo: "Gross w. kargo",
        maxGrossWeightCargoTooltip:
          "Maksimal Gross w. kargo {cargoType} {maxWeight} kg",
        maxWeight: "Maksimal {maxWeight} kg",
        cargoPieces: "Koli kargo",
        maxCargoPiecesTooltip: "Maksimal koli kargo {cargoType}: {maxPieces}",
        maxPieces: "Maksimal {maxPieces} koli",
        cargoDimension: "Dimensi kargo",
        dimension: "P x L x T",
        editIfDimensionChanged: "Edit jika dimensi berubah",
        cargoVolumeWeight: "Volume w. kargo",
        maxCargoVolumeWeightTooltip:
          "Maksimal Volume w. kargo {cargoType}: {maxWeight} kg",
        calculating: "Sedang dihitung ...",
        cargoChargeableWeight: "Chargeable w. kargo",
        cargoType: {
          plane: "pesawat",
          truck: "truk",
          ship: "kapal"
        },
        error: {
          baggingWeightLocked: "Berat tidak bisa lebih dari timbang ulang",
          baggingWeightLockedTooltip:
            "Berat tidak bisa diubah karena mengikuti hasil bagging.",
          maxCargoChargeableWeightDiff:
            "Selisih CW kargo maks. {maxWeight} kg per STT",
          chargeableWeightDifference: "Selisih CW kargo ≥ 1 kg"
        }
      },
      scanTableList: {
        emptyStateAlt: "Empty State",
        empty: "Belum ada paket yang discan.",
        delete: "Hapus",
        column: {
          no: "No.",
          bagNo: "No. bag",
          chargeableBag: "Chargeable w. bag",
          sttNo: "No. STT",
          chargeableStt: "Chargeable w. STT",
          shippingType: "Jenis pengiriman",
          commodity: "Komoditas",
          destinationCity: "Kota tujuan",
          action: "Atur"
        }
      },
      scanTableSection: {
        inputPlaceholder: "Masukkan shipment/STT/bag",
        invalidSttTitle: "STT tidak valid",
        total: "Total {count}",
        scanProcessFailed: "Gagal memproses scan",
        bagAlreadyExists: "Bag sudah ada di tabel",
        sttAlreadyExists: "STT sudah ada di tabel",
        weightExcess:
          "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Cargo.",
        export: {
          sttNumber: "Nomor STT",
          failedReason: "Alasan Gagal"
        },
        deleteModal: {
          title: "Yakin Hapus data?",
          message: "Data otomatis akan hilang dari daftar tabel.",
          confirm: "Ya, Hapus"
        }
      },
      detailHistory: {
        title: "Riwayat status kargo",
        empty: "Oops.. Belum ada data yang dapat ditampilkan",
        proofOfDelivery: "Lihat bukti pengiriman",
        proofWeightAdjustment: "Lihat bukti foto perubahan berat",
        totalPieces: "Jumlah koli",
        grossWeight: "Gross w.",
        volumeWeight: "Volume w."
      },
      detailInfo: {
        bookingDate: "Tanggal booking",
        lastUpdated: "Terakhir diupdate",
        inProcessBooking: "Dalam proses booking",
        cancelledOrFailedBooking: "Dibatalkan/Gagal booking",
        printStatus: "Status Print",
        weightDispute: "Selisih berat",
        manualCargoNumber: "No. Kargo/SMU manual",
        sttWeight: "Berat STT",
        reweighWeight: "Berat timbang ulang",
        cargoWeight: "Berat kargo",
        grossWeight: "Gross W.",
        volumeWeight: "Volume W.",
        chargeableWeight: "Chargeable W.",
        grossWeightCargo: "Gross W. Kargo",
        cargoPieces: "Koli kargo",
        volumeWeightCargo: "Volume W. Kargo",
        totalSttBag: "Total STT/Bag",
        chargeableWeightCargo: "Chargeable W. Kargo",
        weightDisputeBag: "Bag selisih berat",
        pieces: "koli",
        stt: "STT",
        bag: "bag",
        photoProofAlt: "Bukti foto perubahan berat koli {index}",
        viewMorePhotoProof: "Lihat {count} bukti foto lainnya",
        sttBagList: "Daftar STT/bag",
        emptySttBag: "Tidak ada STT atau bagging di dalam kargo ini",
        disputeBagTooltip: "Bag dengan selisih berat",
        viewProofPhoto: "Lihat foto bukti",
        processedByBagging: "Diproses bagging",
        processedByCargo: "Diproses kargo",
        print: {
          labelCargo: "Label kargo",
          awbLionCargo: "AWB Lion Cargo",
          manifestCargo: "Manifest kargo"
        }
      },
      disputeSummary: {
        withWeightDispute: "dengan selisih berat",
        dataRange: "Data {dateRange}",
        download: "Download",
        minimumWeightPerPiece: "SMU dengan minimum berat per koli",
        error: {
          downloadSummary: "Gagal mendownload data dispute summary!",
          downloadMinimumWeight: "Gagal mendownload data minimum weight!"
        }
      },
      filterSection: {
        searchPlaceholder: "No.kargo/SMU",
        destinationAirportCode: "Kode bandara tujuan",
        hubLocation: "Lokasi HUB",
        filter: "Filter",
        selectDate: "Pilih tanggal"
      },
      downloadList: {
        title: "Buat daftar kargo",
        startBookingDate: "Tanggal mulai booking",
        inputStartDate: "Masukan tanggal mulai",
        endBookingDate: "Tanggal sampai booking",
        inputEndDate: "Masukan tanggal selesai",
        hubLocation: "Lokasi Hub",
        selectHubLocation: "Pilih lokasi hub",
        bookingUser: "User pembooking",
        selectBookingUser: "Pilih user pembooking",
        downloadFailed: "Download Gagal !"
      },
      searchFlightDatePicker: {
        selectOtherDate: "Pilih tanggal lain"
      },
      buttonLoadMore: {
        label: "Lihat lebih banyak"
      },
      filterRtc: {
        client: "Klien",
        selectDestinationCity: "Pilih kota tujuan",
        searchDestinationCityHere: "Cari kota tujuan disini",
        notFound: "Apa yang Anda cari tidak ditemukan atau tidak ada.",
        selectClient: "Pilih klien",
        searchClientHere: "Cari klien disini",
        selectMinimumLimit: "Pilih batas minimum",
        minimumWeight: "Minimum berat",
        minimumPieces: "Minimum koli",
        minimumWeightAndPieces: "Minimum berat & koli",
        destinationCitiesSelected: "kota tujuan dipilih",
        clientsSelected: "klien dipilih",
        cotNearest: "COT terdekat",
        cotLongest: "COT terlama"
      },
      booking: "Booking",
      modalErrorRowEmpty: "Ada baris yang kosong!",
      modalErrorDataExceed: "Data booking melebihi batas!",
      modalErrorHeaderInvalid: "Header berkas tidak valid!",
      modalErrorRowEmptyAlt: "Ada baris yang kosong!",
      modalErrorQueueFull: "Antrian bulk booking penuh",
      modalErrorFileSize: "Ukuran file bulk booking melebihi {size} MB",
      modalErrorSystem: "Terjadi kendala sistem",
      modalSubtitleRowEmpty: "Cek berkas, lengkapi semua baris & upload ulang.",
      modalSubtitleDataExceed:
        "Data maksimal {maxStt} baris. Silahkan hapus beberapa data yang diupload.",
      modalSubtitleHeaderInvalid:
        "Cek berkas & upload ulang sesuai format template",
      modalSubtitleRowEmptyAlt:
        "Cek berkas, lengkapi semua baris & upload ulang.",
      modalSubtitleQueueFull: "Tunggu beberapa saat dan coba lagi.",
      modalSubtitleFileSize: "Ubah file dan upload ulang file Anda.",
      modalSubtitleSystem: 'Klik "Muat ulang" atau tunggu beberapa saat lagi.',
      btnUploadAgain: "Upload ulang",
      btnReload: "Muat ulang",
      btnUnderstand: "Ok, mengerti",
      btnBack: "Kembali",
      uploadFileCaption:
        "Format .xlsx. Maksimum {maxStt} STT dan file {maxMb} MB.<br/>Hanya 500 data row pertama yang akan diproses.",
      uploadFileErrorFormat: "Format berkas tidak sesuai",
      searchPlaceholder: "Cari Upload ID/Nama Aktivitas",
      selectPlaceholder: "Pilih client/partner/Internal",
      clientNameTitle: "Nama Client / Partner",
      clientNamePlaceholder: "Cari client / partner",
      templatePlaceholder: "Pilih template format",
      attachment: "Berkas Lampiran",
      hintSection1:
        "Pastikan seluruh data yang Anda masukan telah benar dan sesuai",
      hintSection2:
        "dengan berkas yang akan diupload. Pelajari cara mengisi template",
      hintSection3: "disini",
      errorClient: "Partner atau Client Sedang Tidak Aktif",
      successBookingTitle: "Upload Berkas Berhasil",
      successBookingMessage: "Data pada berkas pengiriman berhasil terbooking",
      errorPartial:
        "Beberapa data pengiriman berhasil terbooking menjadi STT, namun terdapat kegagalan pada beberapa data. Silahkan download untuk mengatahui kesalahan.",
      failedBookingTitle: "Upload Berkas Gagal",
      failedBookingMessage: "Data pada berkas pengiriman gagal terbooking"
    },
    common: {
      retailInternational: "Internasional Retail",
      clientInternational: "Internasional Klien",
      retailDomestic: "Domestik Retail",
      clientDomestic: "Domestik Klien",
      bookingInternational: "Booking internasional",
      bookingDomestic: "Booking domestik",
      commodityData: "Data komoditas",
      districtData: "Data kecamatan"
    }
  },
  pickupV2: {
    list: {
      title: "Daftar Pickup",
      createConfig: "Atur jadwal Pick Up",
      wood: "KAYU",
      piece: "koli",
      additional: "Tambahan",
      table: {
        orderId: "Order ID",
        status: "Status",
        totalRequest: "Total request",
        totalRequestTooltip: "Jumlah koli yang direquest untuk di Pick Up.",
        totalPickup: "Total Dipickup",
        totalPickupTooltip:
          "Jumlah STT dan koli yang sudah di Pick Up oleh kurir.",
        agentHubProcessed: "Diproses Agen/Hub",
        agentHubProcessedTooltip:
          "Jumlah STT dan koli yang diproses oleh Agen/Hub.",
        createdAt: "Tanggal dibuat"
      },
      emptyTitle: "Belum ada daftar Pick Up",
      emptyMessage: "Semua daftar Pick Up akan muncul di halaman ini.",
      notFoundTitle: "Hasil tidak ditemukan",
      notFoundMessage: "Cek ulang kata kunci atau gunakan kata kunci lainnya.",
      summary: {
        pickUp: "Pick Up",
        waitingCourier: "Menunggu Kurir",
        pickUpPackage: "Paket di Pick Up",
        pickUpCompleted: "Pick Up selesai",
        processedAgentHub: "Diproses Agen/Hub"
      },
      filter: {
        searchPlaceholder: "Cari Order ID",
        pickupSchedule: "Jadwal Pick Up",
        vehicleType: "Tipe Armada",
        vehicleTypePlaceholder: "Pilih tipe armada",
        serviceType: "Jenis Pengiriman",
        status: "Status",
        statusPlaceholder: "Pilih status",
        statusList: {
          searchingCourier: "Mencari Kurir",
          courierAssigned: "Kurir Ditugaskan",
          packagePickedUp: "Paket di Pick Up",
          completed: "Selesai",
          cancelledByCourier: "Dibatalkan Kurir",
          cancelledByClient: "Dibatalkan Klien",
          cancelledByAdmin: "Dibatalkan Admin",
          packageMerged: "Pick Up Digabung"
        }
      }
    },
    modalSttPickupList: {
      title: "Daftar STT yang dapat di Pick Up ({bkdCount})",
      titleAwb: "Daftar Airway Bill yang dapat di Pick Up ({bkdCount})",
      searchPlaceholder: "Cari STT",
      empty: {
        title: "Belum ada STT siap pickup",
        message: "Tidak ada STT yang dapat ditampilkan."
      },
      notFound: {
        title: "Hasil tidak ditemukan",
        message: "Cek ulang kata kunci atau gunakan kata kunci lainnya."
      },
      copyStt: "Salin nomor STT",
      copiedStt: "Nomor STT tersalin ke clipboard",
      column: {
        sttNo: "No. STT",
        awbAndShipment: "No. AWB/Shipment",
        shipmentNo: "No. shipment",
        lastStatus: "Status terakhir",
        destinationCity: "Kota tujuan",
        productType: "Jenis pengiriman",
        chargeableWeight: "Berat dikenakan biaya",
        createdAt: "Tanggal booking",
        bookedFor: "Dibooking untuk"
      }
    },
    detailSidebar: {
      statusPickUp: "Status Pick Up",
      createdAt: "Tanggal dibuat",
      by: "Oleh {name}",
      courierInfo: "Informasi kurir",
      courierNotAssigned: "Kurir belum ditugaskan",
      proofPhotos: "Bukti foto",
      courierName: "Nama kurir",
      revealPhone: "Tampilkan nomor",
      sidebar: {
        merge: {
          infoMessage:
            "Shipment ini gabungan dari <strong>{shipmentCount}</strong> dengan total koli & berat yang dihitung keseluruhannya.",
          shipmentUnit: "shipment",
          viewLink: "Lihat shipment",
          listTitle: "Daftar shipment tergabung",
          listItem: "{shipmentId} ({koliCount} koli - {weightKg} kg)",
          close: "Tutup"
        }
      }
    },
    detail: {
      pageTitle: "Daftar Pick Up | Detail",
      requestInfo: {
        sectionTitle: "Detail Request Pick Up",
        warehousePrefix: "Warehouse",
        coordinateLabel: "Titik koordinat: {coordinate}",
        courierNoteLabel: "Catatan untuk kurir",
        courierNoteEmpty: "-"
      }
    }
  },
  bookingV4: {
    breadcrumb: {
      retailBooking: "Retail Booking"
    },
    pageTitle: "Booking Baru",
    pageTitleEdit: "Ubah Booking",
    bookingHistory: "Riwayat Booking",
    bookingHistorySuccessTitle: "Riwayat Berhasil Booking ({counter})",
    reset: "Reset",
    cancelVoucher: "Batalkan Voucher",
    reserveVoucher: "Simpan Voucher",
    header: {
      bookingHistory: {
        button: "Cetak Tagihan & Resi"
      },
      receiptFormat: {
        a4: "Resi A4",
        a6: "Resi A6",
        none: "Tanpa Print Resi",
        title: "Format Resi"
      },
      tabs: {
        domestic: "Domestik",
        international: "Internasional"
      }
    },
    detailSender: "Pengirim",
    detailRecipient: "Penerima",
    country: "Negara",
    name: "Nama",
    phoneNumber: "No. Handphone",
    edit: "Ubah",
    address: "Alamat",
    districtCity: "Kecamatan, Kota",
    postalCode: "Kode Pos",
    office: "Kantor",
    autofill: "Salin & isi otomatis detail penerima",
    paste: "Tempel",
    valid: "Valid",
    sender: {
      title: "Pengirim",
      country: {
        label: "Negara asal",
        placeholder: "Pilih negara asal",
        error: {
          required: "Negara asal wajib diisi",
          notFound: "Negara tidak ditemukan"
        }
      },
      name: {
        placeholder: "Nama pengirim",
        error: {
          required: "Nama harus diisi.",
          minLength: "Min. 3 karakter.",
          notFound: "Data pelanggan tidak ditemukan"
        }
      },
      phone: {
        placeholder: "Masukkan nomor handphone",
        error: {
          required: "Nomor HP harus diisi.",
          invalid: "Nomor tidak valid.",
          notFound: "Data pelanggan tidak ditemukan",
          fraud: {
            limited1: "Nomor telah melebihi",
            limited2: "limit transaksi",
            limited3: "COD/DFOD per hari.",
            limitedTooltip:
              "Setiap nomor HP dibatasi maks. transaksi COD/DFOD hanya 10 STT (tidak termasuk CNX) atau total ongkir Rp300.000.",
            suspected: "Nomor memiliki tingkat retur COD/DFOD yang tinggi.",
            tresholdProtection:
              "Pengiriman mendapatkan perlindungan gratis hingga"
          }
        }
      },
      address: {
        placeholder: "Alamat lengkap pengirim",
        error: {
          required: "Alamat harus diisi.",
          minLength: "Min. 3 karakter.",
          sameAddress: "Alamat pengirim & penerima harus berbeda."
        }
      }
    },
    recipient: {
      title: "Penerima",
      country: {
        label: "Negara tujuan",
        placeholder: "Pilih negara tujuan",
        error: {
          required: "Negara tujuan harus dipilih.",
          notFound: "Negara tidak ditemukan"
        }
      },
      name: {
        placeholder: "Nama penerima",
        error: {
          required: "Nama harus diisi.",
          minLength: "Min. 3 karakter.",
          notFound: "Data pelanggan tidak ditemukan"
        }
      },
      phone: {
        placeholder: "Masukkan nomor handphone",
        error: {
          required: "Nomor HP harus diisi.",
          invalid: "Nomor tidak valid.",
          notFound: "Data pelanggan tidak ditemukan"
        }
      },
      address: {
        placeholder: "Alamat lengkap penerima",
        error: {
          required: "Alamat harus diisi.",
          minLength: "Min. 3 karakter.",
          sameAddress: "Alamat pengirim & penerima harus berbeda."
        }
      },
      city: {
        label: "Kecamatan, Kota",
        labelInternational: "Kota, Wilayah",
        placeholder: "Pilih kecamatan, kota",
        placeholderInternational: "Pilih wilayah, kota",
        error: {
          required: "Kecamatan, kota harus dipilih.",
          requiredInternational: "Wilayah, kota harus dipilih.",
          notFound: "Hasil tidak ditemukan. Cek & coba lagi",
          routeNotAvailable: "Rute ke tujuan ini belum tersedia."
        },
        misbookingGuidance:
          "Tujuan ini rawan salah kirim. Pastikan pilihan sesuai alamat penerima."
      },
      postalCode: {
        placeholder: "Pilih kode",
        error: {
          required: "Harus dipilih.",
          notFound: "Kode pos tidak ditemukan"
        }
      },
      autofill: {
        processing: "Memproses data...",
        unsupportedFormat:
          "Format yang disalin tidak didukung. Salin teks, lalu coba lagi.",
        emptyClipboard:
          "Tidak ada data yang disalin. Salin data penerima terlebih dahulu.",
        processingError: "Gagal memproses data. Coba lagi.",
        success: "Berhasil mengisi data penerima"
      }
    },
    optional: "Opsional",
    additionalPhoto: "Foto Pendukung",
    beforeAfterPackingPhoto: "Foto sebelum & sesudah paket packing",
    packageBeforePacking: "Paket sebelum packing",
    packageAfterPacking: "Paket sesudah packing",
    recipientIdNumber: "Nomor ID penerima",
    recipientIdPhoto: "Foto ID Penerima",
    recipientTaxIdNumber: "Nomor tax ID penerima",
    recipientTaxIdPhoto: "Foto Tax ID Penerima",
    doc: {
      title: "Dokumen Pendukung Pengiriman Luar Negeri",
      titleFTZ: "Dokumen Pendukung free trade zone",
      subtitle: "Dokumen Pendukung",
      guide: {
        title: "Panduan dokumen pendukung",
        expand: "Buka",
        collapse: "Tutup",
        content: `<ul class="custom-list">
          <li>Gunakan format <span class="font-bold">JPG, JPEG, PNG, atau PDF</span> (maks. 5 MB/file).</li>
          <li>Pastikan <span class="font-bold">merek barang</span> terlihat jelas pada foto sebelum dipacking.</li>
          <li>Pastikan hasil foto terlihat <span class="font-bold">jelas dan lengkap</span> untuk mempercepat proses verifikasi.</li>
          <li>Anda dapat menambahkan hingga <span class="font-bold">5 dokumen pendukung lain</span> (Contoh: izin impor, surat edaran, dll.). Cek detail <a target="_blank" rel="noopener noreferrer" class="underline font-bold" href="https://lionparcel.com/sk">s&k</a></li>
        </ul>`
      },
      email: {
        label: "Email Penerima",
        placeholder: "Masukkan email penerima",
        errorRequired: "Email penerima harus diisi.",
        errorInvalid: "Email tidak valid"
      },
      idNumber: {
        label: "No. Identitas Penerima",
        placeholder: "Masukkan ID penerima",
        errorRequired: "ID penerima harus diisi.",
        errorInvalid: "Nomor identitas hanya boleh berisi huruf dan angka"
      },
      taxNumber: {
        label: "TAX ID Penerima",
        placeholder: "Masukkan TAX ID",
        errorRequired: "TAX ID harus diisi.",
        errorInvalid:
          "Nomor registrasi pajak hanya boleh berisi huruf dan angka",
        errorMin: "Nomor registrasi pajak minimal 15 karakter",
      },
      dutyTaxTerms: {
        label: "Pembayaran Bea Cukai & Pajak",
        dap: "Ditanggung penerima (DAP)",
        ddp: "Ditanggung pengirim (DDP)",
        placeholder: "Pilih penanggung biaya",
        infoCopy: `<ul class="custom-list">
          <li><span class="font-bold">Delivered Duty Paid (DDP):</span> Pengirim akan menanggung seluruh biaya bea cukai & pajak.</li>
          <li><span class="font-bold">Delivery At Place (DAP):</span> Penerima akan menanggung seluruh biaya bea cukai & pajak saat paket sampai di tujuan.</li>
        </ul>`,
        dutyTaxTermsBannerPrefix:
          "Jika terdapat biaya Bea Cukai & Pajak, maka biaya tersebut akan dibebankan ke",
        shipper: "Pengirim",
        recipient: "Penerima",
        errorRequired: "Penanggung biaya wajib dipilih"
      },
      upload: {
        idCard: "Kartu identitas",
        taxCard: "Kartu registrasi pajak",
        beforePacking: "Paket sebelum packing",
        afterPacking: "Paket sesudah packing",
        additional: "Tambah Dokumen Pendukung Lain",
        additionalDocument: "Dokumen <br>tambahan",
        limitMessage: "Maksimal 5 file tambahan (JPG/JPEG/PNG/PDF, maks 5 MB)",
        errorRequired: "Harus diisi.",
        uploadFailed: "Dokumen gagal diunggah. Silakan coba lagi.",
        error:
          "Format file tidak sesuai atau melebihi 5 MB. Gunakan JPG, JPEG, PNG, atau PDF."
      }
    },
    referenceNumber: {
      title: "No. Referensi",
      placeholder: "Masukkan nomor referensi",
      helperText:
        "Masukkan ID Eksternal/STT Manual/Shipment ID agar pesanan dapat dilacak dengan nomor tersebut.",
      maxLimit: "Maks. {max} nomor referensi dapat ditambahkan.",
      duplicateType: "ID Eksternal/STT Manual/Shipment ID sudah ditambahkan.",
      type: {
        sttManual: "STT Manual",
        shipmentId: "Shipment ID",
        externalRef: "Referensi Eksternal"
      },
      error: {
        externalRequired: "No. referensi wajib diisi",
        minimumRef: "Min. 3 karakter",
        selectClientFirst:
          "Pilih Klien terlebih dahulu sebelum memasukkan STT Manual"
      },
      eksternalRefCanBeUsed: "Nomor referensi eksternal bisa digunakan."
    },
    reference: {
      error: {
        required: "Harus diisi"
      }
    },
    goods: {
      title: "Barang & Koli",
      button: {
        reset: "Reset"
      },
      itemDetails: {
        title: "Detail Barang"
      },
      cipl: {
        title: "Detail Barang (CIPL)",
        itemName: "Nama Barang",
        quantity: "Jumlah",
        unitPrice: "Harga Barang Satuan",
        totalPrice: "Total Harga",
        footerTotal: "Total Harga Barang",
        footerEstimated: "(Est. {currency} {amount})",
        addRow: "Tambah",
        deleteRow: "Hapus",
        otherCommodity: "Lainnya",
        placeholder: {
          itemName: "Pilih barang",
          quantity: "Masukkan Jumlah",
          unitPrice: "Masukkan Harga Barang Satuan"
        },
        senderInfo: "Informasikan ke pengirim:",
        deminimisWarning:
          "Pengiriman dikenakan bea masuk & pajak karena melebihi batas {currency}{amount}.",
        importDocWarning:
          "Pengiriman diperlukan dokumen izin edar resmi seperti BPOM, NPRA atau yang setara di negara tujuan.",
        selfClearanceWarning:
          "Penerima wajib mengurus proses bea cukai dan dokumen impor di negara tujuan.",
        error: {
          itemDetailMandatory: "Nama barang harus diisi",
          quantityMandatory: "Harus diisi",
          goodsPriceMandatory: "Harga harus diisi"
        }
      },
      commodity: {
        title: "Komoditas",
        placeholder: "Pilih komoditas",
        viewAll: "Lihat Semua",
        notFound: "Komoditas tidak ditemukan",
        note: "Catatan",
        tnc: "Syarat & Ketentuan",
        tncBody: "Isi komoditas sesuai syarat & ketentuan.",
        recommendationError: "Gagal memuat rekomendasi",
        errorRequired: "Komoditas harus dipilih",
        errorInactive: "Komoditas tidak aktif",
        modal: {
          searchResult: "Hasil Pencarian",
          searchPlaceholder: "Masukkan atau pilih komoditas",
          mostUsed: "Paling Sering Digunakan",
          emptySearch: "Hasil tidak ditemukan",
          emptySearchDescription: "Cek & coba kata kunci lain",
          emptyCategory: "Masukkan kata kunci atau pilih kategori",
          reload: "Muat ulang"
        }
      },
      koli: {
        title: "Berat Koli",
        grossWeight: "Berat kotor",
        dimensions: "Dimensi (P x L x T)",
        length: "P",
        width: "L",
        height: "T",
        volumeWeight: "Berat dimensi",
        button: {
          add: "Tambah",
          delete: "Hapus"
        },
        alert: {
          hws:
            "Berat diatas {minimumWeightKg} kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi."
        },
        error: {
          hwsSecondRow:
            "Berat diatas {minimumWeightKg} kg hanya diperbolehkan 1 koli.",
          maximumWeight:
            "Total berat barang melebihi batas maksimum {maxKg} kg/STT.",
          districtOnePiece: "Kecamatan, kota tujuan hanya 1 koli.",
          emptyGrossWeight: "Harus diisi.",
          emptyVolumeWeight: "Dimensi paket wajib diisi",
          adjustWeight: "Perubahan penurunan berat tidak diizinkan"
        },
        infobarWeightComma: "Berat < 1 kg gunakan (,). Contoh: 0,5 kg.",
        tooltip: {
          title: "Berat dimensi dihitung :",
          line1:
            "Jenis pengiriman <strong>BOSSPACK, REGPACK, MINIPACK, BIGPACKFAST</strong> dihitung dengan (Panjang x lebar x tinggi)/Rp6.000",
          line2:
            "Jenis pengiriman <strong>INTERPACK</strong> dihitung dengan (Panjang x lebar x tinggi)/Rp5.000",
          line3:
            "Jenis pengiriman <strong>JAGOPACK, BIGPACK</strong> dihitung dengan (Panjang x lebar x tinggi)/Rp4.000"
        }
      },
      uploadWeight: {
        title: "Wajib upload bukti foto barang untuk ubah berat",
        showGuide: "Lihat panduan",
        closeGuide: "Tutup panduan",
        sampleBadge: "CONTOH FOTO",
        addPhoto: "Tambah Foto",
        guideScalePhoto: "Foto timbangan",
        guidePackageIdentityPhoto: "Foto barang <br> dengan identitas",
        additionalPhoto: "Foto tambahan",
        guides: {
          resolutionBold: "Resolusi foto",
          resolutionText: "jelas dan tidak buram.",
          scaleBold: "Timbangan",
          scaleOrText: "atau",
          volumeBold: "pengukuran volume",
          volumeText: "terlihat jelas.",
          labelSttBold: "Label STT, shipment,",
          labelSttText: "atau label lainnya dapat dibaca.",
          wholePackageBold: "Seluruh paket",
          wholePackageText: "terlihat utuh dalam satu foto."
        },
        error:
          "Harap upload minimal 2 foto bukti penimbangan untuk mengubah berat STT ini."
      },
      savedPackage: {
        commodity: "Komoditas",
        totalPieces: "Total koli",
        grossWeight: "Berat kotor",
        checkbox: {
          label: "Simpan (Maks. 3 data barang & koli tersimpan. Data baru akan menggantikan data lama jika melebihi batas)."
        },
        tooltip: {
          title: "Detail",
          dimensionHeader: "Dimensi (P x L x T)",
          weightHeader: "Berat kotor",
          dimensionValue: "{length} x {width} x {height} cm",
          weightValue: "{weight} kg",
          totalWeight: "Total Berat Kotor"
        }
      }
    },
    supportingDoc: {
      error: {
        required: "Dokumen pendukung wajib diisi"
      }
    },
    cashback: "Cashback",
    shippingEstimation: "Estimasi Pengiriman",
    shippingProduct: "Produk Pengiriman",
    agentDiscount: "Diskon Agen",
    product: {
      discount: "Diskon",
      price: "Harga",
      sla: "{sla} hari",
      starTooltip: "Direkomendasikan",
      title: "Jenis Pengiriman",
      infoPrice: "Harga belum termasuk",
      otherPrice: "biaya lainnya",
      infoTariff: ", cek total tarif di ringkasan!",
      tooltip: {
        title: "Biaya lainnya (jika ada):",
        priceMsg: `<ul class="px-2 py-4">
        <li>• Biaya tambahan komoditas</li>
        <li>• Biaya tambahan berat</li>
        <li>• Biaya tambahan dokumen</li>
        <li>• Biaya packing kayu</li>
        <li>• Biaya proteksi</li>
        <li>• Biaya admin proteksi</li>
        <li>• Biaya COD</li>
        </ul>`
      },
      infobar:
        "Harga belum termasuk biaya lainnya, cek total tarif di ringkasan!",
      otherFeesDetail:
        "Biaya lainnya (jika ada): Biaya tambahan komoditas, Biaya tambahan berat, Biaya tambahan dokumen, Biaya packing kayu, Biaya proteksi, Biaya admin proteksi, Biaya COD",
      unavailable: "Belum tersedia",
      embargo: "Embargo",
      discountAgent: "Diskon",
      discountAgentToggle: "Diskon Agen",
      discountAgentPercent: "Diskon {percent}%",
      minWeightNote: "*Harga berlaku min. 10 kg",
      sectionSubtitle:
        "Total ongkir akan menyesuaikan layanan tambahan yang dipilih.",
      error: {
        title: "Terjadi kendala sistem",
        subtitle: 'Klik "Muat Ulang" untuk memperbarui halaman.',
        retry: "Muat ulang"
      }
    },
    // GENESIS-19573 detailing's localization table lists a flat "bookingV4.vippack"
    // string alongside nested "bookingV4.vippack.badge/.discountBadge/.termsLink",
    // which can't coexist as one JS key. Nested as "label" instead — use
    // $t("bookingV4.vippack.label"), not $t("bookingV4.vippack").
    vippack: {
      label: "VIPPACK",
      badge: "VIPPACK Aktif",
      discountBadge: "Diskon Agen {discount}%",
      termsLink: "Syarat & Ketentuan"
    },
    formCompletion: {
      title: "Status pengisian",
      sender: "Pengirim",
      recipient: "Penerima",
      referenceNumber: "No. Referensi",
      product: "Jenis Pengiriman",
      doc: "Dokumen Pendukung",
      goods: "Barang & koli",
      status: {
        complete: "Selesai",
        incomplete: "Belum Lengkap"
      },
      field: {
        required: "Wajib",
        optional: "Opsional"
      },
      email: "Email",
      idNumber: "No. Identitas",
      taxNumber: "TAX ID",
      upload: {
        idCard: "Foto Kartu Identitas",
        taxCard: "Foto NPWP",
        beforePacking: "Foto Sebelum Packing",
        afterPacking: "Foto Sesudah Packing",
        packing: "Foto paket"
      }
    },
    otpCode: "Kode OTP",
    sendOtp: "Kirim OTP",
    verify: "Verifikasi",
    voucher: {
      apply: "Pakai",
      sectionTitle: "Voucher",
      seeMore: "Lebih banyak",
      inputTitle: "Kode Voucher",
      placeholder: "Masukkan kode voucher",
      bannerOtp: "Voucher ini perlu verifikasi OTP.",
      tnc: "s&k",
      modalTitle: "Voucher",
      clearCode: "Hapus kode voucher",
      close: "Tutup",
      loading: "Memuat voucher...",
      emptyTitle: "Belum ada voucher tersedia",
      emptyDescription: "Voucher akan muncul di sini",
      completeRequired: "Lengkapi data booking untuk melihat voucher",
      appliedSuccess: "Voucher berhasil dipakai.",
      card: {
        percentage: "Diskon {value}% Hingga {max}",
        nominal: "Diskon {amount}",
        description: "Min. transaksi {minimum} s.d {endDate}",
        thousand: "{value}rb",
        million: "{value}jt"
      },
      terms: {
        title: "Syarat & ketentuan:",
        minimum: "Minimal transaksi {amount}.",
        productTypes: "Berlaku untuk jenis pengiriman {types}.",
        serviceTypes: "Berlaku untuk layanan pengiriman {types}.",
        usageLimit:
          "Voucher hanya dapat digunakan maksimal {count} kali per pelanggan.",
        validUntil: "Voucher berlaku sampai {date}.",
        percentageDiscount:
          "Nikmati diskon {value}% dengan maksimal diskon {maximum}.",
        nominalDiscount: "Nikmati diskon {amount}."
      },
      otp: {
        title: "Masukkan kode OTP",
        description:
          "Silakan cek kode OTP yang telah dikirim via SMS ke nomor pengirim.",
        resend: "Kirim Ulang OTP",
        resendCountdown: "Kirim ulang kode OTP dalam {countdown}",
        notReceived: "Belum menerima kode?",
        continueWithoutVoucher: "Lanjutkan tanpa voucher",
        error: {
          invalid: "Kode OTP tidak valid. Silakan coba lagi."
        }
      },
      error: {
        minTransaction: "Minimal transaksi {amount}",
        invalid: "Voucher tidak tersedia.",
        expired: "Kode voucher sudah kadaluarsa",
        quotaExhausted: "Kuota voucher habis"
      }
    },
    payment: {
      title: "Pilih pembayaran",
      cash: "Tunai",
      cod: "COD",
      dfod: "DFOD",
      invoiceLimit: "Limit Tagihan",
      tooltip: {
        cod: `<h3 class="font-bold">Cash On Delivery</h3>
        <ul class="custom-list">
          <li><span class="font-bold">Pengirim</span> tidak perlu membayar ongkir.</li>
          <li>Pengiriman sudah termasuk proteksi.</li>
          <li>Harga barang COD minimal Rp10.000 - Rp5.000.000. Jika paket sudah sampai, <span class="font-bold">pengirim</span> dikenakan biaya COD minimal Rp4.000 atau 4% (Mana yang lebih besar) dari total (harga barang + ongkir). Jika terjadi retur, <span class="font-bold">pengirim</span> membayar 50% dari total biaya ongkir.</li>
          <li><span class="font-bold">Pengirim</span> akan menerima penghasilan COD di saldo aplikasi Lion Parcel.</li>
          <li>Jika paket sudah sampai, <span class="font-bold">penerima</span> hanya membayar ongkir dan harga barang.</li>
          <li><span class="font-bold">POS booking</span> mendapatkan diskon Agen sesuai persentase komisi yang berlaku apabila paket diterima; jika pengiriman gagal, tidak akan dapat diskon.</li>
        </ul>`,
        dfod: `<h3 class="font-bold">Delivery Fee On Delivery</h3>
        <ul class="custom-list">
          <li><span class="font-bold">Pengirim</span> tidak perlu membayar ongkir.</li>
          <li>Pengiriman belum termasuk proteksi.</li>
          <li>Jika paket sudah sampai, <span class="font-bold">penerima</span> hanya membayar ongkir, dengan tambahan biaya DFOD minimal Rp1.000 atau 3% (Mana yang besar) dari total biaya ongkir. Jika terjadi retur, <span class="font-bold">pengirim</span> membayar 50% dari total biaya ongkir.</li>
          <li><span class="font-bold">Pengirim</span> akan menerima penghasilan COD di saldo aplikasi Lion Parcel.</li>
          <li><span class="font-bold">POS booking</span> mendapatkan diskon Agen sebesar 1% apabila paket diterima. Jika pengiriman gagal, tidak akan dapat diskon.</li>
        </ul>`
      },
      disable: {
        destination: "Kota tujuan belum bisa COD/DFOD.",
        partner: "Mitra belum bisa COD/DFOD.",
        client: "Mitra belum bisa COD/DFOD.",
        dailyLimit: "Pengirim limit transaksi COD/DFOD",
        blacklist: "Pengirim tidak bisa COD/DFOD",
        generic: "Pengirim tidak bisa COD/DFOD",
        invoiceLimitFrozen: "Limit Tagihan tidak tersedia sementara.",
        phoneNumberBlacklist: "Tidak bisa COD/DFOD, hubungi CS LP.",
        phoneNumberLimit: "Melebihi limit transaksi COD/DFOD.",
        productType: "Jenis pengiriman belum bisa COD/DFOD."
      },
      warning: {
        suspected: "Nomor ini memiliki tingkat retur COD/DFOD yang tinggi"
      }
    },
    protection: {
      checkbox: "Proteksi",
      alreadyProtected: "Pengiriman sudah terproteksi",
      agentDiscount: "Diskon Agen",
      tooltip: "Biaya proteksi: Tier 1: ...",
      itemPrice: {
        title: "Harga barang",
        placeholder: "Masukkan harga barang",
        error: "Harga barang wajib diisi",
        errorMax: "Harga barang maksimal {value}",
        errorMin: "Harga barang minimal {value}"
      },
      codAmount: {
        title: "Total tagihan COD",
        placeholder: "Masukkan tagihan COD",
        footerEstimated: "Est. {currency}{amount}",
        tooltipDescription:
          "Jika tidak diisi, tagihan COD akan mengikuti harga barang."
      }
    },
    chargeableWeight: {
      title: "Detail berat barang",
      grossWeight: "Total berat kotor",
      volumeWeight: "Total berat volume",
      woodpacking: "Tambahan berat packing kayu",
      final: "Berat final (CW)"
    },
    totalKoli: {
      format: "({n} koli)"
    },
    // GENESIS-20108 TotalTarifSectionV4 + dropdown rincian tarif
    footer: {
      save: "Simpan perubahan",
      bookingAction: "Booking",
      totalTariff: "Total tarif",
      recipientPayable: "Biaya yang harus dibayar penerima",
      detailTitle: "Detail pembayaran",
      empty: "Tarif belum tersedia",
      publishShippingRate: "Publish rate + shipping surcharge",
      originForwardRate: "Origin forward rate",
      destinationForwardRate: "Destination forward rate",
      shippingCost: "Biaya pengiriman",
      commoditySurcharge: "Biaya tambahan komoditas",
      heavyweightSurcharge: "Biaya tambahan berat",
      documentSurcharge: "Biaya tambahan dokumen",
      totalAdditionalSurcharge: "Total biaya tambahan",
      protection: "Proteksi",
      protectionBasic: "Basic",
      protectionFree: "Gratis",
      woodpacking: "Packing Kayu",
      woodpackingIncluded: "Termasuk biaya tambahan packing kayu",
      insuranceAdminFee: "Biaya admin asuransi",
      codGoodsPrice: "Harga barang COD",
      codFee: "Biaya COD",
      codReturnFee: "Biaya retur",
      dfodShippingCod: "Biaya COD Ongkir",
      taxEstimation: "Estimasi pajak",
      totalAfterVoucher: "Total tarif setelah voucher",
      discountLabel: "Diskon {value}",
      promoBadge: "Promo {value}%",
      promo: {
        tactical: "Tactical promo",
        campaign: "Campaign promo"
      },
      voucher: "Voucher promo",
      refresh: "Refresh",
      error: "Gagal memuat tarif"
    },
    completeForm: "Harap lengkapi semua data",
    validationError: "Validasi Formulir Gagal",
    error: {
      limitTagihanInsufficient:
        "Limit Tagihan tidak mencukupi untuk transaksi ini"
    },
    success: {
      title: "Booking berhasil!",
      close: "Tutup",
      printInvoice: "Buat tagihan",
      printReceipt: "Print Resi",
      copy: "Salin",
      recipient: "Penerima",
      destination: "Kecamatan, kota tujuan",
      serviceType: "Jenis pengiriman",
      estimation: "Estimasi pengiriman",
      codFee: "Biaya COD",
      dfodFee: "Biaya DFOD",
      payableByReceiver: "Biaya dibayar penerima",
      totalTariff: "Total tarif",
      discount: "Diskon",
      pieces: "koli"
    },
    client: {
      label: "Klien",
      fieldPlaceholder: "Pilih klien",
      openList: "Lihat klien",
      clear: "Hapus klien",
      required: "Nama client wajib diisi",
      searchPlaceholder: "Masukkan & pilih nama/alias/kode klien cabang.",
      originPlaceholder: "Masukkan & pilih kota asal klien (3LC)",
      originNotFound: "Apa yang Anda cari tidak ditemukan atau tidak ada.",
      serviceTypePlaceholder: "Pilih tipe layanan pengiriman",
      reset: "Reset",
      emptyInitial: "Belum ada klien cabang terdaftar",
      emptyFiltered:
        "Klien cabang tidak ditemukan. Coba ubah filter atau kata kunci.",
      notFound: "Data tidak ditemukan.",
      notFoundTitle: "Pencarian klien tidak ditemukan",
      notFoundSubtitle: "Cek kata kunci & coba kembali.",
      listError: "Daftar klien gagal dimuat.",
      retry: "Ulangi",
      filter: {
        title: "Filter pencarian klien",
        originLabel: "Kota asal klien (3LC)",
        serviceTypeLabel: "Tipe layanan pengiriman"
      },
      list: {
        title: "Daftar klien",
        close: "Tutup daftar klien",
        clientName: "Nama klien",
        clientAlias: "Alias",
        clientOrigin: "Kota asal",
        clientType: "Tipe klien",
        serviceType: "Layanan pengiriman",
        clientCode: "Kode klien"
      }
    },
    previewInvoice: {
      title: "Preview Buat Tagihan",
      totalStt: "Jumlah STT",
      totalTariff: "Total Tarif",
      totalInvoice: "Total Tagihan",
      billedTo: "Ditagihkan ke",
      billedToPlaceholder: "Pilih tujuan penagihan",
      note: "Catatan",
      notePlaceholder: "Masukkan catatan untuk penerima tagihan",
      sendTo: "Kirim Ke",
      invoiceFormat: "Format tagihan",
      formatPlaceholder: "Pilih format",
      cancel: "Batalkan",
      createInvoice: "Buat Tagihan",
      errorGetHistory: "Gagal mengambil data riwayat berhasil booking!",
      errorCreateInvoice: "Buat tagihan gagal!",
      options: {
        pdfA4: "PDF (A4)",
        pngA4: "PNG (A4)",
        pdfStruk: "PDF (Ukuran Struk)"
      }
    },
    shipment: {
      additionalWeight: {
        title: "Wajib upload bukti foto barang untuk ubah berat",
        collapsedButton: "Tutup panduan",
        content: `<ul class="custom-list">
          <li><span class="font-bold">Resolusi foto</span> jelas dan tidak buram.</li>
          <li><span class="font-bold">Timbangan</span> atau <span class="font-bold">pengukuran volume</span> terlihat jelas.</li>
          <li><span class="font-bold">Label STT, shipment,</span> atau <span class="font-bold">label lainnya</span> dapat dibaca.</li>
          <li><span class="font-bold">Seluruh paket</span> terlihat utuh dalam satu foto.</li>
        </ul>`,
        weightPhoto: "Foto timbangan",
        photoWithIdentity: "Foto barang dengan identitas",
        additionalPhoto: "Foto tambahan",
        belowPieces: "Koli tidak boleh diturunkan"
      },
      goodsName: {
        title: "Kategori barang"
      }
    },
    savedAddress: {
      title: "Pilih detail barang tersimpan"
    }, // savedAddress Close
    pos: {
      title: "POS pembooking",
      placeholder: "Pilih POS",
      error: "POS pembooking harus diisi"
    }
  },
  bookingV4Client: {
    breadcrumb: {
      parent: "Booking",
      title: "Booking Klien"
    }
  },
  codIncome: {
    title: "Penghasilan COD",
    search: "Cari No. STT atau ID Transaksi Genesis",
    summaryTitle: "Hasil COD",
    filter: "Filter",
    filterAll: "Semua",
    emptyMessage: "Oops.. Belum ada data yang dapat ditampilkan",
    column: {
      id: "ID transaksi Genesis",
      transactionDate: "Tanggal transaksi",
      route: "Rute pengiriman",
      sttNo: "No. STT",
      transactionType: "Tipe transaksi",
      activity: "Aktivitas",
      amount: "Jumlah",
      balance: "Saldo terakhir",
      note: "Catatan",
      bankName: "Nama bank",
      accountName: "Nama rekening",
      accountNumber: "No. rekening",
      refId: "Genesis referensi ID",
      status: "Status"
    },
    status: {
      success: "Sukses",
      request: "Diproses",
      failed: "Gagal"
    },
    downloadStatement: "Download Mutasi",
    withdrawal: {
      title: "Penarikan",
      titlePage: "Penarikan Saldo",
      codBalance: "Penghasilan COD",
      passwordTitle: "Password akun Anda",
      passwordPlaceholder: "Masukan password genesis",
      errorPassword: "Password anda salah",
      amountTitle: "Jumlah penarikan saldo",
      amountPlaceholder: "0",
      amountMinMaxNote: "Penarikan min. {min} dan maks. {max}",
      amountFrequencyNote: "Penarikan hanya 1x dalam seminggu.",
      errorAmountExceedBalance: "Nominal melebihi saldo tersedia.",
      errorAmountBelowMin: "Nominal minimal penarikan saldo {min}.",
      errorAmountAboveMax: "Nominal maksimal penarikan saldo {max}.",
      sidebarTitle: "Rincian penarikan",
      destinationAccount: "Rekening tujuan",
      amountSummaryLabel: "Jumlah penarikan",
      withdrawButton: "Tarik saldo",
      snackbarSuccessTitle: "Penarikan berhasil",
      snackbarSuccessMessage: "Penarikan sebesar {amount} kamu telah diajukan."
    }
  }
};
